// These characters are the same in SJIS.
var SAME_IN_SJIS = [
  ' ', '!', '"', '#', '$',
  '%', '&', '\'', '(', ')',
  '*', '+', ',', '-', '.',
  '/', '0', '1', '2', '3',
  '4', '5', '6', '7', '8',
  '9', ':', ';', '<', '=',
  '>', '?', '@', 'A', 'B',
  'C', 'D', 'E', 'F', 'G',
  'H', 'I', 'J', 'K', 'L',
  'M', 'N', 'O', 'P', 'Q',
  'R', 'S', 'T', 'U', 'V',
  'W', 'X', 'Y', 'Z', '[',
  '\\', ']', '^', '_', '`',
  'a', 'b', 'c', 'd', 'e',
  'f', 'g', 'h', 'i', 'j',
  'k', 'l', 'm', 'n', 'o',
  'p', 'q', 'r', 's', 't',
  'u', 'v', 'w', 'x', 'y',
  'z', '{', '|', '}', '~',
  '\u007f'
];

var sjisconv = {};

var i = SAME_IN_SJIS.length;
while (i--) {
  var value = SAME_IN_SJIS[i];
  sjisconv[value] = value;
}

sjisconv['\u00a2'] = '\u0081\u0091';
sjisconv['\u00a3'] = '\u0081\u0092';
sjisconv['\u00a7'] = '\u0081\u0098';
sjisconv['\u00a8'] = '\u0081N';
sjisconv['\u00ac'] = '\u0081\u00ca';
sjisconv['\u00b0'] = '\u0081\u008b';
sjisconv['\u00b1'] = '\u0081}';
sjisconv['\u00b4'] = '\u0081L';
sjisconv['\u00b6'] = '\u0081\u00f7';
sjisconv['\u00d7'] = '\u0081~';
sjisconv['\u00f7'] = '\u0081\u0080';
sjisconv['\u0391'] = '\u0083\u009f';
sjisconv['\u0392'] = '\u0083\u00a0';
sjisconv['\u0393'] = '\u0083\u00a1';
sjisconv['\u0394'] = '\u0083\u00a2';
sjisconv['\u0395'] = '\u0083\u00a3';
sjisconv['\u0396'] = '\u0083\u00a4';
sjisconv['\u0397'] = '\u0083\u00a5';
sjisconv['\u0398'] = '\u0083\u00a6';
sjisconv['\u0399'] = '\u0083\u00a7';
sjisconv['\u039a'] = '\u0083\u00a8';
sjisconv['\u039b'] = '\u0083\u00a9';
sjisconv['\u039c'] = '\u0083\u00aa';
sjisconv['\u039d'] = '\u0083\u00ab';
sjisconv['\u039e'] = '\u0083\u00ac';
sjisconv['\u039f'] = '\u0083\u00ad';
sjisconv['\u03a0'] = '\u0083\u00ae';
sjisconv['\u03a1'] = '\u0083\u00af';
sjisconv['\u03a3'] = '\u0083\u00b0';
sjisconv['\u03a4'] = '\u0083\u00b1';
sjisconv['\u03a5'] = '\u0083\u00b2';
sjisconv['\u03a6'] = '\u0083\u00b3';
sjisconv['\u03a7'] = '\u0083\u00b4';
sjisconv['\u03a8'] = '\u0083\u00b5';
sjisconv['\u03a9'] = '\u0083\u00b6';
sjisconv['\u03b1'] = '\u0083\u00bf';
sjisconv['\u03b2'] = '\u0083\u00c0';
sjisconv['\u03b3'] = '\u0083\u00c1';
sjisconv['\u03b4'] = '\u0083\u00c2';
sjisconv['\u03b5'] = '\u0083\u00c3';
sjisconv['\u03b6'] = '\u0083\u00c4';
sjisconv['\u03b7'] = '\u0083\u00c5';
sjisconv['\u03b8'] = '\u0083\u00c6';
sjisconv['\u03b9'] = '\u0083\u00c7';
sjisconv['\u03ba'] = '\u0083\u00c8';
sjisconv['\u03bb'] = '\u0083\u00c9';
sjisconv['\u03bc'] = '\u0083\u00ca';
sjisconv['\u03bd'] = '\u0083\u00cb';
sjisconv['\u03be'] = '\u0083\u00cc';
sjisconv['\u03bf'] = '\u0083\u00cd';
sjisconv['\u03c0'] = '\u0083\u00ce';
sjisconv['\u03c1'] = '\u0083\u00cf';
sjisconv['\u03c3'] = '\u0083\u00d0';
sjisconv['\u03c4'] = '\u0083\u00d1';
sjisconv['\u03c5'] = '\u0083\u00d2';
sjisconv['\u03c6'] = '\u0083\u00d3';
sjisconv['\u03c7'] = '\u0083\u00d4';
sjisconv['\u03c8'] = '\u0083\u00d5';
sjisconv['\u03c9'] = '\u0083\u00d6';
sjisconv['\u0401'] = '\u0084F';
sjisconv['\u0410'] = '\u0084@';
sjisconv['\u0411'] = '\u0084A';
sjisconv['\u0412'] = '\u0084B';
sjisconv['\u0413'] = '\u0084C';
sjisconv['\u0414'] = '\u0084D';
sjisconv['\u0415'] = '\u0084E';
sjisconv['\u0416'] = '\u0084G';
sjisconv['\u0417'] = '\u0084H';
sjisconv['\u0418'] = '\u0084I';
sjisconv['\u0419'] = '\u0084J';
sjisconv['\u041a'] = '\u0084K';
sjisconv['\u041b'] = '\u0084L';
sjisconv['\u041c'] = '\u0084M';
sjisconv['\u041d'] = '\u0084N';
sjisconv['\u041e'] = '\u0084O';
sjisconv['\u041f'] = '\u0084P';
sjisconv['\u0420'] = '\u0084Q';
sjisconv['\u0421'] = '\u0084R';
sjisconv['\u0422'] = '\u0084S';
sjisconv['\u0423'] = '\u0084T';
sjisconv['\u0424'] = '\u0084U';
sjisconv['\u0425'] = '\u0084V';
sjisconv['\u0426'] = '\u0084W';
sjisconv['\u0427'] = '\u0084X';
sjisconv['\u0428'] = '\u0084Y';
sjisconv['\u0429'] = '\u0084Z';
sjisconv['\u042a'] = '\u0084[';
sjisconv['\u042b'] = '\u0084\\';
sjisconv['\u042c'] = '\u0084]';
sjisconv['\u042d'] = '\u0084^';
sjisconv['\u042e'] = '\u0084_';
sjisconv['\u042f'] = '\u0084`';
sjisconv['\u0430'] = '\u0084p';
sjisconv['\u0431'] = '\u0084q';
sjisconv['\u0432'] = '\u0084r';
sjisconv['\u0433'] = '\u0084s';
sjisconv['\u0434'] = '\u0084t';
sjisconv['\u0435'] = '\u0084u';
sjisconv['\u0436'] = '\u0084w';
sjisconv['\u0437'] = '\u0084x';
sjisconv['\u0438'] = '\u0084y';
sjisconv['\u0439'] = '\u0084z';
sjisconv['\u043a'] = '\u0084{';
sjisconv['\u043b'] = '\u0084|';
sjisconv['\u043c'] = '\u0084}';
sjisconv['\u043d'] = '\u0084~';
sjisconv['\u043e'] = '\u0084\u0080';
sjisconv['\u043f'] = '\u0084\u0081';
sjisconv['\u0440'] = '\u0084\u0082';
sjisconv['\u0441'] = '\u0084\u0083';
sjisconv['\u0442'] = '\u0084\u0084';
sjisconv['\u0443'] = '\u0084\u0085';
sjisconv['\u0444'] = '\u0084\u0086';
sjisconv['\u0445'] = '\u0084\u0087';
sjisconv['\u0446'] = '\u0084\u0088';
sjisconv['\u0447'] = '\u0084\u0089';
sjisconv['\u0448'] = '\u0084\u008a';
sjisconv['\u0449'] = '\u0084\u008b';
sjisconv['\u044a'] = '\u0084\u008c';
sjisconv['\u044b'] = '\u0084\u008d';
sjisconv['\u044c'] = '\u0084\u008e';
sjisconv['\u044d'] = '\u0084\u008f';
sjisconv['\u044e'] = '\u0084\u0090';
sjisconv['\u044f'] = '\u0084\u0091';
sjisconv['\u0451'] = '\u0084v';
sjisconv['\u2010'] = '\u0081]';
sjisconv['\u2015'] = '\u0081\\';
sjisconv['\u2016'] = '\u0081a';
sjisconv['\u2018'] = '\u0081e';
sjisconv['\u2019'] = '\u0081f';
sjisconv['\u201c'] = '\u0081g';
sjisconv['\u201d'] = '\u0081h';
sjisconv['\u2020'] = '\u0081\u00f5';
sjisconv['\u2021'] = '\u0081\u00f6';
sjisconv['\u2025'] = '\u0081d';
sjisconv['\u2026'] = '\u0081c';
sjisconv['\u2030'] = '\u0081\u00f1';
sjisconv['\u2032'] = '\u0081\u008c';
sjisconv['\u2033'] = '\u0081\u008d';
sjisconv['\u203b'] = '\u0081\u00a6';
sjisconv['\u2103'] = '\u0081\u008e';
sjisconv['\u212b'] = '\u0081\u00f0';
sjisconv['\u2190'] = '\u0081\u00a9';
sjisconv['\u2191'] = '\u0081\u00aa';
sjisconv['\u2192'] = '\u0081\u00a8';
sjisconv['\u2193'] = '\u0081\u00ab';
sjisconv['\u21d2'] = '\u0081\u00cb';
sjisconv['\u21d4'] = '\u0081\u00cc';
sjisconv['\u2200'] = '\u0081\u00cd';
sjisconv['\u2202'] = '\u0081\u00dd';
sjisconv['\u2203'] = '\u0081\u00ce';
sjisconv['\u2207'] = '\u0081\u00de';
sjisconv['\u2208'] = '\u0081\u00b8';
sjisconv['\u220b'] = '\u0081\u00b9';
sjisconv['\u2212'] = '\u0081|';
sjisconv['\u221a'] = '\u0081\u00e3';
sjisconv['\u221d'] = '\u0081\u00e5';
sjisconv['\u221e'] = '\u0081\u0087';
sjisconv['\u2220'] = '\u0081\u00da';
sjisconv['\u2227'] = '\u0081\u00c8';
sjisconv['\u2228'] = '\u0081\u00c9';
sjisconv['\u2229'] = '\u0081\u00bf';
sjisconv['\u222a'] = '\u0081\u00be';
sjisconv['\u222b'] = '\u0081\u00e7';
sjisconv['\u222c'] = '\u0081\u00e8';
sjisconv['\u2234'] = '\u0081\u0088';
sjisconv['\u2235'] = '\u0081\u00e6';
sjisconv['\u223d'] = '\u0081\u00e4';
sjisconv['\u2252'] = '\u0081\u00e0';
sjisconv['\u2260'] = '\u0081\u0082';
sjisconv['\u2261'] = '\u0081\u00df';
sjisconv['\u2266'] = '\u0081\u0085';
sjisconv['\u2267'] = '\u0081\u0086';
sjisconv['\u226a'] = '\u0081\u00e1';
sjisconv['\u226b'] = '\u0081\u00e2';
sjisconv['\u2282'] = '\u0081\u00bc';
sjisconv['\u2283'] = '\u0081\u00bd';
sjisconv['\u2286'] = '\u0081\u00ba';
sjisconv['\u2287'] = '\u0081\u00bb';
sjisconv['\u22a5'] = '\u0081\u00db';
sjisconv['\u2312'] = '\u0081\u00dc';
sjisconv['\u2500'] = '\u0084\u009f';
sjisconv['\u2501'] = '\u0084\u00aa';
sjisconv['\u2502'] = '\u0084\u00a0';
sjisconv['\u2503'] = '\u0084\u00ab';
sjisconv['\u250c'] = '\u0084\u00a1';
sjisconv['\u250f'] = '\u0084\u00ac';
sjisconv['\u2510'] = '\u0084\u00a2';
sjisconv['\u2513'] = '\u0084\u00ad';
sjisconv['\u2514'] = '\u0084\u00a4';
sjisconv['\u2517'] = '\u0084\u00af';
sjisconv['\u2518'] = '\u0084\u00a3';
sjisconv['\u251b'] = '\u0084\u00ae';
sjisconv['\u251c'] = '\u0084\u00a5';
sjisconv['\u251d'] = '\u0084\u00ba';
sjisconv['\u2520'] = '\u0084\u00b5';
sjisconv['\u2523'] = '\u0084\u00b0';
sjisconv['\u2524'] = '\u0084\u00a7';
sjisconv['\u2525'] = '\u0084\u00bc';
sjisconv['\u2528'] = '\u0084\u00b7';
sjisconv['\u252b'] = '\u0084\u00b2';
sjisconv['\u252c'] = '\u0084\u00a6';
sjisconv['\u252f'] = '\u0084\u00b6';
sjisconv['\u2530'] = '\u0084\u00bb';
sjisconv['\u2533'] = '\u0084\u00b1';
sjisconv['\u2534'] = '\u0084\u00a8';
sjisconv['\u2537'] = '\u0084\u00b8';
sjisconv['\u2538'] = '\u0084\u00bd';
sjisconv['\u253b'] = '\u0084\u00b3';
sjisconv['\u253c'] = '\u0084\u00a9';
sjisconv['\u253f'] = '\u0084\u00b9';
sjisconv['\u2542'] = '\u0084\u00be';
sjisconv['\u254b'] = '\u0084\u00b4';
sjisconv['\u25a0'] = '\u0081\u00a1';
sjisconv['\u25a1'] = '\u0081\u00a0';
sjisconv['\u25b2'] = '\u0081\u00a3';
sjisconv['\u25b3'] = '\u0081\u00a2';
sjisconv['\u25bc'] = '\u0081\u00a5';
sjisconv['\u25bd'] = '\u0081\u00a4';
sjisconv['\u25c6'] = '\u0081\u009f';
sjisconv['\u25c7'] = '\u0081\u009e';
sjisconv['\u25cb'] = '\u0081\u009b';
sjisconv['\u25ce'] = '\u0081\u009d';
sjisconv['\u25cf'] = '\u0081\u009c';
sjisconv['\u25ef'] = '\u0081\u00fc';
sjisconv['\u2605'] = '\u0081\u009a';
sjisconv['\u2606'] = '\u0081\u0099';
sjisconv['\u2640'] = '\u0081\u008a';
sjisconv['\u2642'] = '\u0081\u0089';
sjisconv['\u266a'] = '\u0081\u00f4';
sjisconv['\u266d'] = '\u0081\u00f3';
sjisconv['\u266f'] = '\u0081\u00f2';
sjisconv['\u3000'] = '\u0081@';
sjisconv['\u3001'] = '\u0081A';
sjisconv['\u3002'] = '\u0081B';
sjisconv['\u3003'] = '\u0081V';
sjisconv['\u3005'] = '\u0081X';
sjisconv['\u3006'] = '\u0081Y';
sjisconv['\u3007'] = '\u0081Z';
sjisconv['\u3008'] = '\u0081q';
sjisconv['\u3009'] = '\u0081r';
sjisconv['\u300a'] = '\u0081s';
sjisconv['\u300b'] = '\u0081t';
sjisconv['\u300c'] = '\u0081u';
sjisconv['\u300d'] = '\u0081v';
sjisconv['\u300e'] = '\u0081w';
sjisconv['\u300f'] = '\u0081x';
sjisconv['\u3010'] = '\u0081y';
sjisconv['\u3011'] = '\u0081z';
sjisconv['\u3012'] = '\u0081\u00a7';
sjisconv['\u3013'] = '\u0081\u00ac';
sjisconv['\u3014'] = '\u0081k';
sjisconv['\u3015'] = '\u0081l';
sjisconv['\u301c'] = '\u0081`';
sjisconv['\u3041'] = '\u0082\u009f';
sjisconv['\u3042'] = '\u0082\u00a0';
sjisconv['\u3043'] = '\u0082\u00a1';
sjisconv['\u3044'] = '\u0082\u00a2';
sjisconv['\u3045'] = '\u0082\u00a3';
sjisconv['\u3046'] = '\u0082\u00a4';
sjisconv['\u3047'] = '\u0082\u00a5';
sjisconv['\u3048'] = '\u0082\u00a6';
sjisconv['\u3049'] = '\u0082\u00a7';
sjisconv['\u304a'] = '\u0082\u00a8';
sjisconv['\u304b'] = '\u0082\u00a9';
sjisconv['\u304c'] = '\u0082\u00aa';
sjisconv['\u304d'] = '\u0082\u00ab';
sjisconv['\u304e'] = '\u0082\u00ac';
sjisconv['\u304f'] = '\u0082\u00ad';
sjisconv['\u3050'] = '\u0082\u00ae';
sjisconv['\u3051'] = '\u0082\u00af';
sjisconv['\u3052'] = '\u0082\u00b0';
sjisconv['\u3053'] = '\u0082\u00b1';
sjisconv['\u3054'] = '\u0082\u00b2';
sjisconv['\u3055'] = '\u0082\u00b3';
sjisconv['\u3056'] = '\u0082\u00b4';
sjisconv['\u3057'] = '\u0082\u00b5';
sjisconv['\u3058'] = '\u0082\u00b6';
sjisconv['\u3059'] = '\u0082\u00b7';
sjisconv['\u305a'] = '\u0082\u00b8';
sjisconv['\u305b'] = '\u0082\u00b9';
sjisconv['\u305c'] = '\u0082\u00ba';
sjisconv['\u305d'] = '\u0082\u00bb';
sjisconv['\u305e'] = '\u0082\u00bc';
sjisconv['\u305f'] = '\u0082\u00bd';
sjisconv['\u3060'] = '\u0082\u00be';
sjisconv['\u3061'] = '\u0082\u00bf';
sjisconv['\u3062'] = '\u0082\u00c0';
sjisconv['\u3063'] = '\u0082\u00c1';
sjisconv['\u3064'] = '\u0082\u00c2';
sjisconv['\u3065'] = '\u0082\u00c3';
sjisconv['\u3066'] = '\u0082\u00c4';
sjisconv['\u3067'] = '\u0082\u00c5';
sjisconv['\u3068'] = '\u0082\u00c6';
sjisconv['\u3069'] = '\u0082\u00c7';
sjisconv['\u306a'] = '\u0082\u00c8';
sjisconv['\u306b'] = '\u0082\u00c9';
sjisconv['\u306c'] = '\u0082\u00ca';
sjisconv['\u306d'] = '\u0082\u00cb';
sjisconv['\u306e'] = '\u0082\u00cc';
sjisconv['\u306f'] = '\u0082\u00cd';
sjisconv['\u3070'] = '\u0082\u00ce';
sjisconv['\u3071'] = '\u0082\u00cf';
sjisconv['\u3072'] = '\u0082\u00d0';
sjisconv['\u3073'] = '\u0082\u00d1';
sjisconv['\u3074'] = '\u0082\u00d2';
sjisconv['\u3075'] = '\u0082\u00d3';
sjisconv['\u3076'] = '\u0082\u00d4';
sjisconv['\u3077'] = '\u0082\u00d5';
sjisconv['\u3078'] = '\u0082\u00d6';
sjisconv['\u3079'] = '\u0082\u00d7';
sjisconv['\u307a'] = '\u0082\u00d8';
sjisconv['\u307b'] = '\u0082\u00d9';
sjisconv['\u307c'] = '\u0082\u00da';
sjisconv['\u307d'] = '\u0082\u00db';
sjisconv['\u307e'] = '\u0082\u00dc';
sjisconv['\u307f'] = '\u0082\u00dd';
sjisconv['\u3080'] = '\u0082\u00de';
sjisconv['\u3081'] = '\u0082\u00df';
sjisconv['\u3082'] = '\u0082\u00e0';
sjisconv['\u3083'] = '\u0082\u00e1';
sjisconv['\u3084'] = '\u0082\u00e2';
sjisconv['\u3085'] = '\u0082\u00e3';
sjisconv['\u3086'] = '\u0082\u00e4';
sjisconv['\u3087'] = '\u0082\u00e5';
sjisconv['\u3088'] = '\u0082\u00e6';
sjisconv['\u3089'] = '\u0082\u00e7';
sjisconv['\u308a'] = '\u0082\u00e8';
sjisconv['\u308b'] = '\u0082\u00e9';
sjisconv['\u308c'] = '\u0082\u00ea';
sjisconv['\u308d'] = '\u0082\u00eb';
sjisconv['\u308e'] = '\u0082\u00ec';
sjisconv['\u308f'] = '\u0082\u00ed';
sjisconv['\u3090'] = '\u0082\u00ee';
sjisconv['\u3091'] = '\u0082\u00ef';
sjisconv['\u3092'] = '\u0082\u00f0';
sjisconv['\u3093'] = '\u0082\u00f1';
sjisconv['\u309b'] = '\u0081J';
sjisconv['\u309c'] = '\u0081K';
sjisconv['\u309d'] = '\u0081T';
sjisconv['\u309e'] = '\u0081U';
sjisconv['\u30a1'] = '\u0083@';
sjisconv['\u30a2'] = '\u0083A';
sjisconv['\u30a3'] = '\u0083B';
sjisconv['\u30a4'] = '\u0083C';
sjisconv['\u30a5'] = '\u0083D';
sjisconv['\u30a6'] = '\u0083E';
sjisconv['\u30a7'] = '\u0083F';
sjisconv['\u30a8'] = '\u0083G';
sjisconv['\u30a9'] = '\u0083H';
sjisconv['\u30aa'] = '\u0083I';
sjisconv['\u30ab'] = '\u0083J';
sjisconv['\u30ac'] = '\u0083K';
sjisconv['\u30ad'] = '\u0083L';
sjisconv['\u30ae'] = '\u0083M';
sjisconv['\u30af'] = '\u0083N';
sjisconv['\u30b0'] = '\u0083O';
sjisconv['\u30b1'] = '\u0083P';
sjisconv['\u30b2'] = '\u0083Q';
sjisconv['\u30b3'] = '\u0083R';
sjisconv['\u30b4'] = '\u0083S';
sjisconv['\u30b5'] = '\u0083T';
sjisconv['\u30b6'] = '\u0083U';
sjisconv['\u30b7'] = '\u0083V';
sjisconv['\u30b8'] = '\u0083W';
sjisconv['\u30b9'] = '\u0083X';
sjisconv['\u30ba'] = '\u0083Y';
sjisconv['\u30bb'] = '\u0083Z';
sjisconv['\u30bc'] = '\u0083[';
sjisconv['\u30bd'] = '\u0083\\';
sjisconv['\u30be'] = '\u0083]';
sjisconv['\u30bf'] = '\u0083^';
sjisconv['\u30c0'] = '\u0083_';
sjisconv['\u30c1'] = '\u0083`';
sjisconv['\u30c2'] = '\u0083a';
sjisconv['\u30c3'] = '\u0083b';
sjisconv['\u30c4'] = '\u0083c';
sjisconv['\u30c5'] = '\u0083d';
sjisconv['\u30c6'] = '\u0083e';
sjisconv['\u30c7'] = '\u0083f';
sjisconv['\u30c8'] = '\u0083g';
sjisconv['\u30c9'] = '\u0083h';
sjisconv['\u30ca'] = '\u0083i';
sjisconv['\u30cb'] = '\u0083j';
sjisconv['\u30cc'] = '\u0083k';
sjisconv['\u30cd'] = '\u0083l';
sjisconv['\u30ce'] = '\u0083m';
sjisconv['\u30cf'] = '\u0083n';
sjisconv['\u30d0'] = '\u0083o';
sjisconv['\u30d1'] = '\u0083p';
sjisconv['\u30d2'] = '\u0083q';
sjisconv['\u30d3'] = '\u0083r';
sjisconv['\u30d4'] = '\u0083s';
sjisconv['\u30d5'] = '\u0083t';
sjisconv['\u30d6'] = '\u0083u';
sjisconv['\u30d7'] = '\u0083v';
sjisconv['\u30d8'] = '\u0083w';
sjisconv['\u30d9'] = '\u0083x';
sjisconv['\u30da'] = '\u0083y';
sjisconv['\u30db'] = '\u0083z';
sjisconv['\u30dc'] = '\u0083{';
sjisconv['\u30dd'] = '\u0083|';
sjisconv['\u30de'] = '\u0083}';
sjisconv['\u30df'] = '\u0083~';
sjisconv['\u30e0'] = '\u0083\u0080';
sjisconv['\u30e1'] = '\u0083\u0081';
sjisconv['\u30e2'] = '\u0083\u0082';
sjisconv['\u30e3'] = '\u0083\u0083';
sjisconv['\u30e4'] = '\u0083\u0084';
sjisconv['\u30e5'] = '\u0083\u0085';
sjisconv['\u30e6'] = '\u0083\u0086';
sjisconv['\u30e7'] = '\u0083\u0087';
sjisconv['\u30e8'] = '\u0083\u0088';
sjisconv['\u30e9'] = '\u0083\u0089';
sjisconv['\u30ea'] = '\u0083\u008a';
sjisconv['\u30eb'] = '\u0083\u008b';
sjisconv['\u30ec'] = '\u0083\u008c';
sjisconv['\u30ed'] = '\u0083\u008d';
sjisconv['\u30ee'] = '\u0083\u008e';
sjisconv['\u30ef'] = '\u0083\u008f';
sjisconv['\u30f0'] = '\u0083\u0090';
sjisconv['\u30f1'] = '\u0083\u0091';
sjisconv['\u30f2'] = '\u0083\u0092';
sjisconv['\u30f3'] = '\u0083\u0093';
sjisconv['\u30f4'] = '\u0083\u0094';
sjisconv['\u30f5'] = '\u0083\u0095';
sjisconv['\u30f6'] = '\u0083\u0096';
sjisconv['\u30fb'] = '\u0081E';
sjisconv['\u30fc'] = '\u0081[';
sjisconv['\u30fd'] = '\u0081R';
sjisconv['\u30fe'] = '\u0081S';
sjisconv['\u4e00'] = '\u0088\u00ea';
sjisconv['\u4e01'] = '\u0092\u009a';
sjisconv['\u4e03'] = '\u008e\u00b5';
sjisconv['\u4e07'] = '\u0096\u009c';
sjisconv['\u4e08'] = '\u008f\u00e4';
sjisconv['\u4e09'] = '\u008eO';
sjisconv['\u4e0a'] = '\u008f\u00e3';
sjisconv['\u4e0b'] = '\u0089\u00ba';
sjisconv['\u4e0d'] = '\u0095s';
sjisconv['\u4e0e'] = '\u0097^';
sjisconv['\u4e10'] = '\u0098\u00a0';
sjisconv['\u4e11'] = '\u0089N';
sjisconv['\u4e14'] = '\u008a\u008e';
sjisconv['\u4e15'] = '\u0098\u00a1';
sjisconv['\u4e16'] = '\u0090\u00a2';
sjisconv['\u4e17'] = '\u0099\u00c0';
sjisconv['\u4e18'] = '\u008bu';
sjisconv['\u4e19'] = '\u0095\u00b8';
sjisconv['\u4e1e'] = '\u008f\u00e5';
sjisconv['\u4e21'] = '\u0097\u00bc';
sjisconv['\u4e26'] = '\u0095\u00c0';
sjisconv['\u4e2a'] = '\u0098\u00a2';
sjisconv['\u4e2d'] = '\u0092\u0086';
sjisconv['\u4e31'] = '\u0098\u00a3';
sjisconv['\u4e32'] = '\u008b\u00f8';
sjisconv['\u4e36'] = '\u0098\u00a4';
sjisconv['\u4e38'] = '\u008a\u00db';
sjisconv['\u4e39'] = '\u0092O';
sjisconv['\u4e3b'] = '\u008e\u00e5';
sjisconv['\u4e3c'] = '\u0098\u00a5';
sjisconv['\u4e3f'] = '\u0098\u00a6';
sjisconv['\u4e42'] = '\u0098\u00a7';
sjisconv['\u4e43'] = '\u0094T';
sjisconv['\u4e45'] = '\u008bv';
sjisconv['\u4e4b'] = '\u0094V';
sjisconv['\u4e4d'] = '\u0093\u00e1';
sjisconv['\u4e4e'] = '\u008c\u00c1';
sjisconv['\u4e4f'] = '\u0096R';
sjisconv['\u4e55'] = '\u00e5h';
sjisconv['\u4e56'] = '\u0098\u00a8';
sjisconv['\u4e57'] = '\u008f\u00e6';
sjisconv['\u4e58'] = '\u0098\u00a9';
sjisconv['\u4e59'] = '\u0089\u00b3';
sjisconv['\u4e5d'] = '\u008b\u00e3';
sjisconv['\u4e5e'] = '\u008c\u00ee';
sjisconv['\u4e5f'] = '\u0096\u00e7';
sjisconv['\u4e62'] = '\u009b\u00a4';
sjisconv['\u4e71'] = '\u0097\u0090';
sjisconv['\u4e73'] = '\u0093\u00fb';
sjisconv['\u4e7e'] = '\u008a\u00a3';
sjisconv['\u4e80'] = '\u008bT';
sjisconv['\u4e82'] = '\u0098\u00aa';
sjisconv['\u4e85'] = '\u0098\u00ab';
sjisconv['\u4e86'] = '\u0097\u00b9';
sjisconv['\u4e88'] = '\u0097\\';
sjisconv['\u4e89'] = '\u0091\u0088';
sjisconv['\u4e8a'] = '\u0098\u00ad';
sjisconv['\u4e8b'] = '\u008e\u0096';
sjisconv['\u4e8c'] = '\u0093\u00f1';
sjisconv['\u4e8e'] = '\u0098\u00b0';
sjisconv['\u4e91'] = '\u0089]';
sjisconv['\u4e92'] = '\u008c\u00dd';
sjisconv['\u4e94'] = '\u008c\u00dc';
sjisconv['\u4e95'] = '\u0088\u00e4';
sjisconv['\u4e98'] = '\u0098j';
sjisconv['\u4e99'] = '\u0098i';
sjisconv['\u4e9b'] = '\u008d\u00b1';
sjisconv['\u4e9c'] = '\u0088\u009f';
sjisconv['\u4e9e'] = '\u0098\u00b1';
sjisconv['\u4e9f'] = '\u0098\u00b2';
sjisconv['\u4ea0'] = '\u0098\u00b3';
sjisconv['\u4ea1'] = '\u0096S';
sjisconv['\u4ea2'] = '\u0098\u00b4';
sjisconv['\u4ea4'] = '\u008c\u00f0';
sjisconv['\u4ea5'] = '\u0088\u00e5';
sjisconv['\u4ea6'] = '\u0096\u0092';
sjisconv['\u4ea8'] = '\u008b\u009c';
sjisconv['\u4eab'] = '\u008b\u009d';
sjisconv['\u4eac'] = '\u008b\u009e';
sjisconv['\u4ead'] = '\u0092\u00e0';
sjisconv['\u4eae'] = '\u0097\u00ba';
sjisconv['\u4eb0'] = '\u0098\u00b5';
sjisconv['\u4eb3'] = '\u0098\u00b6';
sjisconv['\u4eb6'] = '\u0098\u00b7';
sjisconv['\u4eba'] = '\u0090l';
sjisconv['\u4ec0'] = '\u008fY';
sjisconv['\u4ec1'] = '\u0090m';
sjisconv['\u4ec2'] = '\u0098\u00bc';
sjisconv['\u4ec4'] = '\u0098\u00ba';
sjisconv['\u4ec6'] = '\u0098\u00bb';
sjisconv['\u4ec7'] = '\u008bw';
sjisconv['\u4eca'] = '\u008d\u00a1';
sjisconv['\u4ecb'] = '\u0089\u00ee';
sjisconv['\u4ecd'] = '\u0098\u00b9';
sjisconv['\u4ece'] = '\u0098\u00b8';
sjisconv['\u4ecf'] = '\u0095\u00a7';
sjisconv['\u4ed4'] = '\u008ee';
sjisconv['\u4ed5'] = '\u008ed';
sjisconv['\u4ed6'] = '\u0091\u00bc';
sjisconv['\u4ed7'] = '\u0098\u00bd';
sjisconv['\u4ed8'] = '\u0095t';
sjisconv['\u4ed9'] = '\u0090\u00e5';
sjisconv['\u4edd'] = '\u0081W';
sjisconv['\u4ede'] = '\u0098\u00be';
sjisconv['\u4edf'] = '\u0098\u00c0';
sjisconv['\u4ee3'] = '\u0091\u00e3';
sjisconv['\u4ee4'] = '\u0097\u00df';
sjisconv['\u4ee5'] = '\u0088\u00c8';
sjisconv['\u4eed'] = '\u0098\u00bf';
sjisconv['\u4eee'] = '\u0089\u00bc';
sjisconv['\u4ef0'] = '\u008b\u00c2';
sjisconv['\u4ef2'] = '\u0092\u0087';
sjisconv['\u4ef6'] = '\u008c\u008f';
sjisconv['\u4ef7'] = '\u0098\u00c1';
sjisconv['\u4efb'] = '\u0094C';
sjisconv['\u4f01'] = '\u008a\u00e9';
sjisconv['\u4f09'] = '\u0098\u00c2';
sjisconv['\u4f0a'] = '\u0088\u00c9';
sjisconv['\u4f0d'] = '\u008c\u00de';
sjisconv['\u4f0e'] = '\u008a\u00ea';
sjisconv['\u4f0f'] = '\u0095\u009a';
sjisconv['\u4f10'] = '\u0094\u00b0';
sjisconv['\u4f11'] = '\u008bx';
sjisconv['\u4f1a'] = '\u0089\u00ef';
sjisconv['\u4f1c'] = '\u0098\u00e5';
sjisconv['\u4f1d'] = '\u0093`';
sjisconv['\u4f2f'] = '\u0094\u008c';
sjisconv['\u4f30'] = '\u0098\u00c4';
sjisconv['\u4f34'] = '\u0094\u00ba';
sjisconv['\u4f36'] = '\u0097\u00e0';
sjisconv['\u4f38'] = '\u0090L';
sjisconv['\u4f3a'] = '\u008ef';
sjisconv['\u4f3c'] = '\u008e\u0097';
sjisconv['\u4f3d'] = '\u0089\u00be';
sjisconv['\u4f43'] = '\u0092\u00cf';
sjisconv['\u4f46'] = '\u0092A';
sjisconv['\u4f47'] = '\u0098\u00c8';
sjisconv['\u4f4d'] = '\u0088\u00ca';
sjisconv['\u4f4e'] = '\u0092\u00e1';
sjisconv['\u4f4f'] = '\u008fZ';
sjisconv['\u4f50'] = '\u008d\u00b2';
sjisconv['\u4f51'] = '\u0097C';
sjisconv['\u4f53'] = '\u0091\u00cc';
sjisconv['\u4f55'] = '\u0089\u00bd';
sjisconv['\u4f57'] = '\u0098\u00c7';
sjisconv['\u4f59'] = '\u0097]';
sjisconv['\u4f5a'] = '\u0098\u00c3';
sjisconv['\u4f5b'] = '\u0098\u00c5';
sjisconv['\u4f5c'] = '\u008d\u00ec';
sjisconv['\u4f5d'] = '\u0098\u00c6';
sjisconv['\u4f5e'] = '\u009bC';
sjisconv['\u4f69'] = '\u0098\u00ce';
sjisconv['\u4f6f'] = '\u0098\u00d1';
sjisconv['\u4f70'] = '\u0098\u00cf';
sjisconv['\u4f73'] = '\u0089\u00c0';
sjisconv['\u4f75'] = '\u0095\u00b9';
sjisconv['\u4f76'] = '\u0098\u00c9';
sjisconv['\u4f7b'] = '\u0098\u00cd';
sjisconv['\u4f7c'] = '\u008c\u00f1';
sjisconv['\u4f7f'] = '\u008eg';
sjisconv['\u4f83'] = '\u008a\u00a4';
sjisconv['\u4f86'] = '\u0098\u00d2';
sjisconv['\u4f88'] = '\u0098\u00ca';
sjisconv['\u4f8b'] = '\u0097\u00e1';
sjisconv['\u4f8d'] = '\u008e\u0098';
sjisconv['\u4f8f'] = '\u0098\u00cb';
sjisconv['\u4f91'] = '\u0098\u00d0';
sjisconv['\u4f96'] = '\u0098\u00d3';
sjisconv['\u4f98'] = '\u0098\u00cc';
sjisconv['\u4f9b'] = '\u008b\u009f';
sjisconv['\u4f9d'] = '\u0088\u00cb';
sjisconv['\u4fa0'] = '\u008b\u00a0';
sjisconv['\u4fa1'] = '\u0089\u00bf';
sjisconv['\u4fab'] = '\u009bD';
sjisconv['\u4fad'] = '\u0096\u0099';
sjisconv['\u4fae'] = '\u0095\u008e';
sjisconv['\u4faf'] = '\u008c\u00f2';
sjisconv['\u4fb5'] = '\u0090N';
sjisconv['\u4fb6'] = '\u0097\u00b5';
sjisconv['\u4fbf'] = '\u0095\u00d6';
sjisconv['\u4fc2'] = '\u008cW';
sjisconv['\u4fc3'] = '\u0091\u00a3';
sjisconv['\u4fc4'] = '\u0089\u00e2';
sjisconv['\u4fca'] = '\u008fr';
sjisconv['\u4fce'] = '\u0098\u00d7';
sjisconv['\u4fd0'] = '\u0098\u00dc';
sjisconv['\u4fd1'] = '\u0098\u00da';
sjisconv['\u4fd4'] = '\u0098\u00d5';
sjisconv['\u4fd7'] = '\u0091\u00ad';
sjisconv['\u4fd8'] = '\u0098\u00d8';
sjisconv['\u4fda'] = '\u0098\u00db';
sjisconv['\u4fdb'] = '\u0098\u00d9';
sjisconv['\u4fdd'] = '\u0095\u00db';
sjisconv['\u4fdf'] = '\u0098\u00d6';
sjisconv['\u4fe1'] = '\u0090M';
sjisconv['\u4fe3'] = '\u0096\u0093';
sjisconv['\u4fe4'] = '\u0098\u00dd';
sjisconv['\u4fe5'] = '\u0098\u00de';
sjisconv['\u4fee'] = '\u008fC';
sjisconv['\u4fef'] = '\u0098\u00eb';
sjisconv['\u4ff3'] = '\u0094o';
sjisconv['\u4ff5'] = '\u0095U';
sjisconv['\u4ff6'] = '\u0098\u00e6';
sjisconv['\u4ff8'] = '\u0095\u00ee';
sjisconv['\u4ffa'] = '\u0089\u00b4';
sjisconv['\u4ffe'] = '\u0098\u00ea';
sjisconv['\u5005'] = '\u0098\u00e4';
sjisconv['\u5006'] = '\u0098\u00ed';
sjisconv['\u5009'] = '\u0091q';
sjisconv['\u500b'] = '\u008c\u00c2';
sjisconv['\u500d'] = '\u0094{';
sjisconv['\u500f'] = '\u00e0\u00c5';
sjisconv['\u5011'] = '\u0098\u00ec';
sjisconv['\u5012'] = '\u0093|';
sjisconv['\u5014'] = '\u0098\u00e1';
sjisconv['\u5016'] = '\u008c\u00f4';
sjisconv['\u5019'] = '\u008c\u00f3';
sjisconv['\u501a'] = '\u0098\u00df';
sjisconv['\u501f'] = '\u008e\u00d8';
sjisconv['\u5021'] = '\u0098\u00e7';
sjisconv['\u5023'] = '\u0095\u00ed';
sjisconv['\u5024'] = '\u0092l';
sjisconv['\u5025'] = '\u0098\u00e3';
sjisconv['\u5026'] = '\u008c\u0091';
sjisconv['\u5028'] = '\u0098\u00e0';
sjisconv['\u5029'] = '\u0098\u00e8';
sjisconv['\u502a'] = '\u0098\u00e2';
sjisconv['\u502b'] = '\u0097\u00cf';
sjisconv['\u502c'] = '\u0098\u00e9';
sjisconv['\u502d'] = '\u0098`';
sjisconv['\u5036'] = '\u008b\u00e4';
sjisconv['\u5039'] = '\u008c\u0090';
sjisconv['\u5043'] = '\u0098\u00ee';
sjisconv['\u5047'] = '\u0098\u00ef';
sjisconv['\u5048'] = '\u0098\u00f3';
sjisconv['\u5049'] = '\u0088\u00cc';
sjisconv['\u504f'] = '\u0095\u00ce';
sjisconv['\u5050'] = '\u0098\u00f2';
sjisconv['\u5055'] = '\u0098\u00f1';
sjisconv['\u5056'] = '\u0098\u00f5';
sjisconv['\u505a'] = '\u0098\u00f4';
sjisconv['\u505c'] = '\u0092\u00e2';
sjisconv['\u5065'] = '\u008c\u0092';
sjisconv['\u506c'] = '\u0098\u00f6';
sjisconv['\u5072'] = '\u008e\u00c3';
sjisconv['\u5074'] = '\u0091\u00a4';
sjisconv['\u5075'] = '\u0092\u00e3';
sjisconv['\u5076'] = '\u008b\u00f4';
sjisconv['\u5078'] = '\u0098\u00f7';
sjisconv['\u507d'] = '\u008bU';
sjisconv['\u5080'] = '\u0098\u00f8';
sjisconv['\u5085'] = '\u0098\u00fa';
sjisconv['\u508d'] = '\u0096T';
sjisconv['\u5091'] = '\u008c\u0086';
sjisconv['\u5098'] = '\u008eP';
sjisconv['\u5099'] = '\u0094\u00f5';
sjisconv['\u509a'] = '\u0098\u00f9';
sjisconv['\u50ac'] = '\u008d\u00c3';
sjisconv['\u50ad'] = '\u0097b';
sjisconv['\u50b2'] = '\u0098\u00fc';
sjisconv['\u50b3'] = '\u0099B';
sjisconv['\u50b4'] = '\u0098\u00fb';
sjisconv['\u50b5'] = '\u008d\u00c2';
sjisconv['\u50b7'] = '\u008f\u009d';
sjisconv['\u50be'] = '\u008cX';
sjisconv['\u50c2'] = '\u0099C';
sjisconv['\u50c5'] = '\u008b\u00cd';
sjisconv['\u50c9'] = '\u0099@';
sjisconv['\u50ca'] = '\u0099A';
sjisconv['\u50cd'] = '\u0093\u00ad';
sjisconv['\u50cf'] = '\u0091\u009c';
sjisconv['\u50d1'] = '\u008b\u00a1';
sjisconv['\u50d5'] = '\u0096l';
sjisconv['\u50d6'] = '\u0099D';
sjisconv['\u50da'] = '\u0097\u00bb';
sjisconv['\u50de'] = '\u0099E';
sjisconv['\u50e3'] = '\u0099H';
sjisconv['\u50e5'] = '\u0099F';
sjisconv['\u50e7'] = '\u0091m';
sjisconv['\u50ed'] = '\u0099G';
sjisconv['\u50ee'] = '\u0099I';
sjisconv['\u50f5'] = '\u0099K';
sjisconv['\u50f9'] = '\u0099J';
sjisconv['\u50fb'] = '\u0095\u00c6';
sjisconv['\u5100'] = '\u008bV';
sjisconv['\u5101'] = '\u0099M';
sjisconv['\u5102'] = '\u0099N';
sjisconv['\u5104'] = '\u0089\u00ad';
sjisconv['\u5109'] = '\u0099L';
sjisconv['\u5112'] = '\u008e\u00f2';
sjisconv['\u5114'] = '\u0099Q';
sjisconv['\u5115'] = '\u0099P';
sjisconv['\u5116'] = '\u0099O';
sjisconv['\u5118'] = '\u0098\u00d4';
sjisconv['\u511a'] = '\u0099R';
sjisconv['\u511f'] = '\u008f\u009e';
sjisconv['\u5121'] = '\u0099S';
sjisconv['\u512a'] = '\u0097D';
sjisconv['\u5132'] = '\u0096\u00d7';
sjisconv['\u5137'] = '\u0099U';
sjisconv['\u513a'] = '\u0099T';
sjisconv['\u513b'] = '\u0099W';
sjisconv['\u513c'] = '\u0099V';
sjisconv['\u513f'] = '\u0099X';
sjisconv['\u5140'] = '\u0099Y';
sjisconv['\u5141'] = '\u0088\u00f2';
sjisconv['\u5143'] = '\u008c\u00b3';
sjisconv['\u5144'] = '\u008cZ';
sjisconv['\u5145'] = '\u008f[';
sjisconv['\u5146'] = '\u0092\u009b';
sjisconv['\u5147'] = '\u008b\u00a2';
sjisconv['\u5148'] = '\u0090\u00e6';
sjisconv['\u5149'] = '\u008c\u00f5';
sjisconv['\u514b'] = '\u008d\u008e';
sjisconv['\u514c'] = '\u0099[';
sjisconv['\u514d'] = '\u0096\u00c6';
sjisconv['\u514e'] = '\u0093e';
sjisconv['\u5150'] = '\u008e\u0099';
sjisconv['\u5152'] = '\u0099Z';
sjisconv['\u5154'] = '\u0099\\';
sjisconv['\u515a'] = '\u0093}';
sjisconv['\u515c'] = '\u008a\u0095';
sjisconv['\u5162'] = '\u0099]';
sjisconv['\u5165'] = '\u0093\u00fc';
sjisconv['\u5168'] = '\u0091S';
sjisconv['\u5169'] = '\u0099_';
sjisconv['\u516a'] = '\u0099`';
sjisconv['\u516b'] = '\u0094\u00aa';
sjisconv['\u516c'] = '\u008c\u00f6';
sjisconv['\u516d'] = '\u0098Z';
sjisconv['\u516e'] = '\u0099a';
sjisconv['\u5171'] = '\u008b\u00a4';
sjisconv['\u5175'] = '\u0095\u00ba';
sjisconv['\u5176'] = '\u0091\u00b4';
sjisconv['\u5177'] = '\u008b\u00ef';
sjisconv['\u5178'] = '\u0093T';
sjisconv['\u517c'] = '\u008c\u0093';
sjisconv['\u5180'] = '\u0099b';
sjisconv['\u5182'] = '\u0099c';
sjisconv['\u5185'] = '\u0093\u00e0';
sjisconv['\u5186'] = '\u0089~';
sjisconv['\u5189'] = '\u0099f';
sjisconv['\u518a'] = '\u008d\u00fb';
sjisconv['\u518c'] = '\u0099e';
sjisconv['\u518d'] = '\u008d\u00c4';
sjisconv['\u518f'] = '\u0099g';
sjisconv['\u5190'] = '\u00e3\u00ec';
sjisconv['\u5191'] = '\u0099h';
sjisconv['\u5192'] = '\u0096`';
sjisconv['\u5193'] = '\u0099i';
sjisconv['\u5195'] = '\u0099j';
sjisconv['\u5196'] = '\u0099k';
sjisconv['\u5197'] = '\u008f\u00e7';
sjisconv['\u5199'] = '\u008e\u00ca';
sjisconv['\u51a0'] = '\u008a\u00a5';
sjisconv['\u51a2'] = '\u0099n';
sjisconv['\u51a4'] = '\u0099l';
sjisconv['\u51a5'] = '\u0096\u00bb';
sjisconv['\u51a6'] = '\u0099m';
sjisconv['\u51a8'] = '\u0095y';
sjisconv['\u51a9'] = '\u0099o';
sjisconv['\u51aa'] = '\u0099p';
sjisconv['\u51ab'] = '\u0099q';
sjisconv['\u51ac'] = '\u0093~';
sjisconv['\u51b0'] = '\u0099u';
sjisconv['\u51b1'] = '\u0099s';
sjisconv['\u51b2'] = '\u0099t';
sjisconv['\u51b3'] = '\u0099r';
sjisconv['\u51b4'] = '\u008d\u00e1';
sjisconv['\u51b5'] = '\u0099v';
sjisconv['\u51b6'] = '\u0096\u00e8';
sjisconv['\u51b7'] = '\u0097\u00e2';
sjisconv['\u51bd'] = '\u0099w';
sjisconv['\u51c4'] = '\u0090\u00a6';
sjisconv['\u51c5'] = '\u0099x';
sjisconv['\u51c6'] = '\u008fy';
sjisconv['\u51c9'] = '\u0099y';
sjisconv['\u51cb'] = '\u0092\u009c';
sjisconv['\u51cc'] = '\u0097\u00bd';
sjisconv['\u51cd'] = '\u0093\u0080';
sjisconv['\u51d6'] = '\u0099\u00c3';
sjisconv['\u51db'] = '\u0099z';
sjisconv['\u51dc'] = '\u00ea\u00a3';
sjisconv['\u51dd'] = '\u008b\u00c3';
sjisconv['\u51e0'] = '\u0099{';
sjisconv['\u51e1'] = '\u0096}';
sjisconv['\u51e6'] = '\u008f\u0088';
sjisconv['\u51e7'] = '\u0091\u00fa';
sjisconv['\u51e9'] = '\u0099}';
sjisconv['\u51ea'] = '\u0093\u00e2';
sjisconv['\u51ed'] = '\u0099~';
sjisconv['\u51f0'] = '\u0099\u0080';
sjisconv['\u51f1'] = '\u008aM';
sjisconv['\u51f5'] = '\u0099\u0081';
sjisconv['\u51f6'] = '\u008b\u00a5';
sjisconv['\u51f8'] = '\u0093\u00ca';
sjisconv['\u51f9'] = '\u0089\u009a';
sjisconv['\u51fa'] = '\u008fo';
sjisconv['\u51fd'] = '\u0094\u009f';
sjisconv['\u51fe'] = '\u0099\u0082';
sjisconv['\u5200'] = '\u0093\u0081';
sjisconv['\u5203'] = '\u0090n';
sjisconv['\u5204'] = '\u0099\u0083';
sjisconv['\u5206'] = '\u0095\u00aa';
sjisconv['\u5207'] = '\u0090\u00d8';
sjisconv['\u5208'] = '\u008a\u00a0';
sjisconv['\u520a'] = '\u008a\u00a7';
sjisconv['\u520b'] = '\u0099\u0084';
sjisconv['\u520e'] = '\u0099\u0086';
sjisconv['\u5211'] = '\u008cY';
sjisconv['\u5214'] = '\u0099\u0085';
sjisconv['\u5217'] = '\u0097\u00f1';
sjisconv['\u521d'] = '\u008f\u0089';
sjisconv['\u5224'] = '\u0094\u00bb';
sjisconv['\u5225'] = '\u0095\u00ca';
sjisconv['\u5227'] = '\u0099\u0087';
sjisconv['\u5229'] = '\u0097\u0098';
sjisconv['\u522a'] = '\u0099\u0088';
sjisconv['\u522e'] = '\u0099\u0089';
sjisconv['\u5230'] = '\u0093\u009e';
sjisconv['\u5233'] = '\u0099\u008a';
sjisconv['\u5236'] = '\u0090\u00a7';
sjisconv['\u5237'] = '\u008d\u00fc';
sjisconv['\u5238'] = '\u008c\u0094';
sjisconv['\u5239'] = '\u0099\u008b';
sjisconv['\u523a'] = '\u008eh';
sjisconv['\u523b'] = '\u008d\u008f';
sjisconv['\u5243'] = '\u0092\u00e4';
sjisconv['\u5244'] = '\u0099\u008d';
sjisconv['\u5247'] = '\u0091\u00a5';
sjisconv['\u524a'] = '\u008d\u00ed';
sjisconv['\u524b'] = '\u0099\u008e';
sjisconv['\u524c'] = '\u0099\u008f';
sjisconv['\u524d'] = '\u0091O';
sjisconv['\u524f'] = '\u0099\u008c';
sjisconv['\u5254'] = '\u0099\u0091';
sjisconv['\u5256'] = '\u0096U';
sjisconv['\u525b'] = '\u008d\u0084';
sjisconv['\u525e'] = '\u0099\u0090';
sjisconv['\u5263'] = '\u008c\u0095';
sjisconv['\u5264'] = '\u008d\u00dc';
sjisconv['\u5265'] = '\u0094\u008d';
sjisconv['\u5269'] = '\u0099\u0094';
sjisconv['\u526a'] = '\u0099\u0092';
sjisconv['\u526f'] = '\u0095\u009b';
sjisconv['\u5270'] = '\u008f\u00e8';
sjisconv['\u5271'] = '\u0099\u009b';
sjisconv['\u5272'] = '\u008a\u0084';
sjisconv['\u5273'] = '\u0099\u0095';
sjisconv['\u5274'] = '\u0099\u0093';
sjisconv['\u5275'] = '\u0091n';
sjisconv['\u527d'] = '\u0099\u0097';
sjisconv['\u527f'] = '\u0099\u0096';
sjisconv['\u5283'] = '\u008ac';
sjisconv['\u5287'] = '\u008c\u0080';
sjisconv['\u5288'] = '\u0099\u009c';
sjisconv['\u5289'] = '\u0097\u00ab';
sjisconv['\u528d'] = '\u0099\u0098';
sjisconv['\u5291'] = '\u0099\u009d';
sjisconv['\u5292'] = '\u0099\u009a';
sjisconv['\u5294'] = '\u0099\u0099';
sjisconv['\u529b'] = '\u0097\u00cd';
sjisconv['\u529f'] = '\u008c\u00f7';
sjisconv['\u52a0'] = '\u0089\u00c1';
sjisconv['\u52a3'] = '\u0097\u00f2';
sjisconv['\u52a9'] = '\u008f\u0095';
sjisconv['\u52aa'] = '\u0093w';
sjisconv['\u52ab'] = '\u008d\u0085';
sjisconv['\u52ac'] = '\u0099\u00a0';
sjisconv['\u52ad'] = '\u0099\u00a1';
sjisconv['\u52b1'] = '\u0097\u00e3';
sjisconv['\u52b4'] = '\u0098J';
sjisconv['\u52b5'] = '\u0099\u00a3';
sjisconv['\u52b9'] = '\u008c\u00f8';
sjisconv['\u52bc'] = '\u0099\u00a2';
sjisconv['\u52be'] = '\u008aN';
sjisconv['\u52c1'] = '\u0099\u00a4';
sjisconv['\u52c3'] = '\u0096u';
sjisconv['\u52c5'] = '\u0092\u00ba';
sjisconv['\u52c7'] = '\u0097E';
sjisconv['\u52c9'] = '\u0095\u00d7';
sjisconv['\u52cd'] = '\u0099\u00a5';
sjisconv['\u52d2'] = '\u00e8\u00d3';
sjisconv['\u52d5'] = '\u0093\u00ae';
sjisconv['\u52d7'] = '\u0099\u00a6';
sjisconv['\u52d8'] = '\u008a\u00a8';
sjisconv['\u52d9'] = '\u0096\u00b1';
sjisconv['\u52dd'] = '\u008f\u009f';
sjisconv['\u52de'] = '\u0099\u00a7';
sjisconv['\u52df'] = '\u0095\u00e5';
sjisconv['\u52e0'] = '\u0099\u00ab';
sjisconv['\u52e2'] = '\u0090\u00a8';
sjisconv['\u52e3'] = '\u0099\u00a8';
sjisconv['\u52e4'] = '\u008b\u00ce';
sjisconv['\u52e6'] = '\u0099\u00a9';
sjisconv['\u52e7'] = '\u008a\u00a9';
sjisconv['\u52f2'] = '\u008cM';
sjisconv['\u52f3'] = '\u0099\u00ac';
sjisconv['\u52f5'] = '\u0099\u00ad';
sjisconv['\u52f8'] = '\u0099\u00ae';
sjisconv['\u52f9'] = '\u0099\u00af';
sjisconv['\u52fa'] = '\u008e\u00d9';
sjisconv['\u52fe'] = '\u008c\u00f9';
sjisconv['\u52ff'] = '\u0096\u00dc';
sjisconv['\u5301'] = '\u0096\u00e6';
sjisconv['\u5302'] = '\u0093\u00f5';
sjisconv['\u5305'] = '\u0095\u00ef';
sjisconv['\u5306'] = '\u0099\u00b0';
sjisconv['\u5308'] = '\u0099\u00b1';
sjisconv['\u530d'] = '\u0099\u00b3';
sjisconv['\u530f'] = '\u0099\u00b5';
sjisconv['\u5310'] = '\u0099\u00b4';
sjisconv['\u5315'] = '\u0099\u00b6';
sjisconv['\u5316'] = '\u0089\u00bb';
sjisconv['\u5317'] = '\u0096k';
sjisconv['\u5319'] = '\u008d\u00fa';
sjisconv['\u531a'] = '\u0099\u00b7';
sjisconv['\u531d'] = '\u0091x';
sjisconv['\u5320'] = '\u008f\u00a0';
sjisconv['\u5321'] = '\u008b\u00a7';
sjisconv['\u5323'] = '\u0099\u00b8';
sjisconv['\u532a'] = '\u0094\u00d9';
sjisconv['\u532f'] = '\u0099\u00b9';
sjisconv['\u5331'] = '\u0099\u00ba';
sjisconv['\u5333'] = '\u0099\u00bb';
sjisconv['\u5338'] = '\u0099\u00bc';
sjisconv['\u5339'] = '\u0095C';
sjisconv['\u533a'] = '\u008b\u00e6';
sjisconv['\u533b'] = '\u0088\u00e3';
sjisconv['\u533f'] = '\u0093\u00bd';
sjisconv['\u5340'] = '\u0099\u00bd';
sjisconv['\u5341'] = '\u008f\\';
sjisconv['\u5343'] = '\u0090\u00e7';
sjisconv['\u5345'] = '\u0099\u00bf';
sjisconv['\u5346'] = '\u0099\u00be';
sjisconv['\u5347'] = '\u008f\u00a1';
sjisconv['\u5348'] = '\u008c\u00df';
sjisconv['\u5349'] = '\u0099\u00c1';
sjisconv['\u534a'] = '\u0094\u00bc';
sjisconv['\u534d'] = '\u0099\u00c2';
sjisconv['\u5351'] = '\u0094\u00da';
sjisconv['\u5352'] = '\u0091\u00b2';
sjisconv['\u5353'] = '\u0091\u00ec';
sjisconv['\u5354'] = '\u008b\u00a6';
sjisconv['\u5357'] = '\u0093\u00ec';
sjisconv['\u5358'] = '\u0092P';
sjisconv['\u535a'] = '\u0094\u008e';
sjisconv['\u535c'] = '\u0096m';
sjisconv['\u535e'] = '\u0099\u00c4';
sjisconv['\u5360'] = '\u0090\u00e8';
sjisconv['\u5366'] = '\u008cT';
sjisconv['\u5369'] = '\u0099\u00c5';
sjisconv['\u536e'] = '\u0099\u00c6';
sjisconv['\u536f'] = '\u0089K';
sjisconv['\u5370'] = '\u0088\u00f3';
sjisconv['\u5371'] = '\u008a\u00eb';
sjisconv['\u5373'] = '\u0091\u00a6';
sjisconv['\u5374'] = '\u008bp';
sjisconv['\u5375'] = '\u0097\u0091';
sjisconv['\u5377'] = '\u0099\u00c9';
sjisconv['\u5378'] = '\u0089\u00b5';
sjisconv['\u537b'] = '\u0099\u00c8';
sjisconv['\u537f'] = '\u008b\u00a8';
sjisconv['\u5382'] = '\u0099\u00ca';
sjisconv['\u5384'] = '\u0096\u00ef';
sjisconv['\u5396'] = '\u0099\u00cb';
sjisconv['\u5398'] = '\u0097\u00d0';
sjisconv['\u539a'] = '\u008c\u00fa';
sjisconv['\u539f'] = '\u008c\u00b4';
sjisconv['\u53a0'] = '\u0099\u00cc';
sjisconv['\u53a5'] = '\u0099\u00ce';
sjisconv['\u53a6'] = '\u0099\u00cd';
sjisconv['\u53a8'] = '\u0090~';
sjisconv['\u53a9'] = '\u0089X';
sjisconv['\u53ad'] = '\u0089}';
sjisconv['\u53ae'] = '\u0099\u00cf';
sjisconv['\u53b0'] = '\u0099\u00d0';
sjisconv['\u53b3'] = '\u008c\u00b5';
sjisconv['\u53b6'] = '\u0099\u00d1';
sjisconv['\u53bb'] = '\u008b\u008e';
sjisconv['\u53c2'] = '\u008eQ';
sjisconv['\u53c3'] = '\u0099\u00d2';
sjisconv['\u53c8'] = '\u0096\u0094';
sjisconv['\u53c9'] = '\u008d\u00b3';
sjisconv['\u53ca'] = '\u008by';
sjisconv['\u53cb'] = '\u0097F';
sjisconv['\u53cc'] = '\u0091o';
sjisconv['\u53cd'] = '\u0094\u00bd';
sjisconv['\u53ce'] = '\u008e\u00fb';
sjisconv['\u53d4'] = '\u008ff';
sjisconv['\u53d6'] = '\u008e\u00e6';
sjisconv['\u53d7'] = '\u008e\u00f3';
sjisconv['\u53d9'] = '\u008f\u0096';
sjisconv['\u53db'] = '\u0094\u00be';
sjisconv['\u53df'] = '\u0099\u00d5';
sjisconv['\u53e1'] = '\u0089b';
sjisconv['\u53e2'] = '\u0091p';
sjisconv['\u53e3'] = '\u008c\u00fb';
sjisconv['\u53e4'] = '\u008c\u00c3';
sjisconv['\u53e5'] = '\u008b\u00e5';
sjisconv['\u53e8'] = '\u0099\u00d9';
sjisconv['\u53e9'] = '\u0092@';
sjisconv['\u53ea'] = '\u0091\u00fc';
sjisconv['\u53eb'] = '\u008b\u00a9';
sjisconv['\u53ec'] = '\u008f\u00a2';
sjisconv['\u53ed'] = '\u0099\u00da';
sjisconv['\u53ee'] = '\u0099\u00d8';
sjisconv['\u53ef'] = '\u0089\u00c2';
sjisconv['\u53f0'] = '\u0091\u00e4';
sjisconv['\u53f1'] = '\u008e\u00b6';
sjisconv['\u53f2'] = '\u008ej';
sjisconv['\u53f3'] = '\u0089E';
sjisconv['\u53f6'] = '\u008a\u0090';
sjisconv['\u53f7'] = '\u008d\u0086';
sjisconv['\u53f8'] = '\u008ei';
sjisconv['\u53fa'] = '\u0099\u00db';
sjisconv['\u5401'] = '\u0099\u00dc';
sjisconv['\u5403'] = '\u008bh';
sjisconv['\u5404'] = '\u008ae';
sjisconv['\u5408'] = '\u008d\u0087';
sjisconv['\u5409'] = '\u008bg';
sjisconv['\u540a'] = '\u0092\u00dd';
sjisconv['\u540b'] = '\u0089D';
sjisconv['\u540c'] = '\u0093\u00af';
sjisconv['\u540d'] = '\u0096\u00bc';
sjisconv['\u540e'] = '\u008d@';
sjisconv['\u540f'] = '\u0097\u0099';
sjisconv['\u5410'] = '\u0093f';
sjisconv['\u5411'] = '\u008c\u00fc';
sjisconv['\u541b'] = '\u008cN';
sjisconv['\u541d'] = '\u0099\u00e5';
sjisconv['\u541f'] = '\u008b\u00e1';
sjisconv['\u5420'] = '\u0096i';
sjisconv['\u5426'] = '\u0094\u00db';
sjisconv['\u5429'] = '\u0099\u00e4';
sjisconv['\u542b'] = '\u008a\u00dc';
sjisconv['\u542c'] = '\u0099\u00df';
sjisconv['\u542d'] = '\u0099\u00e0';
sjisconv['\u542e'] = '\u0099\u00e2';
sjisconv['\u5436'] = '\u0099\u00e3';
sjisconv['\u5438'] = '\u008bz';
sjisconv['\u5439'] = '\u0090\u0081';
sjisconv['\u543b'] = '\u0095\u00ab';
sjisconv['\u543c'] = '\u0099\u00e1';
sjisconv['\u543d'] = '\u0099\u00dd';
sjisconv['\u543e'] = '\u008c\u00e1';
sjisconv['\u5440'] = '\u0099\u00de';
sjisconv['\u5442'] = '\u0098C';
sjisconv['\u5446'] = '\u0095\u00f0';
sjisconv['\u5448'] = '\u0092\u00e6';
sjisconv['\u5449'] = '\u008c\u00e0';
sjisconv['\u544a'] = '\u008d\u0090';
sjisconv['\u544e'] = '\u0099\u00e6';
sjisconv['\u5451'] = '\u0093\u00db';
sjisconv['\u545f'] = '\u0099\u00ea';
sjisconv['\u5468'] = '\u008e\u00fc';
sjisconv['\u546a'] = '\u008e\u00f4';
sjisconv['\u5470'] = '\u0099\u00ed';
sjisconv['\u5471'] = '\u0099\u00eb';
sjisconv['\u5473'] = '\u0096\u00a1';
sjisconv['\u5475'] = '\u0099\u00e8';
sjisconv['\u5476'] = '\u0099\u00f1';
sjisconv['\u5477'] = '\u0099\u00ec';
sjisconv['\u547b'] = '\u0099\u00ef';
sjisconv['\u547c'] = '\u008c\u00c4';
sjisconv['\u547d'] = '\u0096\u00bd';
sjisconv['\u5480'] = '\u0099\u00f0';
sjisconv['\u5484'] = '\u0099\u00f2';
sjisconv['\u5486'] = '\u0099\u00f4';
sjisconv['\u548b'] = '\u008d\u00ee';
sjisconv['\u548c'] = '\u0098a';
sjisconv['\u548e'] = '\u0099\u00e9';
sjisconv['\u548f'] = '\u0099\u00e7';
sjisconv['\u5490'] = '\u0099\u00f3';
sjisconv['\u5492'] = '\u0099\u00ee';
sjisconv['\u54a2'] = '\u0099\u00f6';
sjisconv['\u54a4'] = '\u009aB';
sjisconv['\u54a5'] = '\u0099\u00f8';
sjisconv['\u54a8'] = '\u0099\u00fc';
sjisconv['\u54ab'] = '\u009a@';
sjisconv['\u54ac'] = '\u0099\u00f9';
sjisconv['\u54af'] = '\u009a]';
sjisconv['\u54b2'] = '\u008d\u00e7';
sjisconv['\u54b3'] = '\u008aP';
sjisconv['\u54b8'] = '\u0099\u00f7';
sjisconv['\u54bc'] = '\u009aD';
sjisconv['\u54bd'] = '\u0088\u00f4';
sjisconv['\u54be'] = '\u009aC';
sjisconv['\u54c0'] = '\u0088\u00a3';
sjisconv['\u54c1'] = '\u0095i';
sjisconv['\u54c2'] = '\u009aA';
sjisconv['\u54c4'] = '\u0099\u00fa';
sjisconv['\u54c7'] = '\u0099\u00f5';
sjisconv['\u54c8'] = '\u0099\u00fb';
sjisconv['\u54c9'] = '\u008d\u00c6';
sjisconv['\u54d8'] = '\u009aE';
sjisconv['\u54e1'] = '\u0088\u00f5';
sjisconv['\u54e2'] = '\u009aN';
sjisconv['\u54e5'] = '\u009aF';
sjisconv['\u54e6'] = '\u009aG';
sjisconv['\u54e8'] = '\u008f\u00a3';
sjisconv['\u54e9'] = '\u0096\u0089';
sjisconv['\u54ed'] = '\u009aL';
sjisconv['\u54ee'] = '\u009aK';
sjisconv['\u54f2'] = '\u0093N';
sjisconv['\u54fa'] = '\u009aM';
sjisconv['\u54fd'] = '\u009aJ';
sjisconv['\u5504'] = '\u0089S';
sjisconv['\u5506'] = '\u008d\u00b4';
sjisconv['\u5507'] = '\u0090O';
sjisconv['\u550f'] = '\u009aH';
sjisconv['\u5510'] = '\u0093\u0082';
sjisconv['\u5514'] = '\u009aI';
sjisconv['\u5516'] = '\u0088\u00a0';
sjisconv['\u552e'] = '\u009aS';
sjisconv['\u552f'] = '\u0097B';
sjisconv['\u5531'] = '\u008f\u00a5';
sjisconv['\u5533'] = '\u009aY';
sjisconv['\u5538'] = '\u009aX';
sjisconv['\u5539'] = '\u009aO';
sjisconv['\u553e'] = '\u0091\u00c1';
sjisconv['\u5540'] = '\u009aP';
sjisconv['\u5544'] = '\u0091\u00ed';
sjisconv['\u5545'] = '\u009aU';
sjisconv['\u5546'] = '\u008f\u00a4';
sjisconv['\u554c'] = '\u009aR';
sjisconv['\u554f'] = '\u0096\u00e2';
sjisconv['\u5553'] = '\u008c[';
sjisconv['\u5556'] = '\u009aV';
sjisconv['\u5557'] = '\u009aW';
sjisconv['\u555c'] = '\u009aT';
sjisconv['\u555d'] = '\u009aZ';
sjisconv['\u5563'] = '\u009aQ';
sjisconv['\u557b'] = '\u009a`';
sjisconv['\u557c'] = '\u009ae';
sjisconv['\u557e'] = '\u009aa';
sjisconv['\u5580'] = '\u009a\\';
sjisconv['\u5583'] = '\u009af';
sjisconv['\u5584'] = '\u0091P';
sjisconv['\u5587'] = '\u009ah';
sjisconv['\u5589'] = '\u008dA';
sjisconv['\u558a'] = '\u009a^';
sjisconv['\u558b'] = '\u0092\u009d';
sjisconv['\u5598'] = '\u009ab';
sjisconv['\u5599'] = '\u009a[';
sjisconv['\u559a'] = '\u008a\u00ab';
sjisconv['\u559c'] = '\u008a\u00ec';
sjisconv['\u559d'] = '\u008a\u0085';
sjisconv['\u559e'] = '\u009ac';
sjisconv['\u559f'] = '\u009a_';
sjisconv['\u55a7'] = '\u008c\u0096';
sjisconv['\u55a8'] = '\u009ai';
sjisconv['\u55a9'] = '\u009ag';
sjisconv['\u55aa'] = '\u0091r';
sjisconv['\u55ab'] = '\u008bi';
sjisconv['\u55ac'] = '\u008b\u00aa';
sjisconv['\u55ae'] = '\u009ad';
sjisconv['\u55b0'] = '\u008b\u00f2';
sjisconv['\u55b6'] = '\u0089c';
sjisconv['\u55c4'] = '\u009am';
sjisconv['\u55c5'] = '\u009ak';
sjisconv['\u55c7'] = '\u009a\u00a5';
sjisconv['\u55d4'] = '\u009ap';
sjisconv['\u55da'] = '\u009aj';
sjisconv['\u55dc'] = '\u009an';
sjisconv['\u55df'] = '\u009al';
sjisconv['\u55e3'] = '\u008ek';
sjisconv['\u55e4'] = '\u009ao';
sjisconv['\u55f7'] = '\u009ar';
sjisconv['\u55f9'] = '\u009aw';
sjisconv['\u55fd'] = '\u009au';
sjisconv['\u55fe'] = '\u009at';
sjisconv['\u5606'] = '\u0092Q';
sjisconv['\u5609'] = '\u0089\u00c3';
sjisconv['\u5614'] = '\u009aq';
sjisconv['\u5616'] = '\u009as';
sjisconv['\u5617'] = '\u008f\u00a6';
sjisconv['\u5618'] = '\u0089R';
sjisconv['\u561b'] = '\u009av';
sjisconv['\u5629'] = '\u0089\u00dc';
sjisconv['\u562f'] = '\u009a\u0082';
sjisconv['\u5631'] = '\u008f\u00fa';
sjisconv['\u5632'] = '\u009a}';
sjisconv['\u5634'] = '\u009a{';
sjisconv['\u5636'] = '\u009a|';
sjisconv['\u5638'] = '\u009a~';
sjisconv['\u5642'] = '\u0089\\';
sjisconv['\u564c'] = '\u0091X';
sjisconv['\u564e'] = '\u009ax';
sjisconv['\u5650'] = '\u009ay';
sjisconv['\u565b'] = '\u008a\u009a';
sjisconv['\u5664'] = '\u009a\u0081';
sjisconv['\u5668'] = '\u008a\u00ed';
sjisconv['\u566a'] = '\u009a\u0084';
sjisconv['\u566b'] = '\u009a\u0080';
sjisconv['\u566c'] = '\u009a\u0083';
sjisconv['\u5674'] = '\u0095\u00ac';
sjisconv['\u5678'] = '\u0093\u00d3';
sjisconv['\u567a'] = '\u0094\u00b6';
sjisconv['\u5680'] = '\u009a\u0086';
sjisconv['\u5686'] = '\u009a\u0085';
sjisconv['\u5687'] = '\u008ad';
sjisconv['\u568a'] = '\u009a\u0087';
sjisconv['\u568f'] = '\u009a\u008a';
sjisconv['\u5694'] = '\u009a\u0089';
sjisconv['\u56a0'] = '\u009a\u0088';
sjisconv['\u56a2'] = '\u0094X';
sjisconv['\u56a5'] = '\u009a\u008b';
sjisconv['\u56ae'] = '\u009a\u008c';
sjisconv['\u56b4'] = '\u009a\u008e';
sjisconv['\u56b6'] = '\u009a\u008d';
sjisconv['\u56bc'] = '\u009a\u0090';
sjisconv['\u56c0'] = '\u009a\u0093';
sjisconv['\u56c1'] = '\u009a\u0091';
sjisconv['\u56c2'] = '\u009a\u008f';
sjisconv['\u56c3'] = '\u009a\u0092';
sjisconv['\u56c8'] = '\u009a\u0094';
sjisconv['\u56ce'] = '\u009a\u0095';
sjisconv['\u56d1'] = '\u009a\u0096';
sjisconv['\u56d3'] = '\u009a\u0097';
sjisconv['\u56d7'] = '\u009a\u0098';
sjisconv['\u56d8'] = '\u0099d';
sjisconv['\u56da'] = '\u008e\u00fa';
sjisconv['\u56db'] = '\u008el';
sjisconv['\u56de'] = '\u0089\u00f1';
sjisconv['\u56e0'] = '\u0088\u00f6';
sjisconv['\u56e3'] = '\u0092c';
sjisconv['\u56ee'] = '\u009a\u0099';
sjisconv['\u56f0'] = '\u008d\u00a2';
sjisconv['\u56f2'] = '\u0088\u00cd';
sjisconv['\u56f3'] = '\u0090}';
sjisconv['\u56f9'] = '\u009a\u009a';
sjisconv['\u56fa'] = '\u008c\u00c5';
sjisconv['\u56fd'] = '\u008d\u0091';
sjisconv['\u56ff'] = '\u009a\u009c';
sjisconv['\u5700'] = '\u009a\u009b';
sjisconv['\u5703'] = '\u0095\u00de';
sjisconv['\u5704'] = '\u009a\u009d';
sjisconv['\u5708'] = '\u009a\u009f';
sjisconv['\u5709'] = '\u009a\u009e';
sjisconv['\u570b'] = '\u009a\u00a0';
sjisconv['\u570d'] = '\u009a\u00a1';
sjisconv['\u570f'] = '\u008c\u0097';
sjisconv['\u5712'] = '\u0089\u0080';
sjisconv['\u5713'] = '\u009a\u00a2';
sjisconv['\u5716'] = '\u009a\u00a4';
sjisconv['\u5718'] = '\u009a\u00a3';
sjisconv['\u571c'] = '\u009a\u00a6';
sjisconv['\u571f'] = '\u0093y';
sjisconv['\u5726'] = '\u009a\u00a7';
sjisconv['\u5727'] = '\u0088\u00b3';
sjisconv['\u5728'] = '\u008d\u00dd';
sjisconv['\u572d'] = '\u008c\\';
sjisconv['\u5730'] = '\u0092n';
sjisconv['\u5737'] = '\u009a\u00a8';
sjisconv['\u5738'] = '\u009a\u00a9';
sjisconv['\u573b'] = '\u009a\u00ab';
sjisconv['\u5740'] = '\u009a\u00ac';
sjisconv['\u5742'] = '\u008d\u00e2';
sjisconv['\u5747'] = '\u008b\u00cf';
sjisconv['\u574a'] = '\u0096V';
sjisconv['\u574e'] = '\u009a\u00aa';
sjisconv['\u574f'] = '\u009a\u00ad';
sjisconv['\u5750'] = '\u008d\u00bf';
sjisconv['\u5751'] = '\u008dB';
sjisconv['\u5761'] = '\u009a\u00b1';
sjisconv['\u5764'] = '\u008d\u00a3';
sjisconv['\u5766'] = '\u0092R';
sjisconv['\u5769'] = '\u009a\u00ae';
sjisconv['\u576a'] = '\u0092\u00d8';
sjisconv['\u577f'] = '\u009a\u00b2';
sjisconv['\u5782'] = '\u0090\u0082';
sjisconv['\u5788'] = '\u009a\u00b0';
sjisconv['\u5789'] = '\u009a\u00b3';
sjisconv['\u578b'] = '\u008c^';
sjisconv['\u5793'] = '\u009a\u00b4';
sjisconv['\u57a0'] = '\u009a\u00b5';
sjisconv['\u57a2'] = '\u008dC';
sjisconv['\u57a3'] = '\u008a_';
sjisconv['\u57a4'] = '\u009a\u00b7';
sjisconv['\u57aa'] = '\u009a\u00b8';
sjisconv['\u57b0'] = '\u009a\u00b9';
sjisconv['\u57b3'] = '\u009a\u00b6';
sjisconv['\u57c0'] = '\u009a\u00af';
sjisconv['\u57c3'] = '\u009a\u00ba';
sjisconv['\u57c6'] = '\u009a\u00bb';
sjisconv['\u57cb'] = '\u0096\u0084';
sjisconv['\u57ce'] = '\u008f\u00e9';
sjisconv['\u57d2'] = '\u009a\u00bd';
sjisconv['\u57d3'] = '\u009a\u00be';
sjisconv['\u57d4'] = '\u009a\u00bc';
sjisconv['\u57d6'] = '\u009a\u00c0';
sjisconv['\u57dc'] = '\u0094W';
sjisconv['\u57df'] = '\u0088\u00e6';
sjisconv['\u57e0'] = '\u0095u';
sjisconv['\u57e3'] = '\u009a\u00c1';
sjisconv['\u57f4'] = '\u008f\u00fb';
sjisconv['\u57f7'] = '\u008e\u00b7';
sjisconv['\u57f9'] = '\u0094|';
sjisconv['\u57fa'] = '\u008a\u00ee';
sjisconv['\u57fc'] = '\u008d\u00e9';
sjisconv['\u5800'] = '\u0096x';
sjisconv['\u5802'] = '\u0093\u00b0';
sjisconv['\u5805'] = '\u008c\u0098';
sjisconv['\u5806'] = '\u0091\u00cd';
sjisconv['\u580a'] = '\u009a\u00bf';
sjisconv['\u580b'] = '\u009a\u00c2';
sjisconv['\u5815'] = '\u0091\u00c2';
sjisconv['\u5819'] = '\u009a\u00c3';
sjisconv['\u581d'] = '\u009a\u00c4';
sjisconv['\u5821'] = '\u009a\u00c6';
sjisconv['\u5824'] = '\u0092\u00e7';
sjisconv['\u582a'] = '\u008a\u00ac';
sjisconv['\u582f'] = '\u00ea\u009f';
sjisconv['\u5830'] = '\u0089\u0081';
sjisconv['\u5831'] = '\u0095\u00f1';
sjisconv['\u5834'] = '\u008f\u00ea';
sjisconv['\u5835'] = '\u0093g';
sjisconv['\u583a'] = '\u008d\u00e4';
sjisconv['\u583d'] = '\u009a\u00cc';
sjisconv['\u5840'] = '\u0095\u00bb';
sjisconv['\u5841'] = '\u0097\u00db';
sjisconv['\u584a'] = '\u0089\u00f2';
sjisconv['\u584b'] = '\u009a\u00c8';
sjisconv['\u5851'] = '\u0091Y';
sjisconv['\u5852'] = '\u009a\u00cb';
sjisconv['\u5854'] = '\u0093\u0083';
sjisconv['\u5857'] = '\u0093h';
sjisconv['\u5858'] = '\u0093\u0084';
sjisconv['\u5859'] = '\u0094\u00b7';
sjisconv['\u585a'] = '\u0092\u00cb';
sjisconv['\u585e'] = '\u008d\u00c7';
sjisconv['\u5862'] = '\u009a\u00c7';
sjisconv['\u5869'] = '\u0089\u0096';
sjisconv['\u586b'] = '\u0093U';
sjisconv['\u5870'] = '\u009a\u00c9';
sjisconv['\u5872'] = '\u009a\u00c5';
sjisconv['\u5875'] = '\u0090o';
sjisconv['\u5879'] = '\u009a\u00cd';
sjisconv['\u587e'] = '\u008fm';
sjisconv['\u5883'] = '\u008b\u00ab';
sjisconv['\u5885'] = '\u009a\u00ce';
sjisconv['\u5893'] = '\u0095\u00e6';
sjisconv['\u5897'] = '\u0091\u009d';
sjisconv['\u589c'] = '\u0092\u00c4';
sjisconv['\u589f'] = '\u009a\u00d0';
sjisconv['\u58a8'] = '\u0096n';
sjisconv['\u58ab'] = '\u009a\u00d1';
sjisconv['\u58ae'] = '\u009a\u00d6';
sjisconv['\u58b3'] = '\u0095\u00ad';
sjisconv['\u58b8'] = '\u009a\u00d5';
sjisconv['\u58b9'] = '\u009a\u00cf';
sjisconv['\u58ba'] = '\u009a\u00d2';
sjisconv['\u58bb'] = '\u009a\u00d4';
sjisconv['\u58be'] = '\u008d\u00a4';
sjisconv['\u58c1'] = '\u0095\u00c7';
sjisconv['\u58c5'] = '\u009a\u00d7';
sjisconv['\u58c7'] = '\u0092d';
sjisconv['\u58ca'] = '\u0089\u00f3';
sjisconv['\u58cc'] = '\u008f\u00eb';
sjisconv['\u58d1'] = '\u009a\u00d9';
sjisconv['\u58d3'] = '\u009a\u00d8';
sjisconv['\u58d5'] = '\u008d\u0088';
sjisconv['\u58d7'] = '\u009a\u00da';
sjisconv['\u58d8'] = '\u009a\u00dc';
sjisconv['\u58d9'] = '\u009a\u00db';
sjisconv['\u58dc'] = '\u009a\u00de';
sjisconv['\u58de'] = '\u009a\u00d3';
sjisconv['\u58df'] = '\u009a\u00e0';
sjisconv['\u58e4'] = '\u009a\u00df';
sjisconv['\u58e5'] = '\u009a\u00dd';
sjisconv['\u58eb'] = '\u008em';
sjisconv['\u58ec'] = '\u0090p';
sjisconv['\u58ee'] = '\u0091s';
sjisconv['\u58ef'] = '\u009a\u00e1';
sjisconv['\u58f0'] = '\u0090\u00ba';
sjisconv['\u58f1'] = '\u0088\u00eb';
sjisconv['\u58f2'] = '\u0094\u0084';
sjisconv['\u58f7'] = '\u0092\u00d9';
sjisconv['\u58f9'] = '\u009a\u00e3';
sjisconv['\u58fa'] = '\u009a\u00e2';
sjisconv['\u58fb'] = '\u009a\u00e4';
sjisconv['\u58fc'] = '\u009a\u00e5';
sjisconv['\u58fd'] = '\u009a\u00e6';
sjisconv['\u5902'] = '\u009a\u00e7';
sjisconv['\u5909'] = '\u0095\u00cf';
sjisconv['\u590a'] = '\u009a\u00e8';
sjisconv['\u590f'] = '\u0089\u00c4';
sjisconv['\u5910'] = '\u009a\u00e9';
sjisconv['\u5915'] = '\u0097[';
sjisconv['\u5916'] = '\u008aO';
sjisconv['\u5918'] = '\u0099\u00c7';
sjisconv['\u5919'] = '\u008fg';
sjisconv['\u591a'] = '\u0091\u00bd';
sjisconv['\u591b'] = '\u009a\u00ea';
sjisconv['\u591c'] = '\u0096\u00e9';
sjisconv['\u5922'] = '\u0096\u00b2';
sjisconv['\u5925'] = '\u009a\u00ec';
sjisconv['\u5927'] = '\u0091\u00e5';
sjisconv['\u5929'] = '\u0093V';
sjisconv['\u592a'] = '\u0091\u00be';
sjisconv['\u592b'] = '\u0095v';
sjisconv['\u592c'] = '\u009a\u00ed';
sjisconv['\u592d'] = '\u009a\u00ee';
sjisconv['\u592e'] = '\u0089\u009b';
sjisconv['\u5931'] = '\u008e\u00b8';
sjisconv['\u5932'] = '\u009a\u00ef';
sjisconv['\u5937'] = '\u0088\u00ce';
sjisconv['\u5938'] = '\u009a\u00f0';
sjisconv['\u593e'] = '\u009a\u00f1';
sjisconv['\u5944'] = '\u0089\u0082';
sjisconv['\u5947'] = '\u008a\u00ef';
sjisconv['\u5948'] = '\u0093\u00de';
sjisconv['\u5949'] = '\u0095\u00f2';
sjisconv['\u594e'] = '\u009a\u00f5';
sjisconv['\u594f'] = '\u0091t';
sjisconv['\u5950'] = '\u009a\u00f4';
sjisconv['\u5951'] = '\u008c_';
sjisconv['\u5954'] = '\u0096z';
sjisconv['\u5955'] = '\u009a\u00f3';
sjisconv['\u5957'] = '\u0093\u0085';
sjisconv['\u5958'] = '\u009a\u00f7';
sjisconv['\u595a'] = '\u009a\u00f6';
sjisconv['\u5960'] = '\u009a\u00f9';
sjisconv['\u5962'] = '\u009a\u00f8';
sjisconv['\u5965'] = '\u0089\u009c';
sjisconv['\u5967'] = '\u009a\u00fa';
sjisconv['\u5968'] = '\u008f\u00a7';
sjisconv['\u5969'] = '\u009a\u00fc';
sjisconv['\u596a'] = '\u0092D';
sjisconv['\u596c'] = '\u009a\u00fb';
sjisconv['\u596e'] = '\u0095\u00b1';
sjisconv['\u5973'] = '\u008f\u0097';
sjisconv['\u5974'] = '\u0093z';
sjisconv['\u5978'] = '\u009b@';
sjisconv['\u597d'] = '\u008dD';
sjisconv['\u5981'] = '\u009bA';
sjisconv['\u5982'] = '\u0094@';
sjisconv['\u5983'] = '\u0094\u00dc';
sjisconv['\u5984'] = '\u0096\u00cf';
sjisconv['\u598a'] = '\u0094D';
sjisconv['\u598d'] = '\u009bJ';
sjisconv['\u5993'] = '\u008bW';
sjisconv['\u5996'] = '\u0097d';
sjisconv['\u5999'] = '\u0096\u00ad';
sjisconv['\u599b'] = '\u009b\u00aa';
sjisconv['\u599d'] = '\u009bB';
sjisconv['\u59a3'] = '\u009bE';
sjisconv['\u59a5'] = '\u0091\u00c3';
sjisconv['\u59a8'] = '\u0096W';
sjisconv['\u59ac'] = '\u0093i';
sjisconv['\u59b2'] = '\u009bF';
sjisconv['\u59b9'] = '\u0096\u0085';
sjisconv['\u59bb'] = '\u008d\u00c8';
sjisconv['\u59be'] = '\u008f\u00a8';
sjisconv['\u59c6'] = '\u009bG';
sjisconv['\u59c9'] = '\u008eo';
sjisconv['\u59cb'] = '\u008en';
sjisconv['\u59d0'] = '\u0088\u00b7';
sjisconv['\u59d1'] = '\u008c\u00c6';
sjisconv['\u59d3'] = '\u0090\u00a9';
sjisconv['\u59d4'] = '\u0088\u00cf';
sjisconv['\u59d9'] = '\u009bK';
sjisconv['\u59da'] = '\u009bL';
sjisconv['\u59dc'] = '\u009bI';
sjisconv['\u59e5'] = '\u0089W';
sjisconv['\u59e6'] = '\u008a\u00ad';
sjisconv['\u59e8'] = '\u009bH';
sjisconv['\u59ea'] = '\u0096\u00c3';
sjisconv['\u59eb'] = '\u0095P';
sjisconv['\u59f6'] = '\u0088\u00a6';
sjisconv['\u59fb'] = '\u0088\u00f7';
sjisconv['\u59ff'] = '\u008ep';
sjisconv['\u5a01'] = '\u0088\u00d0';
sjisconv['\u5a03'] = '\u0088\u00a1';
sjisconv['\u5a09'] = '\u009bQ';
sjisconv['\u5a11'] = '\u009bO';
sjisconv['\u5a18'] = '\u0096\u00ba';
sjisconv['\u5a1a'] = '\u009bR';
sjisconv['\u5a1c'] = '\u009bP';
sjisconv['\u5a1f'] = '\u009bN';
sjisconv['\u5a20'] = '\u0090P';
sjisconv['\u5a25'] = '\u009bM';
sjisconv['\u5a29'] = '\u0095\u00d8';
sjisconv['\u5a2f'] = '\u008c\u00e2';
sjisconv['\u5a35'] = '\u009bV';
sjisconv['\u5a36'] = '\u009bW';
sjisconv['\u5a3c'] = '\u008f\u00a9';
sjisconv['\u5a40'] = '\u009bS';
sjisconv['\u5a41'] = '\u0098K';
sjisconv['\u5a46'] = '\u0094k';
sjisconv['\u5a49'] = '\u009bU';
sjisconv['\u5a5a'] = '\u008d\u00a5';
sjisconv['\u5a62'] = '\u009bX';
sjisconv['\u5a66'] = '\u0095w';
sjisconv['\u5a6a'] = '\u009bY';
sjisconv['\u5a6c'] = '\u009bT';
sjisconv['\u5a7f'] = '\u0096\u00b9';
sjisconv['\u5a92'] = '\u0094}';
sjisconv['\u5a9a'] = '\u009bZ';
sjisconv['\u5a9b'] = '\u0095Q';
sjisconv['\u5abc'] = '\u009b[';
sjisconv['\u5abd'] = '\u009b_';
sjisconv['\u5abe'] = '\u009b\\';
sjisconv['\u5ac1'] = '\u0089\u00c5';
sjisconv['\u5ac2'] = '\u009b^';
sjisconv['\u5ac9'] = '\u008e\u00b9';
sjisconv['\u5acb'] = '\u009b]';
sjisconv['\u5acc'] = '\u008c\u0099';
sjisconv['\u5ad0'] = '\u009bk';
sjisconv['\u5ad6'] = '\u009bd';
sjisconv['\u5ad7'] = '\u009ba';
sjisconv['\u5ae1'] = '\u0092\u0084';
sjisconv['\u5ae3'] = '\u009b`';
sjisconv['\u5ae6'] = '\u009bb';
sjisconv['\u5ae9'] = '\u009bc';
sjisconv['\u5afa'] = '\u009be';
sjisconv['\u5afb'] = '\u009bf';
sjisconv['\u5b09'] = '\u008a\u00f0';
sjisconv['\u5b0b'] = '\u009bh';
sjisconv['\u5b0c'] = '\u009bg';
sjisconv['\u5b16'] = '\u009bi';
sjisconv['\u5b22'] = '\u008f\u00ec';
sjisconv['\u5b2a'] = '\u009bl';
sjisconv['\u5b2c'] = '\u0092\u00da';
sjisconv['\u5b30'] = '\u0089d';
sjisconv['\u5b32'] = '\u009bj';
sjisconv['\u5b36'] = '\u009bm';
sjisconv['\u5b3e'] = '\u009bn';
sjisconv['\u5b40'] = '\u009bq';
sjisconv['\u5b43'] = '\u009bo';
sjisconv['\u5b45'] = '\u009bp';
sjisconv['\u5b50'] = '\u008eq';
sjisconv['\u5b51'] = '\u009br';
sjisconv['\u5b54'] = '\u008dE';
sjisconv['\u5b55'] = '\u009bs';
sjisconv['\u5b57'] = '\u008e\u009a';
sjisconv['\u5b58'] = '\u0091\u00b6';
sjisconv['\u5b5a'] = '\u009bt';
sjisconv['\u5b5b'] = '\u009bu';
sjisconv['\u5b5c'] = '\u008ey';
sjisconv['\u5b5d'] = '\u008dF';
sjisconv['\u5b5f'] = '\u0096\u00d0';
sjisconv['\u5b63'] = '\u008bG';
sjisconv['\u5b64'] = '\u008c\u00c7';
sjisconv['\u5b65'] = '\u009bv';
sjisconv['\u5b66'] = '\u008aw';
sjisconv['\u5b69'] = '\u009bw';
sjisconv['\u5b6b'] = '\u0091\u00b7';
sjisconv['\u5b70'] = '\u009bx';
sjisconv['\u5b71'] = '\u009b\u00a1';
sjisconv['\u5b73'] = '\u009by';
sjisconv['\u5b75'] = '\u009bz';
sjisconv['\u5b78'] = '\u009b{';
sjisconv['\u5b7a'] = '\u009b}';
sjisconv['\u5b80'] = '\u009b~';
sjisconv['\u5b83'] = '\u009b\u0080';
sjisconv['\u5b85'] = '\u0091\u00ee';
sjisconv['\u5b87'] = '\u0089F';
sjisconv['\u5b88'] = '\u008e\u00e7';
sjisconv['\u5b89'] = '\u0088\u00c0';
sjisconv['\u5b8b'] = '\u0091v';
sjisconv['\u5b8c'] = '\u008a\u00ae';
sjisconv['\u5b8d'] = '\u008e\u00b3';
sjisconv['\u5b8f'] = '\u008dG';
sjisconv['\u5b95'] = '\u0093\u0086';
sjisconv['\u5b97'] = '\u008f@';
sjisconv['\u5b98'] = '\u008a\u00af';
sjisconv['\u5b99'] = '\u0092\u0088';
sjisconv['\u5b9a'] = '\u0092\u00e8';
sjisconv['\u5b9b'] = '\u0088\u00b6';
sjisconv['\u5b9c'] = '\u008bX';
sjisconv['\u5b9d'] = '\u0095\u00f3';
sjisconv['\u5b9f'] = '\u008e\u00c0';
sjisconv['\u5ba2'] = '\u008bq';
sjisconv['\u5ba3'] = '\u0090\u00e9';
sjisconv['\u5ba4'] = '\u008e\u00ba';
sjisconv['\u5ba5'] = '\u0097G';
sjisconv['\u5ba6'] = '\u009b\u0081';
sjisconv['\u5bae'] = '\u008b{';
sjisconv['\u5bb0'] = '\u008d\u00c9';
sjisconv['\u5bb3'] = '\u008aQ';
sjisconv['\u5bb4'] = '\u0089\u0083';
sjisconv['\u5bb5'] = '\u008f\u00aa';
sjisconv['\u5bb6'] = '\u0089\u00c6';
sjisconv['\u5bb8'] = '\u009b\u0082';
sjisconv['\u5bb9'] = '\u0097e';
sjisconv['\u5bbf'] = '\u008fh';
sjisconv['\u5bc2'] = '\u008e\u00e2';
sjisconv['\u5bc3'] = '\u009b\u0083';
sjisconv['\u5bc4'] = '\u008a\u00f1';
sjisconv['\u5bc5'] = '\u0093\u00d0';
sjisconv['\u5bc6'] = '\u0096\u00a7';
sjisconv['\u5bc7'] = '\u009b\u0084';
sjisconv['\u5bc9'] = '\u009b\u0085';
sjisconv['\u5bcc'] = '\u0095x';
sjisconv['\u5bd0'] = '\u009b\u0087';
sjisconv['\u5bd2'] = '\u008a\u00a6';
sjisconv['\u5bd3'] = '\u008b\u00f5';
sjisconv['\u5bd4'] = '\u009b\u0086';
sjisconv['\u5bdb'] = '\u008a\u00b0';
sjisconv['\u5bdd'] = '\u0090Q';
sjisconv['\u5bde'] = '\u009b\u008b';
sjisconv['\u5bdf'] = '\u008e@';
sjisconv['\u5be1'] = '\u0089\u00c7';
sjisconv['\u5be2'] = '\u009b\u008a';
sjisconv['\u5be4'] = '\u009b\u0088';
sjisconv['\u5be5'] = '\u009b\u008c';
sjisconv['\u5be6'] = '\u009b\u0089';
sjisconv['\u5be7'] = '\u0094J';
sjisconv['\u5be8'] = '\u009e\u00cb';
sjisconv['\u5be9'] = '\u0090R';
sjisconv['\u5beb'] = '\u009b\u008d';
sjisconv['\u5bee'] = '\u0097\u00be';
sjisconv['\u5bf0'] = '\u009b\u008e';
sjisconv['\u5bf3'] = '\u009b\u0090';
sjisconv['\u5bf5'] = '\u0092\u009e';
sjisconv['\u5bf6'] = '\u009b\u008f';
sjisconv['\u5bf8'] = '\u0090\u00a1';
sjisconv['\u5bfa'] = '\u008e\u009b';
sjisconv['\u5bfe'] = '\u0091\u00ce';
sjisconv['\u5bff'] = '\u008e\u00f5';
sjisconv['\u5c01'] = '\u0095\u0095';
sjisconv['\u5c02'] = '\u0090\u00ea';
sjisconv['\u5c04'] = '\u008e\u00cb';
sjisconv['\u5c05'] = '\u009b\u0091';
sjisconv['\u5c06'] = '\u008f\u00ab';
sjisconv['\u5c07'] = '\u009b\u0092';
sjisconv['\u5c08'] = '\u009b\u0093';
sjisconv['\u5c09'] = '\u0088\u00d1';
sjisconv['\u5c0a'] = '\u0091\u00b8';
sjisconv['\u5c0b'] = '\u0090q';
sjisconv['\u5c0d'] = '\u009b\u0094';
sjisconv['\u5c0e'] = '\u0093\u00b1';
sjisconv['\u5c0f'] = '\u008f\u00ac';
sjisconv['\u5c11'] = '\u008f\u00ad';
sjisconv['\u5c13'] = '\u009b\u0095';
sjisconv['\u5c16'] = '\u0090\u00eb';
sjisconv['\u5c1a'] = '\u008f\u00ae';
sjisconv['\u5c20'] = '\u009b\u0096';
sjisconv['\u5c22'] = '\u009b\u0097';
sjisconv['\u5c24'] = '\u0096\u00de';
sjisconv['\u5c28'] = '\u009b\u0098';
sjisconv['\u5c2d'] = '\u008b\u00c4';
sjisconv['\u5c31'] = '\u008fA';
sjisconv['\u5c38'] = '\u009b\u0099';
sjisconv['\u5c39'] = '\u009b\u009a';
sjisconv['\u5c3a'] = '\u008e\u00da';
sjisconv['\u5c3b'] = '\u0090K';
sjisconv['\u5c3c'] = '\u0093\u00f2';
sjisconv['\u5c3d'] = '\u0090s';
sjisconv['\u5c3e'] = '\u0094\u00f6';
sjisconv['\u5c3f'] = '\u0094A';
sjisconv['\u5c40'] = '\u008b\u00c7';
sjisconv['\u5c41'] = '\u009b\u009b';
sjisconv['\u5c45'] = '\u008b\u008f';
sjisconv['\u5c46'] = '\u009b\u009c';
sjisconv['\u5c48'] = '\u008b\u00fc';
sjisconv['\u5c4a'] = '\u0093\u00cd';
sjisconv['\u5c4b'] = '\u0089\u00ae';
sjisconv['\u5c4d'] = '\u008er';
sjisconv['\u5c4e'] = '\u009b\u009d';
sjisconv['\u5c4f'] = '\u009b\u00a0';
sjisconv['\u5c50'] = '\u009b\u009f';
sjisconv['\u5c51'] = '\u008b\u00fb';
sjisconv['\u5c53'] = '\u009b\u009e';
sjisconv['\u5c55'] = '\u0093W';
sjisconv['\u5c5e'] = '\u0091\u00ae';
sjisconv['\u5c60'] = '\u0093j';
sjisconv['\u5c61'] = '\u008e\u00c6';
sjisconv['\u5c64'] = '\u0091w';
sjisconv['\u5c65'] = '\u0097\u009a';
sjisconv['\u5c6c'] = '\u009b\u00a2';
sjisconv['\u5c6e'] = '\u009b\u00a3';
sjisconv['\u5c6f'] = '\u0093\u00d4';
sjisconv['\u5c71'] = '\u008eR';
sjisconv['\u5c76'] = '\u009b\u00a5';
sjisconv['\u5c79'] = '\u009b\u00a6';
sjisconv['\u5c8c'] = '\u009b\u00a7';
sjisconv['\u5c90'] = '\u008a\u00f2';
sjisconv['\u5c91'] = '\u009b\u00a8';
sjisconv['\u5c94'] = '\u009b\u00a9';
sjisconv['\u5ca1'] = '\u0089\u00aa';
sjisconv['\u5ca8'] = '\u0091Z';
sjisconv['\u5ca9'] = '\u008a\u00e2';
sjisconv['\u5cab'] = '\u009b\u00ab';
sjisconv['\u5cac'] = '\u0096\u00a6';
sjisconv['\u5cb1'] = '\u0091\u00d0';
sjisconv['\u5cb3'] = '\u008ax';
sjisconv['\u5cb6'] = '\u009b\u00ad';
sjisconv['\u5cb7'] = '\u009b\u00af';
sjisconv['\u5cb8'] = '\u008a\u00dd';
sjisconv['\u5cbb'] = '\u009b\u00ac';
sjisconv['\u5cbc'] = '\u009b\u00ae';
sjisconv['\u5cbe'] = '\u009b\u00b1';
sjisconv['\u5cc5'] = '\u009b\u00b0';
sjisconv['\u5cc7'] = '\u009b\u00b2';
sjisconv['\u5cd9'] = '\u009b\u00b3';
sjisconv['\u5ce0'] = '\u0093\u00bb';
sjisconv['\u5ce1'] = '\u008b\u00ac';
sjisconv['\u5ce8'] = '\u0089\u00e3';
sjisconv['\u5ce9'] = '\u009b\u00b4';
sjisconv['\u5cea'] = '\u009b\u00b9';
sjisconv['\u5ced'] = '\u009b\u00b7';
sjisconv['\u5cef'] = '\u0095\u00f5';
sjisconv['\u5cf0'] = '\u0095\u00f4';
sjisconv['\u5cf6'] = '\u0093\u0087';
sjisconv['\u5cfa'] = '\u009b\u00b6';
sjisconv['\u5cfb'] = '\u008fs';
sjisconv['\u5cfd'] = '\u009b\u00b5';
sjisconv['\u5d07'] = '\u0090\u0092';
sjisconv['\u5d0b'] = '\u009b\u00ba';
sjisconv['\u5d0e'] = '\u008d\u00e8';
sjisconv['\u5d11'] = '\u009b\u00c0';
sjisconv['\u5d14'] = '\u009b\u00c1';
sjisconv['\u5d15'] = '\u009b\u00bb';
sjisconv['\u5d16'] = '\u008aR';
sjisconv['\u5d17'] = '\u009b\u00bc';
sjisconv['\u5d18'] = '\u009b\u00c5';
sjisconv['\u5d19'] = '\u009b\u00c4';
sjisconv['\u5d1a'] = '\u009b\u00c3';
sjisconv['\u5d1b'] = '\u009b\u00bf';
sjisconv['\u5d1f'] = '\u009b\u00be';
sjisconv['\u5d22'] = '\u009b\u00c2';
sjisconv['\u5d29'] = '\u0095\u00f6';
sjisconv['\u5d4b'] = '\u009b\u00c9';
sjisconv['\u5d4c'] = '\u009b\u00c6';
sjisconv['\u5d4e'] = '\u009b\u00c8';
sjisconv['\u5d50'] = '\u0097\u0092';
sjisconv['\u5d52'] = '\u009b\u00c7';
sjisconv['\u5d5c'] = '\u009b\u00bd';
sjisconv['\u5d69'] = '\u0090\u0093';
sjisconv['\u5d6c'] = '\u009b\u00ca';
sjisconv['\u5d6f'] = '\u008d\u00b5';
sjisconv['\u5d73'] = '\u009b\u00cb';
sjisconv['\u5d76'] = '\u009b\u00cc';
sjisconv['\u5d82'] = '\u009b\u00cf';
sjisconv['\u5d84'] = '\u009b\u00ce';
sjisconv['\u5d87'] = '\u009b\u00cd';
sjisconv['\u5d8b'] = '\u0093\u0088';
sjisconv['\u5d8c'] = '\u009b\u00b8';
sjisconv['\u5d90'] = '\u009b\u00d5';
sjisconv['\u5d9d'] = '\u009b\u00d1';
sjisconv['\u5da2'] = '\u009b\u00d0';
sjisconv['\u5dac'] = '\u009b\u00d2';
sjisconv['\u5dae'] = '\u009b\u00d3';
sjisconv['\u5db7'] = '\u009b\u00d6';
sjisconv['\u5dba'] = '\u0097\u00e4';
sjisconv['\u5dbc'] = '\u009b\u00d7';
sjisconv['\u5dbd'] = '\u009b\u00d4';
sjisconv['\u5dc9'] = '\u009b\u00d8';
sjisconv['\u5dcc'] = '\u008a\u00de';
sjisconv['\u5dcd'] = '\u009b\u00d9';
sjisconv['\u5dd2'] = '\u009b\u00db';
sjisconv['\u5dd3'] = '\u009b\u00da';
sjisconv['\u5dd6'] = '\u009b\u00dc';
sjisconv['\u5ddb'] = '\u009b\u00dd';
sjisconv['\u5ddd'] = '\u0090\u00ec';
sjisconv['\u5dde'] = '\u008fB';
sjisconv['\u5de1'] = '\u008f\u0084';
sjisconv['\u5de3'] = '\u0091\u0083';
sjisconv['\u5de5'] = '\u008dH';
sjisconv['\u5de6'] = '\u008d\u00b6';
sjisconv['\u5de7'] = '\u008dI';
sjisconv['\u5de8'] = '\u008b\u0090';
sjisconv['\u5deb'] = '\u009b\u00de';
sjisconv['\u5dee'] = '\u008d\u00b7';
sjisconv['\u5df1'] = '\u008c\u00c8';
sjisconv['\u5df2'] = '\u009b\u00df';
sjisconv['\u5df3'] = '\u0096\u00a4';
sjisconv['\u5df4'] = '\u0094b';
sjisconv['\u5df5'] = '\u009b\u00e0';
sjisconv['\u5df7'] = '\u008dJ';
sjisconv['\u5dfb'] = '\u008a\u00aa';
sjisconv['\u5dfd'] = '\u0092F';
sjisconv['\u5dfe'] = '\u008b\u00d0';
sjisconv['\u5e02'] = '\u008es';
sjisconv['\u5e03'] = '\u0095z';
sjisconv['\u5e06'] = '\u0094\u00bf';
sjisconv['\u5e0b'] = '\u009b\u00e1';
sjisconv['\u5e0c'] = '\u008a\u00f3';
sjisconv['\u5e11'] = '\u009b\u00e4';
sjisconv['\u5e16'] = '\u0092\u009f';
sjisconv['\u5e19'] = '\u009b\u00e3';
sjisconv['\u5e1a'] = '\u009b\u00e2';
sjisconv['\u5e1b'] = '\u009b\u00e5';
sjisconv['\u5e1d'] = '\u0092\u00e9';
sjisconv['\u5e25'] = '\u0090\u0083';
sjisconv['\u5e2b'] = '\u008et';
sjisconv['\u5e2d'] = '\u0090\u00c8';
sjisconv['\u5e2f'] = '\u0091\u00d1';
sjisconv['\u5e30'] = '\u008bA';
sjisconv['\u5e33'] = '\u0092\u00a0';
sjisconv['\u5e36'] = '\u009b\u00e6';
sjisconv['\u5e37'] = '\u009b\u00e7';
sjisconv['\u5e38'] = '\u008f\u00ed';
sjisconv['\u5e3d'] = '\u0096X';
sjisconv['\u5e40'] = '\u009b\u00ea';
sjisconv['\u5e43'] = '\u009b\u00e9';
sjisconv['\u5e44'] = '\u009b\u00e8';
sjisconv['\u5e45'] = '\u0095\u009d';
sjisconv['\u5e47'] = '\u009b\u00f1';
sjisconv['\u5e4c'] = '\u0096y';
sjisconv['\u5e4e'] = '\u009b\u00eb';
sjisconv['\u5e54'] = '\u009b\u00ed';
sjisconv['\u5e55'] = '\u0096\u008b';
sjisconv['\u5e57'] = '\u009b\u00ec';
sjisconv['\u5e5f'] = '\u009b\u00ee';
sjisconv['\u5e61'] = '\u0094\u00a6';
sjisconv['\u5e62'] = '\u009b\u00ef';
sjisconv['\u5e63'] = '\u0095\u00bc';
sjisconv['\u5e64'] = '\u009b\u00f0';
sjisconv['\u5e72'] = '\u008a\u00b1';
sjisconv['\u5e73'] = '\u0095\u00bd';
sjisconv['\u5e74'] = '\u0094N';
sjisconv['\u5e75'] = '\u009b\u00f2';
sjisconv['\u5e76'] = '\u009b\u00f3';
sjisconv['\u5e78'] = '\u008dK';
sjisconv['\u5e79'] = '\u008a\u00b2';
sjisconv['\u5e7a'] = '\u009b\u00f4';
sjisconv['\u5e7b'] = '\u008c\u00b6';
sjisconv['\u5e7c'] = '\u0097c';
sjisconv['\u5e7d'] = '\u0097H';
sjisconv['\u5e7e'] = '\u008a\u00f4';
sjisconv['\u5e7f'] = '\u009b\u00f6';
sjisconv['\u5e81'] = '\u0092\u00a1';
sjisconv['\u5e83'] = '\u008dL';
sjisconv['\u5e84'] = '\u008f\u00af';
sjisconv['\u5e87'] = '\u0094\u00dd';
sjisconv['\u5e8a'] = '\u008f\u00b0';
sjisconv['\u5e8f'] = '\u008f\u0098';
sjisconv['\u5e95'] = '\u0092\u00ea';
sjisconv['\u5e96'] = '\u0095\u00f7';
sjisconv['\u5e97'] = '\u0093X';
sjisconv['\u5e9a'] = '\u008dM';
sjisconv['\u5e9c'] = '\u0095{';
sjisconv['\u5ea0'] = '\u009b\u00f7';
sjisconv['\u5ea6'] = '\u0093x';
sjisconv['\u5ea7'] = '\u008d\u00c0';
sjisconv['\u5eab'] = '\u008c\u00c9';
sjisconv['\u5ead'] = '\u0092\u00eb';
sjisconv['\u5eb5'] = '\u0088\u00c1';
sjisconv['\u5eb6'] = '\u008f\u008e';
sjisconv['\u5eb7'] = '\u008dN';
sjisconv['\u5eb8'] = '\u0097f';
sjisconv['\u5ec1'] = '\u009b\u00f8';
sjisconv['\u5ec2'] = '\u009b\u00f9';
sjisconv['\u5ec3'] = '\u0094p';
sjisconv['\u5ec8'] = '\u009b\u00fa';
sjisconv['\u5ec9'] = '\u0097\u00f5';
sjisconv['\u5eca'] = '\u0098L';
sjisconv['\u5ecf'] = '\u009b\u00fc';
sjisconv['\u5ed0'] = '\u009b\u00fb';
sjisconv['\u5ed3'] = '\u008af';
sjisconv['\u5ed6'] = '\u009c@';
sjisconv['\u5eda'] = '\u009cC';
sjisconv['\u5edb'] = '\u009cD';
sjisconv['\u5edd'] = '\u009cB';
sjisconv['\u5edf'] = '\u0095_';
sjisconv['\u5ee0'] = '\u008f\u00b1';
sjisconv['\u5ee1'] = '\u009cF';
sjisconv['\u5ee2'] = '\u009cE';
sjisconv['\u5ee3'] = '\u009cA';
sjisconv['\u5ee8'] = '\u009cG';
sjisconv['\u5ee9'] = '\u009cH';
sjisconv['\u5eec'] = '\u009cI';
sjisconv['\u5ef0'] = '\u009cL';
sjisconv['\u5ef1'] = '\u009cJ';
sjisconv['\u5ef3'] = '\u009cK';
sjisconv['\u5ef4'] = '\u009cM';
sjisconv['\u5ef6'] = '\u0089\u0084';
sjisconv['\u5ef7'] = '\u0092\u00ec';
sjisconv['\u5ef8'] = '\u009cN';
sjisconv['\u5efa'] = '\u008c\u009a';
sjisconv['\u5efb'] = '\u0089\u00f4';
sjisconv['\u5efc'] = '\u0094U';
sjisconv['\u5efe'] = '\u009cO';
sjisconv['\u5eff'] = '\u0093\u00f9';
sjisconv['\u5f01'] = '\u0095\u00d9';
sjisconv['\u5f03'] = '\u009cP';
sjisconv['\u5f04'] = '\u0098M';
sjisconv['\u5f09'] = '\u009cQ';
sjisconv['\u5f0a'] = '\u0095\u00be';
sjisconv['\u5f0b'] = '\u009cT';
sjisconv['\u5f0c'] = '\u0098\u009f';
sjisconv['\u5f0d'] = '\u0098\u00af';
sjisconv['\u5f0f'] = '\u008e\u00ae';
sjisconv['\u5f10'] = '\u0093\u00f3';
sjisconv['\u5f11'] = '\u009cU';
sjisconv['\u5f13'] = '\u008b|';
sjisconv['\u5f14'] = '\u0092\u00a2';
sjisconv['\u5f15'] = '\u0088\u00f8';
sjisconv['\u5f16'] = '\u009cV';
sjisconv['\u5f17'] = '\u0095\u00a4';
sjisconv['\u5f18'] = '\u008dO';
sjisconv['\u5f1b'] = '\u0092o';
sjisconv['\u5f1f'] = '\u0092\u00ed';
sjisconv['\u5f25'] = '\u0096\u00ed';
sjisconv['\u5f26'] = '\u008c\u00b7';
sjisconv['\u5f27'] = '\u008c\u00ca';
sjisconv['\u5f29'] = '\u009cW';
sjisconv['\u5f2d'] = '\u009cX';
sjisconv['\u5f2f'] = '\u009c^';
sjisconv['\u5f31'] = '\u008e\u00e3';
sjisconv['\u5f35'] = '\u0092\u00a3';
sjisconv['\u5f37'] = '\u008b\u00ad';
sjisconv['\u5f38'] = '\u009cY';
sjisconv['\u5f3c'] = '\u0095J';
sjisconv['\u5f3e'] = '\u0092e';
sjisconv['\u5f41'] = '\u009cZ';
sjisconv['\u5f48'] = '\u009c[';
sjisconv['\u5f4a'] = '\u008b\u00ae';
sjisconv['\u5f4c'] = '\u009c\\';
sjisconv['\u5f4e'] = '\u009c]';
sjisconv['\u5f51'] = '\u009c_';
sjisconv['\u5f53'] = '\u0093\u0096';
sjisconv['\u5f56'] = '\u009c`';
sjisconv['\u5f57'] = '\u009ca';
sjisconv['\u5f59'] = '\u009cb';
sjisconv['\u5f5c'] = '\u009cS';
sjisconv['\u5f5d'] = '\u009cR';
sjisconv['\u5f61'] = '\u009cc';
sjisconv['\u5f62'] = '\u008c`';
sjisconv['\u5f66'] = '\u0095F';
sjisconv['\u5f69'] = '\u008d\u00ca';
sjisconv['\u5f6a'] = '\u0095V';
sjisconv['\u5f6b'] = '\u0092\u00a4';
sjisconv['\u5f6c'] = '\u0095j';
sjisconv['\u5f6d'] = '\u009cd';
sjisconv['\u5f70'] = '\u008f\u00b2';
sjisconv['\u5f71'] = '\u0089e';
sjisconv['\u5f73'] = '\u009ce';
sjisconv['\u5f77'] = '\u009cf';
sjisconv['\u5f79'] = '\u0096\u00f0';
sjisconv['\u5f7c'] = '\u0094\u00de';
sjisconv['\u5f7f'] = '\u009ci';
sjisconv['\u5f80'] = '\u0089\u009d';
sjisconv['\u5f81'] = '\u0090\u00aa';
sjisconv['\u5f82'] = '\u009ch';
sjisconv['\u5f83'] = '\u009cg';
sjisconv['\u5f84'] = '\u008ca';
sjisconv['\u5f85'] = '\u0091\u00d2';
sjisconv['\u5f87'] = '\u009cm';
sjisconv['\u5f88'] = '\u009ck';
sjisconv['\u5f8a'] = '\u009cj';
sjisconv['\u5f8b'] = '\u0097\u00a5';
sjisconv['\u5f8c'] = '\u008c\u00e3';
sjisconv['\u5f90'] = '\u008f\u0099';
sjisconv['\u5f91'] = '\u009cl';
sjisconv['\u5f92'] = '\u0093k';
sjisconv['\u5f93'] = '\u008f]';
sjisconv['\u5f97'] = '\u0093\u00be';
sjisconv['\u5f98'] = '\u009cp';
sjisconv['\u5f99'] = '\u009co';
sjisconv['\u5f9e'] = '\u009cn';
sjisconv['\u5fa0'] = '\u009cq';
sjisconv['\u5fa1'] = '\u008c\u00e4';
sjisconv['\u5fa8'] = '\u009cr';
sjisconv['\u5fa9'] = '\u0095\u009c';
sjisconv['\u5faa'] = '\u008fz';
sjisconv['\u5fad'] = '\u009cs';
sjisconv['\u5fae'] = '\u0094\u00f7';
sjisconv['\u5fb3'] = '\u0093\u00bf';
sjisconv['\u5fb4'] = '\u0092\u00a5';
sjisconv['\u5fb9'] = '\u0093O';
sjisconv['\u5fbc'] = '\u009ct';
sjisconv['\u5fbd'] = '\u008bJ';
sjisconv['\u5fc3'] = '\u0090S';
sjisconv['\u5fc5'] = '\u0095K';
sjisconv['\u5fcc'] = '\u008a\u00f5';
sjisconv['\u5fcd'] = '\u0094E';
sjisconv['\u5fd6'] = '\u009cu';
sjisconv['\u5fd7'] = '\u008eu';
sjisconv['\u5fd8'] = '\u0096Y';
sjisconv['\u5fd9'] = '\u0096Z';
sjisconv['\u5fdc'] = '\u0089\u009e';
sjisconv['\u5fdd'] = '\u009cz';
sjisconv['\u5fe0'] = '\u0092\u0089';
sjisconv['\u5fe4'] = '\u009cw';
sjisconv['\u5feb'] = '\u0089\u00f5';
sjisconv['\u5ff0'] = '\u009c\u00ab';
sjisconv['\u5ff1'] = '\u009cy';
sjisconv['\u5ff5'] = '\u0094O';
sjisconv['\u5ff8'] = '\u009cx';
sjisconv['\u5ffb'] = '\u009cv';
sjisconv['\u5ffd'] = '\u008d\u009a';
sjisconv['\u5fff'] = '\u009c|';
sjisconv['\u600e'] = '\u009c\u0083';
sjisconv['\u600f'] = '\u009c\u0089';
sjisconv['\u6010'] = '\u009c\u0081';
sjisconv['\u6012'] = '\u0093{';
sjisconv['\u6015'] = '\u009c\u0086';
sjisconv['\u6016'] = '\u0095|';
sjisconv['\u6019'] = '\u009c\u0080';
sjisconv['\u601b'] = '\u009c\u0085';
sjisconv['\u601c'] = '\u0097\u00e5';
sjisconv['\u601d'] = '\u008ev';
sjisconv['\u6020'] = '\u0091\u00d3';
sjisconv['\u6021'] = '\u009c}';
sjisconv['\u6025'] = '\u008b}';
sjisconv['\u6026'] = '\u009c\u0088';
sjisconv['\u6027'] = '\u0090\u00ab';
sjisconv['\u6028'] = '\u0089\u0085';
sjisconv['\u6029'] = '\u009c\u0082';
sjisconv['\u602a'] = '\u0089\u00f6';
sjisconv['\u602b'] = '\u009c\u0087';
sjisconv['\u602f'] = '\u008b\u00af';
sjisconv['\u6031'] = '\u009c\u0084';
sjisconv['\u603a'] = '\u009c\u008a';
sjisconv['\u6041'] = '\u009c\u008c';
sjisconv['\u6042'] = '\u009c\u0096';
sjisconv['\u6043'] = '\u009c\u0094';
sjisconv['\u6046'] = '\u009c\u0091';
sjisconv['\u604a'] = '\u009c\u0090';
sjisconv['\u604b'] = '\u0097\u00f6';
sjisconv['\u604d'] = '\u009c\u0092';
sjisconv['\u6050'] = '\u008b\u00b0';
sjisconv['\u6052'] = '\u008dP';
sjisconv['\u6055'] = '\u008f\u009a';
sjisconv['\u6059'] = '\u009c\u0099';
sjisconv['\u605a'] = '\u009c\u008b';
sjisconv['\u605f'] = '\u009c\u008f';
sjisconv['\u6060'] = '\u009c~';
sjisconv['\u6062'] = '\u0089\u00f8';
sjisconv['\u6063'] = '\u009c\u0093';
sjisconv['\u6064'] = '\u009c\u0095';
sjisconv['\u6065'] = '\u0092p';
sjisconv['\u6068'] = '\u008d\u00a6';
sjisconv['\u6069'] = '\u0089\u00b6';
sjisconv['\u606a'] = '\u009c\u008d';
sjisconv['\u606b'] = '\u009c\u0098';
sjisconv['\u606c'] = '\u009c\u0097';
sjisconv['\u606d'] = '\u008b\u00b1';
sjisconv['\u606f'] = '\u0091\u00a7';
sjisconv['\u6070'] = '\u008a\u0086';
sjisconv['\u6075'] = '\u008cb';
sjisconv['\u6077'] = '\u009c\u008e';
sjisconv['\u6081'] = '\u009c\u009a';
sjisconv['\u6083'] = '\u009c\u009d';
sjisconv['\u6084'] = '\u009c\u009f';
sjisconv['\u6089'] = '\u008e\u00bb';
sjisconv['\u608b'] = '\u009c\u00a5';
sjisconv['\u608c'] = '\u0092\u00ee';
sjisconv['\u608d'] = '\u009c\u009b';
sjisconv['\u6092'] = '\u009c\u00a3';
sjisconv['\u6094'] = '\u0089\u00f7';
sjisconv['\u6096'] = '\u009c\u00a1';
sjisconv['\u6097'] = '\u009c\u00a2';
sjisconv['\u609a'] = '\u009c\u009e';
sjisconv['\u609b'] = '\u009c\u00a0';
sjisconv['\u609f'] = '\u008c\u00e5';
sjisconv['\u60a0'] = '\u0097I';
sjisconv['\u60a3'] = '\u008a\u00b3';
sjisconv['\u60a6'] = '\u0089x';
sjisconv['\u60a7'] = '\u009c\u00a4';
sjisconv['\u60a9'] = '\u0094Y';
sjisconv['\u60aa'] = '\u0088\u00ab';
sjisconv['\u60b2'] = '\u0094\u00df';
sjisconv['\u60b3'] = '\u009c{';
sjisconv['\u60b4'] = '\u009c\u00aa';
sjisconv['\u60b5'] = '\u009c\u00ae';
sjisconv['\u60b6'] = '\u0096\u00e3';
sjisconv['\u60b8'] = '\u009c\u00a7';
sjisconv['\u60bc'] = '\u0093\u0089';
sjisconv['\u60bd'] = '\u009c\u00ac';
sjisconv['\u60c5'] = '\u008f\u00ee';
sjisconv['\u60c6'] = '\u009c\u00ad';
sjisconv['\u60c7'] = '\u0093\u00d5';
sjisconv['\u60d1'] = '\u0098f';
sjisconv['\u60d3'] = '\u009c\u00a9';
sjisconv['\u60d8'] = '\u009c\u00af';
sjisconv['\u60da'] = '\u008d\u009b';
sjisconv['\u60dc'] = '\u0090\u00c9';
sjisconv['\u60df'] = '\u0088\u00d2';
sjisconv['\u60e0'] = '\u009c\u00a8';
sjisconv['\u60e1'] = '\u009c\u00a6';
sjisconv['\u60e3'] = '\u0091y';
sjisconv['\u60e7'] = '\u009c\u009c';
sjisconv['\u60e8'] = '\u008eS';
sjisconv['\u60f0'] = '\u0091\u00c4';
sjisconv['\u60f1'] = '\u009c\u00bb';
sjisconv['\u60f3'] = '\u0091z';
sjisconv['\u60f4'] = '\u009c\u00b6';
sjisconv['\u60f6'] = '\u009c\u00b3';
sjisconv['\u60f7'] = '\u009c\u00b4';
sjisconv['\u60f9'] = '\u008e\u00e4';
sjisconv['\u60fa'] = '\u009c\u00b7';
sjisconv['\u60fb'] = '\u009c\u00ba';
sjisconv['\u6100'] = '\u009c\u00b5';
sjisconv['\u6101'] = '\u008fD';
sjisconv['\u6103'] = '\u009c\u00b8';
sjisconv['\u6106'] = '\u009c\u00b2';
sjisconv['\u6108'] = '\u0096\u00fa';
sjisconv['\u6109'] = '\u0096\u00f9';
sjisconv['\u610d'] = '\u009c\u00bc';
sjisconv['\u610e'] = '\u009c\u00bd';
sjisconv['\u610f'] = '\u0088\u00d3';
sjisconv['\u6115'] = '\u009c\u00b1';
sjisconv['\u611a'] = '\u008b\u00f0';
sjisconv['\u611b'] = '\u0088\u00a4';
sjisconv['\u611f'] = '\u008a\u00b4';
sjisconv['\u6121'] = '\u009c\u00b9';
sjisconv['\u6127'] = '\u009c\u00c1';
sjisconv['\u6128'] = '\u009c\u00c0';
sjisconv['\u612c'] = '\u009c\u00c5';
sjisconv['\u6134'] = '\u009c\u00c6';
sjisconv['\u613c'] = '\u009c\u00c4';
sjisconv['\u613d'] = '\u009c\u00c7';
sjisconv['\u613e'] = '\u009c\u00bf';
sjisconv['\u613f'] = '\u009c\u00c3';
sjisconv['\u6142'] = '\u009c\u00c8';
sjisconv['\u6144'] = '\u009c\u00c9';
sjisconv['\u6147'] = '\u009c\u00be';
sjisconv['\u6148'] = '\u008e\u009c';
sjisconv['\u614a'] = '\u009c\u00c2';
sjisconv['\u614b'] = '\u0091\u00d4';
sjisconv['\u614c'] = '\u008dQ';
sjisconv['\u614d'] = '\u009c\u00b0';
sjisconv['\u614e'] = '\u0090T';
sjisconv['\u6153'] = '\u009c\u00d6';
sjisconv['\u6155'] = '\u0095\u00e7';
sjisconv['\u6158'] = '\u009c\u00cc';
sjisconv['\u6159'] = '\u009c\u00cd';
sjisconv['\u615a'] = '\u009c\u00ce';
sjisconv['\u615d'] = '\u009c\u00d5';
sjisconv['\u615f'] = '\u009c\u00d4';
sjisconv['\u6162'] = '\u0096\u009d';
sjisconv['\u6163'] = '\u008a\u00b5';
sjisconv['\u6165'] = '\u009c\u00d2';
sjisconv['\u6167'] = '\u008cd';
sjisconv['\u6168'] = '\u008aS';
sjisconv['\u616b'] = '\u009c\u00cf';
sjisconv['\u616e'] = '\u0097\u00b6';
sjisconv['\u616f'] = '\u009c\u00d1';
sjisconv['\u6170'] = '\u0088\u00d4';
sjisconv['\u6171'] = '\u009c\u00d3';
sjisconv['\u6173'] = '\u009c\u00ca';
sjisconv['\u6174'] = '\u009c\u00d0';
sjisconv['\u6175'] = '\u009c\u00d7';
sjisconv['\u6176'] = '\u008cc';
sjisconv['\u6177'] = '\u009c\u00cb';
sjisconv['\u617e'] = '\u0097|';
sjisconv['\u6182'] = '\u0097J';
sjisconv['\u6187'] = '\u009c\u00da';
sjisconv['\u618a'] = '\u009c\u00de';
sjisconv['\u618e'] = '\u0091\u009e';
sjisconv['\u6190'] = '\u0097\u00f7';
sjisconv['\u6191'] = '\u009c\u00df';
sjisconv['\u6194'] = '\u009c\u00dc';
sjisconv['\u6196'] = '\u009c\u00d9';
sjisconv['\u6199'] = '\u009c\u00d8';
sjisconv['\u619a'] = '\u009c\u00dd';
sjisconv['\u61a4'] = '\u0095\u00ae';
sjisconv['\u61a7'] = '\u0093\u00b2';
sjisconv['\u61a9'] = '\u008ce';
sjisconv['\u61ab'] = '\u009c\u00e0';
sjisconv['\u61ac'] = '\u009c\u00db';
sjisconv['\u61ae'] = '\u009c\u00e1';
sjisconv['\u61b2'] = '\u008c\u009b';
sjisconv['\u61b6'] = '\u0089\u00af';
sjisconv['\u61ba'] = '\u009c\u00e9';
sjisconv['\u61be'] = '\u008a\u00b6';
sjisconv['\u61c3'] = '\u009c\u00e7';
sjisconv['\u61c6'] = '\u009c\u00e8';
sjisconv['\u61c7'] = '\u008d\u00a7';
sjisconv['\u61c8'] = '\u009c\u00e6';
sjisconv['\u61c9'] = '\u009c\u00e4';
sjisconv['\u61ca'] = '\u009c\u00e3';
sjisconv['\u61cb'] = '\u009c\u00ea';
sjisconv['\u61cc'] = '\u009c\u00e2';
sjisconv['\u61cd'] = '\u009c\u00ec';
sjisconv['\u61d0'] = '\u0089\u00f9';
sjisconv['\u61e3'] = '\u009c\u00ee';
sjisconv['\u61e6'] = '\u009c\u00ed';
sjisconv['\u61f2'] = '\u0092\u00a6';
sjisconv['\u61f4'] = '\u009c\u00f1';
sjisconv['\u61f6'] = '\u009c\u00ef';
sjisconv['\u61f7'] = '\u009c\u00e5';
sjisconv['\u61f8'] = '\u008c\u009c';
sjisconv['\u61fa'] = '\u009c\u00f0';
sjisconv['\u61fc'] = '\u009c\u00f4';
sjisconv['\u61fd'] = '\u009c\u00f3';
sjisconv['\u61fe'] = '\u009c\u00f5';
sjisconv['\u61ff'] = '\u009c\u00f2';
sjisconv['\u6200'] = '\u009c\u00f6';
sjisconv['\u6208'] = '\u009c\u00f7';
sjisconv['\u6209'] = '\u009c\u00f8';
sjisconv['\u620a'] = '\u0095\u00e8';
sjisconv['\u620c'] = '\u009c\u00fa';
sjisconv['\u620d'] = '\u009c\u00f9';
sjisconv['\u620e'] = '\u008f^';
sjisconv['\u6210'] = '\u0090\u00ac';
sjisconv['\u6211'] = '\u0089\u00e4';
sjisconv['\u6212'] = '\u0089\u00fa';
sjisconv['\u6214'] = '\u009c\u00fb';
sjisconv['\u6216'] = '\u0088\u00bd';
sjisconv['\u621a'] = '\u0090\u00ca';
sjisconv['\u621b'] = '\u009c\u00fc';
sjisconv['\u621d'] = '\u00e6\u00c1';
sjisconv['\u621e'] = '\u009d@';
sjisconv['\u621f'] = '\u008c\u0081';
sjisconv['\u6221'] = '\u009dA';
sjisconv['\u6226'] = '\u0090\u00ed';
sjisconv['\u622a'] = '\u009dB';
sjisconv['\u622e'] = '\u009dC';
sjisconv['\u622f'] = '\u008bY';
sjisconv['\u6230'] = '\u009dD';
sjisconv['\u6232'] = '\u009dE';
sjisconv['\u6233'] = '\u009dF';
sjisconv['\u6234'] = '\u0091\u00d5';
sjisconv['\u6238'] = '\u008c\u00cb';
sjisconv['\u623b'] = '\u0096\u00df';
sjisconv['\u623f'] = '\u0096[';
sjisconv['\u6240'] = '\u008f\u008a';
sjisconv['\u6241'] = '\u009dG';
sjisconv['\u6247'] = '\u0090\u00ee';
sjisconv['\u6248'] = '\u00e7\u00bb';
sjisconv['\u6249'] = '\u0094\u00e0';
sjisconv['\u624b'] = '\u008e\u00e8';
sjisconv['\u624d'] = '\u008d\u00cb';
sjisconv['\u624e'] = '\u009dH';
sjisconv['\u6253'] = '\u0091\u00c5';
sjisconv['\u6255'] = '\u0095\u00a5';
sjisconv['\u6258'] = '\u0091\u00ef';
sjisconv['\u625b'] = '\u009dK';
sjisconv['\u625e'] = '\u009dI';
sjisconv['\u6260'] = '\u009dL';
sjisconv['\u6263'] = '\u009dJ';
sjisconv['\u6268'] = '\u009dM';
sjisconv['\u626e'] = '\u0095\u00af';
sjisconv['\u6271'] = '\u0088\u00b5';
sjisconv['\u6276'] = '\u0095}';
sjisconv['\u6279'] = '\u0094\u00e1';
sjisconv['\u627c'] = '\u009dN';
sjisconv['\u627e'] = '\u009dQ';
sjisconv['\u627f'] = '\u008f\u00b3';
sjisconv['\u6280'] = '\u008bZ';
sjisconv['\u6282'] = '\u009dO';
sjisconv['\u6283'] = '\u009dV';
sjisconv['\u6284'] = '\u008f\u00b4';
sjisconv['\u6289'] = '\u009dP';
sjisconv['\u628a'] = '\u0094c';
sjisconv['\u6291'] = '\u0097}';
sjisconv['\u6292'] = '\u009dR';
sjisconv['\u6293'] = '\u009dS';
sjisconv['\u6294'] = '\u009dW';
sjisconv['\u6295'] = '\u0093\u008a';
sjisconv['\u6296'] = '\u009dT';
sjisconv['\u6297'] = '\u008dR';
sjisconv['\u6298'] = '\u0090\u00dc';
sjisconv['\u629b'] = '\u009de';
sjisconv['\u629c'] = '\u0094\u00b2';
sjisconv['\u629e'] = '\u0091\u00f0';
sjisconv['\u62ab'] = '\u0094\u00e2';
sjisconv['\u62ac'] = '\u009d\u00ab';
sjisconv['\u62b1'] = '\u0095\u00f8';
sjisconv['\u62b5'] = '\u0092\u00ef';
sjisconv['\u62b9'] = '\u0096\u0095';
sjisconv['\u62bb'] = '\u009dZ';
sjisconv['\u62bc'] = '\u0089\u009f';
sjisconv['\u62bd'] = '\u0092\u008a';
sjisconv['\u62c2'] = '\u009dc';
sjisconv['\u62c5'] = '\u0092S';
sjisconv['\u62c6'] = '\u009d]';
sjisconv['\u62c7'] = '\u009dd';
sjisconv['\u62c8'] = '\u009d_';
sjisconv['\u62c9'] = '\u009df';
sjisconv['\u62ca'] = '\u009db';
sjisconv['\u62cc'] = '\u009da';
sjisconv['\u62cd'] = '\u0094\u008f';
sjisconv['\u62cf'] = '\u009d[';
sjisconv['\u62d0'] = '\u0089\u00fb';
sjisconv['\u62d1'] = '\u009dY';
sjisconv['\u62d2'] = '\u008b\u0091';
sjisconv['\u62d3'] = '\u0091\u00f1';
sjisconv['\u62d4'] = '\u009dU';
sjisconv['\u62d7'] = '\u009dX';
sjisconv['\u62d8'] = '\u008dS';
sjisconv['\u62d9'] = '\u0090\u00d9';
sjisconv['\u62db'] = '\u008f\u00b5';
sjisconv['\u62dc'] = '\u009d`';
sjisconv['\u62dd'] = '\u0094q';
sjisconv['\u62e0'] = '\u008b\u0092';
sjisconv['\u62e1'] = '\u008ag';
sjisconv['\u62ec'] = '\u008a\u0087';
sjisconv['\u62ed'] = '\u0090@';
sjisconv['\u62ee'] = '\u009dh';
sjisconv['\u62ef'] = '\u009dm';
sjisconv['\u62f1'] = '\u009di';
sjisconv['\u62f3'] = '\u008c\u009d';
sjisconv['\u62f5'] = '\u009dn';
sjisconv['\u62f6'] = '\u008eA';
sjisconv['\u62f7'] = '\u008d\u0089';
sjisconv['\u62fe'] = '\u008fE';
sjisconv['\u62ff'] = '\u009d\\';
sjisconv['\u6301'] = '\u008e\u009d';
sjisconv['\u6302'] = '\u009dk';
sjisconv['\u6307'] = '\u008ew';
sjisconv['\u6308'] = '\u009dl';
sjisconv['\u6309'] = '\u0088\u00c2';
sjisconv['\u630c'] = '\u009dg';
sjisconv['\u6311'] = '\u0092\u00a7';
sjisconv['\u6319'] = '\u008b\u0093';
sjisconv['\u631f'] = '\u008b\u00b2';
sjisconv['\u6327'] = '\u009dj';
sjisconv['\u6328'] = '\u0088\u00a5';
sjisconv['\u632b'] = '\u008d\u00c1';
sjisconv['\u632f'] = '\u0090U';
sjisconv['\u633a'] = '\u0092\u00f0';
sjisconv['\u633d'] = '\u0094\u00d2';
sjisconv['\u633e'] = '\u009dp';
sjisconv['\u633f'] = '\u0091}';
sjisconv['\u6349'] = '\u0091\u00a8';
sjisconv['\u634c'] = '\u008eJ';
sjisconv['\u634d'] = '\u009dq';
sjisconv['\u634f'] = '\u009ds';
sjisconv['\u6350'] = '\u009do';
sjisconv['\u6355'] = '\u0095\u00df';
sjisconv['\u6357'] = '\u0092\u00bb';
sjisconv['\u635c'] = '\u0091{';
sjisconv['\u6367'] = '\u0095\u00f9';
sjisconv['\u6368'] = '\u008e\u00cc';
sjisconv['\u6369'] = '\u009d\u0080';
sjisconv['\u636b'] = '\u009d~';
sjisconv['\u636e'] = '\u0090\u0098';
sjisconv['\u6372'] = '\u008c\u009e';
sjisconv['\u6376'] = '\u009dx';
sjisconv['\u6377'] = '\u008f\u00b7';
sjisconv['\u637a'] = '\u0093\u00e6';
sjisconv['\u637b'] = '\u0094P';
sjisconv['\u6380'] = '\u009dv';
sjisconv['\u6383'] = '\u0091|';
sjisconv['\u6388'] = '\u008e\u00f6';
sjisconv['\u6389'] = '\u009d{';
sjisconv['\u638c'] = '\u008f\u00b6';
sjisconv['\u638e'] = '\u009du';
sjisconv['\u638f'] = '\u009dz';
sjisconv['\u6392'] = '\u0094r';
sjisconv['\u6396'] = '\u009dt';
sjisconv['\u6398'] = '\u008c@';
sjisconv['\u639b'] = '\u008a|';
sjisconv['\u639f'] = '\u009d|';
sjisconv['\u63a0'] = '\u0097\u00a9';
sjisconv['\u63a1'] = '\u008d\u00cc';
sjisconv['\u63a2'] = '\u0092T';
sjisconv['\u63a3'] = '\u009dy';
sjisconv['\u63a5'] = '\u0090\u00da';
sjisconv['\u63a7'] = '\u008dT';
sjisconv['\u63a8'] = '\u0090\u0084';
sjisconv['\u63a9'] = '\u0089\u0086';
sjisconv['\u63aa'] = '\u0091[';
sjisconv['\u63ab'] = '\u009dw';
sjisconv['\u63ac'] = '\u008bd';
sjisconv['\u63b2'] = '\u008cf';
sjisconv['\u63b4'] = '\u0092\u00cd';
sjisconv['\u63b5'] = '\u009d}';
sjisconv['\u63bb'] = '\u0091~';
sjisconv['\u63be'] = '\u009d\u0081';
sjisconv['\u63c0'] = '\u009d\u0083';
sjisconv['\u63c3'] = '\u0091\u00b5';
sjisconv['\u63c4'] = '\u009d\u0089';
sjisconv['\u63c6'] = '\u009d\u0084';
sjisconv['\u63c9'] = '\u009d\u0086';
sjisconv['\u63cf'] = '\u0095`';
sjisconv['\u63d0'] = '\u0092\u00f1';
sjisconv['\u63d2'] = '\u009d\u0087';
sjisconv['\u63d6'] = '\u0097K';
sjisconv['\u63da'] = '\u0097g';
sjisconv['\u63db'] = '\u008a\u00b7';
sjisconv['\u63e1'] = '\u0088\u00ac';
sjisconv['\u63e3'] = '\u009d\u0085';
sjisconv['\u63e9'] = '\u009d\u0082';
sjisconv['\u63ee'] = '\u008a\u00f6';
sjisconv['\u63f4'] = '\u0089\u0087';
sjisconv['\u63f6'] = '\u009d\u0088';
sjisconv['\u63fa'] = '\u0097h';
sjisconv['\u6406'] = '\u009d\u008c';
sjisconv['\u640d'] = '\u0091\u00b9';
sjisconv['\u640f'] = '\u009d\u0093';
sjisconv['\u6413'] = '\u009d\u008d';
sjisconv['\u6416'] = '\u009d\u008a';
sjisconv['\u6417'] = '\u009d\u0091';
sjisconv['\u641c'] = '\u009dr';
sjisconv['\u6426'] = '\u009d\u008e';
sjisconv['\u6428'] = '\u009d\u0092';
sjisconv['\u642c'] = '\u0094\u00c0';
sjisconv['\u642d'] = '\u0093\u008b';
sjisconv['\u6434'] = '\u009d\u008b';
sjisconv['\u6436'] = '\u009d\u008f';
sjisconv['\u643a'] = '\u008cg';
sjisconv['\u643e'] = '\u008d\u00ef';
sjisconv['\u6442'] = '\u0090\u00db';
sjisconv['\u644e'] = '\u009d\u0097';
sjisconv['\u6458'] = '\u0093E';
sjisconv['\u6467'] = '\u009d\u0094';
sjisconv['\u6469'] = '\u0096\u0080';
sjisconv['\u646f'] = '\u009d\u0095';
sjisconv['\u6476'] = '\u009d\u0096';
sjisconv['\u6478'] = '\u0096\u00cc';
sjisconv['\u647a'] = '\u0090\u00a0';
sjisconv['\u6483'] = '\u008c\u0082';
sjisconv['\u6488'] = '\u009d\u009d';
sjisconv['\u6492'] = '\u008eT';
sjisconv['\u6493'] = '\u009d\u009a';
sjisconv['\u6495'] = '\u009d\u0099';
sjisconv['\u649a'] = '\u0094Q';
sjisconv['\u649e'] = '\u0093\u00b3';
sjisconv['\u64a4'] = '\u0093P';
sjisconv['\u64a5'] = '\u009d\u009b';
sjisconv['\u64a9'] = '\u009d\u009c';
sjisconv['\u64ab'] = '\u0095\u008f';
sjisconv['\u64ad'] = '\u0094d';
sjisconv['\u64ae'] = '\u008eB';
sjisconv['\u64b0'] = '\u0090\u00ef';
sjisconv['\u64b2'] = '\u0096o';
sjisconv['\u64b9'] = '\u008ah';
sjisconv['\u64bb'] = '\u009d\u00a3';
sjisconv['\u64bc'] = '\u009d\u009e';
sjisconv['\u64c1'] = '\u0097i';
sjisconv['\u64c2'] = '\u009d\u00a5';
sjisconv['\u64c5'] = '\u009d\u00a1';
sjisconv['\u64c7'] = '\u009d\u00a2';
sjisconv['\u64cd'] = '\u0091\u0080';
sjisconv['\u64d2'] = '\u009d\u00a0';
sjisconv['\u64d4'] = '\u009d^';
sjisconv['\u64d8'] = '\u009d\u00a4';
sjisconv['\u64da'] = '\u009d\u009f';
sjisconv['\u64e0'] = '\u009d\u00a9';
sjisconv['\u64e1'] = '\u009d\u00aa';
sjisconv['\u64e2'] = '\u0093F';
sjisconv['\u64e3'] = '\u009d\u00ac';
sjisconv['\u64e6'] = '\u008eC';
sjisconv['\u64e7'] = '\u009d\u00a7';
sjisconv['\u64ec'] = '\u008b[';
sjisconv['\u64ef'] = '\u009d\u00ad';
sjisconv['\u64f1'] = '\u009d\u00a6';
sjisconv['\u64f2'] = '\u009d\u00b1';
sjisconv['\u64f4'] = '\u009d\u00b0';
sjisconv['\u64f6'] = '\u009d\u00af';
sjisconv['\u64fa'] = '\u009d\u00b2';
sjisconv['\u64fd'] = '\u009d\u00b4';
sjisconv['\u64fe'] = '\u008f\u00ef';
sjisconv['\u6500'] = '\u009d\u00b3';
sjisconv['\u6505'] = '\u009d\u00b7';
sjisconv['\u6518'] = '\u009d\u00b5';
sjisconv['\u651c'] = '\u009d\u00b6';
sjisconv['\u651d'] = '\u009d\u0090';
sjisconv['\u6523'] = '\u009d\u00b9';
sjisconv['\u6524'] = '\u009d\u00b8';
sjisconv['\u652a'] = '\u009d\u0098';
sjisconv['\u652b'] = '\u009d\u00ba';
sjisconv['\u652c'] = '\u009d\u00ae';
sjisconv['\u652f'] = '\u008ex';
sjisconv['\u6534'] = '\u009d\u00bb';
sjisconv['\u6535'] = '\u009d\u00bc';
sjisconv['\u6536'] = '\u009d\u00be';
sjisconv['\u6537'] = '\u009d\u00bd';
sjisconv['\u6538'] = '\u009d\u00bf';
sjisconv['\u6539'] = '\u0089\u00fc';
sjisconv['\u653b'] = '\u008dU';
sjisconv['\u653e'] = '\u0095\u00fa';
sjisconv['\u653f'] = '\u0090\u00ad';
sjisconv['\u6545'] = '\u008c\u00cc';
sjisconv['\u6548'] = '\u009d\u00c1';
sjisconv['\u654d'] = '\u009d\u00c4';
sjisconv['\u654f'] = '\u0095q';
sjisconv['\u6551'] = '\u008b~';
sjisconv['\u6555'] = '\u009d\u00c3';
sjisconv['\u6556'] = '\u009d\u00c2';
sjisconv['\u6557'] = '\u0094s';
sjisconv['\u6558'] = '\u009d\u00c5';
sjisconv['\u6559'] = '\u008b\u00b3';
sjisconv['\u655d'] = '\u009d\u00c7';
sjisconv['\u655e'] = '\u009d\u00c6';
sjisconv['\u6562'] = '\u008a\u00b8';
sjisconv['\u6563'] = '\u008eU';
sjisconv['\u6566'] = '\u0093\u00d6';
sjisconv['\u656c'] = '\u008ch';
sjisconv['\u6570'] = '\u0090\u0094';
sjisconv['\u6572'] = '\u009d\u00c8';
sjisconv['\u6574'] = '\u0090\u00ae';
sjisconv['\u6575'] = '\u0093G';
sjisconv['\u6577'] = '\u0095~';
sjisconv['\u6578'] = '\u009d\u00c9';
sjisconv['\u6582'] = '\u009d\u00ca';
sjisconv['\u6583'] = '\u009d\u00cb';
sjisconv['\u6587'] = '\u0095\u00b6';
sjisconv['\u6588'] = '\u009b|';
sjisconv['\u6589'] = '\u0090\u00c4';
sjisconv['\u658c'] = '\u0095k';
sjisconv['\u658e'] = '\u008d\u00d6';
sjisconv['\u6590'] = '\u0094\u00e3';
sjisconv['\u6591'] = '\u0094\u00c1';
sjisconv['\u6597'] = '\u0093l';
sjisconv['\u6599'] = '\u0097\u00bf';
sjisconv['\u659b'] = '\u009d\u00cd';
sjisconv['\u659c'] = '\u008e\u00ce';
sjisconv['\u659f'] = '\u009d\u00ce';
sjisconv['\u65a1'] = '\u0088\u00b4';
sjisconv['\u65a4'] = '\u008b\u00d2';
sjisconv['\u65a5'] = '\u0090\u00cb';
sjisconv['\u65a7'] = '\u0095\u0080';
sjisconv['\u65ab'] = '\u009d\u00cf';
sjisconv['\u65ac'] = '\u008ea';
sjisconv['\u65ad'] = '\u0092f';
sjisconv['\u65af'] = '\u008ez';
sjisconv['\u65b0'] = '\u0090V';
sjisconv['\u65b7'] = '\u009d\u00d0';
sjisconv['\u65b9'] = '\u0095\u00fb';
sjisconv['\u65bc'] = '\u0089\u0097';
sjisconv['\u65bd'] = '\u008e{';
sjisconv['\u65c1'] = '\u009d\u00d3';
sjisconv['\u65c3'] = '\u009d\u00d1';
sjisconv['\u65c4'] = '\u009d\u00d4';
sjisconv['\u65c5'] = '\u0097\u00b7';
sjisconv['\u65c6'] = '\u009d\u00d2';
sjisconv['\u65cb'] = '\u0090\u00f9';
sjisconv['\u65cc'] = '\u009d\u00d5';
sjisconv['\u65cf'] = '\u0091\u00b0';
sjisconv['\u65d2'] = '\u009d\u00d6';
sjisconv['\u65d7'] = '\u008a\u00f8';
sjisconv['\u65d9'] = '\u009d\u00d8';
sjisconv['\u65db'] = '\u009d\u00d7';
sjisconv['\u65e0'] = '\u009d\u00d9';
sjisconv['\u65e1'] = '\u009d\u00da';
sjisconv['\u65e2'] = '\u008a\u00f9';
sjisconv['\u65e5'] = '\u0093\u00fa';
sjisconv['\u65e6'] = '\u0092U';
sjisconv['\u65e7'] = '\u008b\u008c';
sjisconv['\u65e8'] = '\u008e|';
sjisconv['\u65e9'] = '\u0091\u0081';
sjisconv['\u65ec'] = '\u008f{';
sjisconv['\u65ed'] = '\u0088\u00ae';
sjisconv['\u65f1'] = '\u009d\u00db';
sjisconv['\u65fa'] = '\u0089\u00a0';
sjisconv['\u65fb'] = '\u009d\u00df';
sjisconv['\u6602'] = '\u008dV';
sjisconv['\u6603'] = '\u009d\u00de';
sjisconv['\u6606'] = '\u008d\u00a9';
sjisconv['\u6607'] = '\u008f\u00b8';
sjisconv['\u660a'] = '\u009d\u00dd';
sjisconv['\u660c'] = '\u008f\u00b9';
sjisconv['\u660e'] = '\u0096\u00be';
sjisconv['\u660f'] = '\u008d\u00a8';
sjisconv['\u6613'] = '\u0088\u00d5';
sjisconv['\u6614'] = '\u0090\u00cc';
sjisconv['\u661c'] = '\u009d\u00e4';
sjisconv['\u661f'] = '\u0090\u00af';
sjisconv['\u6620'] = '\u0089f';
sjisconv['\u6625'] = '\u008ft';
sjisconv['\u6627'] = '\u0096\u0086';
sjisconv['\u6628'] = '\u008d\u00f0';
sjisconv['\u662d'] = '\u008f\u00ba';
sjisconv['\u662f'] = '\u0090\u00a5';
sjisconv['\u6634'] = '\u009d\u00e3';
sjisconv['\u6635'] = '\u009d\u00e1';
sjisconv['\u6636'] = '\u009d\u00e2';
sjisconv['\u663c'] = '\u0092\u008b';
sjisconv['\u663f'] = '\u009eE';
sjisconv['\u6641'] = '\u009d\u00e8';
sjisconv['\u6642'] = '\u008e\u009e';
sjisconv['\u6643'] = '\u008dW';
sjisconv['\u6644'] = '\u009d\u00e6';
sjisconv['\u6649'] = '\u009d\u00e7';
sjisconv['\u664b'] = '\u0090W';
sjisconv['\u664f'] = '\u009d\u00e5';
sjisconv['\u6652'] = '\u008eN';
sjisconv['\u665d'] = '\u009d\u00ea';
sjisconv['\u665e'] = '\u009d\u00e9';
sjisconv['\u665f'] = '\u009d\u00ee';
sjisconv['\u6662'] = '\u009d\u00ef';
sjisconv['\u6664'] = '\u009d\u00eb';
sjisconv['\u6666'] = '\u008aA';
sjisconv['\u6667'] = '\u009d\u00ec';
sjisconv['\u6668'] = '\u009d\u00ed';
sjisconv['\u6669'] = '\u0094\u00d3';
sjisconv['\u666e'] = '\u0095\u0081';
sjisconv['\u666f'] = '\u008ci';
sjisconv['\u6670'] = '\u009d\u00f0';
sjisconv['\u6674'] = '\u0090\u00b0';
sjisconv['\u6676'] = '\u008f\u00bb';
sjisconv['\u667a'] = '\u0092q';
sjisconv['\u6681'] = '\u008b\u00c5';
sjisconv['\u6683'] = '\u009d\u00f1';
sjisconv['\u6684'] = '\u009d\u00f5';
sjisconv['\u6687'] = '\u0089\u00c9';
sjisconv['\u6688'] = '\u009d\u00f2';
sjisconv['\u6689'] = '\u009d\u00f4';
sjisconv['\u668e'] = '\u009d\u00f3';
sjisconv['\u6691'] = '\u008f\u008b';
sjisconv['\u6696'] = '\u0092g';
sjisconv['\u6697'] = '\u0088\u00c3';
sjisconv['\u6698'] = '\u009d\u00f6';
sjisconv['\u669d'] = '\u009d\u00f7';
sjisconv['\u66a2'] = '\u0092\u00a8';
sjisconv['\u66a6'] = '\u0097\u00ef';
sjisconv['\u66ab'] = '\u008eb';
sjisconv['\u66ae'] = '\u0095\u00e9';
sjisconv['\u66b4'] = '\u0096\\';
sjisconv['\u66b8'] = '\u009eA';
sjisconv['\u66b9'] = '\u009d\u00f9';
sjisconv['\u66bc'] = '\u009d\u00fc';
sjisconv['\u66be'] = '\u009d\u00fb';
sjisconv['\u66c1'] = '\u009d\u00f8';
sjisconv['\u66c4'] = '\u009e@';
sjisconv['\u66c7'] = '\u0093\u00dc';
sjisconv['\u66c9'] = '\u009d\u00fa';
sjisconv['\u66d6'] = '\u009eB';
sjisconv['\u66d9'] = '\u008f\u008c';
sjisconv['\u66da'] = '\u009eC';
sjisconv['\u66dc'] = '\u0097j';
sjisconv['\u66dd'] = '\u0094\u0098';
sjisconv['\u66e0'] = '\u009eD';
sjisconv['\u66e6'] = '\u009eF';
sjisconv['\u66e9'] = '\u009eG';
sjisconv['\u66f0'] = '\u009eH';
sjisconv['\u66f2'] = '\u008b\u00c8';
sjisconv['\u66f3'] = '\u0089g';
sjisconv['\u66f4'] = '\u008dX';
sjisconv['\u66f5'] = '\u009eI';
sjisconv['\u66f7'] = '\u009eJ';
sjisconv['\u66f8'] = '\u008f\u0091';
sjisconv['\u66f9'] = '\u0091\u0082';
sjisconv['\u66fc'] = '\u0099\u00d6';
sjisconv['\u66fd'] = '\u0091]';
sjisconv['\u66fe'] = '\u0091\\';
sjisconv['\u66ff'] = '\u0091\u00d6';
sjisconv['\u6700'] = '\u008d\u00c5';
sjisconv['\u6703'] = '\u0098\u00f0';
sjisconv['\u6708'] = '\u008c\u008e';
sjisconv['\u6709'] = '\u0097L';
sjisconv['\u670b'] = '\u0095\u00fc';
sjisconv['\u670d'] = '\u0095\u009e';
sjisconv['\u670f'] = '\u009eK';
sjisconv['\u6714'] = '\u008d\u00f1';
sjisconv['\u6715'] = '\u0092\u00bd';
sjisconv['\u6716'] = '\u009eL';
sjisconv['\u6717'] = '\u0098N';
sjisconv['\u671b'] = '\u0096]';
sjisconv['\u671d'] = '\u0092\u00a9';
sjisconv['\u671e'] = '\u009eM';
sjisconv['\u671f'] = '\u008a\u00fa';
sjisconv['\u6726'] = '\u009eN';
sjisconv['\u6727'] = '\u009eO';
sjisconv['\u6728'] = '\u0096\u00d8';
sjisconv['\u672a'] = '\u0096\u00a2';
sjisconv['\u672b'] = '\u0096\u0096';
sjisconv['\u672c'] = '\u0096{';
sjisconv['\u672d'] = '\u008eD';
sjisconv['\u672e'] = '\u009eQ';
sjisconv['\u6731'] = '\u008e\u00e9';
sjisconv['\u6734'] = '\u0096p';
sjisconv['\u6736'] = '\u009eS';
sjisconv['\u6737'] = '\u009eV';
sjisconv['\u6738'] = '\u009eU';
sjisconv['\u673a'] = '\u008a\u00f7';
sjisconv['\u673d'] = '\u008b\u0080';
sjisconv['\u673f'] = '\u009eR';
sjisconv['\u6741'] = '\u009eT';
sjisconv['\u6746'] = '\u009eW';
sjisconv['\u6749'] = '\u0090\u0099';
sjisconv['\u674e'] = '\u0097\u009b';
sjisconv['\u674f'] = '\u0088\u00c7';
sjisconv['\u6750'] = '\u008d\u00de';
sjisconv['\u6751'] = '\u0091\u00ba';
sjisconv['\u6753'] = '\u008e\u00db';
sjisconv['\u6756'] = '\u008f\u00f1';
sjisconv['\u6759'] = '\u009eZ';
sjisconv['\u675c'] = '\u0093m';
sjisconv['\u675e'] = '\u009eX';
sjisconv['\u675f'] = '\u0091\u00a9';
sjisconv['\u6760'] = '\u009eY';
sjisconv['\u6761'] = '\u008f\u00f0';
sjisconv['\u6762'] = '\u0096\u00db';
sjisconv['\u6763'] = '\u009e[';
sjisconv['\u6764'] = '\u009e\\';
sjisconv['\u6765'] = '\u0097\u0088';
sjisconv['\u676a'] = '\u009ea';
sjisconv['\u676d'] = '\u008dY';
sjisconv['\u676f'] = '\u0094t';
sjisconv['\u6770'] = '\u009e^';
sjisconv['\u6771'] = '\u0093\u008c';
sjisconv['\u6772'] = '\u009d\u00dc';
sjisconv['\u6773'] = '\u009d\u00e0';
sjisconv['\u6775'] = '\u008bn';
sjisconv['\u6777'] = '\u0094f';
sjisconv['\u677c'] = '\u009e`';
sjisconv['\u677e'] = '\u008f\u00bc';
sjisconv['\u677f'] = '\u0094\u00c2';
sjisconv['\u6785'] = '\u009ef';
sjisconv['\u6787'] = '\u0094\u00f8';
sjisconv['\u6789'] = '\u009e]';
sjisconv['\u678b'] = '\u009ec';
sjisconv['\u678c'] = '\u009eb';
sjisconv['\u6790'] = '\u0090\u00cd';
sjisconv['\u6795'] = '\u0096\u008d';
sjisconv['\u6797'] = '\u0097\u00d1';
sjisconv['\u679a'] = '\u0096\u0087';
sjisconv['\u679c'] = '\u0089\u00ca';
sjisconv['\u679d'] = '\u008e}';
sjisconv['\u67a0'] = '\u0098g';
sjisconv['\u67a1'] = '\u009ee';
sjisconv['\u67a2'] = '\u0090\u0095';
sjisconv['\u67a6'] = '\u009ed';
sjisconv['\u67a9'] = '\u009e_';
sjisconv['\u67af'] = '\u008c\u00cd';
sjisconv['\u67b3'] = '\u009ek';
sjisconv['\u67b4'] = '\u009ei';
sjisconv['\u67b6'] = '\u0089\u00cb';
sjisconv['\u67b7'] = '\u009eg';
sjisconv['\u67b8'] = '\u009em';
sjisconv['\u67b9'] = '\u009es';
sjisconv['\u67c1'] = '\u0091\u00c6';
sjisconv['\u67c4'] = '\u0095\u00bf';
sjisconv['\u67c6'] = '\u009eu';
sjisconv['\u67ca'] = '\u0095A';
sjisconv['\u67ce'] = '\u009et';
sjisconv['\u67cf'] = '\u0094\u0090';
sjisconv['\u67d0'] = '\u0096^';
sjisconv['\u67d1'] = '\u008a\u00b9';
sjisconv['\u67d3'] = '\u0090\u00f5';
sjisconv['\u67d4'] = '\u008f_';
sjisconv['\u67d8'] = '\u0092\u00d1';
sjisconv['\u67da'] = '\u0097M';
sjisconv['\u67dd'] = '\u009ep';
sjisconv['\u67de'] = '\u009eo';
sjisconv['\u67e2'] = '\u009eq';
sjisconv['\u67e4'] = '\u009en';
sjisconv['\u67e7'] = '\u009ev';
sjisconv['\u67e9'] = '\u009el';
sjisconv['\u67ec'] = '\u009ej';
sjisconv['\u67ee'] = '\u009er';
sjisconv['\u67ef'] = '\u009eh';
sjisconv['\u67f1'] = '\u0092\u008c';
sjisconv['\u67f3'] = '\u0096\u00f6';
sjisconv['\u67f4'] = '\u008e\u00c4';
sjisconv['\u67f5'] = '\u008d\u00f2';
sjisconv['\u67fb'] = '\u008d\u00b8';
sjisconv['\u67fe'] = '\u0096\u008f';
sjisconv['\u67ff'] = '\u008a`';
sjisconv['\u6802'] = '\u0092\u00cc';
sjisconv['\u6803'] = '\u0093\u00c8';
sjisconv['\u6804'] = '\u0089h';
sjisconv['\u6813'] = '\u0090\u00f0';
sjisconv['\u6816'] = '\u0090\u00b2';
sjisconv['\u6817'] = '\u008cI';
sjisconv['\u681e'] = '\u009ex';
sjisconv['\u6821'] = '\u008dZ';
sjisconv['\u6822'] = '\u008a\u009c';
sjisconv['\u6829'] = '\u009ez';
sjisconv['\u682a'] = '\u008a\u0094';
sjisconv['\u682b'] = '\u009e\u0081';
sjisconv['\u6832'] = '\u009e}';
sjisconv['\u6834'] = '\u0090\u00f1';
sjisconv['\u6838'] = '\u008aj';
sjisconv['\u6839'] = '\u008d\u00aa';
sjisconv['\u683c'] = '\u008ai';
sjisconv['\u683d'] = '\u008d\u00cd';
sjisconv['\u6840'] = '\u009e{';
sjisconv['\u6841'] = '\u008c\u0085';
sjisconv['\u6842'] = '\u008cj';
sjisconv['\u6843'] = '\u0093\u008d';
sjisconv['\u6846'] = '\u009ey';
sjisconv['\u6848'] = '\u0088\u00c4';
sjisconv['\u684d'] = '\u009e|';
sjisconv['\u684e'] = '\u009e~';
sjisconv['\u6850'] = '\u008b\u00cb';
sjisconv['\u6851'] = '\u008cK';
sjisconv['\u6853'] = '\u008a\u00ba';
sjisconv['\u6854'] = '\u008bj';
sjisconv['\u6859'] = '\u009e\u0082';
sjisconv['\u685c'] = '\u008d\u00f7';
sjisconv['\u685d'] = '\u0096\u0091';
sjisconv['\u685f'] = '\u008eV';
sjisconv['\u6863'] = '\u009e\u0083';
sjisconv['\u6867'] = '\u0095O';
sjisconv['\u6874'] = '\u009e\u008f';
sjisconv['\u6876'] = '\u0089\u00b1';
sjisconv['\u6877'] = '\u009e\u0084';
sjisconv['\u687e'] = '\u009e\u0095';
sjisconv['\u687f'] = '\u009e\u0085';
sjisconv['\u6881'] = '\u0097\u00c0';
sjisconv['\u6883'] = '\u009e\u008c';
sjisconv['\u6885'] = '\u0094~';
sjisconv['\u688d'] = '\u009e\u0094';
sjisconv['\u688f'] = '\u009e\u0087';
sjisconv['\u6893'] = '\u0088\u00b2';
sjisconv['\u6894'] = '\u009e\u0089';
sjisconv['\u6897'] = '\u008d[';
sjisconv['\u689b'] = '\u009e\u008b';
sjisconv['\u689d'] = '\u009e\u008a';
sjisconv['\u689f'] = '\u009e\u0086';
sjisconv['\u68a0'] = '\u009e\u0091';
sjisconv['\u68a2'] = '\u008f\u00bd';
sjisconv['\u68a6'] = '\u009a\u00eb';
sjisconv['\u68a7'] = '\u008c\u00e6';
sjisconv['\u68a8'] = '\u0097\u009c';
sjisconv['\u68ad'] = '\u009e\u0088';
sjisconv['\u68af'] = '\u0092\u00f2';
sjisconv['\u68b0'] = '\u008aB';
sjisconv['\u68b1'] = '\u008d\u00ab';
sjisconv['\u68b3'] = '\u009e\u0080';
sjisconv['\u68b5'] = '\u009e\u0090';
sjisconv['\u68b6'] = '\u008a\u0081';
sjisconv['\u68b9'] = '\u009e\u008e';
sjisconv['\u68ba'] = '\u009e\u0092';
sjisconv['\u68bc'] = '\u0093\u008e';
sjisconv['\u68c4'] = '\u008a\u00fc';
sjisconv['\u68c6'] = '\u009e\u00b0';
sjisconv['\u68c9'] = '\u0096\u00c7';
sjisconv['\u68ca'] = '\u009e\u0097';
sjisconv['\u68cb'] = '\u008a\u00fb';
sjisconv['\u68cd'] = '\u009e\u009e';
sjisconv['\u68d2'] = '\u0096_';
sjisconv['\u68d4'] = '\u009e\u009f';
sjisconv['\u68d5'] = '\u009e\u00a1';
sjisconv['\u68d7'] = '\u009e\u00a5';
sjisconv['\u68d8'] = '\u009e\u0099';
sjisconv['\u68da'] = '\u0092I';
sjisconv['\u68df'] = '\u0093\u008f';
sjisconv['\u68e0'] = '\u009e\u00a9';
sjisconv['\u68e1'] = '\u009e\u009c';
sjisconv['\u68e3'] = '\u009e\u00a6';
sjisconv['\u68e7'] = '\u009e\u00a0';
sjisconv['\u68ee'] = '\u0090X';
sjisconv['\u68ef'] = '\u009e\u00aa';
sjisconv['\u68f2'] = '\u0090\u00b1';
sjisconv['\u68f9'] = '\u009e\u00a8';
sjisconv['\u68fa'] = '\u008a\u00bb';
sjisconv['\u6900'] = '\u0098o';
sjisconv['\u6901'] = '\u009e\u0096';
sjisconv['\u6904'] = '\u009e\u00a4';
sjisconv['\u6905'] = '\u0088\u00d6';
sjisconv['\u6908'] = '\u009e\u0098';
sjisconv['\u690b'] = '\u0096\u00b8';
sjisconv['\u690c'] = '\u009e\u009d';
sjisconv['\u690d'] = '\u0090A';
sjisconv['\u690e'] = '\u0092\u00c5';
sjisconv['\u690f'] = '\u009e\u0093';
sjisconv['\u6912'] = '\u009e\u00a3';
sjisconv['\u6919'] = '\u0090\u009a';
sjisconv['\u691a'] = '\u009e\u00ad';
sjisconv['\u691b'] = '\u008a\u0091';
sjisconv['\u691c'] = '\u008c\u009f';
sjisconv['\u6921'] = '\u009e\u00af';
sjisconv['\u6922'] = '\u009e\u009a';
sjisconv['\u6923'] = '\u009e\u00ae';
sjisconv['\u6925'] = '\u009e\u00a7';
sjisconv['\u6926'] = '\u009e\u009b';
sjisconv['\u6928'] = '\u009e\u00ab';
sjisconv['\u692a'] = '\u009e\u00ac';
sjisconv['\u6930'] = '\u009e\u00bd';
sjisconv['\u6934'] = '\u0093\u00cc';
sjisconv['\u6936'] = '\u009e\u00a2';
sjisconv['\u6939'] = '\u009e\u00b9';
sjisconv['\u693d'] = '\u009e\u00bb';
sjisconv['\u693f'] = '\u0092\u00d6';
sjisconv['\u694a'] = '\u0097k';
sjisconv['\u6953'] = '\u0095\u0096';
sjisconv['\u6954'] = '\u009e\u00b6';
sjisconv['\u6955'] = '\u0091\u00c8';
sjisconv['\u6959'] = '\u009e\u00bc';
sjisconv['\u695a'] = '\u0091^';
sjisconv['\u695c'] = '\u009e\u00b3';
sjisconv['\u695d'] = '\u009e\u00c0';
sjisconv['\u695e'] = '\u009e\u00bf';
sjisconv['\u6960'] = '\u0093\u00ed';
sjisconv['\u6961'] = '\u009e\u00be';
sjisconv['\u6962'] = '\u0093\u00e8';
sjisconv['\u696a'] = '\u009e\u00c2';
sjisconv['\u696b'] = '\u009e\u00b5';
sjisconv['\u696d'] = '\u008b\u00c6';
sjisconv['\u696e'] = '\u009e\u00b8';
sjisconv['\u696f'] = '\u008f|';
sjisconv['\u6973'] = '\u0094\u0080';
sjisconv['\u6974'] = '\u009e\u00ba';
sjisconv['\u6975'] = '\u008b\u00c9';
sjisconv['\u6977'] = '\u009e\u00b2';
sjisconv['\u6978'] = '\u009e\u00b4';
sjisconv['\u6979'] = '\u009e\u00b1';
sjisconv['\u697c'] = '\u0098O';
sjisconv['\u697d'] = '\u008ay';
sjisconv['\u697e'] = '\u009e\u00b7';
sjisconv['\u6981'] = '\u009e\u00c1';
sjisconv['\u6982'] = '\u008aT';
sjisconv['\u698a'] = '\u008d\u00e5';
sjisconv['\u698e'] = '\u0089|';
sjisconv['\u6991'] = '\u009e\u00d2';
sjisconv['\u6994'] = '\u0098P';
sjisconv['\u6995'] = '\u009e\u00d5';
sjisconv['\u699b'] = '\u0090Y';
sjisconv['\u699c'] = '\u009e\u00d4';
sjisconv['\u69a0'] = '\u009e\u00d3';
sjisconv['\u69a7'] = '\u009e\u00d0';
sjisconv['\u69ae'] = '\u009e\u00c4';
sjisconv['\u69b1'] = '\u009e\u00e1';
sjisconv['\u69b2'] = '\u009e\u00c3';
sjisconv['\u69b4'] = '\u009e\u00d6';
sjisconv['\u69bb'] = '\u009e\u00ce';
sjisconv['\u69be'] = '\u009e\u00c9';
sjisconv['\u69bf'] = '\u009e\u00c6';
sjisconv['\u69c1'] = '\u009e\u00c7';
sjisconv['\u69c3'] = '\u009e\u00cf';
sjisconv['\u69c7'] = '\u00ea\u00a0';
sjisconv['\u69ca'] = '\u009e\u00cc';
sjisconv['\u69cb'] = '\u008d\\';
sjisconv['\u69cc'] = '\u0092\u00c6';
sjisconv['\u69cd'] = '\u0091\u0084';
sjisconv['\u69ce'] = '\u009e\u00ca';
sjisconv['\u69d0'] = '\u009e\u00c5';
sjisconv['\u69d3'] = '\u009e\u00c8';
sjisconv['\u69d8'] = '\u0097l';
sjisconv['\u69d9'] = '\u0096\u008a';
sjisconv['\u69dd'] = '\u009e\u00cd';
sjisconv['\u69de'] = '\u009e\u00d7';
sjisconv['\u69e7'] = '\u009e\u00df';
sjisconv['\u69e8'] = '\u009e\u00d8';
sjisconv['\u69eb'] = '\u009e\u00e5';
sjisconv['\u69ed'] = '\u009e\u00e3';
sjisconv['\u69f2'] = '\u009e\u00de';
sjisconv['\u69f9'] = '\u009e\u00dd';
sjisconv['\u69fb'] = '\u0092\u00ce';
sjisconv['\u69fd'] = '\u0091\u0085';
sjisconv['\u69ff'] = '\u009e\u00db';
sjisconv['\u6a02'] = '\u009e\u00d9';
sjisconv['\u6a05'] = '\u009e\u00e0';
sjisconv['\u6a0a'] = '\u009e\u00e6';
sjisconv['\u6a0b'] = '\u0094\u00f3';
sjisconv['\u6a0c'] = '\u009e\u00ec';
sjisconv['\u6a12'] = '\u009e\u00e7';
sjisconv['\u6a13'] = '\u009e\u00ea';
sjisconv['\u6a14'] = '\u009e\u00e4';
sjisconv['\u6a17'] = '\u0092\u0094';
sjisconv['\u6a19'] = '\u0095W';
sjisconv['\u6a1b'] = '\u009e\u00da';
sjisconv['\u6a1e'] = '\u009e\u00e2';
sjisconv['\u6a1f'] = '\u008f\u00be';
sjisconv['\u6a21'] = '\u0096\u00cd';
sjisconv['\u6a22'] = '\u009e\u00f6';
sjisconv['\u6a23'] = '\u009e\u00e9';
sjisconv['\u6a29'] = '\u008c\u00a0';
sjisconv['\u6a2a'] = '\u0089\u00a1';
sjisconv['\u6a2b'] = '\u008a~';
sjisconv['\u6a2e'] = '\u009e\u00d1';
sjisconv['\u6a35'] = '\u008f\u00bf';
sjisconv['\u6a36'] = '\u009e\u00ee';
sjisconv['\u6a38'] = '\u009e\u00f5';
sjisconv['\u6a39'] = '\u008e\u00f7';
sjisconv['\u6a3a'] = '\u008a\u0092';
sjisconv['\u6a3d'] = '\u0092M';
sjisconv['\u6a44'] = '\u009e\u00eb';
sjisconv['\u6a47'] = '\u009e\u00f0';
sjisconv['\u6a48'] = '\u009e\u00f4';
sjisconv['\u6a4b'] = '\u008b\u00b4';
sjisconv['\u6a58'] = '\u008bk';
sjisconv['\u6a59'] = '\u009e\u00f2';
sjisconv['\u6a5f'] = '\u008b@';
sjisconv['\u6a61'] = '\u0093\u00c9';
sjisconv['\u6a62'] = '\u009e\u00f1';
sjisconv['\u6a66'] = '\u009e\u00f3';
sjisconv['\u6a72'] = '\u009e\u00ed';
sjisconv['\u6a78'] = '\u009e\u00ef';
sjisconv['\u6a7f'] = '\u008a\u0080';
sjisconv['\u6a80'] = '\u0092h';
sjisconv['\u6a84'] = '\u009e\u00fa';
sjisconv['\u6a8d'] = '\u009e\u00f8';
sjisconv['\u6a8e'] = '\u008c\u00e7';
sjisconv['\u6a90'] = '\u009e\u00f7';
sjisconv['\u6a97'] = '\u009f@';
sjisconv['\u6a9c'] = '\u009ew';
sjisconv['\u6aa0'] = '\u009e\u00f9';
sjisconv['\u6aa2'] = '\u009e\u00fb';
sjisconv['\u6aa3'] = '\u009e\u00fc';
sjisconv['\u6aaa'] = '\u009fK';
sjisconv['\u6aac'] = '\u009fG';
sjisconv['\u6aae'] = '\u009e\u008d';
sjisconv['\u6ab3'] = '\u009fF';
sjisconv['\u6ab8'] = '\u009fE';
sjisconv['\u6abb'] = '\u009fB';
sjisconv['\u6ac1'] = '\u009e\u00e8';
sjisconv['\u6ac2'] = '\u009fD';
sjisconv['\u6ac3'] = '\u009fC';
sjisconv['\u6ad1'] = '\u009fI';
sjisconv['\u6ad3'] = '\u0098E';
sjisconv['\u6ada'] = '\u009fL';
sjisconv['\u6adb'] = '\u008b\u00f9';
sjisconv['\u6ade'] = '\u009fH';
sjisconv['\u6adf'] = '\u009fJ';
sjisconv['\u6ae8'] = '\u0094\u00a5';
sjisconv['\u6aea'] = '\u009fM';
sjisconv['\u6afa'] = '\u009fQ';
sjisconv['\u6afb'] = '\u009fN';
sjisconv['\u6b04'] = '\u0097\u0093';
sjisconv['\u6b05'] = '\u009fO';
sjisconv['\u6b0a'] = '\u009e\u00dc';
sjisconv['\u6b12'] = '\u009fR';
sjisconv['\u6b16'] = '\u009fS';
sjisconv['\u6b1d'] = '\u0089T';
sjisconv['\u6b1f'] = '\u009fU';
sjisconv['\u6b20'] = '\u008c\u0087';
sjisconv['\u6b21'] = '\u008e\u009f';
sjisconv['\u6b23'] = '\u008b\u00d3';
sjisconv['\u6b27'] = '\u0089\u00a2';
sjisconv['\u6b32'] = '\u0097~';
sjisconv['\u6b37'] = '\u009fW';
sjisconv['\u6b38'] = '\u009fV';
sjisconv['\u6b39'] = '\u009fY';
sjisconv['\u6b3a'] = '\u008b\\';
sjisconv['\u6b3d'] = '\u008b\u00d4';
sjisconv['\u6b3e'] = '\u008a\u00bc';
sjisconv['\u6b43'] = '\u009f\\';
sjisconv['\u6b47'] = '\u009f[';
sjisconv['\u6b49'] = '\u009f]';
sjisconv['\u6b4c'] = '\u0089\u00cc';
sjisconv['\u6b4e'] = '\u0092V';
sjisconv['\u6b50'] = '\u009f^';
sjisconv['\u6b53'] = '\u008a\u00bd';
sjisconv['\u6b54'] = '\u009f`';
sjisconv['\u6b59'] = '\u009f_';
sjisconv['\u6b5b'] = '\u009fa';
sjisconv['\u6b5f'] = '\u009fb';
sjisconv['\u6b61'] = '\u009fc';
sjisconv['\u6b62'] = '\u008e~';
sjisconv['\u6b63'] = '\u0090\u00b3';
sjisconv['\u6b64'] = '\u008d\u009f';
sjisconv['\u6b66'] = '\u0095\u0090';
sjisconv['\u6b69'] = '\u0095\u00e0';
sjisconv['\u6b6a'] = '\u0098c';
sjisconv['\u6b6f'] = '\u008e\u0095';
sjisconv['\u6b73'] = '\u008d\u00ce';
sjisconv['\u6b74'] = '\u0097\u00f0';
sjisconv['\u6b78'] = '\u009fd';
sjisconv['\u6b79'] = '\u009fe';
sjisconv['\u6b7b'] = '\u008e\u0080';
sjisconv['\u6b7f'] = '\u009ff';
sjisconv['\u6b80'] = '\u009fg';
sjisconv['\u6b83'] = '\u009fi';
sjisconv['\u6b84'] = '\u009fh';
sjisconv['\u6b86'] = '\u0096w';
sjisconv['\u6b89'] = '\u008f}';
sjisconv['\u6b8a'] = '\u008e\u00ea';
sjisconv['\u6b8b'] = '\u008ec';
sjisconv['\u6b8d'] = '\u009fj';
sjisconv['\u6b95'] = '\u009fl';
sjisconv['\u6b96'] = '\u0090B';
sjisconv['\u6b98'] = '\u009fk';
sjisconv['\u6b9e'] = '\u009fm';
sjisconv['\u6ba4'] = '\u009fn';
sjisconv['\u6baa'] = '\u009fo';
sjisconv['\u6bab'] = '\u009fp';
sjisconv['\u6baf'] = '\u009fq';
sjisconv['\u6bb1'] = '\u009fs';
sjisconv['\u6bb2'] = '\u009fr';
sjisconv['\u6bb3'] = '\u009ft';
sjisconv['\u6bb4'] = '\u0089\u00a3';
sjisconv['\u6bb5'] = '\u0092i';
sjisconv['\u6bb7'] = '\u009fu';
sjisconv['\u6bba'] = '\u008eE';
sjisconv['\u6bbb'] = '\u008ak';
sjisconv['\u6bbc'] = '\u009fv';
sjisconv['\u6bbf'] = '\u0093a';
sjisconv['\u6bc0'] = '\u009a\u00ca';
sjisconv['\u6bc5'] = '\u008bB';
sjisconv['\u6bc6'] = '\u009fw';
sjisconv['\u6bcb'] = '\u009fx';
sjisconv['\u6bcd'] = '\u0095\u00ea';
sjisconv['\u6bce'] = '\u0096\u0088';
sjisconv['\u6bd2'] = '\u0093\u00c5';
sjisconv['\u6bd3'] = '\u009fy';
sjisconv['\u6bd4'] = '\u0094\u00e4';
sjisconv['\u6bd8'] = '\u0094\u00f9';
sjisconv['\u6bdb'] = '\u0096\u00d1';
sjisconv['\u6bdf'] = '\u009fz';
sjisconv['\u6beb'] = '\u009f|';
sjisconv['\u6bec'] = '\u009f{';
sjisconv['\u6bef'] = '\u009f~';
sjisconv['\u6bf3'] = '\u009f}';
sjisconv['\u6c08'] = '\u009f\u0081';
sjisconv['\u6c0f'] = '\u008e\u0081';
sjisconv['\u6c11'] = '\u0096\u00af';
sjisconv['\u6c13'] = '\u009f\u0082';
sjisconv['\u6c14'] = '\u009f\u0083';
sjisconv['\u6c17'] = '\u008bC';
sjisconv['\u6c1b'] = '\u009f\u0084';
sjisconv['\u6c23'] = '\u009f\u0086';
sjisconv['\u6c24'] = '\u009f\u0085';
sjisconv['\u6c34'] = '\u0090\u0085';
sjisconv['\u6c37'] = '\u0095X';
sjisconv['\u6c38'] = '\u0089i';
sjisconv['\u6c3e'] = '\u0094\u00c3';
sjisconv['\u6c40'] = '\u0092\u00f3';
sjisconv['\u6c41'] = '\u008f`';
sjisconv['\u6c42'] = '\u008b\u0081';
sjisconv['\u6c4e'] = '\u0094\u00c4';
sjisconv['\u6c50'] = '\u008e\u00ac';
sjisconv['\u6c55'] = '\u009f\u0088';
sjisconv['\u6c57'] = '\u008a\u00be';
sjisconv['\u6c5a'] = '\u0089\u0098';
sjisconv['\u6c5d'] = '\u0093\u00f0';
sjisconv['\u6c5e'] = '\u009f\u0087';
sjisconv['\u6c5f'] = '\u008d]';
sjisconv['\u6c60'] = '\u0092r';
sjisconv['\u6c62'] = '\u009f\u0089';
sjisconv['\u6c68'] = '\u009f\u0091';
sjisconv['\u6c6a'] = '\u009f\u008a';
sjisconv['\u6c70'] = '\u0091\u00bf';
sjisconv['\u6c72'] = '\u008b\u0082';
sjisconv['\u6c73'] = '\u009f\u0092';
sjisconv['\u6c7a'] = '\u008c\u0088';
sjisconv['\u6c7d'] = '\u008bD';
sjisconv['\u6c7e'] = '\u009f\u0090';
sjisconv['\u6c81'] = '\u009f\u008e';
sjisconv['\u6c82'] = '\u009f\u008b';
sjisconv['\u6c83'] = '\u0097\u0080';
sjisconv['\u6c88'] = '\u0092\u00be';
sjisconv['\u6c8c'] = '\u0093\u00d7';
sjisconv['\u6c8d'] = '\u009f\u008c';
sjisconv['\u6c90'] = '\u009f\u0094';
sjisconv['\u6c92'] = '\u009f\u0093';
sjisconv['\u6c93'] = '\u008cB';
sjisconv['\u6c96'] = '\u0089\u00ab';
sjisconv['\u6c99'] = '\u008d\u00b9';
sjisconv['\u6c9a'] = '\u009f\u008d';
sjisconv['\u6c9b'] = '\u009f\u008f';
sjisconv['\u6ca1'] = '\u0096v';
sjisconv['\u6ca2'] = '\u0091\u00f2';
sjisconv['\u6cab'] = '\u0096\u0097';
sjisconv['\u6cae'] = '\u009f\u009c';
sjisconv['\u6cb1'] = '\u009f\u009d';
sjisconv['\u6cb3'] = '\u0089\u00cd';
sjisconv['\u6cb8'] = '\u0095\u00a6';
sjisconv['\u6cb9'] = '\u0096\u00fb';
sjisconv['\u6cba'] = '\u009f\u009f';
sjisconv['\u6cbb'] = '\u008e\u00a1';
sjisconv['\u6cbc'] = '\u008f\u00c0';
sjisconv['\u6cbd'] = '\u009f\u0098';
sjisconv['\u6cbe'] = '\u009f\u009e';
sjisconv['\u6cbf'] = '\u0089\u0088';
sjisconv['\u6cc1'] = '\u008b\u00b5';
sjisconv['\u6cc4'] = '\u009f\u0095';
sjisconv['\u6cc5'] = '\u009f\u009a';
sjisconv['\u6cc9'] = '\u0090\u00f2';
sjisconv['\u6cca'] = '\u0094\u0091';
sjisconv['\u6ccc'] = '\u0094\u00e5';
sjisconv['\u6cd3'] = '\u009f\u0097';
sjisconv['\u6cd5'] = '\u0096@';
sjisconv['\u6cd7'] = '\u009f\u0099';
sjisconv['\u6cd9'] = '\u009f\u00a2';
sjisconv['\u6cdb'] = '\u009f\u00a0';
sjisconv['\u6cdd'] = '\u009f\u009b';
sjisconv['\u6ce1'] = '\u0096A';
sjisconv['\u6ce2'] = '\u0094g';
sjisconv['\u6ce3'] = '\u008b\u0083';
sjisconv['\u6ce5'] = '\u0093D';
sjisconv['\u6ce8'] = '\u0092\u008d';
sjisconv['\u6cea'] = '\u009f\u00a3';
sjisconv['\u6cef'] = '\u009f\u00a1';
sjisconv['\u6cf0'] = '\u0091\u00d7';
sjisconv['\u6cf1'] = '\u009f\u0096';
sjisconv['\u6cf3'] = '\u0089j';
sjisconv['\u6d0b'] = '\u0097m';
sjisconv['\u6d0c'] = '\u009f\u00ae';
sjisconv['\u6d12'] = '\u009f\u00ad';
sjisconv['\u6d17'] = '\u0090\u00f4';
sjisconv['\u6d19'] = '\u009f\u00aa';
sjisconv['\u6d1b'] = '\u0097\u008c';
sjisconv['\u6d1e'] = '\u0093\u00b4';
sjisconv['\u6d1f'] = '\u009f\u00a4';
sjisconv['\u6d25'] = '\u0092\u00c3';
sjisconv['\u6d29'] = '\u0089k';
sjisconv['\u6d2a'] = '\u008d^';
sjisconv['\u6d2b'] = '\u009f\u00a7';
sjisconv['\u6d32'] = '\u008fF';
sjisconv['\u6d33'] = '\u009f\u00ac';
sjisconv['\u6d35'] = '\u009f\u00ab';
sjisconv['\u6d36'] = '\u009f\u00a6';
sjisconv['\u6d38'] = '\u009f\u00a9';
sjisconv['\u6d3b'] = '\u008a\u0088';
sjisconv['\u6d3d'] = '\u009f\u00a8';
sjisconv['\u6d3e'] = '\u0094h';
sjisconv['\u6d41'] = '\u0097\u00ac';
sjisconv['\u6d44'] = '\u008f\u00f2';
sjisconv['\u6d45'] = '\u0090\u00f3';
sjisconv['\u6d59'] = '\u009f\u00b4';
sjisconv['\u6d5a'] = '\u009f\u00b2';
sjisconv['\u6d5c'] = '\u0095l';
sjisconv['\u6d63'] = '\u009f\u00af';
sjisconv['\u6d64'] = '\u009f\u00b1';
sjisconv['\u6d66'] = '\u0089Y';
sjisconv['\u6d69'] = '\u008d_';
sjisconv['\u6d6a'] = '\u0098Q';
sjisconv['\u6d6c'] = '\u008a\\';
sjisconv['\u6d6e'] = '\u0095\u0082';
sjisconv['\u6d74'] = '\u0097\u0081';
sjisconv['\u6d77'] = '\u008aC';
sjisconv['\u6d78'] = '\u0090Z';
sjisconv['\u6d79'] = '\u009f\u00b3';
sjisconv['\u6d85'] = '\u009f\u00b8';
sjisconv['\u6d88'] = '\u008f\u00c1';
sjisconv['\u6d8c'] = '\u0097O';
sjisconv['\u6d8e'] = '\u009f\u00b5';
sjisconv['\u6d93'] = '\u009f\u00b0';
sjisconv['\u6d95'] = '\u009f\u00b6';
sjisconv['\u6d99'] = '\u0097\u00dc';
sjisconv['\u6d9b'] = '\u0093\u0093';
sjisconv['\u6d9c'] = '\u0093\u00c0';
sjisconv['\u6daf'] = '\u008aU';
sjisconv['\u6db2'] = '\u0089t';
sjisconv['\u6db5'] = '\u009f\u00bc';
sjisconv['\u6db8'] = '\u009f\u00bf';
sjisconv['\u6dbc'] = '\u0097\u00c1';
sjisconv['\u6dc0'] = '\u0097\u0084';
sjisconv['\u6dc5'] = '\u009f\u00c6';
sjisconv['\u6dc6'] = '\u009f\u00c0';
sjisconv['\u6dc7'] = '\u009f\u00bd';
sjisconv['\u6dcb'] = '\u0097\u00d2';
sjisconv['\u6dcc'] = '\u009f\u00c3';
sjisconv['\u6dd1'] = '\u008fi';
sjisconv['\u6dd2'] = '\u009f\u00c5';
sjisconv['\u6dd5'] = '\u009f\u00ca';
sjisconv['\u6dd8'] = '\u0093\u0091';
sjisconv['\u6dd9'] = '\u009f\u00c8';
sjisconv['\u6dde'] = '\u009f\u00c2';
sjisconv['\u6de1'] = '\u0092W';
sjisconv['\u6de4'] = '\u009f\u00c9';
sjisconv['\u6de6'] = '\u009f\u00be';
sjisconv['\u6de8'] = '\u009f\u00c4';
sjisconv['\u6dea'] = '\u009f\u00cb';
sjisconv['\u6deb'] = '\u0088\u00fa';
sjisconv['\u6dec'] = '\u009f\u00c1';
sjisconv['\u6dee'] = '\u009f\u00cc';
sjisconv['\u6df1'] = '\u0090[';
sjisconv['\u6df3'] = '\u008f~';
sjisconv['\u6df5'] = '\u0095\u00a3';
sjisconv['\u6df7'] = '\u008d\u00ac';
sjisconv['\u6df9'] = '\u009f\u00b9';
sjisconv['\u6dfa'] = '\u009f\u00c7';
sjisconv['\u6dfb'] = '\u0093Y';
sjisconv['\u6e05'] = '\u0090\u00b4';
sjisconv['\u6e07'] = '\u008a\u0089';
sjisconv['\u6e08'] = '\u008d\u00cf';
sjisconv['\u6e09'] = '\u008f\u00c2';
sjisconv['\u6e0a'] = '\u009f\u00bb';
sjisconv['\u6e0b'] = '\u008fa';
sjisconv['\u6e13'] = '\u008ck';
sjisconv['\u6e15'] = '\u009f\u00ba';
sjisconv['\u6e19'] = '\u009f\u00d0';
sjisconv['\u6e1a'] = '\u008f\u008d';
sjisconv['\u6e1b'] = '\u008c\u00b8';
sjisconv['\u6e1d'] = '\u009f\u00df';
sjisconv['\u6e1f'] = '\u009f\u00d9';
sjisconv['\u6e20'] = '\u008b\u0094';
sjisconv['\u6e21'] = '\u0093n';
sjisconv['\u6e23'] = '\u009f\u00d4';
sjisconv['\u6e24'] = '\u009f\u00dd';
sjisconv['\u6e25'] = '\u0088\u00ad';
sjisconv['\u6e26'] = '\u0089Q';
sjisconv['\u6e29'] = '\u0089\u00b7';
sjisconv['\u6e2b'] = '\u009f\u00d6';
sjisconv['\u6e2c'] = '\u0091\u00aa';
sjisconv['\u6e2d'] = '\u009f\u00cd';
sjisconv['\u6e2e'] = '\u009f\u00cf';
sjisconv['\u6e2f'] = '\u008d`';
sjisconv['\u6e38'] = '\u009f\u00e0';
sjisconv['\u6e3a'] = '\u009f\u00db';
sjisconv['\u6e3e'] = '\u009f\u00d3';
sjisconv['\u6e43'] = '\u009f\u00da';
sjisconv['\u6e4a'] = '\u0096\u00a9';
sjisconv['\u6e4d'] = '\u009f\u00d8';
sjisconv['\u6e4e'] = '\u009f\u00dc';
sjisconv['\u6e56'] = '\u008c\u00ce';
sjisconv['\u6e58'] = '\u008f\u00c3';
sjisconv['\u6e5b'] = '\u0092X';
sjisconv['\u6e5f'] = '\u009f\u00d2';
sjisconv['\u6e67'] = '\u0097N';
sjisconv['\u6e6b'] = '\u009f\u00d5';
sjisconv['\u6e6e'] = '\u009f\u00ce';
sjisconv['\u6e6f'] = '\u0093\u0092';
sjisconv['\u6e72'] = '\u009f\u00d1';
sjisconv['\u6e76'] = '\u009f\u00d7';
sjisconv['\u6e7e'] = '\u0098p';
sjisconv['\u6e7f'] = '\u008e\u00bc';
sjisconv['\u6e80'] = '\u0096\u009e';
sjisconv['\u6e82'] = '\u009f\u00e1';
sjisconv['\u6e8c'] = '\u0094\u00ac';
sjisconv['\u6e8f'] = '\u009f\u00ed';
sjisconv['\u6e90'] = '\u008c\u00b9';
sjisconv['\u6e96'] = '\u008f\u0080';
sjisconv['\u6e98'] = '\u009f\u00e3';
sjisconv['\u6e9c'] = '\u0097\u00ad';
sjisconv['\u6e9d'] = '\u008da';
sjisconv['\u6e9f'] = '\u009f\u00f0';
sjisconv['\u6ea2'] = '\u0088\u00ec';
sjisconv['\u6ea5'] = '\u009f\u00ee';
sjisconv['\u6eaa'] = '\u009f\u00e2';
sjisconv['\u6eaf'] = '\u009f\u00e8';
sjisconv['\u6eb2'] = '\u009f\u00ea';
sjisconv['\u6eb6'] = '\u0097n';
sjisconv['\u6eb7'] = '\u009f\u00e5';
sjisconv['\u6eba'] = '\u0093M';
sjisconv['\u6ebd'] = '\u009f\u00e7';
sjisconv['\u6ec2'] = '\u009f\u00ef';
sjisconv['\u6ec4'] = '\u009f\u00e9';
sjisconv['\u6ec5'] = '\u0096\u00c5';
sjisconv['\u6ec9'] = '\u009f\u00e4';
sjisconv['\u6ecb'] = '\u008e\u00a0';
sjisconv['\u6ecc'] = '\u009f\u00fc';
sjisconv['\u6ed1'] = '\u008a\u008a';
sjisconv['\u6ed3'] = '\u009f\u00e6';
sjisconv['\u6ed4'] = '\u009f\u00eb';
sjisconv['\u6ed5'] = '\u009f\u00ec';
sjisconv['\u6edd'] = '\u0091\u00ea';
sjisconv['\u6ede'] = '\u0091\u00d8';
sjisconv['\u6eec'] = '\u009f\u00f4';
sjisconv['\u6eef'] = '\u009f\u00fa';
sjisconv['\u6ef2'] = '\u009f\u00f8';
sjisconv['\u6ef4'] = '\u0093H';
sjisconv['\u6ef7'] = '\u00e0B';
sjisconv['\u6ef8'] = '\u009f\u00f5';
sjisconv['\u6efe'] = '\u009f\u00f6';
sjisconv['\u6eff'] = '\u009f\u00de';
sjisconv['\u6f01'] = '\u008b\u0099';
sjisconv['\u6f02'] = '\u0095Y';
sjisconv['\u6f06'] = '\u008e\u00bd';
sjisconv['\u6f09'] = '\u008d\u0097';
sjisconv['\u6f0f'] = '\u0098R';
sjisconv['\u6f11'] = '\u009f\u00f2';
sjisconv['\u6f13'] = '\u00e0A';
sjisconv['\u6f14'] = '\u0089\u0089';
sjisconv['\u6f15'] = '\u0091\u0086';
sjisconv['\u6f20'] = '\u0094\u0099';
sjisconv['\u6f22'] = '\u008a\u00bf';
sjisconv['\u6f23'] = '\u0097\u00f8';
sjisconv['\u6f2b'] = '\u0096\u009f';
sjisconv['\u6f2c'] = '\u0092\u00d0';
sjisconv['\u6f31'] = '\u009f\u00f9';
sjisconv['\u6f32'] = '\u009f\u00fb';
sjisconv['\u6f38'] = '\u0091Q';
sjisconv['\u6f3e'] = '\u00e0@';
sjisconv['\u6f3f'] = '\u009f\u00f7';
sjisconv['\u6f41'] = '\u009f\u00f1';
sjisconv['\u6f45'] = '\u008a\u00c1';
sjisconv['\u6f54'] = '\u008c\u0089';
sjisconv['\u6f58'] = '\u00e0N';
sjisconv['\u6f5b'] = '\u00e0I';
sjisconv['\u6f5c'] = '\u0090\u00f6';
sjisconv['\u6f5f'] = '\u008a\u0083';
sjisconv['\u6f64'] = '\u008f\u0081';
sjisconv['\u6f66'] = '\u00e0R';
sjisconv['\u6f6d'] = '\u00e0K';
sjisconv['\u6f6e'] = '\u0092\u00aa';
sjisconv['\u6f6f'] = '\u00e0H';
sjisconv['\u6f70'] = '\u0092\u00d7';
sjisconv['\u6f74'] = '\u00e0k';
sjisconv['\u6f78'] = '\u00e0E';
sjisconv['\u6f7a'] = '\u00e0D';
sjisconv['\u6f7c'] = '\u00e0M';
sjisconv['\u6f80'] = '\u00e0G';
sjisconv['\u6f81'] = '\u00e0F';
sjisconv['\u6f82'] = '\u00e0L';
sjisconv['\u6f84'] = '\u0090\u009f';
sjisconv['\u6f86'] = '\u00e0C';
sjisconv['\u6f8e'] = '\u00e0O';
sjisconv['\u6f91'] = '\u00e0P';
sjisconv['\u6f97'] = '\u008a\u00c0';
sjisconv['\u6fa1'] = '\u00e0U';
sjisconv['\u6fa3'] = '\u00e0T';
sjisconv['\u6fa4'] = '\u00e0V';
sjisconv['\u6faa'] = '\u00e0Y';
sjisconv['\u6fb1'] = '\u0093b';
sjisconv['\u6fb3'] = '\u00e0S';
sjisconv['\u6fb9'] = '\u00e0W';
sjisconv['\u6fc0'] = '\u008c\u0083';
sjisconv['\u6fc1'] = '\u0091\u00f7';
sjisconv['\u6fc2'] = '\u00e0Q';
sjisconv['\u6fc3'] = '\u0094Z';
sjisconv['\u6fc6'] = '\u00e0X';
sjisconv['\u6fd4'] = '\u00e0]';
sjisconv['\u6fd5'] = '\u00e0[';
sjisconv['\u6fd8'] = '\u00e0^';
sjisconv['\u6fdb'] = '\u00e0a';
sjisconv['\u6fdf'] = '\u00e0Z';
sjisconv['\u6fe0'] = '\u008d\u008a';
sjisconv['\u6fe1'] = '\u0094G';
sjisconv['\u6fe4'] = '\u009f\u00b7';
sjisconv['\u6feb'] = '\u0097\u0094';
sjisconv['\u6fec'] = '\u00e0\\';
sjisconv['\u6fee'] = '\u00e0`';
sjisconv['\u6fef'] = '\u0091\u00f3';
sjisconv['\u6ff1'] = '\u00e0_';
sjisconv['\u6ff3'] = '\u00e0J';
sjisconv['\u6ff6'] = '\u00e8\u0089';
sjisconv['\u6ffa'] = '\u00e0d';
sjisconv['\u6ffe'] = '\u00e0h';
sjisconv['\u7001'] = '\u00e0f';
sjisconv['\u7009'] = '\u00e0b';
sjisconv['\u700b'] = '\u00e0c';
sjisconv['\u700f'] = '\u00e0g';
sjisconv['\u7011'] = '\u00e0e';
sjisconv['\u7015'] = '\u0095m';
sjisconv['\u7018'] = '\u00e0m';
sjisconv['\u701a'] = '\u00e0j';
sjisconv['\u701b'] = '\u00e0i';
sjisconv['\u701d'] = '\u00e0l';
sjisconv['\u701e'] = '\u0093\u00d2';
sjisconv['\u701f'] = '\u00e0n';
sjisconv['\u7026'] = '\u0092\u0095';
sjisconv['\u7027'] = '\u0091\u00eb';
sjisconv['\u702c'] = '\u0090\u00a3';
sjisconv['\u7030'] = '\u00e0o';
sjisconv['\u7032'] = '\u00e0q';
sjisconv['\u703e'] = '\u00e0p';
sjisconv['\u704c'] = '\u009f\u00f3';
sjisconv['\u7051'] = '\u00e0r';
sjisconv['\u7058'] = '\u0093\u00e5';
sjisconv['\u7063'] = '\u00e0s';
sjisconv['\u706b'] = '\u0089\u00ce';
sjisconv['\u706f'] = '\u0093\u0094';
sjisconv['\u7070'] = '\u008aD';
sjisconv['\u7078'] = '\u008b\u0084';
sjisconv['\u707c'] = '\u008e\u00dc';
sjisconv['\u707d'] = '\u008d\u00d0';
sjisconv['\u7089'] = '\u0098F';
sjisconv['\u708a'] = '\u0090\u0086';
sjisconv['\u708e'] = '\u0089\u008a';
sjisconv['\u7092'] = '\u00e0u';
sjisconv['\u7099'] = '\u00e0t';
sjisconv['\u70ac'] = '\u00e0x';
sjisconv['\u70ad'] = '\u0092Y';
sjisconv['\u70ae'] = '\u00e0{';
sjisconv['\u70af'] = '\u00e0v';
sjisconv['\u70b3'] = '\u00e0z';
sjisconv['\u70b8'] = '\u00e0y';
sjisconv['\u70b9'] = '\u0093_';
sjisconv['\u70ba'] = '\u0088\u00d7';
sjisconv['\u70c8'] = '\u0097\u00f3';
sjisconv['\u70cb'] = '\u00e0}';
sjisconv['\u70cf'] = '\u0089G';
sjisconv['\u70d9'] = '\u00e0\u0080';
sjisconv['\u70dd'] = '\u00e0~';
sjisconv['\u70df'] = '\u00e0|';
sjisconv['\u70f1'] = '\u00e0w';
sjisconv['\u70f9'] = '\u0096B';
sjisconv['\u70fd'] = '\u00e0\u0082';
sjisconv['\u7109'] = '\u00e0\u0081';
sjisconv['\u7114'] = '\u0089\u008b';
sjisconv['\u7119'] = '\u00e0\u0084';
sjisconv['\u711a'] = '\u0095\u00b0';
sjisconv['\u711c'] = '\u00e0\u0083';
sjisconv['\u7121'] = '\u0096\u00b3';
sjisconv['\u7126'] = '\u008f\u00c5';
sjisconv['\u7136'] = '\u0091R';
sjisconv['\u713c'] = '\u008f\u00c4';
sjisconv['\u7149'] = '\u0097\u00f9';
sjisconv['\u714c'] = '\u00e0\u008a';
sjisconv['\u714e'] = '\u0090\u00f7';
sjisconv['\u7155'] = '\u00e0\u0086';
sjisconv['\u7156'] = '\u00e0\u008b';
sjisconv['\u7159'] = '\u0089\u008c';
sjisconv['\u7162'] = '\u00e0\u0089';
sjisconv['\u7164'] = '\u0094\u0081';
sjisconv['\u7165'] = '\u00e0\u0085';
sjisconv['\u7166'] = '\u00e0\u0088';
sjisconv['\u7167'] = '\u008f\u00c6';
sjisconv['\u7169'] = '\u0094\u00cf';
sjisconv['\u716c'] = '\u00e0\u008c';
sjisconv['\u716e'] = '\u008e\u00cf';
sjisconv['\u717d'] = '\u0090\u00f8';
sjisconv['\u7184'] = '\u00e0\u008f';
sjisconv['\u7188'] = '\u00e0\u0087';
sjisconv['\u718a'] = '\u008cF';
sjisconv['\u718f'] = '\u00e0\u008d';
sjisconv['\u7194'] = '\u0097o';
sjisconv['\u7195'] = '\u00e0\u0090';
sjisconv['\u7199'] = '\u00ea\u00a4';
sjisconv['\u719f'] = '\u008fn';
sjisconv['\u71a8'] = '\u00e0\u0091';
sjisconv['\u71ac'] = '\u00e0\u0092';
sjisconv['\u71b1'] = '\u0094M';
sjisconv['\u71b9'] = '\u00e0\u0094';
sjisconv['\u71be'] = '\u00e0\u0095';
sjisconv['\u71c3'] = '\u0094R';
sjisconv['\u71c8'] = '\u0093\u0095';
sjisconv['\u71c9'] = '\u00e0\u0097';
sjisconv['\u71ce'] = '\u00e0\u0099';
sjisconv['\u71d0'] = '\u0097\u00d3';
sjisconv['\u71d2'] = '\u00e0\u0096';
sjisconv['\u71d4'] = '\u00e0\u0098';
sjisconv['\u71d5'] = '\u0089\u008d';
sjisconv['\u71d7'] = '\u00e0\u0093';
sjisconv['\u71df'] = '\u009az';
sjisconv['\u71e0'] = '\u00e0\u009a';
sjisconv['\u71e5'] = '\u0091\u0087';
sjisconv['\u71e6'] = '\u008eW';
sjisconv['\u71e7'] = '\u00e0\u009c';
sjisconv['\u71ec'] = '\u00e0\u009b';
sjisconv['\u71ed'] = '\u0090C';
sjisconv['\u71ee'] = '\u0099\u00d7';
sjisconv['\u71f5'] = '\u00e0\u009d';
sjisconv['\u71f9'] = '\u00e0\u009f';
sjisconv['\u71fb'] = '\u00e0\u008e';
sjisconv['\u71fc'] = '\u00e0\u009e';
sjisconv['\u71ff'] = '\u00e0\u00a0';
sjisconv['\u7206'] = '\u0094\u009a';
sjisconv['\u720d'] = '\u00e0\u00a1';
sjisconv['\u7210'] = '\u00e0\u00a2';
sjisconv['\u721b'] = '\u00e0\u00a3';
sjisconv['\u7228'] = '\u00e0\u00a4';
sjisconv['\u722a'] = '\u0092\u00dc';
sjisconv['\u722c'] = '\u00e0\u00a6';
sjisconv['\u722d'] = '\u00e0\u00a5';
sjisconv['\u7230'] = '\u00e0\u00a7';
sjisconv['\u7232'] = '\u00e0\u00a8';
sjisconv['\u7235'] = '\u008e\u00dd';
sjisconv['\u7236'] = '\u0095\u0083';
sjisconv['\u723a'] = '\u0096\u00ea';
sjisconv['\u723b'] = '\u00e0\u00a9';
sjisconv['\u723c'] = '\u00e0\u00aa';
sjisconv['\u723d'] = '\u0091u';
sjisconv['\u723e'] = '\u008e\u00a2';
sjisconv['\u723f'] = '\u00e0\u00ab';
sjisconv['\u7240'] = '\u00e0\u00ac';
sjisconv['\u7246'] = '\u00e0\u00ad';
sjisconv['\u7247'] = '\u0095\u00d0';
sjisconv['\u7248'] = '\u0094\u00c5';
sjisconv['\u724b'] = '\u00e0\u00ae';
sjisconv['\u724c'] = '\u0094v';
sjisconv['\u7252'] = '\u0092\u00ab';
sjisconv['\u7258'] = '\u00e0\u00af';
sjisconv['\u7259'] = '\u0089\u00e5';
sjisconv['\u725b'] = '\u008b\u008d';
sjisconv['\u725d'] = '\u0096\u00c4';
sjisconv['\u725f'] = '\u0096\u00b4';
sjisconv['\u7261'] = '\u0089\u00b2';
sjisconv['\u7262'] = '\u0098S';
sjisconv['\u7267'] = '\u0096q';
sjisconv['\u7269'] = '\u0095\u00a8';
sjisconv['\u7272'] = '\u0090\u00b5';
sjisconv['\u7274'] = '\u00e0\u00b0';
sjisconv['\u7279'] = '\u0093\u00c1';
sjisconv['\u727d'] = '\u008c\u00a1';
sjisconv['\u727e'] = '\u00e0\u00b1';
sjisconv['\u7280'] = '\u008d\u00d2';
sjisconv['\u7281'] = '\u00e0\u00b3';
sjisconv['\u7282'] = '\u00e0\u00b2';
sjisconv['\u7287'] = '\u00e0\u00b4';
sjisconv['\u7292'] = '\u00e0\u00b5';
sjisconv['\u7296'] = '\u00e0\u00b6';
sjisconv['\u72a0'] = '\u008b]';
sjisconv['\u72a2'] = '\u00e0\u00b7';
sjisconv['\u72a7'] = '\u00e0\u00b8';
sjisconv['\u72ac'] = '\u008c\u00a2';
sjisconv['\u72af'] = '\u0094\u00c6';
sjisconv['\u72b2'] = '\u00e0\u00ba';
sjisconv['\u72b6'] = '\u008f\u00f3';
sjisconv['\u72b9'] = '\u00e0\u00b9';
sjisconv['\u72c2'] = '\u008b\u00b6';
sjisconv['\u72c3'] = '\u00e0\u00bb';
sjisconv['\u72c4'] = '\u00e0\u00bd';
sjisconv['\u72c6'] = '\u00e0\u00bc';
sjisconv['\u72ce'] = '\u00e0\u00be';
sjisconv['\u72d0'] = '\u008c\u00cf';
sjisconv['\u72d2'] = '\u00e0\u00bf';
sjisconv['\u72d7'] = '\u008b\u00e7';
sjisconv['\u72d9'] = '\u0091_';
sjisconv['\u72db'] = '\u008d\u009d';
sjisconv['\u72e0'] = '\u00e0\u00c1';
sjisconv['\u72e1'] = '\u00e0\u00c2';
sjisconv['\u72e2'] = '\u00e0\u00c0';
sjisconv['\u72e9'] = '\u008e\u00eb';
sjisconv['\u72ec'] = '\u0093\u00c6';
sjisconv['\u72ed'] = '\u008b\u00b7';
sjisconv['\u72f7'] = '\u00e0\u00c4';
sjisconv['\u72f8'] = '\u0092K';
sjisconv['\u72f9'] = '\u00e0\u00c3';
sjisconv['\u72fc'] = '\u0098T';
sjisconv['\u72fd'] = '\u0094\u0082';
sjisconv['\u730a'] = '\u00e0\u00c7';
sjisconv['\u7316'] = '\u00e0\u00c9';
sjisconv['\u7317'] = '\u00e0\u00c6';
sjisconv['\u731b'] = '\u0096\u00d2';
sjisconv['\u731c'] = '\u00e0\u00c8';
sjisconv['\u731d'] = '\u00e0\u00ca';
sjisconv['\u731f'] = '\u0097\u00c2';
sjisconv['\u7325'] = '\u00e0\u00ce';
sjisconv['\u7329'] = '\u00e0\u00cd';
sjisconv['\u732a'] = '\u0092\u0096';
sjisconv['\u732b'] = '\u0094L';
sjisconv['\u732e'] = '\u008c\u00a3';
sjisconv['\u732f'] = '\u00e0\u00cc';
sjisconv['\u7334'] = '\u00e0\u00cb';
sjisconv['\u7336'] = '\u0097P';
sjisconv['\u7337'] = '\u0097Q';
sjisconv['\u733e'] = '\u00e0\u00cf';
sjisconv['\u733f'] = '\u0089\u008e';
sjisconv['\u7344'] = '\u008d\u0096';
sjisconv['\u7345'] = '\u008e\u0082';
sjisconv['\u734e'] = '\u00e0\u00d0';
sjisconv['\u734f'] = '\u00e0\u00d1';
sjisconv['\u7357'] = '\u00e0\u00d3';
sjisconv['\u7363'] = '\u008fb';
sjisconv['\u7368'] = '\u00e0\u00d5';
sjisconv['\u736a'] = '\u00e0\u00d4';
sjisconv['\u7370'] = '\u00e0\u00d6';
sjisconv['\u7372'] = '\u008al';
sjisconv['\u7375'] = '\u00e0\u00d8';
sjisconv['\u7378'] = '\u00e0\u00d7';
sjisconv['\u737a'] = '\u00e0\u00da';
sjisconv['\u737b'] = '\u00e0\u00d9';
sjisconv['\u7384'] = '\u008c\u00ba';
sjisconv['\u7387'] = '\u0097\u00a6';
sjisconv['\u7389'] = '\u008b\u00ca';
sjisconv['\u738b'] = '\u0089\u00a4';
sjisconv['\u7396'] = '\u008b\u00e8';
sjisconv['\u73a9'] = '\u008a\u00df';
sjisconv['\u73b2'] = '\u0097\u00e6';
sjisconv['\u73b3'] = '\u00e0\u00dc';
sjisconv['\u73bb'] = '\u00e0\u00de';
sjisconv['\u73c0'] = '\u00e0\u00df';
sjisconv['\u73c2'] = '\u0089\u00cf';
sjisconv['\u73c8'] = '\u00e0\u00db';
sjisconv['\u73ca'] = '\u008eX';
sjisconv['\u73cd'] = '\u0092\u00bf';
sjisconv['\u73ce'] = '\u00e0\u00dd';
sjisconv['\u73de'] = '\u00e0\u00e2';
sjisconv['\u73e0'] = '\u008e\u00ec';
sjisconv['\u73e5'] = '\u00e0\u00e0';
sjisconv['\u73ea'] = '\u008c]';
sjisconv['\u73ed'] = '\u0094\u00c7';
sjisconv['\u73ee'] = '\u00e0\u00e1';
sjisconv['\u73f1'] = '\u00e0\u00fc';
sjisconv['\u73f8'] = '\u00e0\u00e7';
sjisconv['\u73fe'] = '\u008c\u00bb';
sjisconv['\u7403'] = '\u008b\u0085';
sjisconv['\u7405'] = '\u00e0\u00e4';
sjisconv['\u7406'] = '\u0097\u009d';
sjisconv['\u7409'] = '\u0097\u00ae';
sjisconv['\u7422'] = '\u0091\u00f4';
sjisconv['\u7425'] = '\u00e0\u00e6';
sjisconv['\u7432'] = '\u00e0\u00e8';
sjisconv['\u7433'] = '\u0097\u00d4';
sjisconv['\u7434'] = '\u008b\u00d5';
sjisconv['\u7435'] = '\u0094\u00fa';
sjisconv['\u7436'] = '\u0094i';
sjisconv['\u743a'] = '\u00e0\u00e9';
sjisconv['\u743f'] = '\u00e0\u00eb';
sjisconv['\u7441'] = '\u00e0\u00ee';
sjisconv['\u7455'] = '\u00e0\u00ea';
sjisconv['\u7459'] = '\u00e0\u00ed';
sjisconv['\u745a'] = '\u008c\u00e8';
sjisconv['\u745b'] = '\u0089l';
sjisconv['\u745c'] = '\u00e0\u00ef';
sjisconv['\u745e'] = '\u0090\u0090';
sjisconv['\u745f'] = '\u00e0\u00ec';
sjisconv['\u7460'] = '\u0097\u00da';
sjisconv['\u7463'] = '\u00e0\u00f2';
sjisconv['\u7464'] = '\u00ea\u00a2';
sjisconv['\u7469'] = '\u00e0\u00f0';
sjisconv['\u746a'] = '\u00e0\u00f3';
sjisconv['\u746f'] = '\u00e0\u00e5';
sjisconv['\u7470'] = '\u00e0\u00f1';
sjisconv['\u7473'] = '\u008d\u00ba';
sjisconv['\u7476'] = '\u00e0\u00f4';
sjisconv['\u747e'] = '\u00e0\u00f5';
sjisconv['\u7483'] = '\u0097\u009e';
sjisconv['\u748b'] = '\u00e0\u00f6';
sjisconv['\u749e'] = '\u00e0\u00f7';
sjisconv['\u74a2'] = '\u00e0\u00e3';
sjisconv['\u74a7'] = '\u00e0\u00f8';
sjisconv['\u74b0'] = '\u008a\u00c2';
sjisconv['\u74bd'] = '\u008e\u00a3';
sjisconv['\u74ca'] = '\u00e0\u00f9';
sjisconv['\u74cf'] = '\u00e0\u00fa';
sjisconv['\u74d4'] = '\u00e0\u00fb';
sjisconv['\u74dc'] = '\u0089Z';
sjisconv['\u74e0'] = '\u00e1@';
sjisconv['\u74e2'] = '\u0095Z';
sjisconv['\u74e3'] = '\u00e1A';
sjisconv['\u74e6'] = '\u008a\u00a2';
sjisconv['\u74e7'] = '\u00e1B';
sjisconv['\u74e9'] = '\u00e1C';
sjisconv['\u74ee'] = '\u00e1D';
sjisconv['\u74f0'] = '\u00e1F';
sjisconv['\u74f1'] = '\u00e1G';
sjisconv['\u74f2'] = '\u00e1E';
sjisconv['\u74f6'] = '\u0095r';
sjisconv['\u74f7'] = '\u00e1I';
sjisconv['\u74f8'] = '\u00e1H';
sjisconv['\u7503'] = '\u00e1K';
sjisconv['\u7504'] = '\u00e1J';
sjisconv['\u7505'] = '\u00e1L';
sjisconv['\u750c'] = '\u00e1M';
sjisconv['\u750d'] = '\u00e1O';
sjisconv['\u750e'] = '\u00e1N';
sjisconv['\u7511'] = '\u008d\u0099';
sjisconv['\u7513'] = '\u00e1Q';
sjisconv['\u7515'] = '\u00e1P';
sjisconv['\u7518'] = '\u008a\u00c3';
sjisconv['\u751a'] = '\u0090r';
sjisconv['\u751c'] = '\u0093[';
sjisconv['\u751e'] = '\u00e1R';
sjisconv['\u751f'] = '\u0090\u00b6';
sjisconv['\u7523'] = '\u008eY';
sjisconv['\u7525'] = '\u0089\u0099';
sjisconv['\u7526'] = '\u00e1S';
sjisconv['\u7528'] = '\u0097p';
sjisconv['\u752b'] = '\u0095\u00e1';
sjisconv['\u752c'] = '\u00e1T';
sjisconv['\u7530'] = '\u0093c';
sjisconv['\u7531'] = '\u0097R';
sjisconv['\u7532'] = '\u008db';
sjisconv['\u7533'] = '\u0090\\';
sjisconv['\u7537'] = '\u0092j';
sjisconv['\u7538'] = '\u0099\u00b2';
sjisconv['\u753a'] = '\u0092\u00ac';
sjisconv['\u753b'] = '\u0089\u00e6';
sjisconv['\u753c'] = '\u00e1U';
sjisconv['\u7544'] = '\u00e1V';
sjisconv['\u7546'] = '\u00e1[';
sjisconv['\u7549'] = '\u00e1Y';
sjisconv['\u754a'] = '\u00e1X';
sjisconv['\u754b'] = '\u009d\u00c0';
sjisconv['\u754c'] = '\u008aE';
sjisconv['\u754d'] = '\u00e1W';
sjisconv['\u754f'] = '\u0088\u00d8';
sjisconv['\u7551'] = '\u0094\u00a8';
sjisconv['\u7554'] = '\u0094\u00c8';
sjisconv['\u7559'] = '\u0097\u00af';
sjisconv['\u755a'] = '\u00e1\\';
sjisconv['\u755b'] = '\u00e1Z';
sjisconv['\u755c'] = '\u0092{';
sjisconv['\u755d'] = '\u0090\u00a4';
sjisconv['\u7560'] = '\u0094\u00a9';
sjisconv['\u7562'] = '\u0095L';
sjisconv['\u7564'] = '\u00e1^';
sjisconv['\u7565'] = '\u0097\u00aa';
sjisconv['\u7566'] = '\u008cl';
sjisconv['\u7567'] = '\u00e1_';
sjisconv['\u7569'] = '\u00e1]';
sjisconv['\u756a'] = '\u0094\u00d4';
sjisconv['\u756b'] = '\u00e1`';
sjisconv['\u756d'] = '\u00e1a';
sjisconv['\u7570'] = '\u0088\u00d9';
sjisconv['\u7573'] = '\u008f\u00f4';
sjisconv['\u7574'] = '\u00e1f';
sjisconv['\u7576'] = '\u00e1c';
sjisconv['\u7577'] = '\u0093\u00eb';
sjisconv['\u7578'] = '\u00e1b';
sjisconv['\u757f'] = '\u008bE';
sjisconv['\u7582'] = '\u00e1i';
sjisconv['\u7586'] = '\u00e1d';
sjisconv['\u7587'] = '\u00e1e';
sjisconv['\u7589'] = '\u00e1h';
sjisconv['\u758a'] = '\u00e1g';
sjisconv['\u758b'] = '\u0095D';
sjisconv['\u758e'] = '\u0091a';
sjisconv['\u758f'] = '\u0091`';
sjisconv['\u7591'] = '\u008b^';
sjisconv['\u7594'] = '\u00e1j';
sjisconv['\u759a'] = '\u00e1k';
sjisconv['\u759d'] = '\u00e1l';
sjisconv['\u75a3'] = '\u00e1n';
sjisconv['\u75a5'] = '\u00e1m';
sjisconv['\u75ab'] = '\u0089u';
sjisconv['\u75b1'] = '\u00e1v';
sjisconv['\u75b2'] = '\u0094\u00e6';
sjisconv['\u75b3'] = '\u00e1p';
sjisconv['\u75b5'] = '\u00e1r';
sjisconv['\u75b8'] = '\u00e1t';
sjisconv['\u75b9'] = '\u0090]';
sjisconv['\u75bc'] = '\u00e1u';
sjisconv['\u75bd'] = '\u00e1s';
sjisconv['\u75be'] = '\u008e\u00be';
sjisconv['\u75c2'] = '\u00e1o';
sjisconv['\u75c3'] = '\u00e1q';
sjisconv['\u75c5'] = '\u0095a';
sjisconv['\u75c7'] = '\u008f\u00c7';
sjisconv['\u75ca'] = '\u00e1x';
sjisconv['\u75cd'] = '\u00e1w';
sjisconv['\u75d2'] = '\u00e1y';
sjisconv['\u75d4'] = '\u008e\u00a4';
sjisconv['\u75d5'] = '\u008d\u00ad';
sjisconv['\u75d8'] = '\u0093\u0097';
sjisconv['\u75d9'] = '\u00e1z';
sjisconv['\u75db'] = '\u0092\u00c9';
sjisconv['\u75de'] = '\u00e1|';
sjisconv['\u75e2'] = '\u0097\u009f';
sjisconv['\u75e3'] = '\u00e1{';
sjisconv['\u75e9'] = '\u0091\u0089';
sjisconv['\u75f0'] = '\u00e1\u0082';
sjisconv['\u75f2'] = '\u00e1\u0084';
sjisconv['\u75f3'] = '\u00e1\u0085';
sjisconv['\u75f4'] = '\u0092s';
sjisconv['\u75fa'] = '\u00e1\u0083';
sjisconv['\u75fc'] = '\u00e1\u0080';
sjisconv['\u75fe'] = '\u00e1}';
sjisconv['\u75ff'] = '\u00e1~';
sjisconv['\u7601'] = '\u00e1\u0081';
sjisconv['\u7609'] = '\u00e1\u0088';
sjisconv['\u760b'] = '\u00e1\u0086';
sjisconv['\u760d'] = '\u00e1\u0087';
sjisconv['\u761f'] = '\u00e1\u0089';
sjisconv['\u7620'] = '\u00e1\u008b';
sjisconv['\u7621'] = '\u00e1\u008c';
sjisconv['\u7622'] = '\u00e1\u008d';
sjisconv['\u7624'] = '\u00e1\u008e';
sjisconv['\u7627'] = '\u00e1\u008a';
sjisconv['\u7630'] = '\u00e1\u0090';
sjisconv['\u7634'] = '\u00e1\u008f';
sjisconv['\u763b'] = '\u00e1\u0091';
sjisconv['\u7642'] = '\u0097\u00c3';
sjisconv['\u7646'] = '\u00e1\u0094';
sjisconv['\u7647'] = '\u00e1\u0092';
sjisconv['\u7648'] = '\u00e1\u0093';
sjisconv['\u764c'] = '\u008a\u00e0';
sjisconv['\u7652'] = '\u0096\u00fc';
sjisconv['\u7656'] = '\u0095\u00c8';
sjisconv['\u7658'] = '\u00e1\u0096';
sjisconv['\u765c'] = '\u00e1\u0095';
sjisconv['\u7661'] = '\u00e1\u0097';
sjisconv['\u7662'] = '\u00e1\u0098';
sjisconv['\u7667'] = '\u00e1\u009c';
sjisconv['\u7668'] = '\u00e1\u0099';
sjisconv['\u7669'] = '\u00e1\u009a';
sjisconv['\u766a'] = '\u00e1\u009b';
sjisconv['\u766c'] = '\u00e1\u009d';
sjisconv['\u7670'] = '\u00e1\u009e';
sjisconv['\u7672'] = '\u00e1\u009f';
sjisconv['\u7676'] = '\u00e1\u00a0';
sjisconv['\u7678'] = '\u00e1\u00a1';
sjisconv['\u767a'] = '\u0094\u00ad';
sjisconv['\u767b'] = '\u0093o';
sjisconv['\u767c'] = '\u00e1\u00a2';
sjisconv['\u767d'] = '\u0094\u0092';
sjisconv['\u767e'] = '\u0095S';
sjisconv['\u7680'] = '\u00e1\u00a3';
sjisconv['\u7683'] = '\u00e1\u00a4';
sjisconv['\u7684'] = '\u0093I';
sjisconv['\u7686'] = '\u008aF';
sjisconv['\u7687'] = '\u008dc';
sjisconv['\u7688'] = '\u00e1\u00a5';
sjisconv['\u768b'] = '\u00e1\u00a6';
sjisconv['\u768e'] = '\u00e1\u00a7';
sjisconv['\u7690'] = '\u008eH';
sjisconv['\u7693'] = '\u00e1\u00a9';
sjisconv['\u7696'] = '\u00e1\u00a8';
sjisconv['\u7699'] = '\u00e1\u00aa';
sjisconv['\u769a'] = '\u00e1\u00ab';
sjisconv['\u76ae'] = '\u0094\u00e7';
sjisconv['\u76b0'] = '\u00e1\u00ac';
sjisconv['\u76b4'] = '\u00e1\u00ad';
sjisconv['\u76b7'] = '\u00ea\u0089';
sjisconv['\u76b8'] = '\u00e1\u00ae';
sjisconv['\u76b9'] = '\u00e1\u00af';
sjisconv['\u76ba'] = '\u00e1\u00b0';
sjisconv['\u76bf'] = '\u008eM';
sjisconv['\u76c2'] = '\u00e1\u00b1';
sjisconv['\u76c3'] = '\u0094u';
sjisconv['\u76c6'] = '\u0096~';
sjisconv['\u76c8'] = '\u0089m';
sjisconv['\u76ca'] = '\u0089v';
sjisconv['\u76cd'] = '\u00e1\u00b2';
sjisconv['\u76d2'] = '\u00e1\u00b4';
sjisconv['\u76d6'] = '\u00e1\u00b3';
sjisconv['\u76d7'] = '\u0093\u0090';
sjisconv['\u76db'] = '\u0090\u00b7';
sjisconv['\u76dc'] = '\u009fX';
sjisconv['\u76de'] = '\u00e1\u00b5';
sjisconv['\u76df'] = '\u0096\u00bf';
sjisconv['\u76e1'] = '\u00e1\u00b6';
sjisconv['\u76e3'] = '\u008a\u00c4';
sjisconv['\u76e4'] = '\u0094\u00d5';
sjisconv['\u76e5'] = '\u00e1\u00b7';
sjisconv['\u76e7'] = '\u00e1\u00b8';
sjisconv['\u76ea'] = '\u00e1\u00b9';
sjisconv['\u76ee'] = '\u0096\u00da';
sjisconv['\u76f2'] = '\u0096\u00d3';
sjisconv['\u76f4'] = '\u0092\u00bc';
sjisconv['\u76f8'] = '\u0091\u008a';
sjisconv['\u76fb'] = '\u00e1\u00bb';
sjisconv['\u76fe'] = '\u008f\u0082';
sjisconv['\u7701'] = '\u008f\u00c8';
sjisconv['\u7704'] = '\u00e1\u00be';
sjisconv['\u7707'] = '\u00e1\u00bd';
sjisconv['\u7708'] = '\u00e1\u00bc';
sjisconv['\u7709'] = '\u0094\u00fb';
sjisconv['\u770b'] = '\u008a\u00c5';
sjisconv['\u770c'] = '\u008c\u00a7';
sjisconv['\u771b'] = '\u00e1\u00c4';
sjisconv['\u771e'] = '\u00e1\u00c1';
sjisconv['\u771f'] = '\u0090^';
sjisconv['\u7720'] = '\u0096\u00b0';
sjisconv['\u7724'] = '\u00e1\u00c0';
sjisconv['\u7725'] = '\u00e1\u00c2';
sjisconv['\u7726'] = '\u00e1\u00c3';
sjisconv['\u7729'] = '\u00e1\u00bf';
sjisconv['\u7737'] = '\u00e1\u00c5';
sjisconv['\u7738'] = '\u00e1\u00c6';
sjisconv['\u773a'] = '\u0092\u00ad';
sjisconv['\u773c'] = '\u008a\u00e1';
sjisconv['\u7740'] = '\u0092\u0085';
sjisconv['\u7747'] = '\u00e1\u00c7';
sjisconv['\u775a'] = '\u00e1\u00c8';
sjisconv['\u775b'] = '\u00e1\u00cb';
sjisconv['\u7761'] = '\u0090\u0087';
sjisconv['\u7763'] = '\u0093\u00c2';
sjisconv['\u7765'] = '\u00e1\u00cc';
sjisconv['\u7766'] = '\u0096r';
sjisconv['\u7768'] = '\u00e1\u00c9';
sjisconv['\u776b'] = '\u00e1\u00ca';
sjisconv['\u7779'] = '\u00e1\u00cf';
sjisconv['\u777e'] = '\u00e1\u00ce';
sjisconv['\u777f'] = '\u00e1\u00cd';
sjisconv['\u778b'] = '\u00e1\u00d1';
sjisconv['\u778e'] = '\u00e1\u00d0';
sjisconv['\u7791'] = '\u00e1\u00d2';
sjisconv['\u779e'] = '\u00e1\u00d4';
sjisconv['\u77a0'] = '\u00e1\u00d3';
sjisconv['\u77a5'] = '\u0095\u00cb';
sjisconv['\u77ac'] = '\u008fu';
sjisconv['\u77ad'] = '\u0097\u00c4';
sjisconv['\u77b0'] = '\u00e1\u00d5';
sjisconv['\u77b3'] = '\u0093\u00b5';
sjisconv['\u77b6'] = '\u00e1\u00d6';
sjisconv['\u77b9'] = '\u00e1\u00d7';
sjisconv['\u77bb'] = '\u00e1\u00db';
sjisconv['\u77bc'] = '\u00e1\u00d9';
sjisconv['\u77bd'] = '\u00e1\u00da';
sjisconv['\u77bf'] = '\u00e1\u00d8';
sjisconv['\u77c7'] = '\u00e1\u00dc';
sjisconv['\u77cd'] = '\u00e1\u00dd';
sjisconv['\u77d7'] = '\u00e1\u00de';
sjisconv['\u77da'] = '\u00e1\u00df';
sjisconv['\u77db'] = '\u0096\u00b5';
sjisconv['\u77dc'] = '\u00e1\u00e0';
sjisconv['\u77e2'] = '\u0096\u00ee';
sjisconv['\u77e3'] = '\u00e1\u00e1';
sjisconv['\u77e5'] = '\u0092m';
sjisconv['\u77e7'] = '\u0094\u008a';
sjisconv['\u77e9'] = '\u008b\u00e9';
sjisconv['\u77ed'] = '\u0092Z';
sjisconv['\u77ee'] = '\u00e1\u00e2';
sjisconv['\u77ef'] = '\u008b\u00b8';
sjisconv['\u77f3'] = '\u0090\u00ce';
sjisconv['\u77fc'] = '\u00e1\u00e3';
sjisconv['\u7802'] = '\u008d\u00bb';
sjisconv['\u780c'] = '\u00e1\u00e4';
sjisconv['\u7812'] = '\u00e1\u00e5';
sjisconv['\u7814'] = '\u008c\u00a4';
sjisconv['\u7815'] = '\u008d\u00d3';
sjisconv['\u7820'] = '\u00e1\u00e7';
sjisconv['\u7825'] = '\u0093u';
sjisconv['\u7826'] = '\u008d\u00d4';
sjisconv['\u7827'] = '\u008bm';
sjisconv['\u7832'] = '\u0096C';
sjisconv['\u7834'] = '\u0094j';
sjisconv['\u783a'] = '\u0093v';
sjisconv['\u783f'] = '\u008d{';
sjisconv['\u7845'] = '\u00e1\u00e9';
sjisconv['\u785d'] = '\u008f\u00c9';
sjisconv['\u786b'] = '\u0097\u00b0';
sjisconv['\u786c'] = '\u008dd';
sjisconv['\u786f'] = '\u008c\u00a5';
sjisconv['\u7872'] = '\u0094\u00a1';
sjisconv['\u7874'] = '\u00e1\u00eb';
sjisconv['\u787c'] = '\u00e1\u00ed';
sjisconv['\u7881'] = '\u008c\u00e9';
sjisconv['\u7886'] = '\u00e1\u00ec';
sjisconv['\u7887'] = '\u0092\u00f4';
sjisconv['\u788c'] = '\u00e1\u00ef';
sjisconv['\u788d'] = '\u008aV';
sjisconv['\u788e'] = '\u00e1\u00ea';
sjisconv['\u7891'] = '\u0094\u00e8';
sjisconv['\u7893'] = '\u0089O';
sjisconv['\u7895'] = '\u008d\u00ea';
sjisconv['\u7897'] = '\u0098q';
sjisconv['\u789a'] = '\u00e1\u00ee';
sjisconv['\u78a3'] = '\u00e1\u00f0';
sjisconv['\u78a7'] = '\u0095\u00c9';
sjisconv['\u78a9'] = '\u0090\u00d7';
sjisconv['\u78aa'] = '\u00e1\u00f2';
sjisconv['\u78af'] = '\u00e1\u00f3';
sjisconv['\u78b5'] = '\u00e1\u00f1';
sjisconv['\u78ba'] = '\u008am';
sjisconv['\u78bc'] = '\u00e1\u00f9';
sjisconv['\u78be'] = '\u00e1\u00f8';
sjisconv['\u78c1'] = '\u008e\u00a5';
sjisconv['\u78c5'] = '\u00e1\u00fa';
sjisconv['\u78c6'] = '\u00e1\u00f5';
sjisconv['\u78ca'] = '\u00e1\u00fb';
sjisconv['\u78cb'] = '\u00e1\u00f6';
sjisconv['\u78d0'] = '\u0094\u00d6';
sjisconv['\u78d1'] = '\u00e1\u00f4';
sjisconv['\u78d4'] = '\u00e1\u00f7';
sjisconv['\u78da'] = '\u00e2A';
sjisconv['\u78e7'] = '\u00e2@';
sjisconv['\u78e8'] = '\u0096\u0081';
sjisconv['\u78ec'] = '\u00e1\u00fc';
sjisconv['\u78ef'] = '\u0088\u00e9';
sjisconv['\u78f4'] = '\u00e2C';
sjisconv['\u78fd'] = '\u00e2B';
sjisconv['\u7901'] = '\u008f\u00ca';
sjisconv['\u7907'] = '\u00e2D';
sjisconv['\u790e'] = '\u0091b';
sjisconv['\u7911'] = '\u00e2F';
sjisconv['\u7912'] = '\u00e2E';
sjisconv['\u7919'] = '\u00e2G';
sjisconv['\u7926'] = '\u00e1\u00e6';
sjisconv['\u792a'] = '\u00e1\u00e8';
sjisconv['\u792b'] = '\u00e2I';
sjisconv['\u792c'] = '\u00e2H';
sjisconv['\u793a'] = '\u008e\u00a6';
sjisconv['\u793c'] = '\u0097\u00e7';
sjisconv['\u793e'] = '\u008e\u00d0';
sjisconv['\u7940'] = '\u00e2J';
sjisconv['\u7941'] = '\u008cV';
sjisconv['\u7947'] = '\u008b_';
sjisconv['\u7948'] = '\u008bF';
sjisconv['\u7949'] = '\u008e\u0083';
sjisconv['\u7950'] = '\u0097S';
sjisconv['\u7953'] = '\u00e2P';
sjisconv['\u7955'] = '\u00e2O';
sjisconv['\u7956'] = '\u0091c';
sjisconv['\u7957'] = '\u00e2L';
sjisconv['\u795a'] = '\u00e2N';
sjisconv['\u795d'] = '\u008fj';
sjisconv['\u795e'] = '\u0090_';
sjisconv['\u795f'] = '\u00e2M';
sjisconv['\u7960'] = '\u00e2K';
sjisconv['\u7962'] = '\u0094I';
sjisconv['\u7965'] = '\u008f\u00cb';
sjisconv['\u7968'] = '\u0095[';
sjisconv['\u796d'] = '\u008d\u00d5';
sjisconv['\u7977'] = '\u0093\u0098';
sjisconv['\u797a'] = '\u00e2Q';
sjisconv['\u797f'] = '\u00e2R';
sjisconv['\u7980'] = '\u00e2h';
sjisconv['\u7981'] = '\u008b\u00d6';
sjisconv['\u7984'] = '\u0098\\';
sjisconv['\u7985'] = '\u0091T';
sjisconv['\u798a'] = '\u00e2S';
sjisconv['\u798d'] = '\u0089\u00d0';
sjisconv['\u798e'] = '\u0092\u00f5';
sjisconv['\u798f'] = '\u0095\u009f';
sjisconv['\u799d'] = '\u00e2T';
sjisconv['\u79a6'] = '\u008b\u009a';
sjisconv['\u79a7'] = '\u00e2U';
sjisconv['\u79aa'] = '\u00e2W';
sjisconv['\u79ae'] = '\u00e2X';
sjisconv['\u79b0'] = '\u0094H';
sjisconv['\u79b3'] = '\u00e2Y';
sjisconv['\u79b9'] = '\u00e2Z';
sjisconv['\u79ba'] = '\u00e2[';
sjisconv['\u79bd'] = '\u008b\u00d7';
sjisconv['\u79be'] = '\u0089\u00d1';
sjisconv['\u79bf'] = '\u0093\u00c3';
sjisconv['\u79c0'] = '\u008fG';
sjisconv['\u79c1'] = '\u008e\u0084';
sjisconv['\u79c9'] = '\u00e2\\';
sjisconv['\u79cb'] = '\u008fH';
sjisconv['\u79d1'] = '\u0089\u00c8';
sjisconv['\u79d2'] = '\u0095b';
sjisconv['\u79d5'] = '\u00e2]';
sjisconv['\u79d8'] = '\u0094\u00e9';
sjisconv['\u79df'] = '\u0091d';
sjisconv['\u79e1'] = '\u00e2`';
sjisconv['\u79e3'] = '\u00e2a';
sjisconv['\u79e4'] = '\u0094\u0089';
sjisconv['\u79e6'] = '\u0090`';
sjisconv['\u79e7'] = '\u00e2^';
sjisconv['\u79e9'] = '\u0092\u0081';
sjisconv['\u79ec'] = '\u00e2_';
sjisconv['\u79f0'] = '\u008f\u00cc';
sjisconv['\u79fb'] = '\u0088\u00da';
sjisconv['\u7a00'] = '\u008bH';
sjisconv['\u7a08'] = '\u00e2b';
sjisconv['\u7a0b'] = '\u0092\u00f6';
sjisconv['\u7a0d'] = '\u00e2c';
sjisconv['\u7a0e'] = '\u0090\u00c5';
sjisconv['\u7a14'] = '\u0096\u00ab';
sjisconv['\u7a17'] = '\u0095B';
sjisconv['\u7a18'] = '\u00e2d';
sjisconv['\u7a19'] = '\u00e2e';
sjisconv['\u7a1a'] = '\u0092t';
sjisconv['\u7a1c'] = '\u0097\u00c5';
sjisconv['\u7a1f'] = '\u00e2g';
sjisconv['\u7a20'] = '\u00e2f';
sjisconv['\u7a2e'] = '\u008e\u00ed';
sjisconv['\u7a31'] = '\u00e2i';
sjisconv['\u7a32'] = '\u0088\u00ee';
sjisconv['\u7a37'] = '\u00e2l';
sjisconv['\u7a3b'] = '\u00e2j';
sjisconv['\u7a3c'] = '\u0089\u00d2';
sjisconv['\u7a3d'] = '\u008cm';
sjisconv['\u7a3e'] = '\u00e2k';
sjisconv['\u7a3f'] = '\u008de';
sjisconv['\u7a40'] = '\u008d\u0092';
sjisconv['\u7a42'] = '\u0095\u00e4';
sjisconv['\u7a43'] = '\u00e2m';
sjisconv['\u7a46'] = '\u0096s';
sjisconv['\u7a49'] = '\u00e2o';
sjisconv['\u7a4d'] = '\u0090\u00cf';
sjisconv['\u7a4e'] = '\u0089n';
sjisconv['\u7a4f'] = '\u0089\u00b8';
sjisconv['\u7a50'] = '\u0088\u00aa';
sjisconv['\u7a57'] = '\u00e2n';
sjisconv['\u7a61'] = '\u00e2p';
sjisconv['\u7a62'] = '\u00e2q';
sjisconv['\u7a63'] = '\u008f\u00f5';
sjisconv['\u7a69'] = '\u00e2r';
sjisconv['\u7a6b'] = '\u008an';
sjisconv['\u7a70'] = '\u00e2t';
sjisconv['\u7a74'] = '\u008c\u008a';
sjisconv['\u7a76'] = '\u008b\u0086';
sjisconv['\u7a79'] = '\u00e2u';
sjisconv['\u7a7a'] = '\u008b\u00f3';
sjisconv['\u7a7d'] = '\u00e2v';
sjisconv['\u7a7f'] = '\u0090\u00fa';
sjisconv['\u7a81'] = '\u0093\u00cb';
sjisconv['\u7a83'] = '\u0090\u00de';
sjisconv['\u7a84'] = '\u008d\u00f3';
sjisconv['\u7a88'] = '\u00e2w';
sjisconv['\u7a92'] = '\u0092\u0082';
sjisconv['\u7a93'] = '\u0091\u008b';
sjisconv['\u7a95'] = '\u00e2y';
sjisconv['\u7a96'] = '\u00e2{';
sjisconv['\u7a97'] = '\u00e2x';
sjisconv['\u7a98'] = '\u00e2z';
sjisconv['\u7a9f'] = '\u008cA';
sjisconv['\u7aa9'] = '\u00e2|';
sjisconv['\u7aaa'] = '\u008cE';
sjisconv['\u7aae'] = '\u008b\u0087';
sjisconv['\u7aaf'] = '\u0097q';
sjisconv['\u7ab0'] = '\u00e2~';
sjisconv['\u7ab6'] = '\u00e2\u0080';
sjisconv['\u7aba'] = '\u0089M';
sjisconv['\u7abf'] = '\u00e2\u0083';
sjisconv['\u7ac3'] = '\u008a\u0096';
sjisconv['\u7ac4'] = '\u00e2\u0082';
sjisconv['\u7ac5'] = '\u00e2\u0081';
sjisconv['\u7ac7'] = '\u00e2\u0085';
sjisconv['\u7ac8'] = '\u00e2}';
sjisconv['\u7aca'] = '\u00e2\u0086';
sjisconv['\u7acb'] = '\u0097\u00a7';
sjisconv['\u7acd'] = '\u00e2\u0087';
sjisconv['\u7acf'] = '\u00e2\u0088';
sjisconv['\u7ad2'] = '\u009a\u00f2';
sjisconv['\u7ad3'] = '\u00e2\u008a';
sjisconv['\u7ad5'] = '\u00e2\u0089';
sjisconv['\u7ad9'] = '\u00e2\u008b';
sjisconv['\u7ada'] = '\u00e2\u008c';
sjisconv['\u7adc'] = '\u0097\u00b3';
sjisconv['\u7add'] = '\u00e2\u008d';
sjisconv['\u7adf'] = '\u00e8\u00ed';
sjisconv['\u7ae0'] = '\u008f\u00cd';
sjisconv['\u7ae1'] = '\u00e2\u008e';
sjisconv['\u7ae2'] = '\u00e2\u008f';
sjisconv['\u7ae3'] = '\u008fv';
sjisconv['\u7ae5'] = '\u0093\u00b6';
sjisconv['\u7ae6'] = '\u00e2\u0090';
sjisconv['\u7aea'] = '\u0092G';
sjisconv['\u7aed'] = '\u00e2\u0091';
sjisconv['\u7aef'] = '\u0092[';
sjisconv['\u7af0'] = '\u00e2\u0092';
sjisconv['\u7af6'] = '\u008b\u00a3';
sjisconv['\u7af8'] = '\u0099^';
sjisconv['\u7af9'] = '\u0092|';
sjisconv['\u7afa'] = '\u008e\u00b1';
sjisconv['\u7aff'] = '\u008a\u00c6';
sjisconv['\u7b02'] = '\u00e2\u0093';
sjisconv['\u7b04'] = '\u00e2\u00a0';
sjisconv['\u7b06'] = '\u00e2\u0096';
sjisconv['\u7b08'] = '\u008b\u0088';
sjisconv['\u7b0a'] = '\u00e2\u0095';
sjisconv['\u7b0b'] = '\u00e2\u00a2';
sjisconv['\u7b0f'] = '\u00e2\u0094';
sjisconv['\u7b11'] = '\u008f\u00ce';
sjisconv['\u7b18'] = '\u00e2\u0098';
sjisconv['\u7b19'] = '\u00e2\u0099';
sjisconv['\u7b1b'] = '\u0093J';
sjisconv['\u7b1e'] = '\u00e2\u009a';
sjisconv['\u7b20'] = '\u008a}';
sjisconv['\u7b25'] = '\u0090y';
sjisconv['\u7b26'] = '\u0095\u0084';
sjisconv['\u7b28'] = '\u00e2\u009c';
sjisconv['\u7b2c'] = '\u0091\u00e6';
sjisconv['\u7b33'] = '\u00e2\u0097';
sjisconv['\u7b35'] = '\u00e2\u009b';
sjisconv['\u7b36'] = '\u00e2\u009d';
sjisconv['\u7b39'] = '\u008d\u00f9';
sjisconv['\u7b45'] = '\u00e2\u00a4';
sjisconv['\u7b46'] = '\u0095M';
sjisconv['\u7b48'] = '\u0094\u00a4';
sjisconv['\u7b49'] = '\u0093\u0099';
sjisconv['\u7b4b'] = '\u008b\u00d8';
sjisconv['\u7b4c'] = '\u00e2\u00a3';
sjisconv['\u7b4d'] = '\u00e2\u00a1';
sjisconv['\u7b4f'] = '\u0094\u00b3';
sjisconv['\u7b50'] = '\u00e2\u009e';
sjisconv['\u7b51'] = '\u0092}';
sjisconv['\u7b52'] = '\u0093\u009b';
sjisconv['\u7b54'] = '\u0093\u009a';
sjisconv['\u7b56'] = '\u008d\u00f4';
sjisconv['\u7b5d'] = '\u00e2\u00b6';
sjisconv['\u7b65'] = '\u00e2\u00a6';
sjisconv['\u7b67'] = '\u00e2\u00a8';
sjisconv['\u7b6c'] = '\u00e2\u00ab';
sjisconv['\u7b6e'] = '\u00e2\u00ac';
sjisconv['\u7b70'] = '\u00e2\u00a9';
sjisconv['\u7b71'] = '\u00e2\u00aa';
sjisconv['\u7b74'] = '\u00e2\u00a7';
sjisconv['\u7b75'] = '\u00e2\u00a5';
sjisconv['\u7b7a'] = '\u00e2\u009f';
sjisconv['\u7b86'] = '\u0095\u00cd';
sjisconv['\u7b87'] = '\u0089\u00d3';
sjisconv['\u7b8b'] = '\u00e2\u00b3';
sjisconv['\u7b8d'] = '\u00e2\u00b0';
sjisconv['\u7b8f'] = '\u00e2\u00b5';
sjisconv['\u7b92'] = '\u00e2\u00b4';
sjisconv['\u7b94'] = '\u0094\u0093';
sjisconv['\u7b95'] = '\u0096\u00a5';
sjisconv['\u7b97'] = '\u008eZ';
sjisconv['\u7b98'] = '\u00e2\u00ae';
sjisconv['\u7b99'] = '\u00e2\u00b7';
sjisconv['\u7b9a'] = '\u00e2\u00b2';
sjisconv['\u7b9c'] = '\u00e2\u00b1';
sjisconv['\u7b9d'] = '\u00e2\u00ad';
sjisconv['\u7b9f'] = '\u00e2\u00af';
sjisconv['\u7ba1'] = '\u008a\u00c7';
sjisconv['\u7baa'] = '\u0092\\';
sjisconv['\u7bad'] = '\u0090\u00fb';
sjisconv['\u7bb1'] = '\u0094\u00a0';
sjisconv['\u7bb4'] = '\u00e2\u00bc';
sjisconv['\u7bb8'] = '\u0094\u00a2';
sjisconv['\u7bc0'] = '\u0090\u00df';
sjisconv['\u7bc1'] = '\u00e2\u00b9';
sjisconv['\u7bc4'] = '\u0094\u00cd';
sjisconv['\u7bc6'] = '\u00e2\u00bd';
sjisconv['\u7bc7'] = '\u0095\u00d1';
sjisconv['\u7bc9'] = '\u0092z';
sjisconv['\u7bcb'] = '\u00e2\u00b8';
sjisconv['\u7bcc'] = '\u00e2\u00ba';
sjisconv['\u7bcf'] = '\u00e2\u00bb';
sjisconv['\u7bdd'] = '\u00e2\u00be';
sjisconv['\u7be0'] = '\u008e\u00c2';
sjisconv['\u7be4'] = '\u0093\u00c4';
sjisconv['\u7be5'] = '\u00e2\u00c3';
sjisconv['\u7be6'] = '\u00e2\u00c2';
sjisconv['\u7be9'] = '\u00e2\u00bf';
sjisconv['\u7bed'] = '\u0098U';
sjisconv['\u7bf3'] = '\u00e2\u00c8';
sjisconv['\u7bf6'] = '\u00e2\u00cc';
sjisconv['\u7bf7'] = '\u00e2\u00c9';
sjisconv['\u7c00'] = '\u00e2\u00c5';
sjisconv['\u7c07'] = '\u00e2\u00c6';
sjisconv['\u7c0d'] = '\u00e2\u00cb';
sjisconv['\u7c11'] = '\u00e2\u00c0';
sjisconv['\u7c12'] = '\u0099\u00d3';
sjisconv['\u7c13'] = '\u00e2\u00c7';
sjisconv['\u7c14'] = '\u00e2\u00c1';
sjisconv['\u7c17'] = '\u00e2\u00ca';
sjisconv['\u7c1f'] = '\u00e2\u00d0';
sjisconv['\u7c21'] = '\u008a\u00c8';
sjisconv['\u7c23'] = '\u00e2\u00cd';
sjisconv['\u7c27'] = '\u00e2\u00ce';
sjisconv['\u7c2a'] = '\u00e2\u00cf';
sjisconv['\u7c2b'] = '\u00e2\u00d2';
sjisconv['\u7c37'] = '\u00e2\u00d1';
sjisconv['\u7c38'] = '\u0094\u00f4';
sjisconv['\u7c3d'] = '\u00e2\u00d3';
sjisconv['\u7c3e'] = '\u0097\u00fa';
sjisconv['\u7c3f'] = '\u0095\u00eb';
sjisconv['\u7c40'] = '\u00e2\u00d8';
sjisconv['\u7c43'] = '\u00e2\u00d5';
sjisconv['\u7c4c'] = '\u00e2\u00d4';
sjisconv['\u7c4d'] = '\u0090\u00d0';
sjisconv['\u7c4f'] = '\u00e2\u00d7';
sjisconv['\u7c50'] = '\u00e2\u00d9';
sjisconv['\u7c54'] = '\u00e2\u00d6';
sjisconv['\u7c56'] = '\u00e2\u00dd';
sjisconv['\u7c58'] = '\u00e2\u00da';
sjisconv['\u7c5f'] = '\u00e2\u00db';
sjisconv['\u7c60'] = '\u00e2\u00c4';
sjisconv['\u7c64'] = '\u00e2\u00dc';
sjisconv['\u7c65'] = '\u00e2\u00de';
sjisconv['\u7c6c'] = '\u00e2\u00df';
sjisconv['\u7c73'] = '\u0095\u00c4';
sjisconv['\u7c75'] = '\u00e2\u00e0';
sjisconv['\u7c7e'] = '\u0096\u00e0';
sjisconv['\u7c81'] = '\u008b\u00cc';
sjisconv['\u7c82'] = '\u008cH';
sjisconv['\u7c83'] = '\u00e2\u00e1';
sjisconv['\u7c89'] = '\u0095\u00b2';
sjisconv['\u7c8b'] = '\u0090\u0088';
sjisconv['\u7c8d'] = '\u0096\u00ae';
sjisconv['\u7c90'] = '\u00e2\u00e2';
sjisconv['\u7c92'] = '\u0097\u00b1';
sjisconv['\u7c95'] = '\u0094\u0094';
sjisconv['\u7c97'] = '\u0091e';
sjisconv['\u7c98'] = '\u0094S';
sjisconv['\u7c9b'] = '\u008fl';
sjisconv['\u7c9f'] = '\u0088\u00be';
sjisconv['\u7ca1'] = '\u00e2\u00e7';
sjisconv['\u7ca2'] = '\u00e2\u00e5';
sjisconv['\u7ca4'] = '\u00e2\u00e3';
sjisconv['\u7ca5'] = '\u008a\u009f';
sjisconv['\u7ca7'] = '\u008f\u00cf';
sjisconv['\u7ca8'] = '\u00e2\u00e8';
sjisconv['\u7cab'] = '\u00e2\u00e6';
sjisconv['\u7cad'] = '\u00e2\u00e4';
sjisconv['\u7cae'] = '\u00e2\u00ec';
sjisconv['\u7cb1'] = '\u00e2\u00eb';
sjisconv['\u7cb2'] = '\u00e2\u00ea';
sjisconv['\u7cb3'] = '\u00e2\u00e9';
sjisconv['\u7cb9'] = '\u00e2\u00ed';
sjisconv['\u7cbd'] = '\u00e2\u00ee';
sjisconv['\u7cbe'] = '\u0090\u00b8';
sjisconv['\u7cc0'] = '\u00e2\u00ef';
sjisconv['\u7cc2'] = '\u00e2\u00f1';
sjisconv['\u7cc5'] = '\u00e2\u00f0';
sjisconv['\u7cca'] = '\u008c\u00d0';
sjisconv['\u7cce'] = '\u0091W';
sjisconv['\u7cd2'] = '\u00e2\u00f3';
sjisconv['\u7cd6'] = '\u0093\u009c';
sjisconv['\u7cd8'] = '\u00e2\u00f2';
sjisconv['\u7cdc'] = '\u00e2\u00f4';
sjisconv['\u7cde'] = '\u0095\u00b3';
sjisconv['\u7cdf'] = '\u0091\u008c';
sjisconv['\u7ce0'] = '\u008df';
sjisconv['\u7ce2'] = '\u00e2\u00f5';
sjisconv['\u7ce7'] = '\u0097\u00c6';
sjisconv['\u7cef'] = '\u00e2\u00f7';
sjisconv['\u7cf2'] = '\u00e2\u00f8';
sjisconv['\u7cf4'] = '\u00e2\u00f9';
sjisconv['\u7cf6'] = '\u00e2\u00fa';
sjisconv['\u7cf8'] = '\u008e\u0085';
sjisconv['\u7cfa'] = '\u00e2\u00fb';
sjisconv['\u7cfb'] = '\u008cn';
sjisconv['\u7cfe'] = '\u008b\u008a';
sjisconv['\u7d00'] = '\u008bI';
sjisconv['\u7d02'] = '\u00e3@';
sjisconv['\u7d04'] = '\u0096\u00f1';
sjisconv['\u7d05'] = '\u008dg';
sjisconv['\u7d06'] = '\u00e2\u00fc';
sjisconv['\u7d0a'] = '\u00e3C';
sjisconv['\u7d0b'] = '\u0096\u00e4';
sjisconv['\u7d0d'] = '\u0094[';
sjisconv['\u7d10'] = '\u0095R';
sjisconv['\u7d14'] = '\u008f\u0083';
sjisconv['\u7d15'] = '\u00e3B';
sjisconv['\u7d17'] = '\u008e\u00d1';
sjisconv['\u7d18'] = '\u008dh';
sjisconv['\u7d19'] = '\u008e\u0086';
sjisconv['\u7d1a'] = '\u008b\u0089';
sjisconv['\u7d1b'] = '\u0095\u00b4';
sjisconv['\u7d1c'] = '\u00e3A';
sjisconv['\u7d20'] = '\u0091f';
sjisconv['\u7d21'] = '\u0096a';
sjisconv['\u7d22'] = '\u008d\u00f5';
sjisconv['\u7d2b'] = '\u008e\u0087';
sjisconv['\u7d2c'] = '\u0092\u00db';
sjisconv['\u7d2e'] = '\u00e3F';
sjisconv['\u7d2f'] = '\u0097\u00dd';
sjisconv['\u7d30'] = '\u008d\u00d7';
sjisconv['\u7d32'] = '\u00e3G';
sjisconv['\u7d33'] = '\u0090a';
sjisconv['\u7d35'] = '\u00e3I';
sjisconv['\u7d39'] = '\u008f\u00d0';
sjisconv['\u7d3a'] = '\u008d\u00ae';
sjisconv['\u7d3f'] = '\u00e3H';
sjisconv['\u7d42'] = '\u008fI';
sjisconv['\u7d43'] = '\u008c\u00bc';
sjisconv['\u7d44'] = '\u0091g';
sjisconv['\u7d45'] = '\u00e3D';
sjisconv['\u7d46'] = '\u00e3J';
sjisconv['\u7d4b'] = '\u00e3E';
sjisconv['\u7d4c'] = '\u008co';
sjisconv['\u7d4e'] = '\u00e3M';
sjisconv['\u7d4f'] = '\u00e3Q';
sjisconv['\u7d50'] = '\u008c\u008b';
sjisconv['\u7d56'] = '\u00e3L';
sjisconv['\u7d5b'] = '\u00e3U';
sjisconv['\u7d5e'] = '\u008di';
sjisconv['\u7d61'] = '\u0097\u008d';
sjisconv['\u7d62'] = '\u0088\u00ba';
sjisconv['\u7d63'] = '\u00e3R';
sjisconv['\u7d66'] = '\u008b\u008b';
sjisconv['\u7d68'] = '\u00e3O';
sjisconv['\u7d6e'] = '\u00e3P';
sjisconv['\u7d71'] = '\u0093\u009d';
sjisconv['\u7d72'] = '\u00e3N';
sjisconv['\u7d73'] = '\u00e3K';
sjisconv['\u7d75'] = '\u008aG';
sjisconv['\u7d76'] = '\u0090\u00e2';
sjisconv['\u7d79'] = '\u008c\u00a6';
sjisconv['\u7d7d'] = '\u00e3W';
sjisconv['\u7d89'] = '\u00e3T';
sjisconv['\u7d8f'] = '\u00e3V';
sjisconv['\u7d93'] = '\u00e3S';
sjisconv['\u7d99'] = '\u008cp';
sjisconv['\u7d9a'] = '\u0091\u00b1';
sjisconv['\u7d9b'] = '\u00e3X';
sjisconv['\u7d9c'] = '\u0091\u008e';
sjisconv['\u7d9f'] = '\u00e3e';
sjisconv['\u7da2'] = '\u00e3a';
sjisconv['\u7da3'] = '\u00e3[';
sjisconv['\u7dab'] = '\u00e3_';
sjisconv['\u7dac'] = '\u008e\u00f8';
sjisconv['\u7dad'] = '\u0088\u00db';
sjisconv['\u7dae'] = '\u00e3Z';
sjisconv['\u7daf'] = '\u00e3b';
sjisconv['\u7db0'] = '\u00e3f';
sjisconv['\u7db1'] = '\u008dj';
sjisconv['\u7db2'] = '\u0096\u00d4';
sjisconv['\u7db4'] = '\u0092\u00d4';
sjisconv['\u7db5'] = '\u00e3\\';
sjisconv['\u7db8'] = '\u00e3d';
sjisconv['\u7dba'] = '\u00e3Y';
sjisconv['\u7dbb'] = '\u0092]';
sjisconv['\u7dbd'] = '\u00e3^';
sjisconv['\u7dbe'] = '\u0088\u00bb';
sjisconv['\u7dbf'] = '\u0096\u00c8';
sjisconv['\u7dc7'] = '\u00e3]';
sjisconv['\u7dca'] = '\u008b\u00d9';
sjisconv['\u7dcb'] = '\u0094\u00ea';
sjisconv['\u7dcf'] = '\u0091\u008d';
sjisconv['\u7dd1'] = '\u0097\u00ce';
sjisconv['\u7dd2'] = '\u008f\u008f';
sjisconv['\u7dd5'] = '\u00e3\u008e';
sjisconv['\u7dd8'] = '\u00e3g';
sjisconv['\u7dda'] = '\u0090\u00fc';
sjisconv['\u7ddc'] = '\u00e3c';
sjisconv['\u7ddd'] = '\u00e3h';
sjisconv['\u7dde'] = '\u00e3j';
sjisconv['\u7de0'] = '\u0092\u00f7';
sjisconv['\u7de1'] = '\u00e3m';
sjisconv['\u7de4'] = '\u00e3i';
sjisconv['\u7de8'] = '\u0095\u00d2';
sjisconv['\u7de9'] = '\u008a\u00c9';
sjisconv['\u7dec'] = '\u0096\u00c9';
sjisconv['\u7def'] = '\u0088\u00dc';
sjisconv['\u7df2'] = '\u00e3l';
sjisconv['\u7df4'] = '\u0097\u00fb';
sjisconv['\u7dfb'] = '\u00e3k';
sjisconv['\u7e01'] = '\u0089\u008f';
sjisconv['\u7e04'] = '\u0093\u00ea';
sjisconv['\u7e05'] = '\u00e3n';
sjisconv['\u7e09'] = '\u00e3u';
sjisconv['\u7e0a'] = '\u00e3o';
sjisconv['\u7e0b'] = '\u00e3v';
sjisconv['\u7e12'] = '\u00e3r';
sjisconv['\u7e1b'] = '\u0094\u009b';
sjisconv['\u7e1e'] = '\u008e\u00c8';
sjisconv['\u7e1f'] = '\u00e3t';
sjisconv['\u7e21'] = '\u00e3q';
sjisconv['\u7e22'] = '\u00e3w';
sjisconv['\u7e23'] = '\u00e3p';
sjisconv['\u7e26'] = '\u008fc';
sjisconv['\u7e2b'] = '\u0096D';
sjisconv['\u7e2e'] = '\u008fk';
sjisconv['\u7e31'] = '\u00e3s';
sjisconv['\u7e32'] = '\u00e3\u0080';
sjisconv['\u7e35'] = '\u00e3{';
sjisconv['\u7e37'] = '\u00e3~';
sjisconv['\u7e39'] = '\u00e3|';
sjisconv['\u7e3a'] = '\u00e3\u0081';
sjisconv['\u7e3b'] = '\u00e3z';
sjisconv['\u7e3d'] = '\u00e3`';
sjisconv['\u7e3e'] = '\u0090\u00d1';
sjisconv['\u7e41'] = '\u0094\u00c9';
sjisconv['\u7e43'] = '\u00e3}';
sjisconv['\u7e46'] = '\u00e3x';
sjisconv['\u7e4a'] = '\u0091@';
sjisconv['\u7e4b'] = '\u008cq';
sjisconv['\u7e4d'] = '\u008fJ';
sjisconv['\u7e54'] = '\u0090D';
sjisconv['\u7e55'] = '\u0091U';
sjisconv['\u7e56'] = '\u00e3\u0084';
sjisconv['\u7e59'] = '\u00e3\u0086';
sjisconv['\u7e5a'] = '\u00e3\u0087';
sjisconv['\u7e5d'] = '\u00e3\u0083';
sjisconv['\u7e5e'] = '\u00e3\u0085';
sjisconv['\u7e66'] = '\u00e3y';
sjisconv['\u7e67'] = '\u00e3\u0082';
sjisconv['\u7e69'] = '\u00e3\u008a';
sjisconv['\u7e6a'] = '\u00e3\u0089';
sjisconv['\u7e6d'] = '\u0096\u009a';
sjisconv['\u7e70'] = '\u008cJ';
sjisconv['\u7e79'] = '\u00e3\u0088';
sjisconv['\u7e7b'] = '\u00e3\u008c';
sjisconv['\u7e7c'] = '\u00e3\u008b';
sjisconv['\u7e7d'] = '\u00e3\u008f';
sjisconv['\u7e7f'] = '\u00e3\u0091';
sjisconv['\u7e82'] = '\u008e[';
sjisconv['\u7e83'] = '\u00e3\u008d';
sjisconv['\u7e88'] = '\u00e3\u0092';
sjisconv['\u7e89'] = '\u00e3\u0093';
sjisconv['\u7e8c'] = '\u00e3\u0094';
sjisconv['\u7e8e'] = '\u00e3\u009a';
sjisconv['\u7e8f'] = '\u0093Z';
sjisconv['\u7e90'] = '\u00e3\u0096';
sjisconv['\u7e92'] = '\u00e3\u0095';
sjisconv['\u7e93'] = '\u00e3\u0097';
sjisconv['\u7e94'] = '\u00e3\u0098';
sjisconv['\u7e96'] = '\u00e3\u0099';
sjisconv['\u7e9b'] = '\u00e3\u009b';
sjisconv['\u7e9c'] = '\u00e3\u009c';
sjisconv['\u7f36'] = '\u008a\u00ca';
sjisconv['\u7f38'] = '\u00e3\u009d';
sjisconv['\u7f3a'] = '\u00e3\u009e';
sjisconv['\u7f45'] = '\u00e3\u009f';
sjisconv['\u7f4c'] = '\u00e3\u00a0';
sjisconv['\u7f4d'] = '\u00e3\u00a1';
sjisconv['\u7f4e'] = '\u00e3\u00a2';
sjisconv['\u7f50'] = '\u00e3\u00a3';
sjisconv['\u7f51'] = '\u00e3\u00a4';
sjisconv['\u7f54'] = '\u00e3\u00a6';
sjisconv['\u7f55'] = '\u00e3\u00a5';
sjisconv['\u7f58'] = '\u00e3\u00a7';
sjisconv['\u7f5f'] = '\u00e3\u00a8';
sjisconv['\u7f60'] = '\u00e3\u00a9';
sjisconv['\u7f67'] = '\u00e3\u00ac';
sjisconv['\u7f68'] = '\u00e3\u00aa';
sjisconv['\u7f69'] = '\u00e3\u00ab';
sjisconv['\u7f6a'] = '\u008d\u00df';
sjisconv['\u7f6b'] = '\u008cr';
sjisconv['\u7f6e'] = '\u0092u';
sjisconv['\u7f70'] = '\u0094\u00b1';
sjisconv['\u7f72'] = '\u008f\u0090';
sjisconv['\u7f75'] = '\u0094l';
sjisconv['\u7f77'] = '\u0094\u00eb';
sjisconv['\u7f78'] = '\u00e3\u00ad';
sjisconv['\u7f79'] = '\u009c\u00eb';
sjisconv['\u7f82'] = '\u00e3\u00ae';
sjisconv['\u7f83'] = '\u00e3\u00b0';
sjisconv['\u7f85'] = '\u0097\u0085';
sjisconv['\u7f86'] = '\u00e3\u00af';
sjisconv['\u7f87'] = '\u00e3\u00b2';
sjisconv['\u7f88'] = '\u00e3\u00b1';
sjisconv['\u7f8a'] = '\u0097r';
sjisconv['\u7f8c'] = '\u00e3\u00b3';
sjisconv['\u7f8e'] = '\u0094\u00fc';
sjisconv['\u7f94'] = '\u00e3\u00b4';
sjisconv['\u7f9a'] = '\u00e3\u00b7';
sjisconv['\u7f9d'] = '\u00e3\u00b6';
sjisconv['\u7f9e'] = '\u00e3\u00b5';
sjisconv['\u7fa3'] = '\u00e3\u00b8';
sjisconv['\u7fa4'] = '\u008cQ';
sjisconv['\u7fa8'] = '\u0091A';
sjisconv['\u7fa9'] = '\u008b`';
sjisconv['\u7fae'] = '\u00e3\u00bc';
sjisconv['\u7faf'] = '\u00e3\u00b9';
sjisconv['\u7fb2'] = '\u00e3\u00ba';
sjisconv['\u7fb6'] = '\u00e3\u00bd';
sjisconv['\u7fb8'] = '\u00e3\u00be';
sjisconv['\u7fb9'] = '\u00e3\u00bb';
sjisconv['\u7fbd'] = '\u0089H';
sjisconv['\u7fc1'] = '\u0089\u00a5';
sjisconv['\u7fc5'] = '\u00e3\u00c0';
sjisconv['\u7fc6'] = '\u00e3\u00c1';
sjisconv['\u7fca'] = '\u00e3\u00c2';
sjisconv['\u7fcc'] = '\u0097\u0082';
sjisconv['\u7fd2'] = '\u008fK';
sjisconv['\u7fd4'] = '\u00e3\u00c4';
sjisconv['\u7fd5'] = '\u00e3\u00c3';
sjisconv['\u7fe0'] = '\u0090\u0089';
sjisconv['\u7fe1'] = '\u00e3\u00c5';
sjisconv['\u7fe6'] = '\u00e3\u00c6';
sjisconv['\u7fe9'] = '\u00e3\u00c7';
sjisconv['\u7feb'] = '\u008a\u00e3';
sjisconv['\u7ff0'] = '\u008a\u00cb';
sjisconv['\u7ff3'] = '\u00e3\u00c8';
sjisconv['\u7ff9'] = '\u00e3\u00c9';
sjisconv['\u7ffb'] = '\u0096|';
sjisconv['\u7ffc'] = '\u0097\u0083';
sjisconv['\u8000'] = '\u0097s';
sjisconv['\u8001'] = '\u0098V';
sjisconv['\u8003'] = '\u008dl';
sjisconv['\u8004'] = '\u00e3\u00cc';
sjisconv['\u8005'] = '\u008e\u00d2';
sjisconv['\u8006'] = '\u00e3\u00cb';
sjisconv['\u800b'] = '\u00e3\u00cd';
sjisconv['\u800c'] = '\u008e\u00a7';
sjisconv['\u8010'] = '\u0091\u00cf';
sjisconv['\u8012'] = '\u00e3\u00ce';
sjisconv['\u8015'] = '\u008dk';
sjisconv['\u8017'] = '\u0096\u00d5';
sjisconv['\u8018'] = '\u00e3\u00cf';
sjisconv['\u8019'] = '\u00e3\u00d0';
sjisconv['\u801c'] = '\u00e3\u00d1';
sjisconv['\u8021'] = '\u00e3\u00d2';
sjisconv['\u8028'] = '\u00e3\u00d3';
sjisconv['\u8033'] = '\u008e\u00a8';
sjisconv['\u8036'] = '\u0096\u00eb';
sjisconv['\u803b'] = '\u00e3\u00d5';
sjisconv['\u803d'] = '\u0092^';
sjisconv['\u803f'] = '\u00e3\u00d4';
sjisconv['\u8046'] = '\u00e3\u00d7';
sjisconv['\u804a'] = '\u00e3\u00d6';
sjisconv['\u8052'] = '\u00e3\u00d8';
sjisconv['\u8056'] = '\u0090\u00b9';
sjisconv['\u8058'] = '\u00e3\u00d9';
sjisconv['\u805a'] = '\u00e3\u00da';
sjisconv['\u805e'] = '\u0095\u00b7';
sjisconv['\u805f'] = '\u00e3\u00db';
sjisconv['\u8061'] = '\u0091\u008f';
sjisconv['\u8062'] = '\u00e3\u00dc';
sjisconv['\u8068'] = '\u00e3\u00dd';
sjisconv['\u806f'] = '\u0097\u00fc';
sjisconv['\u8070'] = '\u00e3\u00e0';
sjisconv['\u8072'] = '\u00e3\u00df';
sjisconv['\u8073'] = '\u00e3\u00de';
sjisconv['\u8074'] = '\u0092\u00ae';
sjisconv['\u8076'] = '\u00e3\u00e1';
sjisconv['\u8077'] = '\u0090E';
sjisconv['\u8079'] = '\u00e3\u00e2';
sjisconv['\u807d'] = '\u00e3\u00e3';
sjisconv['\u807e'] = '\u0098W';
sjisconv['\u807f'] = '\u00e3\u00e4';
sjisconv['\u8084'] = '\u00e3\u00e5';
sjisconv['\u8085'] = '\u00e3\u00e7';
sjisconv['\u8086'] = '\u00e3\u00e6';
sjisconv['\u8087'] = '\u0094\u00a3';
sjisconv['\u8089'] = '\u0093\u00f7';
sjisconv['\u808b'] = '\u0098]';
sjisconv['\u808c'] = '\u0094\u00a7';
sjisconv['\u8093'] = '\u00e3\u00e9';
sjisconv['\u8096'] = '\u008f\u00d1';
sjisconv['\u8098'] = '\u0095I';
sjisconv['\u809a'] = '\u00e3\u00ea';
sjisconv['\u809b'] = '\u00e3\u00e8';
sjisconv['\u809d'] = '\u008a\u00cc';
sjisconv['\u80a1'] = '\u008c\u00d2';
sjisconv['\u80a2'] = '\u008e\u0088';
sjisconv['\u80a5'] = '\u0094\u00ec';
sjisconv['\u80a9'] = '\u008c\u00a8';
sjisconv['\u80aa'] = '\u0096b';
sjisconv['\u80ac'] = '\u00e3\u00ed';
sjisconv['\u80ad'] = '\u00e3\u00eb';
sjisconv['\u80af'] = '\u008dm';
sjisconv['\u80b1'] = '\u008dn';
sjisconv['\u80b2'] = '\u0088\u00e7';
sjisconv['\u80b4'] = '\u008d\u00e6';
sjisconv['\u80ba'] = '\u0094x';
sjisconv['\u80c3'] = '\u0088\u00dd';
sjisconv['\u80c4'] = '\u00e3\u00f2';
sjisconv['\u80c6'] = '\u0092_';
sjisconv['\u80cc'] = '\u0094w';
sjisconv['\u80ce'] = '\u0091\u00d9';
sjisconv['\u80d6'] = '\u00e3\u00f4';
sjisconv['\u80d9'] = '\u00e3\u00f0';
sjisconv['\u80da'] = '\u00e3\u00f3';
sjisconv['\u80db'] = '\u00e3\u00ee';
sjisconv['\u80dd'] = '\u00e3\u00f1';
sjisconv['\u80de'] = '\u0096E';
sjisconv['\u80e1'] = '\u008c\u00d3';
sjisconv['\u80e4'] = '\u0088\u00fb';
sjisconv['\u80e5'] = '\u00e3\u00ef';
sjisconv['\u80ef'] = '\u00e3\u00f6';
sjisconv['\u80f1'] = '\u00e3\u00f7';
sjisconv['\u80f4'] = '\u0093\u00b7';
sjisconv['\u80f8'] = '\u008b\u00b9';
sjisconv['\u80fc'] = '\u00e4E';
sjisconv['\u80fd'] = '\u0094\\';
sjisconv['\u8102'] = '\u008e\u0089';
sjisconv['\u8105'] = '\u008b\u00ba';
sjisconv['\u8106'] = '\u0090\u00c6';
sjisconv['\u8107'] = '\u0098e';
sjisconv['\u8108'] = '\u0096\u00ac';
sjisconv['\u8109'] = '\u00e3\u00f5';
sjisconv['\u810a'] = '\u0090\u00d2';
sjisconv['\u811a'] = '\u008br';
sjisconv['\u811b'] = '\u00e3\u00f8';
sjisconv['\u8123'] = '\u00e3\u00fa';
sjisconv['\u8129'] = '\u00e3\u00f9';
sjisconv['\u812f'] = '\u00e3\u00fb';
sjisconv['\u8131'] = '\u0092E';
sjisconv['\u8133'] = '\u0094]';
sjisconv['\u8139'] = '\u0092\u00af';
sjisconv['\u813e'] = '\u00e4B';
sjisconv['\u8146'] = '\u00e4A';
sjisconv['\u814b'] = '\u00e3\u00fc';
sjisconv['\u814e'] = '\u0090t';
sjisconv['\u8150'] = '\u0095\u0085';
sjisconv['\u8151'] = '\u00e4D';
sjisconv['\u8153'] = '\u00e4C';
sjisconv['\u8154'] = '\u008do';
sjisconv['\u8155'] = '\u0098r';
sjisconv['\u815f'] = '\u00e4T';
sjisconv['\u8165'] = '\u00e4H';
sjisconv['\u8166'] = '\u00e4I';
sjisconv['\u816b'] = '\u008e\u00ee';
sjisconv['\u816e'] = '\u00e4G';
sjisconv['\u8170'] = '\u008d\u0098';
sjisconv['\u8171'] = '\u00e4F';
sjisconv['\u8174'] = '\u00e4J';
sjisconv['\u8178'] = '\u0092\u00b0';
sjisconv['\u8179'] = '\u0095\u00a0';
sjisconv['\u817a'] = '\u0091B';
sjisconv['\u817f'] = '\u0091\u00da';
sjisconv['\u8180'] = '\u00e4N';
sjisconv['\u8182'] = '\u00e4O';
sjisconv['\u8183'] = '\u00e4K';
sjisconv['\u8188'] = '\u00e4L';
sjisconv['\u818a'] = '\u00e4M';
sjisconv['\u818f'] = '\u008dp';
sjisconv['\u8193'] = '\u00e4U';
sjisconv['\u8195'] = '\u00e4Q';
sjisconv['\u819a'] = '\u0095\u0086';
sjisconv['\u819c'] = '\u0096\u008c';
sjisconv['\u819d'] = '\u0095G';
sjisconv['\u81a0'] = '\u00e4P';
sjisconv['\u81a3'] = '\u00e4S';
sjisconv['\u81a4'] = '\u00e4R';
sjisconv['\u81a8'] = '\u0096c';
sjisconv['\u81a9'] = '\u00e4V';
sjisconv['\u81b0'] = '\u00e4W';
sjisconv['\u81b3'] = '\u0091V';
sjisconv['\u81b5'] = '\u00e4X';
sjisconv['\u81b8'] = '\u00e4Z';
sjisconv['\u81ba'] = '\u00e4^';
sjisconv['\u81bd'] = '\u00e4[';
sjisconv['\u81be'] = '\u00e4Y';
sjisconv['\u81bf'] = '\u0094^';
sjisconv['\u81c0'] = '\u00e4\\';
sjisconv['\u81c2'] = '\u00e4]';
sjisconv['\u81c6'] = '\u0089\u00b0';
sjisconv['\u81c8'] = '\u00e4d';
sjisconv['\u81c9'] = '\u00e4_';
sjisconv['\u81cd'] = '\u00e4`';
sjisconv['\u81d1'] = '\u00e4a';
sjisconv['\u81d3'] = '\u0091\u009f';
sjisconv['\u81d8'] = '\u00e4c';
sjisconv['\u81d9'] = '\u00e4b';
sjisconv['\u81da'] = '\u00e4e';
sjisconv['\u81df'] = '\u00e4f';
sjisconv['\u81e0'] = '\u00e4g';
sjisconv['\u81e3'] = '\u0090b';
sjisconv['\u81e5'] = '\u0089\u00e7';
sjisconv['\u81e7'] = '\u00e4h';
sjisconv['\u81e8'] = '\u0097\u00d5';
sjisconv['\u81ea'] = '\u008e\u00a9';
sjisconv['\u81ed'] = '\u008fL';
sjisconv['\u81f3'] = '\u008e\u008a';
sjisconv['\u81f4'] = '\u0092v';
sjisconv['\u81fa'] = '\u00e4i';
sjisconv['\u81fb'] = '\u00e4j';
sjisconv['\u81fc'] = '\u0089P';
sjisconv['\u81fe'] = '\u00e4k';
sjisconv['\u8201'] = '\u00e4l';
sjisconv['\u8202'] = '\u00e4m';
sjisconv['\u8205'] = '\u00e4n';
sjisconv['\u8207'] = '\u00e4o';
sjisconv['\u8208'] = '\u008b\u00bb';
sjisconv['\u8209'] = '\u009d\u00a8';
sjisconv['\u820a'] = '\u00e4p';
sjisconv['\u820c'] = '\u0090\u00e3';
sjisconv['\u820d'] = '\u00e4q';
sjisconv['\u820e'] = '\u008e\u00c9';
sjisconv['\u8210'] = '\u00e4r';
sjisconv['\u8212'] = '\u0098\u00ae';
sjisconv['\u8216'] = '\u00e4s';
sjisconv['\u8217'] = '\u0095\u00dc';
sjisconv['\u8218'] = '\u008a\u00da';
sjisconv['\u821b'] = '\u0091C';
sjisconv['\u821c'] = '\u008fw';
sjisconv['\u821e'] = '\u0095\u0091';
sjisconv['\u821f'] = '\u008fM';
sjisconv['\u8229'] = '\u00e4t';
sjisconv['\u822a'] = '\u008dq';
sjisconv['\u822b'] = '\u00e4u';
sjisconv['\u822c'] = '\u0094\u00ca';
sjisconv['\u822e'] = '\u00e4\u0084';
sjisconv['\u8233'] = '\u00e4w';
sjisconv['\u8235'] = '\u0091\u00c7';
sjisconv['\u8236'] = '\u0094\u0095';
sjisconv['\u8237'] = '\u008c\u00bd';
sjisconv['\u8238'] = '\u00e4v';
sjisconv['\u8239'] = '\u0091D';
sjisconv['\u8240'] = '\u00e4x';
sjisconv['\u8247'] = '\u0092\u00f8';
sjisconv['\u8258'] = '\u00e4z';
sjisconv['\u8259'] = '\u00e4y';
sjisconv['\u825a'] = '\u00e4|';
sjisconv['\u825d'] = '\u00e4{';
sjisconv['\u825f'] = '\u00e4}';
sjisconv['\u8262'] = '\u00e4\u0080';
sjisconv['\u8264'] = '\u00e4~';
sjisconv['\u8266'] = '\u008a\u00cd';
sjisconv['\u8268'] = '\u00e4\u0081';
sjisconv['\u826a'] = '\u00e4\u0082';
sjisconv['\u826b'] = '\u00e4\u0083';
sjisconv['\u826e'] = '\u008d\u00af';
sjisconv['\u826f'] = '\u0097\u00c7';
sjisconv['\u8271'] = '\u00e4\u0085';
sjisconv['\u8272'] = '\u0090F';
sjisconv['\u8276'] = '\u0089\u0090';
sjisconv['\u8277'] = '\u00e4\u0086';
sjisconv['\u8278'] = '\u00e4\u0087';
sjisconv['\u827e'] = '\u00e4\u0088';
sjisconv['\u828b'] = '\u0088\u00f0';
sjisconv['\u828d'] = '\u00e4\u0089';
sjisconv['\u8292'] = '\u00e4\u008a';
sjisconv['\u8299'] = '\u0095\u0087';
sjisconv['\u829d'] = '\u008e\u00c5';
sjisconv['\u829f'] = '\u00e4\u008c';
sjisconv['\u82a5'] = '\u008aH';
sjisconv['\u82a6'] = '\u0088\u00b0';
sjisconv['\u82ab'] = '\u00e4\u008b';
sjisconv['\u82ac'] = '\u00e4\u008e';
sjisconv['\u82ad'] = '\u0094m';
sjisconv['\u82af'] = '\u0090c';
sjisconv['\u82b1'] = '\u0089\u00d4';
sjisconv['\u82b3'] = '\u0096F';
sjisconv['\u82b8'] = '\u008c|';
sjisconv['\u82b9'] = '\u008b\u00da';
sjisconv['\u82bb'] = '\u00e4\u008d';
sjisconv['\u82bd'] = '\u0089\u00e8';
sjisconv['\u82c5'] = '\u008a\u00a1';
sjisconv['\u82d1'] = '\u0089\u0091';
sjisconv['\u82d2'] = '\u00e4\u0092';
sjisconv['\u82d3'] = '\u0097\u00e8';
sjisconv['\u82d4'] = '\u0091\u00db';
sjisconv['\u82d7'] = '\u0095c';
sjisconv['\u82d9'] = '\u00e4\u009e';
sjisconv['\u82db'] = '\u0089\u00d5';
sjisconv['\u82dc'] = '\u00e4\u009c';
sjisconv['\u82de'] = '\u00e4\u009a';
sjisconv['\u82df'] = '\u00e4\u0091';
sjisconv['\u82e1'] = '\u00e4\u008f';
sjisconv['\u82e3'] = '\u00e4\u0090';
sjisconv['\u82e5'] = '\u008e\u00e1';
sjisconv['\u82e6'] = '\u008b\u00ea';
sjisconv['\u82e7'] = '\u0092\u0097';
sjisconv['\u82eb'] = '\u0093\u00cf';
sjisconv['\u82f1'] = '\u0089p';
sjisconv['\u82f3'] = '\u00e4\u0094';
sjisconv['\u82f4'] = '\u00e4\u0093';
sjisconv['\u82f9'] = '\u00e4\u0099';
sjisconv['\u82fa'] = '\u00e4\u0095';
sjisconv['\u82fb'] = '\u00e4\u0098';
sjisconv['\u8302'] = '\u0096\u00ce';
sjisconv['\u8303'] = '\u00e4\u0097';
sjisconv['\u8304'] = '\u0089\u00d6';
sjisconv['\u8305'] = '\u008a\u009d';
sjisconv['\u8306'] = '\u00e4\u009b';
sjisconv['\u8309'] = '\u00e4\u009d';
sjisconv['\u830e'] = '\u008cs';
sjisconv['\u8316'] = '\u00e4\u00a1';
sjisconv['\u8317'] = '\u00e4\u00aa';
sjisconv['\u8318'] = '\u00e4\u00ab';
sjisconv['\u831c'] = '\u0088\u00a9';
sjisconv['\u8323'] = '\u00e4\u00b2';
sjisconv['\u8328'] = '\u0088\u00ef';
sjisconv['\u832b'] = '\u00e4\u00a9';
sjisconv['\u832f'] = '\u00e4\u00a8';
sjisconv['\u8331'] = '\u00e4\u00a3';
sjisconv['\u8332'] = '\u00e4\u00a2';
sjisconv['\u8334'] = '\u00e4\u00a0';
sjisconv['\u8335'] = '\u00e4\u009f';
sjisconv['\u8336'] = '\u0092\u0083';
sjisconv['\u8338'] = '\u0091\u00f9';
sjisconv['\u8339'] = '\u00e4\u00a5';
sjisconv['\u8340'] = '\u00e4\u00a4';
sjisconv['\u8345'] = '\u00e4\u00a7';
sjisconv['\u8349'] = '\u0091\u0090';
sjisconv['\u834a'] = '\u008ct';
sjisconv['\u834f'] = '\u0089`';
sjisconv['\u8350'] = '\u00e4\u00a6';
sjisconv['\u8352'] = '\u008dr';
sjisconv['\u8358'] = '\u0091\u0091';
sjisconv['\u8373'] = '\u00e4\u00b8';
sjisconv['\u8375'] = '\u00e4\u00b9';
sjisconv['\u8377'] = '\u0089\u00d7';
sjisconv['\u837b'] = '\u0089\u00ac';
sjisconv['\u837c'] = '\u00e4\u00b6';
sjisconv['\u8385'] = '\u00e4\u00ac';
sjisconv['\u8387'] = '\u00e4\u00b4';
sjisconv['\u8389'] = '\u00e4\u00bb';
sjisconv['\u838a'] = '\u00e4\u00b5';
sjisconv['\u838e'] = '\u00e4\u00b3';
sjisconv['\u8393'] = '\u00e4\u0096';
sjisconv['\u8396'] = '\u00e4\u00b1';
sjisconv['\u839a'] = '\u00e4\u00ad';
sjisconv['\u839e'] = '\u008a\u00ce';
sjisconv['\u839f'] = '\u00e4\u00af';
sjisconv['\u83a0'] = '\u00e4\u00ba';
sjisconv['\u83a2'] = '\u00e4\u00b0';
sjisconv['\u83a8'] = '\u00e4\u00bc';
sjisconv['\u83aa'] = '\u00e4\u00ae';
sjisconv['\u83ab'] = '\u0094\u009c';
sjisconv['\u83b1'] = '\u0097\u0089';
sjisconv['\u83b5'] = '\u00e4\u00b7';
sjisconv['\u83bd'] = '\u00e4\u00cd';
sjisconv['\u83c1'] = '\u00e4\u00c5';
sjisconv['\u83c5'] = '\u0090\u009b';
sjisconv['\u83ca'] = '\u008be';
sjisconv['\u83cc'] = '\u008b\u00db';
sjisconv['\u83ce'] = '\u00e4\u00c0';
sjisconv['\u83d3'] = '\u0089\u00d9';
sjisconv['\u83d6'] = '\u008f\u00d2';
sjisconv['\u83d8'] = '\u00e4\u00c3';
sjisconv['\u83dc'] = '\u008d\u00d8';
sjisconv['\u83df'] = '\u0093p';
sjisconv['\u83e0'] = '\u00e4\u00c8';
sjisconv['\u83e9'] = '\u0095\u00ec';
sjisconv['\u83eb'] = '\u00e4\u00bf';
sjisconv['\u83ef'] = '\u0089\u00d8';
sjisconv['\u83f0'] = '\u008c\u00d4';
sjisconv['\u83f1'] = '\u0095H';
sjisconv['\u83f2'] = '\u00e4\u00c9';
sjisconv['\u83f4'] = '\u00e4\u00bd';
sjisconv['\u83f7'] = '\u00e4\u00c6';
sjisconv['\u83fb'] = '\u00e4\u00d0';
sjisconv['\u83fd'] = '\u00e4\u00c1';
sjisconv['\u8403'] = '\u00e4\u00c2';
sjisconv['\u8404'] = '\u0093\u00b8';
sjisconv['\u8407'] = '\u00e4\u00c7';
sjisconv['\u840b'] = '\u00e4\u00c4';
sjisconv['\u840c'] = '\u0096G';
sjisconv['\u840d'] = '\u00e4\u00ca';
sjisconv['\u840e'] = '\u0088\u00de';
sjisconv['\u8413'] = '\u00e4\u00be';
sjisconv['\u8420'] = '\u00e4\u00cc';
sjisconv['\u8422'] = '\u00e4\u00cb';
sjisconv['\u8429'] = '\u0094\u008b';
sjisconv['\u842a'] = '\u00e4\u00d2';
sjisconv['\u842c'] = '\u00e4\u00dd';
sjisconv['\u8431'] = '\u008a\u009e';
sjisconv['\u8435'] = '\u00e4\u00e0';
sjisconv['\u8438'] = '\u00e4\u00ce';
sjisconv['\u843c'] = '\u00e4\u00d3';
sjisconv['\u843d'] = '\u0097\u008e';
sjisconv['\u8446'] = '\u00e4\u00dc';
sjisconv['\u8449'] = '\u0097t';
sjisconv['\u844e'] = '\u0097\u00a8';
sjisconv['\u8457'] = '\u0092\u0098';
sjisconv['\u845b'] = '\u008a\u008b';
sjisconv['\u8461'] = '\u0095\u0092';
sjisconv['\u8462'] = '\u00e4\u00e2';
sjisconv['\u8463'] = '\u0093\u009f';
sjisconv['\u8466'] = '\u0088\u00af';
sjisconv['\u8469'] = '\u00e4\u00db';
sjisconv['\u846b'] = '\u00e4\u00d7';
sjisconv['\u846c'] = '\u0091\u0092';
sjisconv['\u846d'] = '\u00e4\u00d1';
sjisconv['\u846e'] = '\u00e4\u00d9';
sjisconv['\u846f'] = '\u00e4\u00de';
sjisconv['\u8471'] = '\u0094K';
sjisconv['\u8475'] = '\u0088\u00a8';
sjisconv['\u8477'] = '\u00e4\u00d6';
sjisconv['\u8479'] = '\u00e4\u00df';
sjisconv['\u847a'] = '\u0095\u0098';
sjisconv['\u8482'] = '\u00e4\u00da';
sjisconv['\u8484'] = '\u00e4\u00d5';
sjisconv['\u848b'] = '\u008f\u00d3';
sjisconv['\u8490'] = '\u008fN';
sjisconv['\u8494'] = '\u008e\u00aa';
sjisconv['\u8499'] = '\u0096\u00d6';
sjisconv['\u849c'] = '\u0095f';
sjisconv['\u849f'] = '\u00e4\u00e5';
sjisconv['\u84a1'] = '\u00e4\u00ee';
sjisconv['\u84ad'] = '\u00e4\u00d8';
sjisconv['\u84b2'] = '\u008a\u0097';
sjisconv['\u84b8'] = '\u008f\u00f6';
sjisconv['\u84b9'] = '\u00e4\u00e3';
sjisconv['\u84bb'] = '\u00e4\u00e8';
sjisconv['\u84bc'] = '\u0091\u0093';
sjisconv['\u84bf'] = '\u00e4\u00e4';
sjisconv['\u84c1'] = '\u00e4\u00eb';
sjisconv['\u84c4'] = '\u0092~';
sjisconv['\u84c6'] = '\u00e4\u00ec';
sjisconv['\u84c9'] = '\u0097u';
sjisconv['\u84ca'] = '\u00e4\u00e1';
sjisconv['\u84cb'] = '\u008aW';
sjisconv['\u84cd'] = '\u00e4\u00e7';
sjisconv['\u84d0'] = '\u00e4\u00ea';
sjisconv['\u84d1'] = '\u0096\u00aa';
sjisconv['\u84d6'] = '\u00e4\u00ed';
sjisconv['\u84d9'] = '\u00e4\u00e6';
sjisconv['\u84da'] = '\u00e4\u00e9';
sjisconv['\u84ec'] = '\u0096H';
sjisconv['\u84ee'] = '\u0098@';
sjisconv['\u84f4'] = '\u00e4\u00f1';
sjisconv['\u84fc'] = '\u00e4\u00f8';
sjisconv['\u84ff'] = '\u00e4\u00f0';
sjisconv['\u8500'] = '\u008e\u00c1';
sjisconv['\u8506'] = '\u00e4\u00cf';
sjisconv['\u8511'] = '\u0095\u00cc';
sjisconv['\u8513'] = '\u0096\u00a0';
sjisconv['\u8514'] = '\u00e4\u00f7';
sjisconv['\u8515'] = '\u00e4\u00f6';
sjisconv['\u8517'] = '\u00e4\u00f2';
sjisconv['\u8518'] = '\u00e4\u00f3';
sjisconv['\u851a'] = '\u0089U';
sjisconv['\u851f'] = '\u00e4\u00f5';
sjisconv['\u8521'] = '\u00e4\u00ef';
sjisconv['\u8526'] = '\u0092\u00d3';
sjisconv['\u852c'] = '\u00e4\u00f4';
sjisconv['\u852d'] = '\u0088\u00fc';
sjisconv['\u8535'] = '\u0091\u00a0';
sjisconv['\u853d'] = '\u0095\u00c1';
sjisconv['\u8540'] = '\u00e4\u00f9';
sjisconv['\u8541'] = '\u00e5@';
sjisconv['\u8543'] = '\u0094\u00d7';
sjisconv['\u8548'] = '\u00e4\u00fc';
sjisconv['\u8549'] = '\u008f\u00d4';
sjisconv['\u854a'] = '\u008e\u00c7';
sjisconv['\u854b'] = '\u00e5B';
sjisconv['\u854e'] = '\u008b\u00bc';
sjisconv['\u8555'] = '\u00e5C';
sjisconv['\u8557'] = '\u0095\u0099';
sjisconv['\u8558'] = '\u00e4\u00fb';
sjisconv['\u855a'] = '\u00e4\u00d4';
sjisconv['\u8563'] = '\u00e4\u00fa';
sjisconv['\u8568'] = '\u0098n';
sjisconv['\u8569'] = '\u0093\u00a0';
sjisconv['\u856a'] = '\u0095\u0093';
sjisconv['\u856d'] = '\u00e5J';
sjisconv['\u8577'] = '\u00e5P';
sjisconv['\u857e'] = '\u00e5Q';
sjisconv['\u8580'] = '\u00e5D';
sjisconv['\u8584'] = '\u0094\u0096';
sjisconv['\u8587'] = '\u00e5N';
sjisconv['\u8588'] = '\u00e5F';
sjisconv['\u858a'] = '\u00e5H';
sjisconv['\u8590'] = '\u00e5R';
sjisconv['\u8591'] = '\u00e5G';
sjisconv['\u8594'] = '\u00e5K';
sjisconv['\u8597'] = '\u0089\u0092';
sjisconv['\u8599'] = '\u0093\u00e3';
sjisconv['\u859b'] = '\u00e5L';
sjisconv['\u859c'] = '\u00e5O';
sjisconv['\u85a4'] = '\u00e5E';
sjisconv['\u85a6'] = '\u0091E';
sjisconv['\u85a8'] = '\u00e5I';
sjisconv['\u85a9'] = '\u008eF';
sjisconv['\u85aa'] = '\u0090d';
sjisconv['\u85ab'] = '\u008cO';
sjisconv['\u85ac'] = '\u0096\u00f2';
sjisconv['\u85ae'] = '\u0096\u00f7';
sjisconv['\u85af'] = '\u008f\u0092';
sjisconv['\u85b9'] = '\u00e5V';
sjisconv['\u85ba'] = '\u00e5T';
sjisconv['\u85c1'] = '\u0098m';
sjisconv['\u85c9'] = '\u00e5S';
sjisconv['\u85cd'] = '\u0097\u0095';
sjisconv['\u85cf'] = '\u00e5U';
sjisconv['\u85d0'] = '\u00e5W';
sjisconv['\u85d5'] = '\u00e5X';
sjisconv['\u85dc'] = '\u00e5[';
sjisconv['\u85dd'] = '\u00e5Y';
sjisconv['\u85e4'] = '\u0093\u00a1';
sjisconv['\u85e5'] = '\u00e5Z';
sjisconv['\u85e9'] = '\u0094\u00cb';
sjisconv['\u85ea'] = '\u00e5M';
sjisconv['\u85f7'] = '\u008f\u0093';
sjisconv['\u85f9'] = '\u00e5\\';
sjisconv['\u85fa'] = '\u00e5a';
sjisconv['\u85fb'] = '\u0091\u0094';
sjisconv['\u85fe'] = '\u00e5`';
sjisconv['\u8602'] = '\u00e5A';
sjisconv['\u8606'] = '\u00e5b';
sjisconv['\u8607'] = '\u0091h';
sjisconv['\u860a'] = '\u00e5]';
sjisconv['\u860b'] = '\u00e5_';
sjisconv['\u8613'] = '\u00e5^';
sjisconv['\u8616'] = '\u009fP';
sjisconv['\u8617'] = '\u009fA';
sjisconv['\u861a'] = '\u00e5d';
sjisconv['\u8622'] = '\u00e5c';
sjisconv['\u862d'] = '\u0097\u0096';
sjisconv['\u862f'] = '\u00e1\u00ba';
sjisconv['\u8630'] = '\u00e5e';
sjisconv['\u863f'] = '\u00e5f';
sjisconv['\u864d'] = '\u00e5g';
sjisconv['\u864e'] = '\u008c\u00d5';
sjisconv['\u8650'] = '\u008bs';
sjisconv['\u8654'] = '\u00e5i';
sjisconv['\u8655'] = '\u0099|';
sjisconv['\u865a'] = '\u008b\u0095';
sjisconv['\u865c'] = '\u0097\u00b8';
sjisconv['\u865e'] = '\u008b\u00f1';
sjisconv['\u865f'] = '\u00e5j';
sjisconv['\u8667'] = '\u00e5k';
sjisconv['\u866b'] = '\u0092\u008e';
sjisconv['\u8671'] = '\u00e5l';
sjisconv['\u8679'] = '\u0093\u00f8';
sjisconv['\u867b'] = '\u0088\u00b8';
sjisconv['\u868a'] = '\u0089\u00e1';
sjisconv['\u868b'] = '\u00e5q';
sjisconv['\u868c'] = '\u00e5r';
sjisconv['\u8693'] = '\u00e5m';
sjisconv['\u8695'] = '\u008e\\';
sjisconv['\u86a3'] = '\u00e5n';
sjisconv['\u86a4'] = '\u0094a';
sjisconv['\u86a9'] = '\u00e5o';
sjisconv['\u86aa'] = '\u00e5p';
sjisconv['\u86ab'] = '\u00e5z';
sjisconv['\u86af'] = '\u00e5t';
sjisconv['\u86b0'] = '\u00e5w';
sjisconv['\u86b6'] = '\u00e5s';
sjisconv['\u86c4'] = '\u00e5u';
sjisconv['\u86c6'] = '\u00e5v';
sjisconv['\u86c7'] = '\u008e\u00d6';
sjisconv['\u86c9'] = '\u00e5x';
sjisconv['\u86cb'] = '\u0092`';
sjisconv['\u86cd'] = '\u008cu';
sjisconv['\u86ce'] = '\u008aa';
sjisconv['\u86d4'] = '\u00e5{';
sjisconv['\u86d9'] = '\u008a^';
sjisconv['\u86db'] = '\u00e5\u0081';
sjisconv['\u86de'] = '\u00e5|';
sjisconv['\u86df'] = '\u00e5\u0080';
sjisconv['\u86e4'] = '\u0094\u00b8';
sjisconv['\u86e9'] = '\u00e5}';
sjisconv['\u86ec'] = '\u00e5~';
sjisconv['\u86ed'] = '\u0095g';
sjisconv['\u86ee'] = '\u0094\u00d8';
sjisconv['\u86ef'] = '\u00e5\u0082';
sjisconv['\u86f8'] = '\u0091\u00fb';
sjisconv['\u86f9'] = '\u00e5\u008c';
sjisconv['\u86fb'] = '\u00e5\u0088';
sjisconv['\u86fe'] = '\u0089\u00e9';
sjisconv['\u8700'] = '\u00e5\u0086';
sjisconv['\u8702'] = '\u0096I';
sjisconv['\u8703'] = '\u00e5\u0087';
sjisconv['\u8706'] = '\u00e5\u0084';
sjisconv['\u8708'] = '\u00e5\u0085';
sjisconv['\u8709'] = '\u00e5\u008a';
sjisconv['\u870a'] = '\u00e5\u008d';
sjisconv['\u870d'] = '\u00e5\u008b';
sjisconv['\u8711'] = '\u00e5\u0089';
sjisconv['\u8712'] = '\u00e5\u0083';
sjisconv['\u8718'] = '\u0092w';
sjisconv['\u871a'] = '\u00e5\u0094';
sjisconv['\u871c'] = '\u0096\u00a8';
sjisconv['\u8725'] = '\u00e5\u0092';
sjisconv['\u8729'] = '\u00e5\u0093';
sjisconv['\u8734'] = '\u00e5\u008e';
sjisconv['\u8737'] = '\u00e5\u0090';
sjisconv['\u873b'] = '\u00e5\u0091';
sjisconv['\u873f'] = '\u00e5\u008f';
sjisconv['\u8749'] = '\u0090\u00e4';
sjisconv['\u874b'] = '\u0098X';
sjisconv['\u874c'] = '\u00e5\u0098';
sjisconv['\u874e'] = '\u00e5\u0099';
sjisconv['\u8753'] = '\u00e5\u009f';
sjisconv['\u8755'] = '\u0090I';
sjisconv['\u8757'] = '\u00e5\u009b';
sjisconv['\u8759'] = '\u00e5\u009e';
sjisconv['\u875f'] = '\u00e5\u0096';
sjisconv['\u8760'] = '\u00e5\u0095';
sjisconv['\u8763'] = '\u00e5\u00a0';
sjisconv['\u8766'] = '\u0089\u00da';
sjisconv['\u8768'] = '\u00e5\u009c';
sjisconv['\u876a'] = '\u00e5\u00a1';
sjisconv['\u876e'] = '\u00e5\u009d';
sjisconv['\u8774'] = '\u00e5\u009a';
sjisconv['\u8776'] = '\u0092\u00b1';
sjisconv['\u8778'] = '\u00e5\u0097';
sjisconv['\u877f'] = '\u0094\u0088';
sjisconv['\u8782'] = '\u00e5\u00a5';
sjisconv['\u878d'] = '\u0097Z';
sjisconv['\u879f'] = '\u00e5\u00a4';
sjisconv['\u87a2'] = '\u00e5\u00a3';
sjisconv['\u87ab'] = '\u00e5\u00ac';
sjisconv['\u87af'] = '\u00e5\u00a6';
sjisconv['\u87b3'] = '\u00e5\u00ae';
sjisconv['\u87ba'] = '\u0097\u0086';
sjisconv['\u87bb'] = '\u00e5\u00b1';
sjisconv['\u87bd'] = '\u00e5\u00a8';
sjisconv['\u87c0'] = '\u00e5\u00a9';
sjisconv['\u87c4'] = '\u00e5\u00ad';
sjisconv['\u87c6'] = '\u00e5\u00b0';
sjisconv['\u87c7'] = '\u00e5\u00af';
sjisconv['\u87cb'] = '\u00e5\u00a7';
sjisconv['\u87d0'] = '\u00e5\u00aa';
sjisconv['\u87d2'] = '\u00e5\u00bb';
sjisconv['\u87e0'] = '\u00e5\u00b4';
sjisconv['\u87ef'] = '\u00e5\u00b2';
sjisconv['\u87f2'] = '\u00e5\u00b3';
sjisconv['\u87f6'] = '\u00e5\u00b8';
sjisconv['\u87f7'] = '\u00e5\u00b9';
sjisconv['\u87f9'] = '\u008aI';
sjisconv['\u87fb'] = '\u008ba';
sjisconv['\u87fe'] = '\u00e5\u00b7';
sjisconv['\u8805'] = '\u00e5\u00a2';
sjisconv['\u880d'] = '\u00e5\u00b6';
sjisconv['\u880e'] = '\u00e5\u00ba';
sjisconv['\u880f'] = '\u00e5\u00b5';
sjisconv['\u8811'] = '\u00e5\u00bc';
sjisconv['\u8815'] = '\u00e5\u00be';
sjisconv['\u8816'] = '\u00e5\u00bd';
sjisconv['\u8821'] = '\u00e5\u00c0';
sjisconv['\u8822'] = '\u00e5\u00bf';
sjisconv['\u8823'] = '\u00e5y';
sjisconv['\u8827'] = '\u00e5\u00c4';
sjisconv['\u8831'] = '\u00e5\u00c1';
sjisconv['\u8836'] = '\u00e5\u00c2';
sjisconv['\u8839'] = '\u00e5\u00c3';
sjisconv['\u883b'] = '\u00e5\u00c5';
sjisconv['\u8840'] = '\u008c\u008c';
sjisconv['\u8842'] = '\u00e5\u00c7';
sjisconv['\u8844'] = '\u00e5\u00c6';
sjisconv['\u8846'] = '\u008fO';
sjisconv['\u884c'] = '\u008ds';
sjisconv['\u884d'] = '\u009f\u00a5';
sjisconv['\u8852'] = '\u00e5\u00c8';
sjisconv['\u8853'] = '\u008fp';
sjisconv['\u8857'] = '\u008aX';
sjisconv['\u8859'] = '\u00e5\u00c9';
sjisconv['\u885b'] = '\u0089q';
sjisconv['\u885d'] = '\u008f\u00d5';
sjisconv['\u885e'] = '\u00e5\u00ca';
sjisconv['\u8861'] = '\u008dt';
sjisconv['\u8862'] = '\u00e5\u00cb';
sjisconv['\u8863'] = '\u0088\u00df';
sjisconv['\u8868'] = '\u0095\\';
sjisconv['\u886b'] = '\u00e5\u00cc';
sjisconv['\u8870'] = '\u0090\u008a';
sjisconv['\u8872'] = '\u00e5\u00d3';
sjisconv['\u8875'] = '\u00e5\u00d0';
sjisconv['\u8877'] = '\u0092\u008f';
sjisconv['\u887d'] = '\u00e5\u00d1';
sjisconv['\u887e'] = '\u00e5\u00ce';
sjisconv['\u887f'] = '\u008b\u00dc';
sjisconv['\u8881'] = '\u00e5\u00cd';
sjisconv['\u8882'] = '\u00e5\u00d4';
sjisconv['\u8888'] = '\u008cU';
sjisconv['\u888b'] = '\u0091\u00dc';
sjisconv['\u888d'] = '\u00e5\u00da';
sjisconv['\u8892'] = '\u00e5\u00d6';
sjisconv['\u8896'] = '\u0091\u00b3';
sjisconv['\u8897'] = '\u00e5\u00d5';
sjisconv['\u8899'] = '\u00e5\u00d8';
sjisconv['\u889e'] = '\u00e5\u00cf';
sjisconv['\u88a2'] = '\u00e5\u00d9';
sjisconv['\u88a4'] = '\u00e5\u00db';
sjisconv['\u88ab'] = '\u0094\u00ed';
sjisconv['\u88ae'] = '\u00e5\u00d7';
sjisconv['\u88b0'] = '\u00e5\u00dc';
sjisconv['\u88b1'] = '\u00e5\u00de';
sjisconv['\u88b4'] = '\u008c\u00d1';
sjisconv['\u88b5'] = '\u00e5\u00d2';
sjisconv['\u88b7'] = '\u0088\u00bf';
sjisconv['\u88bf'] = '\u00e5\u00dd';
sjisconv['\u88c1'] = '\u008d\u00d9';
sjisconv['\u88c2'] = '\u0097\u00f4';
sjisconv['\u88c3'] = '\u00e5\u00df';
sjisconv['\u88c4'] = '\u00e5\u00e0';
sjisconv['\u88c5'] = '\u0091\u0095';
sjisconv['\u88cf'] = '\u0097\u00a0';
sjisconv['\u88d4'] = '\u00e5\u00e1';
sjisconv['\u88d5'] = '\u0097T';
sjisconv['\u88d8'] = '\u00e5\u00e2';
sjisconv['\u88d9'] = '\u00e5\u00e3';
sjisconv['\u88dc'] = '\u0095\u00e2';
sjisconv['\u88dd'] = '\u00e5\u00e4';
sjisconv['\u88df'] = '\u008d\u00be';
sjisconv['\u88e1'] = '\u0097\u00a1';
sjisconv['\u88e8'] = '\u00e5\u00e9';
sjisconv['\u88f2'] = '\u00e5\u00ea';
sjisconv['\u88f3'] = '\u008f\u00d6';
sjisconv['\u88f4'] = '\u00e5\u00e8';
sjisconv['\u88f8'] = '\u0097\u0087';
sjisconv['\u88f9'] = '\u00e5\u00e5';
sjisconv['\u88fc'] = '\u00e5\u00e7';
sjisconv['\u88fd'] = '\u0090\u00bb';
sjisconv['\u88fe'] = '\u0090\u009e';
sjisconv['\u8902'] = '\u00e5\u00e6';
sjisconv['\u8904'] = '\u00e5\u00eb';
sjisconv['\u8907'] = '\u0095\u00a1';
sjisconv['\u890a'] = '\u00e5\u00ed';
sjisconv['\u890c'] = '\u00e5\u00ec';
sjisconv['\u8910'] = '\u008a\u008c';
sjisconv['\u8912'] = '\u0096J';
sjisconv['\u8913'] = '\u00e5\u00ee';
sjisconv['\u891d'] = '\u00e5\u00fa';
sjisconv['\u891e'] = '\u00e5\u00f0';
sjisconv['\u8925'] = '\u00e5\u00f1';
sjisconv['\u892a'] = '\u00e5\u00f2';
sjisconv['\u892b'] = '\u00e5\u00f3';
sjisconv['\u8936'] = '\u00e5\u00f7';
sjisconv['\u8938'] = '\u00e5\u00f8';
sjisconv['\u893b'] = '\u00e5\u00f6';
sjisconv['\u8941'] = '\u00e5\u00f4';
sjisconv['\u8943'] = '\u00e5\u00ef';
sjisconv['\u8944'] = '\u00e5\u00f5';
sjisconv['\u894c'] = '\u00e5\u00f9';
sjisconv['\u894d'] = '\u00e8\u00b5';
sjisconv['\u8956'] = '\u0089\u00a6';
sjisconv['\u895e'] = '\u00e5\u00fc';
sjisconv['\u895f'] = '\u008b\u00dd';
sjisconv['\u8960'] = '\u00e5\u00fb';
sjisconv['\u8964'] = '\u00e6A';
sjisconv['\u8966'] = '\u00e6@';
sjisconv['\u896a'] = '\u00e6C';
sjisconv['\u896d'] = '\u00e6B';
sjisconv['\u896f'] = '\u00e6D';
sjisconv['\u8972'] = '\u008fP';
sjisconv['\u8974'] = '\u00e6E';
sjisconv['\u8977'] = '\u00e6F';
sjisconv['\u897e'] = '\u00e6G';
sjisconv['\u897f'] = '\u0090\u00bc';
sjisconv['\u8981'] = '\u0097v';
sjisconv['\u8983'] = '\u00e6H';
sjisconv['\u8986'] = '\u0095\u00a2';
sjisconv['\u8987'] = '\u0094e';
sjisconv['\u8988'] = '\u00e6I';
sjisconv['\u898a'] = '\u00e6J';
sjisconv['\u898b'] = '\u008c\u00a9';
sjisconv['\u898f'] = '\u008bK';
sjisconv['\u8993'] = '\u00e6K';
sjisconv['\u8996'] = '\u008e\u008b';
sjisconv['\u8997'] = '\u0094`';
sjisconv['\u8998'] = '\u00e6L';
sjisconv['\u899a'] = '\u008ao';
sjisconv['\u89a1'] = '\u00e6M';
sjisconv['\u89a6'] = '\u00e6O';
sjisconv['\u89a7'] = '\u0097\u0097';
sjisconv['\u89a9'] = '\u00e6N';
sjisconv['\u89aa'] = '\u0090e';
sjisconv['\u89ac'] = '\u00e6P';
sjisconv['\u89af'] = '\u00e6Q';
sjisconv['\u89b2'] = '\u00e6R';
sjisconv['\u89b3'] = '\u008a\u00cf';
sjisconv['\u89ba'] = '\u00e6S';
sjisconv['\u89bd'] = '\u00e6T';
sjisconv['\u89bf'] = '\u00e6U';
sjisconv['\u89c0'] = '\u00e6V';
sjisconv['\u89d2'] = '\u008ap';
sjisconv['\u89da'] = '\u00e6W';
sjisconv['\u89dc'] = '\u00e6X';
sjisconv['\u89dd'] = '\u00e6Y';
sjisconv['\u89e3'] = '\u0089\u00f0';
sjisconv['\u89e6'] = '\u0090G';
sjisconv['\u89e7'] = '\u00e6Z';
sjisconv['\u89f4'] = '\u00e6[';
sjisconv['\u89f8'] = '\u00e6\\';
sjisconv['\u8a00'] = '\u008c\u00be';
sjisconv['\u8a02'] = '\u0092\u00f9';
sjisconv['\u8a03'] = '\u00e6]';
sjisconv['\u8a08'] = '\u008cv';
sjisconv['\u8a0a'] = '\u0090u';
sjisconv['\u8a0c'] = '\u00e6`';
sjisconv['\u8a0e'] = '\u0093\u00a2';
sjisconv['\u8a10'] = '\u00e6_';
sjisconv['\u8a13'] = '\u008cP';
sjisconv['\u8a16'] = '\u00e6^';
sjisconv['\u8a17'] = '\u0091\u00f5';
sjisconv['\u8a18'] = '\u008bL';
sjisconv['\u8a1b'] = '\u00e6a';
sjisconv['\u8a1d'] = '\u00e6b';
sjisconv['\u8a1f'] = '\u008f\u00d7';
sjisconv['\u8a23'] = '\u008c\u008d';
sjisconv['\u8a25'] = '\u00e6c';
sjisconv['\u8a2a'] = '\u0096K';
sjisconv['\u8a2d'] = '\u0090\u00dd';
sjisconv['\u8a31'] = '\u008b\u0096';
sjisconv['\u8a33'] = '\u0096\u00f3';
sjisconv['\u8a34'] = '\u0091i';
sjisconv['\u8a36'] = '\u00e6d';
sjisconv['\u8a3a'] = '\u0090f';
sjisconv['\u8a3b'] = '\u0092\u0090';
sjisconv['\u8a3c'] = '\u008f\u00d8';
sjisconv['\u8a41'] = '\u00e6e';
sjisconv['\u8a46'] = '\u00e6h';
sjisconv['\u8a48'] = '\u00e6i';
sjisconv['\u8a50'] = '\u008d\u00bc';
sjisconv['\u8a51'] = '\u0091\u00c0';
sjisconv['\u8a52'] = '\u00e6g';
sjisconv['\u8a54'] = '\u008f\u00d9';
sjisconv['\u8a55'] = '\u0095]';
sjisconv['\u8a5b'] = '\u00e6f';
sjisconv['\u8a5e'] = '\u008e\u008c';
sjisconv['\u8a60'] = '\u0089r';
sjisconv['\u8a62'] = '\u00e6m';
sjisconv['\u8a63'] = '\u008cw';
sjisconv['\u8a66'] = '\u008e\u008e';
sjisconv['\u8a69'] = '\u008e\u008d';
sjisconv['\u8a6b'] = '\u0098l';
sjisconv['\u8a6c'] = '\u00e6l';
sjisconv['\u8a6d'] = '\u00e6k';
sjisconv['\u8a6e'] = '\u0091F';
sjisconv['\u8a70'] = '\u008bl';
sjisconv['\u8a71'] = '\u0098b';
sjisconv['\u8a72'] = '\u008aY';
sjisconv['\u8a73'] = '\u008f\u00da';
sjisconv['\u8a7c'] = '\u00e6j';
sjisconv['\u8a82'] = '\u00e6o';
sjisconv['\u8a84'] = '\u00e6p';
sjisconv['\u8a85'] = '\u00e6n';
sjisconv['\u8a87'] = '\u008c\u00d6';
sjisconv['\u8a89'] = '\u0097_';
sjisconv['\u8a8c'] = '\u008e\u008f';
sjisconv['\u8a8d'] = '\u0094F';
sjisconv['\u8a91'] = '\u00e6s';
sjisconv['\u8a93'] = '\u0090\u00be';
sjisconv['\u8a95'] = '\u0092a';
sjisconv['\u8a98'] = '\u0097U';
sjisconv['\u8a9a'] = '\u00e6v';
sjisconv['\u8a9e'] = '\u008c\u00ea';
sjisconv['\u8aa0'] = '\u0090\u00bd';
sjisconv['\u8aa1'] = '\u00e6r';
sjisconv['\u8aa3'] = '\u00e6w';
sjisconv['\u8aa4'] = '\u008c\u00eb';
sjisconv['\u8aa5'] = '\u00e6t';
sjisconv['\u8aa6'] = '\u00e6u';
sjisconv['\u8aa8'] = '\u00e6q';
sjisconv['\u8aac'] = '\u0090\u00e0';
sjisconv['\u8aad'] = '\u0093\u00c7';
sjisconv['\u8ab0'] = '\u0092N';
sjisconv['\u8ab2'] = '\u0089\u00db';
sjisconv['\u8ab9'] = '\u0094\u00ee';
sjisconv['\u8abc'] = '\u008bb';
sjisconv['\u8abf'] = '\u0092\u00b2';
sjisconv['\u8ac2'] = '\u00e6z';
sjisconv['\u8ac4'] = '\u00e6x';
sjisconv['\u8ac7'] = '\u0092k';
sjisconv['\u8acb'] = '\u0090\u00bf';
sjisconv['\u8acc'] = '\u008a\u00d0';
sjisconv['\u8acd'] = '\u00e6y';
sjisconv['\u8acf'] = '\u0090z';
sjisconv['\u8ad2'] = '\u0097\u00c8';
sjisconv['\u8ad6'] = '\u0098_';
sjisconv['\u8ada'] = '\u00e6{';
sjisconv['\u8adb'] = '\u00e6\u0087';
sjisconv['\u8adc'] = '\u0092\u00b3';
sjisconv['\u8ade'] = '\u00e6\u0086';
sjisconv['\u8ae0'] = '\u00e6\u0083';
sjisconv['\u8ae1'] = '\u00e6\u008b';
sjisconv['\u8ae2'] = '\u00e6\u0084';
sjisconv['\u8ae4'] = '\u00e6\u0080';
sjisconv['\u8ae6'] = '\u0092\u00fa';
sjisconv['\u8ae7'] = '\u00e6~';
sjisconv['\u8aeb'] = '\u00e6|';
sjisconv['\u8aed'] = '\u0097@';
sjisconv['\u8aee'] = '\u008e\u0090';
sjisconv['\u8af1'] = '\u00e6\u0081';
sjisconv['\u8af3'] = '\u00e6}';
sjisconv['\u8af7'] = '\u00e6\u0085';
sjisconv['\u8af8'] = '\u008f\u0094';
sjisconv['\u8afa'] = '\u008c\u00bf';
sjisconv['\u8afe'] = '\u0091\u00f8';
sjisconv['\u8b00'] = '\u0096d';
sjisconv['\u8b01'] = '\u0089y';
sjisconv['\u8b02'] = '\u0088\u00e0';
sjisconv['\u8b04'] = '\u0093\u00a3';
sjisconv['\u8b07'] = '\u00e6\u0089';
sjisconv['\u8b0c'] = '\u00e6\u0088';
sjisconv['\u8b0e'] = '\u0093\u00e4';
sjisconv['\u8b10'] = '\u00e6\u008d';
sjisconv['\u8b14'] = '\u00e6\u0082';
sjisconv['\u8b16'] = '\u00e6\u008c';
sjisconv['\u8b17'] = '\u00e6\u008e';
sjisconv['\u8b19'] = '\u008c\u00aa';
sjisconv['\u8b1a'] = '\u00e6\u008a';
sjisconv['\u8b1b'] = '\u008du';
sjisconv['\u8b1d'] = '\u008e\u00d3';
sjisconv['\u8b20'] = '\u00e6\u008f';
sjisconv['\u8b21'] = '\u0097w';
sjisconv['\u8b26'] = '\u00e6\u0092';
sjisconv['\u8b28'] = '\u00e6\u0095';
sjisconv['\u8b2b'] = '\u00e6\u0093';
sjisconv['\u8b2c'] = '\u0095T';
sjisconv['\u8b33'] = '\u00e6\u0090';
sjisconv['\u8b39'] = '\u008b\u00de';
sjisconv['\u8b3e'] = '\u00e6\u0094';
sjisconv['\u8b41'] = '\u00e6\u0096';
sjisconv['\u8b49'] = '\u00e6\u009a';
sjisconv['\u8b4c'] = '\u00e6\u0097';
sjisconv['\u8b4e'] = '\u00e6\u0099';
sjisconv['\u8b4f'] = '\u00e6\u0098';
sjisconv['\u8b56'] = '\u00e6\u009b';
sjisconv['\u8b58'] = '\u008e\u00af';
sjisconv['\u8b5a'] = '\u00e6\u009d';
sjisconv['\u8b5b'] = '\u00e6\u009c';
sjisconv['\u8b5c'] = '\u0095\u0088';
sjisconv['\u8b5f'] = '\u00e6\u009f';
sjisconv['\u8b66'] = '\u008cx';
sjisconv['\u8b6b'] = '\u00e6\u009e';
sjisconv['\u8b6c'] = '\u00e6\u00a0';
sjisconv['\u8b6f'] = '\u00e6\u00a1';
sjisconv['\u8b70'] = '\u008bc';
sjisconv['\u8b71'] = '\u00e3\u00bf';
sjisconv['\u8b72'] = '\u008f\u00f7';
sjisconv['\u8b74'] = '\u00e6\u00a2';
sjisconv['\u8b77'] = '\u008c\u00ec';
sjisconv['\u8b7d'] = '\u00e6\u00a3';
sjisconv['\u8b80'] = '\u00e6\u00a4';
sjisconv['\u8b83'] = '\u008e]';
sjisconv['\u8b8a'] = '\u009d\u00cc';
sjisconv['\u8b8c'] = '\u00e6\u00a5';
sjisconv['\u8b8e'] = '\u00e6\u00a6';
sjisconv['\u8b90'] = '\u008fQ';
sjisconv['\u8b92'] = '\u00e6\u00a7';
sjisconv['\u8b93'] = '\u00e6\u00a8';
sjisconv['\u8b96'] = '\u00e6\u00a9';
sjisconv['\u8b99'] = '\u00e6\u00aa';
sjisconv['\u8b9a'] = '\u00e6\u00ab';
sjisconv['\u8c37'] = '\u0092J';
sjisconv['\u8c3a'] = '\u00e6\u00ac';
sjisconv['\u8c3f'] = '\u00e6\u00ae';
sjisconv['\u8c41'] = '\u00e6\u00ad';
sjisconv['\u8c46'] = '\u0093\u00a4';
sjisconv['\u8c48'] = '\u00e6\u00af';
sjisconv['\u8c4a'] = '\u0096L';
sjisconv['\u8c4c'] = '\u00e6\u00b0';
sjisconv['\u8c4e'] = '\u00e6\u00b1';
sjisconv['\u8c50'] = '\u00e6\u00b2';
sjisconv['\u8c55'] = '\u00e6\u00b3';
sjisconv['\u8c5a'] = '\u0093\u00d8';
sjisconv['\u8c61'] = '\u008f\u00db';
sjisconv['\u8c62'] = '\u00e6\u00b4';
sjisconv['\u8c6a'] = '\u008d\u008b';
sjisconv['\u8c6b'] = '\u0098\u00ac';
sjisconv['\u8c6c'] = '\u00e6\u00b5';
sjisconv['\u8c78'] = '\u00e6\u00b6';
sjisconv['\u8c79'] = '\u0095^';
sjisconv['\u8c7a'] = '\u00e6\u00b7';
sjisconv['\u8c7c'] = '\u00e6\u00bf';
sjisconv['\u8c82'] = '\u00e6\u00b8';
sjisconv['\u8c85'] = '\u00e6\u00ba';
sjisconv['\u8c89'] = '\u00e6\u00b9';
sjisconv['\u8c8a'] = '\u00e6\u00bb';
sjisconv['\u8c8c'] = '\u0096e';
sjisconv['\u8c8d'] = '\u00e6\u00bc';
sjisconv['\u8c8e'] = '\u00e6\u00bd';
sjisconv['\u8c94'] = '\u00e6\u00be';
sjisconv['\u8c98'] = '\u00e6\u00c0';
sjisconv['\u8c9d'] = '\u008aL';
sjisconv['\u8c9e'] = '\u0092\u00e5';
sjisconv['\u8ca0'] = '\u0095\u0089';
sjisconv['\u8ca1'] = '\u008d\u00e0';
sjisconv['\u8ca2'] = '\u008dv';
sjisconv['\u8ca7'] = '\u0095n';
sjisconv['\u8ca8'] = '\u0089\u00dd';
sjisconv['\u8ca9'] = '\u0094\u00cc';
sjisconv['\u8caa'] = '\u00e6\u00c3';
sjisconv['\u8cab'] = '\u008a\u00d1';
sjisconv['\u8cac'] = '\u0090\u00d3';
sjisconv['\u8cad'] = '\u00e6\u00c2';
sjisconv['\u8cae'] = '\u00e6\u00c7';
sjisconv['\u8caf'] = '\u0092\u0099';
sjisconv['\u8cb0'] = '\u0096\u00e1';
sjisconv['\u8cb2'] = '\u00e6\u00c5';
sjisconv['\u8cb3'] = '\u00e6\u00c6';
sjisconv['\u8cb4'] = '\u008bM';
sjisconv['\u8cb6'] = '\u00e6\u00c8';
sjisconv['\u8cb7'] = '\u0094\u0083';
sjisconv['\u8cb8'] = '\u0091\u00dd';
sjisconv['\u8cbb'] = '\u0094\u00ef';
sjisconv['\u8cbc'] = '\u0093\\';
sjisconv['\u8cbd'] = '\u00e6\u00c4';
sjisconv['\u8cbf'] = '\u0096f';
sjisconv['\u8cc0'] = '\u0089\u00ea';
sjisconv['\u8cc1'] = '\u00e6\u00ca';
sjisconv['\u8cc2'] = '\u0098G';
sjisconv['\u8cc3'] = '\u0092\u00c0';
sjisconv['\u8cc4'] = '\u0098d';
sjisconv['\u8cc7'] = '\u008e\u0091';
sjisconv['\u8cc8'] = '\u00e6\u00c9';
sjisconv['\u8cca'] = '\u0091\u00af';
sjisconv['\u8ccd'] = '\u00e6\u00da';
sjisconv['\u8cce'] = '\u0091G';
sjisconv['\u8cd1'] = '\u0093\u00f6';
sjisconv['\u8cd3'] = '\u0095o';
sjisconv['\u8cda'] = '\u00e6\u00cd';
sjisconv['\u8cdb'] = '\u008e^';
sjisconv['\u8cdc'] = '\u008e\u0092';
sjisconv['\u8cde'] = '\u008f\u00dc';
sjisconv['\u8ce0'] = '\u0094\u0085';
sjisconv['\u8ce2'] = '\u008c\u00ab';
sjisconv['\u8ce3'] = '\u00e6\u00cc';
sjisconv['\u8ce4'] = '\u00e6\u00cb';
sjisconv['\u8ce6'] = '\u0095\u008a';
sjisconv['\u8cea'] = '\u008e\u00bf';
sjisconv['\u8ced'] = '\u0093q';
sjisconv['\u8cfa'] = '\u00e6\u00cf';
sjisconv['\u8cfb'] = '\u00e6\u00d0';
sjisconv['\u8cfc'] = '\u008dw';
sjisconv['\u8cfd'] = '\u00e6\u00ce';
sjisconv['\u8d04'] = '\u00e6\u00d1';
sjisconv['\u8d05'] = '\u00e6\u00d2';
sjisconv['\u8d07'] = '\u00e6\u00d4';
sjisconv['\u8d08'] = '\u0091\u00a1';
sjisconv['\u8d0a'] = '\u00e6\u00d3';
sjisconv['\u8d0b'] = '\u008a\u00e4';
sjisconv['\u8d0d'] = '\u00e6\u00d6';
sjisconv['\u8d0f'] = '\u00e6\u00d5';
sjisconv['\u8d10'] = '\u00e6\u00d7';
sjisconv['\u8d13'] = '\u00e6\u00d9';
sjisconv['\u8d14'] = '\u00e6\u00db';
sjisconv['\u8d16'] = '\u00e6\u00dc';
sjisconv['\u8d64'] = '\u0090\u00d4';
sjisconv['\u8d66'] = '\u008e\u00cd';
sjisconv['\u8d67'] = '\u00e6\u00dd';
sjisconv['\u8d6b'] = '\u008aq';
sjisconv['\u8d6d'] = '\u00e6\u00de';
sjisconv['\u8d70'] = '\u0091\u0096';
sjisconv['\u8d71'] = '\u00e6\u00df';
sjisconv['\u8d73'] = '\u00e6\u00e0';
sjisconv['\u8d74'] = '\u0095\u008b';
sjisconv['\u8d77'] = '\u008bN';
sjisconv['\u8d81'] = '\u00e6\u00e1';
sjisconv['\u8d85'] = '\u0092\u00b4';
sjisconv['\u8d8a'] = '\u0089z';
sjisconv['\u8d99'] = '\u00e6\u00e2';
sjisconv['\u8da3'] = '\u008e\u00ef';
sjisconv['\u8da8'] = '\u0090\u0096';
sjisconv['\u8db3'] = '\u0091\u00ab';
sjisconv['\u8dba'] = '\u00e6\u00e5';
sjisconv['\u8dbe'] = '\u00e6\u00e4';
sjisconv['\u8dc2'] = '\u00e6\u00e3';
sjisconv['\u8dcb'] = '\u00e6\u00eb';
sjisconv['\u8dcc'] = '\u00e6\u00e9';
sjisconv['\u8dcf'] = '\u00e6\u00e6';
sjisconv['\u8dd6'] = '\u00e6\u00e8';
sjisconv['\u8dda'] = '\u00e6\u00e7';
sjisconv['\u8ddb'] = '\u00e6\u00ea';
sjisconv['\u8ddd'] = '\u008b\u0097';
sjisconv['\u8ddf'] = '\u00e6\u00ee';
sjisconv['\u8de1'] = '\u0090\u00d5';
sjisconv['\u8de3'] = '\u00e6\u00ef';
sjisconv['\u8de8'] = '\u008c\u00d7';
sjisconv['\u8dea'] = '\u00e6\u00ec';
sjisconv['\u8deb'] = '\u00e6\u00ed';
sjisconv['\u8def'] = '\u0098H';
sjisconv['\u8df3'] = '\u0092\u00b5';
sjisconv['\u8df5'] = '\u0091H';
sjisconv['\u8dfc'] = '\u00e6\u00f0';
sjisconv['\u8dff'] = '\u00e6\u00f3';
sjisconv['\u8e08'] = '\u00e6\u00f1';
sjisconv['\u8e09'] = '\u00e6\u00f2';
sjisconv['\u8e0a'] = '\u0097x';
sjisconv['\u8e0f'] = '\u0093\u00a5';
sjisconv['\u8e10'] = '\u00e6\u00f6';
sjisconv['\u8e1d'] = '\u00e6\u00f4';
sjisconv['\u8e1e'] = '\u00e6\u00f5';
sjisconv['\u8e1f'] = '\u00e6\u00f7';
sjisconv['\u8e2a'] = '\u00e7H';
sjisconv['\u8e30'] = '\u00e6\u00fa';
sjisconv['\u8e34'] = '\u00e6\u00fb';
sjisconv['\u8e35'] = '\u00e6\u00f9';
sjisconv['\u8e42'] = '\u00e6\u00f8';
sjisconv['\u8e44'] = '\u0092\u00fb';
sjisconv['\u8e47'] = '\u00e7@';
sjisconv['\u8e48'] = '\u00e7D';
sjisconv['\u8e49'] = '\u00e7A';
sjisconv['\u8e4a'] = '\u00e6\u00fc';
sjisconv['\u8e4c'] = '\u00e7B';
sjisconv['\u8e50'] = '\u00e7C';
sjisconv['\u8e55'] = '\u00e7J';
sjisconv['\u8e59'] = '\u00e7E';
sjisconv['\u8e5f'] = '\u0090\u00d6';
sjisconv['\u8e60'] = '\u00e7G';
sjisconv['\u8e63'] = '\u00e7I';
sjisconv['\u8e64'] = '\u00e7F';
sjisconv['\u8e72'] = '\u00e7L';
sjisconv['\u8e74'] = '\u008fR';
sjisconv['\u8e76'] = '\u00e7K';
sjisconv['\u8e7c'] = '\u00e7M';
sjisconv['\u8e81'] = '\u00e7N';
sjisconv['\u8e84'] = '\u00e7Q';
sjisconv['\u8e85'] = '\u00e7P';
sjisconv['\u8e87'] = '\u00e7O';
sjisconv['\u8e8a'] = '\u00e7S';
sjisconv['\u8e8b'] = '\u00e7R';
sjisconv['\u8e8d'] = '\u0096\u00f4';
sjisconv['\u8e91'] = '\u00e7U';
sjisconv['\u8e93'] = '\u00e7T';
sjisconv['\u8e94'] = '\u00e7V';
sjisconv['\u8e99'] = '\u00e7W';
sjisconv['\u8ea1'] = '\u00e7Y';
sjisconv['\u8eaa'] = '\u00e7X';
sjisconv['\u8eab'] = '\u0090g';
sjisconv['\u8eac'] = '\u00e7Z';
sjisconv['\u8eaf'] = '\u008b\u00eb';
sjisconv['\u8eb0'] = '\u00e7[';
sjisconv['\u8eb1'] = '\u00e7]';
sjisconv['\u8ebe'] = '\u00e7^';
sjisconv['\u8ec5'] = '\u00e7_';
sjisconv['\u8ec6'] = '\u00e7\\';
sjisconv['\u8ec8'] = '\u00e7`';
sjisconv['\u8eca'] = '\u008e\u00d4';
sjisconv['\u8ecb'] = '\u00e7a';
sjisconv['\u8ecc'] = '\u008bO';
sjisconv['\u8ecd'] = '\u008cR';
sjisconv['\u8ed2'] = '\u008c\u00ac';
sjisconv['\u8edb'] = '\u00e7b';
sjisconv['\u8edf'] = '\u0093\u00ee';
sjisconv['\u8ee2'] = '\u0093]';
sjisconv['\u8ee3'] = '\u00e7c';
sjisconv['\u8eeb'] = '\u00e7f';
sjisconv['\u8ef8'] = '\u008e\u00b2';
sjisconv['\u8efb'] = '\u00e7e';
sjisconv['\u8efc'] = '\u00e7d';
sjisconv['\u8efd'] = '\u008cy';
sjisconv['\u8efe'] = '\u00e7g';
sjisconv['\u8f03'] = '\u008ar';
sjisconv['\u8f05'] = '\u00e7i';
sjisconv['\u8f09'] = '\u008d\u00da';
sjisconv['\u8f0a'] = '\u00e7h';
sjisconv['\u8f0c'] = '\u00e7q';
sjisconv['\u8f12'] = '\u00e7k';
sjisconv['\u8f13'] = '\u00e7m';
sjisconv['\u8f14'] = '\u0095\u00e3';
sjisconv['\u8f15'] = '\u00e7j';
sjisconv['\u8f19'] = '\u00e7l';
sjisconv['\u8f1b'] = '\u00e7p';
sjisconv['\u8f1c'] = '\u00e7n';
sjisconv['\u8f1d'] = '\u008bP';
sjisconv['\u8f1f'] = '\u00e7o';
sjisconv['\u8f26'] = '\u00e7r';
sjisconv['\u8f29'] = '\u0094y';
sjisconv['\u8f2a'] = '\u0097\u00d6';
sjisconv['\u8f2f'] = '\u008fS';
sjisconv['\u8f33'] = '\u00e7s';
sjisconv['\u8f38'] = '\u0097A';
sjisconv['\u8f39'] = '\u00e7u';
sjisconv['\u8f3b'] = '\u00e7t';
sjisconv['\u8f3e'] = '\u00e7x';
sjisconv['\u8f3f'] = '\u0097`';
sjisconv['\u8f42'] = '\u00e7w';
sjisconv['\u8f44'] = '\u008a\u008d';
sjisconv['\u8f45'] = '\u00e7v';
sjisconv['\u8f46'] = '\u00e7{';
sjisconv['\u8f49'] = '\u00e7z';
sjisconv['\u8f4c'] = '\u00e7y';
sjisconv['\u8f4d'] = '\u0093Q';
sjisconv['\u8f4e'] = '\u00e7|';
sjisconv['\u8f57'] = '\u00e7}';
sjisconv['\u8f5c'] = '\u00e7~';
sjisconv['\u8f5f'] = '\u008d\u008c';
sjisconv['\u8f61'] = '\u008cD';
sjisconv['\u8f62'] = '\u00e7\u0080';
sjisconv['\u8f63'] = '\u00e7\u0081';
sjisconv['\u8f64'] = '\u00e7\u0082';
sjisconv['\u8f9b'] = '\u0090h';
sjisconv['\u8f9c'] = '\u00e7\u0083';
sjisconv['\u8f9e'] = '\u008e\u00ab';
sjisconv['\u8f9f'] = '\u00e7\u0084';
sjisconv['\u8fa3'] = '\u00e7\u0085';
sjisconv['\u8fa7'] = '\u0099\u009f';
sjisconv['\u8fa8'] = '\u0099\u009e';
sjisconv['\u8fad'] = '\u00e7\u0086';
sjisconv['\u8fae'] = '\u00e3\u0090';
sjisconv['\u8faf'] = '\u00e7\u0087';
sjisconv['\u8fb0'] = '\u0092C';
sjisconv['\u8fb1'] = '\u0090J';
sjisconv['\u8fb2'] = '\u0094_';
sjisconv['\u8fb7'] = '\u00e7\u0088';
sjisconv['\u8fba'] = '\u0095\u00d3';
sjisconv['\u8fbb'] = '\u0092\u00d2';
sjisconv['\u8fbc'] = '\u008d\u009e';
sjisconv['\u8fbf'] = '\u0092H';
sjisconv['\u8fc2'] = '\u0089I';
sjisconv['\u8fc4'] = '\u0096\u0098';
sjisconv['\u8fc5'] = '\u0090v';
sjisconv['\u8fce'] = '\u008c}';
sjisconv['\u8fd1'] = '\u008b\u00df';
sjisconv['\u8fd4'] = '\u0095\u00d4';
sjisconv['\u8fda'] = '\u00e7\u0089';
sjisconv['\u8fe2'] = '\u00e7\u008b';
sjisconv['\u8fe5'] = '\u00e7\u008a';
sjisconv['\u8fe6'] = '\u0089\u00de';
sjisconv['\u8fe9'] = '\u0093\u00f4';
sjisconv['\u8fea'] = '\u00e7\u008c';
sjisconv['\u8feb'] = '\u0094\u0097';
sjisconv['\u8fed'] = '\u0093R';
sjisconv['\u8fef'] = '\u00e7\u008d';
sjisconv['\u8ff0'] = '\u008fq';
sjisconv['\u8ff4'] = '\u00e7\u008f';
sjisconv['\u8ff7'] = '\u0096\u00c0';
sjisconv['\u8ff8'] = '\u00e7\u009e';
sjisconv['\u8ff9'] = '\u00e7\u0091';
sjisconv['\u8ffa'] = '\u00e7\u0092';
sjisconv['\u8ffd'] = '\u0092\u00c7';
sjisconv['\u9000'] = '\u0091\u00de';
sjisconv['\u9001'] = '\u0091\u0097';
sjisconv['\u9003'] = '\u0093\u00a6';
sjisconv['\u9005'] = '\u00e7\u0090';
sjisconv['\u9006'] = '\u008bt';
sjisconv['\u900b'] = '\u00e7\u0099';
sjisconv['\u900d'] = '\u00e7\u0096';
sjisconv['\u900e'] = '\u00e7\u00a3';
sjisconv['\u900f'] = '\u0093\u00a7';
sjisconv['\u9010'] = '\u0092\u0080';
sjisconv['\u9011'] = '\u00e7\u0093';
sjisconv['\u9013'] = '\u0092\u00fc';
sjisconv['\u9014'] = '\u0093r';
sjisconv['\u9015'] = '\u00e7\u0094';
sjisconv['\u9016'] = '\u00e7\u0098';
sjisconv['\u9017'] = '\u0090\u0080';
sjisconv['\u9019'] = '\u0094\u0087';
sjisconv['\u901a'] = '\u0092\u00ca';
sjisconv['\u901d'] = '\u0090\u00c0';
sjisconv['\u901e'] = '\u00e7\u0097';
sjisconv['\u901f'] = '\u0091\u00ac';
sjisconv['\u9020'] = '\u0091\u00a2';
sjisconv['\u9021'] = '\u00e7\u0095';
sjisconv['\u9022'] = '\u0088\u00a7';
sjisconv['\u9023'] = '\u0098A';
sjisconv['\u9027'] = '\u00e7\u009a';
sjisconv['\u902e'] = '\u0091\u00df';
sjisconv['\u9031'] = '\u008fT';
sjisconv['\u9032'] = '\u0090i';
sjisconv['\u9035'] = '\u00e7\u009c';
sjisconv['\u9036'] = '\u00e7\u009b';
sjisconv['\u9038'] = '\u0088\u00ed';
sjisconv['\u9039'] = '\u00e7\u009d';
sjisconv['\u903c'] = '\u0095N';
sjisconv['\u903e'] = '\u00e7\u00a5';
sjisconv['\u9041'] = '\u0093\u00d9';
sjisconv['\u9042'] = '\u0090\u008b';
sjisconv['\u9045'] = '\u0092x';
sjisconv['\u9047'] = '\u008b\u00f6';
sjisconv['\u9049'] = '\u00e7\u00a4';
sjisconv['\u904a'] = '\u0097V';
sjisconv['\u904b'] = '\u0089^';
sjisconv['\u904d'] = '\u0095\u00d5';
sjisconv['\u904e'] = '\u0089\u00df';
sjisconv['\u904f'] = '\u00e7\u009f';
sjisconv['\u9050'] = '\u00e7\u00a0';
sjisconv['\u9051'] = '\u00e7\u00a1';
sjisconv['\u9052'] = '\u00e7\u00a2';
sjisconv['\u9053'] = '\u0093\u00b9';
sjisconv['\u9054'] = '\u0092B';
sjisconv['\u9055'] = '\u0088\u00e1';
sjisconv['\u9056'] = '\u00e7\u00a6';
sjisconv['\u9058'] = '\u00e7\u00a7';
sjisconv['\u9059'] = '\u00ea\u00a1';
sjisconv['\u905c'] = '\u0091\u00bb';
sjisconv['\u905e'] = '\u00e7\u00a8';
sjisconv['\u9060'] = '\u0089\u0093';
sjisconv['\u9061'] = '\u0091k';
sjisconv['\u9063'] = '\u008c\u00ad';
sjisconv['\u9065'] = '\u0097y';
sjisconv['\u9068'] = '\u00e7\u00a9';
sjisconv['\u9069'] = '\u0093K';
sjisconv['\u906d'] = '\u0091\u0098';
sjisconv['\u906e'] = '\u008e\u00d5';
sjisconv['\u906f'] = '\u00e7\u00aa';
sjisconv['\u9072'] = '\u00e7\u00ad';
sjisconv['\u9075'] = '\u008f\u0085';
sjisconv['\u9076'] = '\u00e7\u00ab';
sjisconv['\u9077'] = '\u0091J';
sjisconv['\u9078'] = '\u0091I';
sjisconv['\u907a'] = '\u0088\u00e2';
sjisconv['\u907c'] = '\u0097\u00c9';
sjisconv['\u907d'] = '\u00e7\u00af';
sjisconv['\u907f'] = '\u0094\u00f0';
sjisconv['\u9080'] = '\u00e7\u00b1';
sjisconv['\u9081'] = '\u00e7\u00b0';
sjisconv['\u9082'] = '\u00e7\u00ae';
sjisconv['\u9083'] = '\u00e2\u0084';
sjisconv['\u9084'] = '\u008a\u00d2';
sjisconv['\u9087'] = '\u00e7\u008e';
sjisconv['\u9089'] = '\u00e7\u00b3';
sjisconv['\u908a'] = '\u00e7\u00b2';
sjisconv['\u908f'] = '\u00e7\u00b4';
sjisconv['\u9091'] = '\u0097W';
sjisconv['\u90a3'] = '\u0093\u00df';
sjisconv['\u90a6'] = '\u0096M';
sjisconv['\u90a8'] = '\u00e7\u00b5';
sjisconv['\u90aa'] = '\u008e\u00d7';
sjisconv['\u90af'] = '\u00e7\u00b6';
sjisconv['\u90b1'] = '\u00e7\u00b7';
sjisconv['\u90b5'] = '\u00e7\u00b8';
sjisconv['\u90b8'] = '\u0093@';
sjisconv['\u90c1'] = '\u0088\u00e8';
sjisconv['\u90ca'] = '\u008dx';
sjisconv['\u90ce'] = '\u0098Y';
sjisconv['\u90db'] = '\u00e7\u00bc';
sjisconv['\u90e1'] = '\u008cS';
sjisconv['\u90e2'] = '\u00e7\u00b9';
sjisconv['\u90e4'] = '\u00e7\u00ba';
sjisconv['\u90e8'] = '\u0095\u0094';
sjisconv['\u90ed'] = '\u008as';
sjisconv['\u90f5'] = '\u0097X';
sjisconv['\u90f7'] = '\u008b\u00bd';
sjisconv['\u90fd'] = '\u0093s';
sjisconv['\u9102'] = '\u00e7\u00bd';
sjisconv['\u9112'] = '\u00e7\u00be';
sjisconv['\u9119'] = '\u00e7\u00bf';
sjisconv['\u912d'] = '\u0093A';
sjisconv['\u9130'] = '\u00e7\u00c1';
sjisconv['\u9132'] = '\u00e7\u00c0';
sjisconv['\u9149'] = '\u0093\u00d1';
sjisconv['\u914a'] = '\u00e7\u00c2';
sjisconv['\u914b'] = '\u008fU';
sjisconv['\u914c'] = '\u008e\u00de';
sjisconv['\u914d'] = '\u0094z';
sjisconv['\u914e'] = '\u0092\u0091';
sjisconv['\u9152'] = '\u008e\u00f0';
sjisconv['\u9154'] = '\u0090\u008c';
sjisconv['\u9156'] = '\u00e7\u00c3';
sjisconv['\u9158'] = '\u00e7\u00c4';
sjisconv['\u9162'] = '\u0090|';
sjisconv['\u9163'] = '\u00e7\u00c5';
sjisconv['\u9165'] = '\u00e7\u00c6';
sjisconv['\u9169'] = '\u00e7\u00c7';
sjisconv['\u916a'] = '\u0097\u008f';
sjisconv['\u916c'] = '\u008fV';
sjisconv['\u9172'] = '\u00e7\u00c9';
sjisconv['\u9173'] = '\u00e7\u00c8';
sjisconv['\u9175'] = '\u008dy';
sjisconv['\u9177'] = '\u008d\u0093';
sjisconv['\u9178'] = '\u008e_';
sjisconv['\u9182'] = '\u00e7\u00cc';
sjisconv['\u9187'] = '\u008f\u0086';
sjisconv['\u9189'] = '\u00e7\u00cb';
sjisconv['\u918b'] = '\u00e7\u00ca';
sjisconv['\u918d'] = '\u0091\u00e7';
sjisconv['\u9190'] = '\u008c\u00ed';
sjisconv['\u9192'] = '\u0090\u00c1';
sjisconv['\u9197'] = '\u0094\u00ae';
sjisconv['\u919c'] = '\u008fX';
sjisconv['\u91a2'] = '\u00e7\u00cd';
sjisconv['\u91a4'] = '\u008f\u00dd';
sjisconv['\u91aa'] = '\u00e7\u00d0';
sjisconv['\u91ab'] = '\u00e7\u00ce';
sjisconv['\u91af'] = '\u00e7\u00cf';
sjisconv['\u91b4'] = '\u00e7\u00d2';
sjisconv['\u91b5'] = '\u00e7\u00d1';
sjisconv['\u91b8'] = '\u008f\u00f8';
sjisconv['\u91ba'] = '\u00e7\u00d3';
sjisconv['\u91c0'] = '\u00e7\u00d4';
sjisconv['\u91c1'] = '\u00e7\u00d5';
sjisconv['\u91c6'] = '\u0094\u00ce';
sjisconv['\u91c7'] = '\u008d\u00d1';
sjisconv['\u91c8'] = '\u008e\u00df';
sjisconv['\u91c9'] = '\u00e7\u00d6';
sjisconv['\u91cb'] = '\u00e7\u00d7';
sjisconv['\u91cc'] = '\u0097\u00a2';
sjisconv['\u91cd'] = '\u008fd';
sjisconv['\u91ce'] = '\u0096\u00ec';
sjisconv['\u91cf'] = '\u0097\u00ca';
sjisconv['\u91d0'] = '\u00e7\u00d8';
sjisconv['\u91d1'] = '\u008b\u00e0';
sjisconv['\u91d6'] = '\u00e7\u00d9';
sjisconv['\u91d8'] = '\u0093B';
sjisconv['\u91db'] = '\u00e7\u00dc';
sjisconv['\u91dc'] = '\u008a\u0098';
sjisconv['\u91dd'] = '\u0090j';
sjisconv['\u91df'] = '\u00e7\u00da';
sjisconv['\u91e1'] = '\u00e7\u00db';
sjisconv['\u91e3'] = '\u0092\u00de';
sjisconv['\u91e6'] = '\u0096t';
sjisconv['\u91e7'] = '\u008b\u00fa';
sjisconv['\u91f5'] = '\u00e7\u00de';
sjisconv['\u91f6'] = '\u00e7\u00df';
sjisconv['\u91fc'] = '\u00e7\u00dd';
sjisconv['\u91ff'] = '\u00e7\u00e1';
sjisconv['\u920d'] = '\u0093\u00dd';
sjisconv['\u920e'] = '\u008ab';
sjisconv['\u9211'] = '\u00e7\u00e5';
sjisconv['\u9214'] = '\u00e7\u00e2';
sjisconv['\u9215'] = '\u00e7\u00e4';
sjisconv['\u921e'] = '\u00e7\u00e0';
sjisconv['\u9229'] = '\u00e8n';
sjisconv['\u922c'] = '\u00e7\u00e3';
sjisconv['\u9234'] = '\u0097\u00e9';
sjisconv['\u9237'] = '\u008c\u00d8';
sjisconv['\u923f'] = '\u00e7\u00ed';
sjisconv['\u9244'] = '\u0093S';
sjisconv['\u9245'] = '\u00e7\u00e8';
sjisconv['\u9248'] = '\u00e7\u00eb';
sjisconv['\u9249'] = '\u00e7\u00e9';
sjisconv['\u924b'] = '\u00e7\u00ee';
sjisconv['\u9250'] = '\u00e7\u00ef';
sjisconv['\u9257'] = '\u00e7\u00e7';
sjisconv['\u925a'] = '\u00e7\u00f4';
sjisconv['\u925b'] = '\u0089\u0094';
sjisconv['\u925e'] = '\u00e7\u00e6';
sjisconv['\u9262'] = '\u0094\u00ab';
sjisconv['\u9264'] = '\u00e7\u00ea';
sjisconv['\u9266'] = '\u008f\u00de';
sjisconv['\u9271'] = '\u008dz';
sjisconv['\u927e'] = '\u0096g';
sjisconv['\u9280'] = '\u008b\u00e2';
sjisconv['\u9283'] = '\u008fe';
sjisconv['\u9285'] = '\u0093\u00ba';
sjisconv['\u9291'] = '\u0091L';
sjisconv['\u9293'] = '\u00e7\u00f2';
sjisconv['\u9295'] = '\u00e7\u00ec';
sjisconv['\u9296'] = '\u00e7\u00f1';
sjisconv['\u9298'] = '\u0096\u00c1';
sjisconv['\u929a'] = '\u0092\u00b6';
sjisconv['\u929b'] = '\u00e7\u00f3';
sjisconv['\u929c'] = '\u00e7\u00f0';
sjisconv['\u92ad'] = '\u0091K';
sjisconv['\u92b7'] = '\u00e7\u00f7';
sjisconv['\u92b9'] = '\u00e7\u00f6';
sjisconv['\u92cf'] = '\u00e7\u00f5';
sjisconv['\u92d2'] = '\u0096N';
sjisconv['\u92e4'] = '\u008f\u009b';
sjisconv['\u92e9'] = '\u00e7\u00f8';
sjisconv['\u92ea'] = '\u0095\u00dd';
sjisconv['\u92ed'] = '\u0089s';
sjisconv['\u92f2'] = '\u0095e';
sjisconv['\u92f3'] = '\u0092\u0092';
sjisconv['\u92f8'] = '\u008b\u0098';
sjisconv['\u92fa'] = '\u00e7\u00fa';
sjisconv['\u92fc'] = '\u008d|';
sjisconv['\u9306'] = '\u008eK';
sjisconv['\u930f'] = '\u00e7\u00f9';
sjisconv['\u9310'] = '\u0090\u008d';
sjisconv['\u9318'] = '\u0090\u008e';
sjisconv['\u9319'] = '\u00e8@';
sjisconv['\u931a'] = '\u00e8B';
sjisconv['\u9320'] = '\u008f\u00f9';
sjisconv['\u9322'] = '\u00e8A';
sjisconv['\u9323'] = '\u00e8C';
sjisconv['\u9326'] = '\u008b\u00d1';
sjisconv['\u9328'] = '\u0095d';
sjisconv['\u932b'] = '\u008e\u00e0';
sjisconv['\u932c'] = '\u0098B';
sjisconv['\u932e'] = '\u00e7\u00fc';
sjisconv['\u932f'] = '\u008d\u00f6';
sjisconv['\u9332'] = '\u0098^';
sjisconv['\u9335'] = '\u00e8E';
sjisconv['\u933a'] = '\u00e8D';
sjisconv['\u933b'] = '\u00e8F';
sjisconv['\u9344'] = '\u00e7\u00fb';
sjisconv['\u934b'] = '\u0093\u00e7';
sjisconv['\u934d'] = '\u0093t';
sjisconv['\u9354'] = '\u0092\u00d5';
sjisconv['\u9356'] = '\u00e8K';
sjisconv['\u935b'] = '\u0092b';
sjisconv['\u935c'] = '\u00e8G';
sjisconv['\u9360'] = '\u00e8H';
sjisconv['\u936c'] = '\u008cL';
sjisconv['\u936e'] = '\u00e8J';
sjisconv['\u9375'] = '\u008c\u00ae';
sjisconv['\u937c'] = '\u00e8I';
sjisconv['\u937e'] = '\u008f\u00df';
sjisconv['\u938c'] = '\u008a\u0099';
sjisconv['\u9394'] = '\u00e8O';
sjisconv['\u9396'] = '\u008d\u00bd';
sjisconv['\u9397'] = '\u0091\u0099';
sjisconv['\u939a'] = '\u0092\u00c8';
sjisconv['\u93a7'] = '\u008aZ';
sjisconv['\u93ac'] = '\u00e8M';
sjisconv['\u93ad'] = '\u00e8N';
sjisconv['\u93ae'] = '\u0092\u00c1';
sjisconv['\u93b0'] = '\u00e8L';
sjisconv['\u93b9'] = '\u00e8P';
sjisconv['\u93c3'] = '\u00e8V';
sjisconv['\u93c8'] = '\u00e8Y';
sjisconv['\u93d0'] = '\u00e8X';
sjisconv['\u93d1'] = '\u0093L';
sjisconv['\u93d6'] = '\u00e8Q';
sjisconv['\u93d7'] = '\u00e8R';
sjisconv['\u93d8'] = '\u00e8U';
sjisconv['\u93dd'] = '\u00e8W';
sjisconv['\u93e1'] = '\u008b\u00be';
sjisconv['\u93e4'] = '\u00e8Z';
sjisconv['\u93e5'] = '\u00e8T';
sjisconv['\u93e8'] = '\u00e8S';
sjisconv['\u9403'] = '\u00e8^';
sjisconv['\u9407'] = '\u00e8_';
sjisconv['\u9410'] = '\u00e8`';
sjisconv['\u9413'] = '\u00e8]';
sjisconv['\u9414'] = '\u00e8\\';
sjisconv['\u9418'] = '\u008f\u00e0';
sjisconv['\u9419'] = '\u0093\u00a8';
sjisconv['\u941a'] = '\u00e8[';
sjisconv['\u9421'] = '\u00e8d';
sjisconv['\u942b'] = '\u00e8b';
sjisconv['\u9435'] = '\u00e8c';
sjisconv['\u9436'] = '\u00e8a';
sjisconv['\u9438'] = '\u0091\u00f6';
sjisconv['\u943a'] = '\u00e8e';
sjisconv['\u9441'] = '\u00e8f';
sjisconv['\u9444'] = '\u00e8h';
sjisconv['\u9451'] = '\u008a\u00d3';
sjisconv['\u9452'] = '\u00e8g';
sjisconv['\u9453'] = '\u0096\u00f8';
sjisconv['\u945a'] = '\u00e8s';
sjisconv['\u945b'] = '\u00e8i';
sjisconv['\u945e'] = '\u00e8l';
sjisconv['\u9460'] = '\u00e8j';
sjisconv['\u9462'] = '\u00e8k';
sjisconv['\u946a'] = '\u00e8m';
sjisconv['\u9470'] = '\u00e8o';
sjisconv['\u9475'] = '\u00e8p';
sjisconv['\u9477'] = '\u00e8q';
sjisconv['\u947c'] = '\u00e8t';
sjisconv['\u947d'] = '\u00e8r';
sjisconv['\u947e'] = '\u00e8u';
sjisconv['\u947f'] = '\u00e8w';
sjisconv['\u9481'] = '\u00e8v';
sjisconv['\u9577'] = '\u0092\u00b7';
sjisconv['\u9580'] = '\u0096\u00e5';
sjisconv['\u9582'] = '\u00e8x';
sjisconv['\u9583'] = '\u0091M';
sjisconv['\u9587'] = '\u00e8y';
sjisconv['\u9589'] = '\u0095\u00c2';
sjisconv['\u958a'] = '\u00e8z';
sjisconv['\u958b'] = '\u008aJ';
sjisconv['\u958f'] = '\u0089[';
sjisconv['\u9591'] = '\u008a\u00d5';
sjisconv['\u9593'] = '\u008a\u00d4';
sjisconv['\u9594'] = '\u00e8{';
sjisconv['\u9596'] = '\u00e8|';
sjisconv['\u9598'] = '\u00e8}';
sjisconv['\u9599'] = '\u00e8~';
sjisconv['\u95a0'] = '\u00e8\u0080';
sjisconv['\u95a2'] = '\u008a\u00d6';
sjisconv['\u95a3'] = '\u008at';
sjisconv['\u95a4'] = '\u008d}';
sjisconv['\u95a5'] = '\u0094\u00b4';
sjisconv['\u95a7'] = '\u00e8\u0082';
sjisconv['\u95a8'] = '\u00e8\u0081';
sjisconv['\u95ad'] = '\u00e8\u0083';
sjisconv['\u95b2'] = '\u0089{';
sjisconv['\u95b9'] = '\u00e8\u0086';
sjisconv['\u95bb'] = '\u00e8\u0085';
sjisconv['\u95bc'] = '\u00e8\u0084';
sjisconv['\u95be'] = '\u00e8\u0087';
sjisconv['\u95c3'] = '\u00e8\u008a';
sjisconv['\u95c7'] = '\u0088\u00c5';
sjisconv['\u95ca'] = '\u00e8\u0088';
sjisconv['\u95cc'] = '\u00e8\u008c';
sjisconv['\u95cd'] = '\u00e8\u008b';
sjisconv['\u95d4'] = '\u00e8\u008e';
sjisconv['\u95d5'] = '\u00e8\u008d';
sjisconv['\u95d6'] = '\u00e8\u008f';
sjisconv['\u95d8'] = '\u0093\u00ac';
sjisconv['\u95dc'] = '\u00e8\u0090';
sjisconv['\u95e1'] = '\u00e8\u0091';
sjisconv['\u95e2'] = '\u00e8\u0093';
sjisconv['\u95e5'] = '\u00e8\u0092';
sjisconv['\u961c'] = '\u0095\u008c';
sjisconv['\u9621'] = '\u00e8\u0094';
sjisconv['\u9628'] = '\u00e8\u0095';
sjisconv['\u962a'] = '\u008d\u00e3';
sjisconv['\u962e'] = '\u00e8\u0096';
sjisconv['\u962f'] = '\u00e8\u0097';
sjisconv['\u9632'] = '\u0096h';
sjisconv['\u963b'] = '\u0091j';
sjisconv['\u963f'] = '\u0088\u00a2';
sjisconv['\u9640'] = '\u0091\u00c9';
sjisconv['\u9642'] = '\u00e8\u0098';
sjisconv['\u9644'] = '\u0095\u008d';
sjisconv['\u964b'] = '\u00e8\u009b';
sjisconv['\u964c'] = '\u00e8\u0099';
sjisconv['\u964d'] = '\u008d~';
sjisconv['\u964f'] = '\u00e8\u009a';
sjisconv['\u9650'] = '\u008c\u00c0';
sjisconv['\u965b'] = '\u0095\u00c3';
sjisconv['\u965c'] = '\u00e8\u009d';
sjisconv['\u965d'] = '\u00e8\u009f';
sjisconv['\u965e'] = '\u00e8\u009e';
sjisconv['\u965f'] = '\u00e8\u00a0';
sjisconv['\u9662'] = '\u0089@';
sjisconv['\u9663'] = '\u0090w';
sjisconv['\u9664'] = '\u008f\u009c';
sjisconv['\u9665'] = '\u008a\u00d7';
sjisconv['\u9666'] = '\u00e8\u00a1';
sjisconv['\u966a'] = '\u0094\u0086';
sjisconv['\u966c'] = '\u00e8\u00a3';
sjisconv['\u9670'] = '\u0089A';
sjisconv['\u9672'] = '\u00e8\u00a2';
sjisconv['\u9673'] = '\u0092\u00c2';
sjisconv['\u9675'] = '\u0097\u00cb';
sjisconv['\u9676'] = '\u0093\u00a9';
sjisconv['\u9677'] = '\u00e8\u009c';
sjisconv['\u9678'] = '\u0097\u00a4';
sjisconv['\u967a'] = '\u008c\u00af';
sjisconv['\u967d'] = '\u0097z';
sjisconv['\u9685'] = '\u008b\u00f7';
sjisconv['\u9686'] = '\u0097\u00b2';
sjisconv['\u9688'] = '\u008cG';
sjisconv['\u968a'] = '\u0091\u00e0';
sjisconv['\u968b'] = '\u00e4@';
sjisconv['\u968d'] = '\u00e8\u00a4';
sjisconv['\u968e'] = '\u008aK';
sjisconv['\u968f'] = '\u0090\u008f';
sjisconv['\u9694'] = '\u008au';
sjisconv['\u9695'] = '\u00e8\u00a6';
sjisconv['\u9697'] = '\u00e8\u00a7';
sjisconv['\u9698'] = '\u00e8\u00a5';
sjisconv['\u9699'] = '\u008c\u0084';
sjisconv['\u969b'] = '\u008d\u00db';
sjisconv['\u969c'] = '\u008f\u00e1';
sjisconv['\u96a0'] = '\u0089B';
sjisconv['\u96a3'] = '\u0097\u00d7';
sjisconv['\u96a7'] = '\u00e8\u00a9';
sjisconv['\u96a8'] = '\u00e7\u00ac';
sjisconv['\u96aa'] = '\u00e8\u00a8';
sjisconv['\u96b0'] = '\u00e8\u00ac';
sjisconv['\u96b1'] = '\u00e8\u00aa';
sjisconv['\u96b2'] = '\u00e8\u00ab';
sjisconv['\u96b4'] = '\u00e8\u00ad';
sjisconv['\u96b6'] = '\u00e8\u00ae';
sjisconv['\u96b7'] = '\u0097\u00ea';
sjisconv['\u96b8'] = '\u00e8\u00af';
sjisconv['\u96b9'] = '\u00e8\u00b0';
sjisconv['\u96bb'] = '\u0090\u00c7';
sjisconv['\u96bc'] = '\u0094\u00b9';
sjisconv['\u96c0'] = '\u0090\u009d';
sjisconv['\u96c1'] = '\u008a\u00e5';
sjisconv['\u96c4'] = '\u0097Y';
sjisconv['\u96c5'] = '\u0089\u00eb';
sjisconv['\u96c6'] = '\u008fW';
sjisconv['\u96c7'] = '\u008c\u00d9';
sjisconv['\u96c9'] = '\u00e8\u00b3';
sjisconv['\u96cb'] = '\u00e8\u00b2';
sjisconv['\u96cc'] = '\u008e\u0093';
sjisconv['\u96cd'] = '\u00e8\u00b4';
sjisconv['\u96ce'] = '\u00e8\u00b1';
sjisconv['\u96d1'] = '\u008eG';
sjisconv['\u96d5'] = '\u00e8\u00b8';
sjisconv['\u96d6'] = '\u00e5\u00ab';
sjisconv['\u96d9'] = '\u0099\u00d4';
sjisconv['\u96db'] = '\u0090\u0097';
sjisconv['\u96dc'] = '\u00e8\u00b6';
sjisconv['\u96e2'] = '\u0097\u00a3';
sjisconv['\u96e3'] = '\u0093\u00ef';
sjisconv['\u96e8'] = '\u0089J';
sjisconv['\u96ea'] = '\u0090\u00e1';
sjisconv['\u96eb'] = '\u008e\u00b4';
sjisconv['\u96f0'] = '\u0095\u00b5';
sjisconv['\u96f2'] = '\u0089_';
sjisconv['\u96f6'] = '\u0097\u00eb';
sjisconv['\u96f7'] = '\u0097\u008b';
sjisconv['\u96f9'] = '\u00e8\u00b9';
sjisconv['\u96fb'] = '\u0093d';
sjisconv['\u9700'] = '\u008e\u00f9';
sjisconv['\u9704'] = '\u00e8\u00ba';
sjisconv['\u9706'] = '\u00e8\u00bb';
sjisconv['\u9707'] = '\u0090k';
sjisconv['\u9708'] = '\u00e8\u00bc';
sjisconv['\u970a'] = '\u0097\u00ec';
sjisconv['\u970d'] = '\u00e8\u00b7';
sjisconv['\u970e'] = '\u00e8\u00be';
sjisconv['\u970f'] = '\u00e8\u00c0';
sjisconv['\u9711'] = '\u00e8\u00bf';
sjisconv['\u9713'] = '\u00e8\u00bd';
sjisconv['\u9716'] = '\u00e8\u00c1';
sjisconv['\u9719'] = '\u00e8\u00c2';
sjisconv['\u971c'] = '\u0091\u009a';
sjisconv['\u971e'] = '\u0089\u00e0';
sjisconv['\u9724'] = '\u00e8\u00c3';
sjisconv['\u9727'] = '\u0096\u00b6';
sjisconv['\u972a'] = '\u00e8\u00c4';
sjisconv['\u9730'] = '\u00e8\u00c5';
sjisconv['\u9732'] = '\u0098I';
sjisconv['\u9738'] = '\u009eP';
sjisconv['\u9739'] = '\u00e8\u00c6';
sjisconv['\u973d'] = '\u00e8\u00c7';
sjisconv['\u973e'] = '\u00e8\u00c8';
sjisconv['\u9742'] = '\u00e8\u00cc';
sjisconv['\u9744'] = '\u00e8\u00c9';
sjisconv['\u9746'] = '\u00e8\u00ca';
sjisconv['\u9748'] = '\u00e8\u00cb';
sjisconv['\u9749'] = '\u00e8\u00cd';
sjisconv['\u9752'] = '\u0090\u00c2';
sjisconv['\u9756'] = '\u0096\u00f5';
sjisconv['\u9759'] = '\u0090\u00c3';
sjisconv['\u975c'] = '\u00e8\u00ce';
sjisconv['\u975e'] = '\u0094\u00f1';
sjisconv['\u9760'] = '\u00e8\u00cf';
sjisconv['\u9761'] = '\u00ear';
sjisconv['\u9762'] = '\u0096\u00ca';
sjisconv['\u9764'] = '\u00e8\u00d0';
sjisconv['\u9766'] = '\u00e8\u00d1';
sjisconv['\u9768'] = '\u00e8\u00d2';
sjisconv['\u9769'] = '\u008av';
sjisconv['\u976b'] = '\u00e8\u00d4';
sjisconv['\u976d'] = '\u0090x';
sjisconv['\u9771'] = '\u00e8\u00d5';
sjisconv['\u9774'] = '\u008cC';
sjisconv['\u9779'] = '\u00e8\u00d6';
sjisconv['\u977a'] = '\u00e8\u00da';
sjisconv['\u977c'] = '\u00e8\u00d8';
sjisconv['\u9781'] = '\u00e8\u00d9';
sjisconv['\u9784'] = '\u008a\u0093';
sjisconv['\u9785'] = '\u00e8\u00d7';
sjisconv['\u9786'] = '\u00e8\u00db';
sjisconv['\u978b'] = '\u00e8\u00dc';
sjisconv['\u978d'] = '\u0088\u00c6';
sjisconv['\u978f'] = '\u00e8\u00dd';
sjisconv['\u9790'] = '\u00e8\u00de';
sjisconv['\u9798'] = '\u008f\u00e2';
sjisconv['\u979c'] = '\u00e8\u00df';
sjisconv['\u97a0'] = '\u008bf';
sjisconv['\u97a3'] = '\u00e8\u00e2';
sjisconv['\u97a6'] = '\u00e8\u00e1';
sjisconv['\u97a8'] = '\u00e8\u00e0';
sjisconv['\u97ab'] = '\u00e6\u0091';
sjisconv['\u97ad'] = '\u0095\u00da';
sjisconv['\u97b3'] = '\u00e8\u00e3';
sjisconv['\u97b4'] = '\u00e8\u00e4';
sjisconv['\u97c3'] = '\u00e8\u00e5';
sjisconv['\u97c6'] = '\u00e8\u00e6';
sjisconv['\u97c8'] = '\u00e8\u00e7';
sjisconv['\u97cb'] = '\u00e8\u00e8';
sjisconv['\u97d3'] = '\u008a\u00d8';
sjisconv['\u97dc'] = '\u00e8\u00e9';
sjisconv['\u97ed'] = '\u00e8\u00ea';
sjisconv['\u97ee'] = '\u0094B';
sjisconv['\u97f2'] = '\u00e8\u00ec';
sjisconv['\u97f3'] = '\u0089\u00b9';
sjisconv['\u97f5'] = '\u00e8\u00ef';
sjisconv['\u97f6'] = '\u00e8\u00ee';
sjisconv['\u97fb'] = '\u0089C';
sjisconv['\u97ff'] = '\u008b\u00bf';
sjisconv['\u9801'] = '\u0095\u00c5';
sjisconv['\u9802'] = '\u0092\u00b8';
sjisconv['\u9803'] = '\u008d\u00a0';
sjisconv['\u9805'] = '\u008d\u0080';
sjisconv['\u9806'] = '\u008f\u0087';
sjisconv['\u9808'] = '\u0090{';
sjisconv['\u980c'] = '\u00e8\u00f1';
sjisconv['\u980f'] = '\u00e8\u00f0';
sjisconv['\u9810'] = '\u0097a';
sjisconv['\u9811'] = '\u008a\u00e6';
sjisconv['\u9812'] = '\u0094\u00d0';
sjisconv['\u9813'] = '\u0093\u00da';
sjisconv['\u9817'] = '\u0090\u009c';
sjisconv['\u9818'] = '\u0097\u00cc';
sjisconv['\u981a'] = '\u008cz';
sjisconv['\u9821'] = '\u00e8\u00f4';
sjisconv['\u9824'] = '\u00e8\u00f3';
sjisconv['\u982c'] = '\u0096j';
sjisconv['\u982d'] = '\u0093\u00aa';
sjisconv['\u9834'] = '\u0089o';
sjisconv['\u9837'] = '\u00e8\u00f5';
sjisconv['\u9838'] = '\u00e8\u00f2';
sjisconv['\u983b'] = '\u0095p';
sjisconv['\u983c'] = '\u0097\u008a';
sjisconv['\u983d'] = '\u00e8\u00f6';
sjisconv['\u9846'] = '\u00e8\u00f7';
sjisconv['\u984b'] = '\u00e8\u00f9';
sjisconv['\u984c'] = '\u0091\u00e8';
sjisconv['\u984d'] = '\u008az';
sjisconv['\u984e'] = '\u008a{';
sjisconv['\u984f'] = '\u00e8\u00f8';
sjisconv['\u9854'] = '\u008a\u00e7';
sjisconv['\u9855'] = '\u008c\u00b0';
sjisconv['\u9858'] = '\u008a\u00e8';
sjisconv['\u985b'] = '\u0093^';
sjisconv['\u985e'] = '\u0097\u00de';
sjisconv['\u9867'] = '\u008c\u00da';
sjisconv['\u986b'] = '\u00e8\u00fa';
sjisconv['\u986f'] = '\u00e8\u00fb';
sjisconv['\u9870'] = '\u00e8\u00fc';
sjisconv['\u9871'] = '\u00e9@';
sjisconv['\u9873'] = '\u00e9B';
sjisconv['\u9874'] = '\u00e9A';
sjisconv['\u98a8'] = '\u0095\u0097';
sjisconv['\u98aa'] = '\u00e9C';
sjisconv['\u98af'] = '\u00e9D';
sjisconv['\u98b1'] = '\u00e9E';
sjisconv['\u98b6'] = '\u00e9F';
sjisconv['\u98c3'] = '\u00e9H';
sjisconv['\u98c4'] = '\u00e9G';
sjisconv['\u98c6'] = '\u00e9I';
sjisconv['\u98db'] = '\u0094\u00f2';
sjisconv['\u98dc'] = '\u00e3\u00ca';
sjisconv['\u98df'] = '\u0090H';
sjisconv['\u98e2'] = '\u008bQ';
sjisconv['\u98e9'] = '\u00e9J';
sjisconv['\u98eb'] = '\u00e9K';
sjisconv['\u98ed'] = '\u0099\u00aa';
sjisconv['\u98ee'] = '\u009fZ';
sjisconv['\u98ef'] = '\u0094\u00d1';
sjisconv['\u98f2'] = '\u0088\u00f9';
sjisconv['\u98f4'] = '\u0088\u00b9';
sjisconv['\u98fc'] = '\u008e\u0094';
sjisconv['\u98fd'] = '\u0096O';
sjisconv['\u98fe'] = '\u008f\u00fc';
sjisconv['\u9903'] = '\u00e9L';
sjisconv['\u9905'] = '\u0096\u00dd';
sjisconv['\u9909'] = '\u00e9M';
sjisconv['\u990a'] = '\u0097{';
sjisconv['\u990c'] = '\u0089a';
sjisconv['\u9910'] = '\u008e`';
sjisconv['\u9912'] = '\u00e9N';
sjisconv['\u9913'] = '\u0089\u00ec';
sjisconv['\u9914'] = '\u00e9O';
sjisconv['\u9918'] = '\u00e9P';
sjisconv['\u991d'] = '\u00e9R';
sjisconv['\u991e'] = '\u00e9S';
sjisconv['\u9920'] = '\u00e9U';
sjisconv['\u9921'] = '\u00e9Q';
sjisconv['\u9924'] = '\u00e9T';
sjisconv['\u9928'] = '\u008a\u00d9';
sjisconv['\u992c'] = '\u00e9V';
sjisconv['\u992e'] = '\u00e9W';
sjisconv['\u993d'] = '\u00e9X';
sjisconv['\u993e'] = '\u00e9Y';
sjisconv['\u9942'] = '\u00e9Z';
sjisconv['\u9945'] = '\u00e9\\';
sjisconv['\u9949'] = '\u00e9[';
sjisconv['\u994b'] = '\u00e9^';
sjisconv['\u994c'] = '\u00e9a';
sjisconv['\u9950'] = '\u00e9]';
sjisconv['\u9951'] = '\u00e9_';
sjisconv['\u9952'] = '\u00e9`';
sjisconv['\u9955'] = '\u00e9b';
sjisconv['\u9957'] = '\u008b\u00c0';
sjisconv['\u9996'] = '\u008e\u00f1';
sjisconv['\u9997'] = '\u00e9c';
sjisconv['\u9998'] = '\u00e9d';
sjisconv['\u9999'] = '\u008d\u0081';
sjisconv['\u99a5'] = '\u00e9e';
sjisconv['\u99a8'] = '\u008a]';
sjisconv['\u99ac'] = '\u0094n';
sjisconv['\u99ad'] = '\u00e9f';
sjisconv['\u99ae'] = '\u00e9g';
sjisconv['\u99b3'] = '\u0092y';
sjisconv['\u99b4'] = '\u0093\u00e9';
sjisconv['\u99bc'] = '\u00e9h';
sjisconv['\u99c1'] = '\u0094\u009d';
sjisconv['\u99c4'] = '\u0091\u00ca';
sjisconv['\u99c5'] = '\u0089w';
sjisconv['\u99c6'] = '\u008b\u00ec';
sjisconv['\u99c8'] = '\u008b\u00ed';
sjisconv['\u99d0'] = '\u0092\u0093';
sjisconv['\u99d1'] = '\u00e9m';
sjisconv['\u99d2'] = '\u008b\u00ee';
sjisconv['\u99d5'] = '\u0089\u00ed';
sjisconv['\u99d8'] = '\u00e9l';
sjisconv['\u99db'] = '\u00e9j';
sjisconv['\u99dd'] = '\u00e9k';
sjisconv['\u99df'] = '\u00e9i';
sjisconv['\u99e2'] = '\u00e9w';
sjisconv['\u99ed'] = '\u00e9n';
sjisconv['\u99ee'] = '\u00e9o';
sjisconv['\u99f1'] = '\u00e9p';
sjisconv['\u99f2'] = '\u00e9q';
sjisconv['\u99f8'] = '\u00e9s';
sjisconv['\u99fb'] = '\u00e9r';
sjisconv['\u99ff'] = '\u008fx';
sjisconv['\u9a01'] = '\u00e9t';
sjisconv['\u9a05'] = '\u00e9v';
sjisconv['\u9a0e'] = '\u008bR';
sjisconv['\u9a0f'] = '\u00e9u';
sjisconv['\u9a12'] = '\u0091\u009b';
sjisconv['\u9a13'] = '\u008c\u00b1';
sjisconv['\u9a19'] = '\u00e9x';
sjisconv['\u9a28'] = '\u0091\u00cb';
sjisconv['\u9a2b'] = '\u00e9y';
sjisconv['\u9a30'] = '\u0093\u00ab';
sjisconv['\u9a37'] = '\u00e9z';
sjisconv['\u9a3e'] = '\u00e9\u0080';
sjisconv['\u9a40'] = '\u00e9}';
sjisconv['\u9a42'] = '\u00e9|';
sjisconv['\u9a43'] = '\u00e9~';
sjisconv['\u9a45'] = '\u00e9{';
sjisconv['\u9a4d'] = '\u00e9\u0082';
sjisconv['\u9a55'] = '\u00e9\u0081';
sjisconv['\u9a57'] = '\u00e9\u0084';
sjisconv['\u9a5a'] = '\u008b\u00c1';
sjisconv['\u9a5b'] = '\u00e9\u0083';
sjisconv['\u9a5f'] = '\u00e9\u0085';
sjisconv['\u9a62'] = '\u00e9\u0086';
sjisconv['\u9a64'] = '\u00e9\u0088';
sjisconv['\u9a65'] = '\u00e9\u0087';
sjisconv['\u9a69'] = '\u00e9\u0089';
sjisconv['\u9a6a'] = '\u00e9\u008b';
sjisconv['\u9a6b'] = '\u00e9\u008a';
sjisconv['\u9aa8'] = '\u008d\u009c';
sjisconv['\u9aad'] = '\u00e9\u008c';
sjisconv['\u9ab0'] = '\u00e9\u008d';
sjisconv['\u9ab8'] = '\u008a[';
sjisconv['\u9abc'] = '\u00e9\u008e';
sjisconv['\u9ac0'] = '\u00e9\u008f';
sjisconv['\u9ac4'] = '\u0090\u0091';
sjisconv['\u9acf'] = '\u00e9\u0090';
sjisconv['\u9ad1'] = '\u00e9\u0091';
sjisconv['\u9ad3'] = '\u00e9\u0092';
sjisconv['\u9ad4'] = '\u00e9\u0093';
sjisconv['\u9ad8'] = '\u008d\u0082';
sjisconv['\u9ade'] = '\u00e9\u0094';
sjisconv['\u9adf'] = '\u00e9\u0095';
sjisconv['\u9ae2'] = '\u00e9\u0096';
sjisconv['\u9ae3'] = '\u00e9\u0097';
sjisconv['\u9ae6'] = '\u00e9\u0098';
sjisconv['\u9aea'] = '\u0094\u00af';
sjisconv['\u9aeb'] = '\u00e9\u009a';
sjisconv['\u9aed'] = '\u0095E';
sjisconv['\u9aee'] = '\u00e9\u009b';
sjisconv['\u9aef'] = '\u00e9\u0099';
sjisconv['\u9af1'] = '\u00e9\u009d';
sjisconv['\u9af4'] = '\u00e9\u009c';
sjisconv['\u9af7'] = '\u00e9\u009e';
sjisconv['\u9afb'] = '\u00e9\u009f';
sjisconv['\u9b06'] = '\u00e9\u00a0';
sjisconv['\u9b18'] = '\u00e9\u00a1';
sjisconv['\u9b1a'] = '\u00e9\u00a2';
sjisconv['\u9b1f'] = '\u00e9\u00a3';
sjisconv['\u9b22'] = '\u00e9\u00a4';
sjisconv['\u9b23'] = '\u00e9\u00a5';
sjisconv['\u9b25'] = '\u00e9\u00a6';
sjisconv['\u9b27'] = '\u00e9\u00a7';
sjisconv['\u9b28'] = '\u00e9\u00a8';
sjisconv['\u9b29'] = '\u00e9\u00a9';
sjisconv['\u9b2a'] = '\u00e9\u00aa';
sjisconv['\u9b2e'] = '\u00e9\u00ab';
sjisconv['\u9b2f'] = '\u00e9\u00ac';
sjisconv['\u9b31'] = '\u009fT';
sjisconv['\u9b32'] = '\u00e9\u00ad';
sjisconv['\u9b3b'] = '\u00e2\u00f6';
sjisconv['\u9b3c'] = '\u008bS';
sjisconv['\u9b41'] = '\u008a@';
sjisconv['\u9b42'] = '\u008d\u00b0';
sjisconv['\u9b43'] = '\u00e9\u00af';
sjisconv['\u9b44'] = '\u00e9\u00ae';
sjisconv['\u9b45'] = '\u0096\u00a3';
sjisconv['\u9b4d'] = '\u00e9\u00b1';
sjisconv['\u9b4e'] = '\u00e9\u00b2';
sjisconv['\u9b4f'] = '\u00e9\u00b0';
sjisconv['\u9b51'] = '\u00e9\u00b3';
sjisconv['\u9b54'] = '\u0096\u0082';
sjisconv['\u9b58'] = '\u00e9\u00b4';
sjisconv['\u9b5a'] = '\u008b\u009b';
sjisconv['\u9b6f'] = '\u0098D';
sjisconv['\u9b74'] = '\u00e9\u00b5';
sjisconv['\u9b83'] = '\u00e9\u00b7';
sjisconv['\u9b8e'] = '\u0088\u00bc';
sjisconv['\u9b91'] = '\u00e9\u00b8';
sjisconv['\u9b92'] = '\u0095\u00a9';
sjisconv['\u9b93'] = '\u00e9\u00b6';
sjisconv['\u9b96'] = '\u00e9\u00b9';
sjisconv['\u9b97'] = '\u00e9\u00ba';
sjisconv['\u9b9f'] = '\u00e9\u00bb';
sjisconv['\u9ba0'] = '\u00e9\u00bc';
sjisconv['\u9ba8'] = '\u00e9\u00bd';
sjisconv['\u9baa'] = '\u0096\u008e';
sjisconv['\u9bab'] = '\u008eL';
sjisconv['\u9bad'] = '\u008d\u00f8';
sjisconv['\u9bae'] = '\u0091N';
sjisconv['\u9bb4'] = '\u00e9\u00be';
sjisconv['\u9bb9'] = '\u00e9\u00c1';
sjisconv['\u9bc0'] = '\u00e9\u00bf';
sjisconv['\u9bc6'] = '\u00e9\u00c2';
sjisconv['\u9bc9'] = '\u008c\u00ef';
sjisconv['\u9bca'] = '\u00e9\u00c0';
sjisconv['\u9bcf'] = '\u00e9\u00c3';
sjisconv['\u9bd1'] = '\u00e9\u00c4';
sjisconv['\u9bd2'] = '\u00e9\u00c5';
sjisconv['\u9bd4'] = '\u00e9\u00c9';
sjisconv['\u9bd6'] = '\u008eI';
sjisconv['\u9bdb'] = '\u0091\u00e2';
sjisconv['\u9be1'] = '\u00e9\u00ca';
sjisconv['\u9be2'] = '\u00e9\u00c7';
sjisconv['\u9be3'] = '\u00e9\u00c6';
sjisconv['\u9be4'] = '\u00e9\u00c8';
sjisconv['\u9be8'] = '\u008c~';
sjisconv['\u9bf0'] = '\u00e9\u00ce';
sjisconv['\u9bf1'] = '\u00e9\u00cd';
sjisconv['\u9bf2'] = '\u00e9\u00cc';
sjisconv['\u9bf5'] = '\u0088\u00b1';
sjisconv['\u9c04'] = '\u00e9\u00d8';
sjisconv['\u9c06'] = '\u00e9\u00d4';
sjisconv['\u9c08'] = '\u00e9\u00d5';
sjisconv['\u9c09'] = '\u00e9\u00d1';
sjisconv['\u9c0a'] = '\u00e9\u00d7';
sjisconv['\u9c0c'] = '\u00e9\u00d3';
sjisconv['\u9c0d'] = '\u008a\u0082';
sjisconv['\u9c10'] = '\u0098k';
sjisconv['\u9c12'] = '\u00e9\u00d6';
sjisconv['\u9c13'] = '\u00e9\u00d2';
sjisconv['\u9c14'] = '\u00e9\u00d0';
sjisconv['\u9c15'] = '\u00e9\u00cf';
sjisconv['\u9c1b'] = '\u00e9\u00da';
sjisconv['\u9c21'] = '\u00e9\u00dd';
sjisconv['\u9c24'] = '\u00e9\u00dc';
sjisconv['\u9c25'] = '\u00e9\u00db';
sjisconv['\u9c2d'] = '\u0095h';
sjisconv['\u9c2e'] = '\u00e9\u00d9';
sjisconv['\u9c2f'] = '\u0088\u00f1';
sjisconv['\u9c30'] = '\u00e9\u00de';
sjisconv['\u9c32'] = '\u00e9\u00e0';
sjisconv['\u9c39'] = '\u008a\u008f';
sjisconv['\u9c3a'] = '\u00e9\u00cb';
sjisconv['\u9c3b'] = '\u0089V';
sjisconv['\u9c3e'] = '\u00e9\u00e2';
sjisconv['\u9c46'] = '\u00e9\u00e1';
sjisconv['\u9c47'] = '\u00e9\u00df';
sjisconv['\u9c48'] = '\u0092L';
sjisconv['\u9c52'] = '\u0096\u0090';
sjisconv['\u9c57'] = '\u0097\u00d8';
sjisconv['\u9c5a'] = '\u00e9\u00e3';
sjisconv['\u9c60'] = '\u00e9\u00e4';
sjisconv['\u9c67'] = '\u00e9\u00e5';
sjisconv['\u9c76'] = '\u00e9\u00e6';
sjisconv['\u9c78'] = '\u00e9\u00e7';
sjisconv['\u9ce5'] = '\u0092\u00b9';
sjisconv['\u9ce7'] = '\u00e9\u00e8';
sjisconv['\u9ce9'] = '\u0094\u00b5';
sjisconv['\u9ceb'] = '\u00e9\u00ed';
sjisconv['\u9cec'] = '\u00e9\u00e9';
sjisconv['\u9cf0'] = '\u00e9\u00ea';
sjisconv['\u9cf3'] = '\u0096P';
sjisconv['\u9cf4'] = '\u0096\u00c2';
sjisconv['\u9cf6'] = '\u0093\u00ce';
sjisconv['\u9d03'] = '\u00e9\u00ee';
sjisconv['\u9d06'] = '\u00e9\u00ef';
sjisconv['\u9d07'] = '\u0093\u00bc';
sjisconv['\u9d08'] = '\u00e9\u00ec';
sjisconv['\u9d09'] = '\u00e9\u00eb';
sjisconv['\u9d0e'] = '\u0089\u00a8';
sjisconv['\u9d12'] = '\u00e9\u00f7';
sjisconv['\u9d15'] = '\u00e9\u00f6';
sjisconv['\u9d1b'] = '\u0089\u0095';
sjisconv['\u9d1f'] = '\u00e9\u00f4';
sjisconv['\u9d23'] = '\u00e9\u00f3';
sjisconv['\u9d26'] = '\u00e9\u00f1';
sjisconv['\u9d28'] = '\u008a\u009b';
sjisconv['\u9d2a'] = '\u00e9\u00f0';
sjisconv['\u9d2b'] = '\u008e\u00b0';
sjisconv['\u9d2c'] = '\u0089\u00a7';
sjisconv['\u9d3b'] = '\u008d\u0083';
sjisconv['\u9d3e'] = '\u00e9\u00fa';
sjisconv['\u9d3f'] = '\u00e9\u00f9';
sjisconv['\u9d41'] = '\u00e9\u00f8';
sjisconv['\u9d44'] = '\u00e9\u00f5';
sjisconv['\u9d46'] = '\u00e9\u00fb';
sjisconv['\u9d48'] = '\u00e9\u00fc';
sjisconv['\u9d50'] = '\u00eaD';
sjisconv['\u9d51'] = '\u00eaC';
sjisconv['\u9d59'] = '\u00eaE';
sjisconv['\u9d5c'] = '\u0089L';
sjisconv['\u9d5d'] = '\u00ea@';
sjisconv['\u9d5e'] = '\u00eaA';
sjisconv['\u9d60'] = '\u008d\u0094';
sjisconv['\u9d61'] = '\u0096\u00b7';
sjisconv['\u9d64'] = '\u00eaB';
sjisconv['\u9d6c'] = '\u0096Q';
sjisconv['\u9d6f'] = '\u00eaJ';
sjisconv['\u9d72'] = '\u00eaF';
sjisconv['\u9d7a'] = '\u00eaK';
sjisconv['\u9d87'] = '\u00eaH';
sjisconv['\u9d89'] = '\u00eaG';
sjisconv['\u9d8f'] = '\u008c{';
sjisconv['\u9d9a'] = '\u00eaL';
sjisconv['\u9da4'] = '\u00eaM';
sjisconv['\u9da9'] = '\u00eaN';
sjisconv['\u9dab'] = '\u00eaI';
sjisconv['\u9daf'] = '\u00e9\u00f2';
sjisconv['\u9db2'] = '\u00eaO';
sjisconv['\u9db4'] = '\u0092\u00df';
sjisconv['\u9db8'] = '\u00eaS';
sjisconv['\u9dba'] = '\u00eaT';
sjisconv['\u9dbb'] = '\u00eaR';
sjisconv['\u9dc1'] = '\u00eaQ';
sjisconv['\u9dc2'] = '\u00eaW';
sjisconv['\u9dc4'] = '\u00eaP';
sjisconv['\u9dc6'] = '\u00eaU';
sjisconv['\u9dcf'] = '\u00eaV';
sjisconv['\u9dd3'] = '\u00eaY';
sjisconv['\u9dd9'] = '\u00eaX';
sjisconv['\u9de6'] = '\u00ea[';
sjisconv['\u9ded'] = '\u00ea\\';
sjisconv['\u9def'] = '\u00ea]';
sjisconv['\u9df2'] = '\u0098h';
sjisconv['\u9df8'] = '\u00eaZ';
sjisconv['\u9df9'] = '\u0091\u00e9';
sjisconv['\u9dfa'] = '\u008d\u00eb';
sjisconv['\u9dfd'] = '\u00ea^';
sjisconv['\u9e1a'] = '\u00ea_';
sjisconv['\u9e1b'] = '\u00ea`';
sjisconv['\u9e1e'] = '\u00eaa';
sjisconv['\u9e75'] = '\u00eab';
sjisconv['\u9e78'] = '\u008c\u00b2';
sjisconv['\u9e79'] = '\u00eac';
sjisconv['\u9e7d'] = '\u00ead';
sjisconv['\u9e7f'] = '\u008e\u00ad';
sjisconv['\u9e81'] = '\u00eae';
sjisconv['\u9e88'] = '\u00eaf';
sjisconv['\u9e8b'] = '\u00eag';
sjisconv['\u9e8c'] = '\u00eah';
sjisconv['\u9e91'] = '\u00eak';
sjisconv['\u9e92'] = '\u00eai';
sjisconv['\u9e93'] = '\u0098[';
sjisconv['\u9e95'] = '\u00eaj';
sjisconv['\u9e97'] = '\u0097\u00ed';
sjisconv['\u9e9d'] = '\u00eal';
sjisconv['\u9e9f'] = '\u0097\u00d9';
sjisconv['\u9ea5'] = '\u00eam';
sjisconv['\u9ea6'] = '\u0094\u009e';
sjisconv['\u9ea9'] = '\u00ean';
sjisconv['\u9eaa'] = '\u00eap';
sjisconv['\u9ead'] = '\u00eaq';
sjisconv['\u9eb8'] = '\u00eao';
sjisconv['\u9eb9'] = '\u008d\u008d';
sjisconv['\u9eba'] = '\u0096\u00cb';
sjisconv['\u9ebb'] = '\u0096\u0083';
sjisconv['\u9ebc'] = '\u009b\u00f5';
sjisconv['\u9ebe'] = '\u009f\u0080';
sjisconv['\u9ebf'] = '\u0096\u009b';
sjisconv['\u9ec4'] = '\u0089\u00a9';
sjisconv['\u9ecc'] = '\u00eas';
sjisconv['\u9ecd'] = '\u008bo';
sjisconv['\u9ece'] = '\u00eat';
sjisconv['\u9ecf'] = '\u00eau';
sjisconv['\u9ed0'] = '\u00eav';
sjisconv['\u9ed2'] = '\u008d\u0095';
sjisconv['\u9ed4'] = '\u00eaw';
sjisconv['\u9ed8'] = '\u00e0\u00d2';
sjisconv['\u9ed9'] = '\u0096\u00d9';
sjisconv['\u9edb'] = '\u0091\u00e1';
sjisconv['\u9edc'] = '\u00eax';
sjisconv['\u9edd'] = '\u00eaz';
sjisconv['\u9ede'] = '\u00eay';
sjisconv['\u9ee0'] = '\u00ea{';
sjisconv['\u9ee5'] = '\u00ea|';
sjisconv['\u9ee8'] = '\u00ea}';
sjisconv['\u9eef'] = '\u00ea~';
sjisconv['\u9ef4'] = '\u00ea\u0080';
sjisconv['\u9ef6'] = '\u00ea\u0081';
sjisconv['\u9ef7'] = '\u00ea\u0082';
sjisconv['\u9ef9'] = '\u00ea\u0083';
sjisconv['\u9efb'] = '\u00ea\u0084';
sjisconv['\u9efc'] = '\u00ea\u0085';
sjisconv['\u9efd'] = '\u00ea\u0086';
sjisconv['\u9f07'] = '\u00ea\u0087';
sjisconv['\u9f08'] = '\u00ea\u0088';
sjisconv['\u9f0e'] = '\u0093C';
sjisconv['\u9f13'] = '\u008c\u00db';
sjisconv['\u9f15'] = '\u00ea\u008a';
sjisconv['\u9f20'] = '\u0091l';
sjisconv['\u9f21'] = '\u00ea\u008b';
sjisconv['\u9f2c'] = '\u00ea\u008c';
sjisconv['\u9f3b'] = '\u0095@';
sjisconv['\u9f3e'] = '\u00ea\u008d';
sjisconv['\u9f4a'] = '\u00ea\u008e';
sjisconv['\u9f4b'] = '\u00e2V';
sjisconv['\u9f4e'] = '\u00e6\u00d8';
sjisconv['\u9f4f'] = '\u00e8\u00eb';
sjisconv['\u9f52'] = '\u00ea\u008f';
sjisconv['\u9f54'] = '\u00ea\u0090';
sjisconv['\u9f5f'] = '\u00ea\u0092';
sjisconv['\u9f60'] = '\u00ea\u0093';
sjisconv['\u9f61'] = '\u00ea\u0094';
sjisconv['\u9f62'] = '\u0097\u00ee';
sjisconv['\u9f63'] = '\u00ea\u0091';
sjisconv['\u9f66'] = '\u00ea\u0095';
sjisconv['\u9f67'] = '\u00ea\u0096';
sjisconv['\u9f6a'] = '\u00ea\u0098';
sjisconv['\u9f6c'] = '\u00ea\u0097';
sjisconv['\u9f72'] = '\u00ea\u009a';
sjisconv['\u9f76'] = '\u00ea\u009b';
sjisconv['\u9f77'] = '\u00ea\u0099';
sjisconv['\u9f8d'] = '\u0097\u00b4';
sjisconv['\u9f95'] = '\u00ea\u009c';
sjisconv['\u9f9c'] = '\u00ea\u009d';
sjisconv['\u9f9d'] = '\u00e2s';
sjisconv['\u9fa0'] = '\u00ea\u009e';
sjisconv['\uff01'] = '\u0081I';
sjisconv['\uff03'] = '\u0081\u0094';
sjisconv['\uff04'] = '\u0081\u0090';
sjisconv['\uff05'] = '\u0081\u0093';
sjisconv['\uff06'] = '\u0081\u0095';
sjisconv['\uff08'] = '\u0081i';
sjisconv['\uff09'] = '\u0081j';
sjisconv['\uff0a'] = '\u0081\u0096';
sjisconv['\uff0b'] = '\u0081{';
sjisconv['\uff0c'] = '\u0081C';
sjisconv['\uff0e'] = '\u0081D';
sjisconv['\uff0f'] = '\u0081^';
sjisconv['\uff10'] = '\u0082O';
sjisconv['\uff11'] = '\u0082P';
sjisconv['\uff12'] = '\u0082Q';
sjisconv['\uff13'] = '\u0082R';
sjisconv['\uff14'] = '\u0082S';
sjisconv['\uff15'] = '\u0082T';
sjisconv['\uff16'] = '\u0082U';
sjisconv['\uff17'] = '\u0082V';
sjisconv['\uff18'] = '\u0082W';
sjisconv['\uff19'] = '\u0082X';
sjisconv['\uff1a'] = '\u0081F';
sjisconv['\uff1b'] = '\u0081G';
sjisconv['\uff1c'] = '\u0081\u0083';
sjisconv['\uff1d'] = '\u0081\u0081';
sjisconv['\uff1e'] = '\u0081\u0084';
sjisconv['\uff1f'] = '\u0081H';
sjisconv['\uff20'] = '\u0081\u0097';
sjisconv['\uff21'] = '\u0082`';
sjisconv['\uff22'] = '\u0082a';
sjisconv['\uff23'] = '\u0082b';
sjisconv['\uff24'] = '\u0082c';
sjisconv['\uff25'] = '\u0082d';
sjisconv['\uff26'] = '\u0082e';
sjisconv['\uff27'] = '\u0082f';
sjisconv['\uff28'] = '\u0082g';
sjisconv['\uff29'] = '\u0082h';
sjisconv['\uff2a'] = '\u0082i';
sjisconv['\uff2b'] = '\u0082j';
sjisconv['\uff2c'] = '\u0082k';
sjisconv['\uff2d'] = '\u0082l';
sjisconv['\uff2e'] = '\u0082m';
sjisconv['\uff2f'] = '\u0082n';
sjisconv['\uff30'] = '\u0082o';
sjisconv['\uff31'] = '\u0082p';
sjisconv['\uff32'] = '\u0082q';
sjisconv['\uff33'] = '\u0082r';
sjisconv['\uff34'] = '\u0082s';
sjisconv['\uff35'] = '\u0082t';
sjisconv['\uff36'] = '\u0082u';
sjisconv['\uff37'] = '\u0082v';
sjisconv['\uff38'] = '\u0082w';
sjisconv['\uff39'] = '\u0082x';
sjisconv['\uff3a'] = '\u0082y';
sjisconv['\uff3b'] = '\u0081m';
sjisconv['\uff3c'] = '\u0081_';
sjisconv['\uff3d'] = '\u0081n';
sjisconv['\uff3e'] = '\u0081O';
sjisconv['\uff3f'] = '\u0081Q';
sjisconv['\uff40'] = '\u0081M';
sjisconv['\uff41'] = '\u0082\u0081';
sjisconv['\uff42'] = '\u0082\u0082';
sjisconv['\uff43'] = '\u0082\u0083';
sjisconv['\uff44'] = '\u0082\u0084';
sjisconv['\uff45'] = '\u0082\u0085';
sjisconv['\uff46'] = '\u0082\u0086';
sjisconv['\uff47'] = '\u0082\u0087';
sjisconv['\uff48'] = '\u0082\u0088';
sjisconv['\uff49'] = '\u0082\u0089';
sjisconv['\uff4a'] = '\u0082\u008a';
sjisconv['\uff4b'] = '\u0082\u008b';
sjisconv['\uff4c'] = '\u0082\u008c';
sjisconv['\uff4d'] = '\u0082\u008d';
sjisconv['\uff4e'] = '\u0082\u008e';
sjisconv['\uff4f'] = '\u0082\u008f';
sjisconv['\uff50'] = '\u0082\u0090';
sjisconv['\uff51'] = '\u0082\u0091';
sjisconv['\uff52'] = '\u0082\u0092';
sjisconv['\uff53'] = '\u0082\u0093';
sjisconv['\uff54'] = '\u0082\u0094';
sjisconv['\uff55'] = '\u0082\u0095';
sjisconv['\uff56'] = '\u0082\u0096';
sjisconv['\uff57'] = '\u0082\u0097';
sjisconv['\uff58'] = '\u0082\u0098';
sjisconv['\uff59'] = '\u0082\u0099';
sjisconv['\uff5a'] = '\u0082\u009a';
sjisconv['\uff5b'] = '\u0081o';
sjisconv['\uff5c'] = '\u0081b';
sjisconv['\uff5d'] = '\u0081p';
sjisconv['\uff61'] = '\u00a1';
sjisconv['\uff62'] = '\u00a2';
sjisconv['\uff63'] = '\u00a3';
sjisconv['\uff64'] = '\u00a4';
sjisconv['\uff65'] = '\u00a5';
sjisconv['\uff66'] = '\u00a6';
sjisconv['\uff67'] = '\u00a7';
sjisconv['\uff68'] = '\u00a8';
sjisconv['\uff69'] = '\u00a9';
sjisconv['\uff6a'] = '\u00aa';
sjisconv['\uff6b'] = '\u00ab';
sjisconv['\uff6c'] = '\u00ac';
sjisconv['\uff6d'] = '\u00ad';
sjisconv['\uff6e'] = '\u00ae';
sjisconv['\uff6f'] = '\u00af';
sjisconv['\uff70'] = '\u00b0';
sjisconv['\uff71'] = '\u00b1';
sjisconv['\uff72'] = '\u00b2';
sjisconv['\uff73'] = '\u00b3';
sjisconv['\uff74'] = '\u00b4';
sjisconv['\uff75'] = '\u00b5';
sjisconv['\uff76'] = '\u00b6';
sjisconv['\uff77'] = '\u00b7';
sjisconv['\uff78'] = '\u00b8';
sjisconv['\uff79'] = '\u00b9';
sjisconv['\uff7a'] = '\u00ba';
sjisconv['\uff7b'] = '\u00bb';
sjisconv['\uff7c'] = '\u00bc';
sjisconv['\uff7d'] = '\u00bd';
sjisconv['\uff7e'] = '\u00be';
sjisconv['\uff7f'] = '\u00bf';
sjisconv['\uff80'] = '\u00c0';
sjisconv['\uff81'] = '\u00c1';
sjisconv['\uff82'] = '\u00c2';
sjisconv['\uff83'] = '\u00c3';
sjisconv['\uff84'] = '\u00c4';
sjisconv['\uff85'] = '\u00c5';
sjisconv['\uff86'] = '\u00c6';
sjisconv['\uff87'] = '\u00c7';
sjisconv['\uff88'] = '\u00c8';
sjisconv['\uff89'] = '\u00c9';
sjisconv['\uff8a'] = '\u00ca';
sjisconv['\uff8b'] = '\u00cb';
sjisconv['\uff8c'] = '\u00cc';
sjisconv['\uff8d'] = '\u00cd';
sjisconv['\uff8e'] = '\u00ce';
sjisconv['\uff8f'] = '\u00cf';
sjisconv['\uff90'] = '\u00d0';
sjisconv['\uff91'] = '\u00d1';
sjisconv['\uff92'] = '\u00d2';
sjisconv['\uff93'] = '\u00d3';
sjisconv['\uff94'] = '\u00d4';
sjisconv['\uff95'] = '\u00d5';
sjisconv['\uff96'] = '\u00d6';
sjisconv['\uff97'] = '\u00d7';
sjisconv['\uff98'] = '\u00d8';
sjisconv['\uff99'] = '\u00d9';
sjisconv['\uff9a'] = '\u00da';
sjisconv['\uff9b'] = '\u00db';
sjisconv['\uff9c'] = '\u00dc';
sjisconv['\uff9d'] = '\u00dd';
sjisconv['\uff9e'] = '\u00de';
sjisconv['\uff9f'] = '\u00df';
sjisconv['\uffe3'] = '\u0081P';
sjisconv['\uffe5'] = '\u0081\u008f';
module.exports = sjisconv;
